"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FaqLinkingCollectionsFullCampaignCollectionOrder = exports.ExtraOrder = exports.ExtraBundleOrder = exports.EntryOrder = exports.CyhhParkFacilityOrder = exports.CyhhParkFacilityFacilitiesCollectionOrder = exports.CaravanTypesOrder = exports.CaravanTypesCaravansByParkCollectionOrder = exports.CaravanTypesCaravanImagesCollectionOrder = exports.CaravanTypesCaravanFeaturesCollectionOrder = exports.CaravanTypeByParkOrder = exports.CaravanTypeByParkLinkingCollectionsCaravanTypesCollectionOrder = exports.CaravanTypeByParkCaravanImagesCollectionOrder = exports.CaravanTypeByParkCaravanFeaturesCollectionOrder = exports.BoxOrder = exports.BoxLinkingCollectionsPitchTypeCollectionOrder = exports.BoxLinkingCollectionsCaravanTypesCollectionOrder = exports.BoxLinkingCollectionsCaravanTypeByParkCollectionOrder = exports.AwardOrder = exports.AwardLinkingCollectionsParkCollectionOrder = exports.AssetOrder = exports.ArticlesTermsAndConditionsCollectionOrder = exports.ArticlesOrder = exports.ArticlesLinkingCollectionsPromotionComponentCollectionOrder = exports.ArticlesLinkingCollectionsArticleHubSectionCollectionOrder = exports.ArticlesLinkingCollectionsArticleHubCollectionOrder = exports.ArticleSectionOrder = exports.ArticleSectionLinkingCollectionsArticlesCollectionOrder = exports.ArticleHubSectionOrder = exports.ArticleHubSectionLinkingCollectionsArticleHubCollectionOrder = exports.ArticleHubSectionArticlesCollectionOrder = exports.ArticleHubOrder = exports.ArticleHubArticleHubSectionsCollectionOrder = exports.AllParkPageOrder = exports.AdvertOrder = exports.AdvertLinkingCollectionsPropositionCategoryCollectionOrder = exports.AdvertLinkingCollectionsParkCollectionOrder = exports.AdvertLinkingCollectionsHomePageCollectionOrder = exports.AdvertLinkingCollectionsFullCampaignCollectionOrder = exports.AccommodationTypeSafetyMeasuresCollectionOrder = exports.AccommodationTypeOrder = exports.AccommodationTypeChecklistCollectionOrder = exports.AccommodationTypeAccommodationGradesCollectionOrder = exports.AccommodationGradeVideosCollectionOrder = exports.AccommodationGradeSpacesCollectionOrder = exports.AccommodationGradeOrder = exports.AccommodationGradeLinkingCollectionsParkCollectionOrder = exports.AccommodationGradeLinkingCollectionsCaravanTypesCollectionOrder = exports.AccommodationGradeLinkingCollectionsAccommodationTypeCollectionOrder = exports.AccommodationGradeImagesCollectionOrder = void 0;
exports.ImageLinkingCollectionsFullCampaignCollectionOrder = exports.ImageLinkingCollectionsCaravanTypesCollectionOrder = exports.ImageLinkingCollectionsCaravanTypeByParkCollectionOrder = exports.ImageLinkingCollectionsBoxCollectionOrder = exports.ImageLinkingCollectionsAwardCollectionOrder = exports.ImageLinkingCollectionsArticlesCollectionOrder = exports.ImageLinkingCollectionsArticleSectionCollectionOrder = exports.ImageLinkingCollectionsAdvertCollectionOrder = exports.ImageLinkingCollectionsAccommodationTypeCollectionOrder = exports.ImageLinkingCollectionsAccommodationGradeCollectionOrder = exports.ImageFormat = exports.HomePageTestimonialsCollectionOrder = exports.HomePageTermsCollectionOrder = exports.HomePagePromotionsCollectionOrder = exports.HomePageParkOffersCollectionOrder = exports.HomePageOrder = exports.HomePageCommercialSellingPointsCollectionOrder = exports.HomePageAdvertsCollectionOrder = exports.HolidaySelectionPageOrder = exports.HolidaySelectionPageHolidayPackagesCollectionOrder = exports.HolidaySearchParametersOrder = exports.HolidaySearchParametersLinkingCollectionsPromotionCollectionOrder = exports.HolidaySearchParametersLinkingCollectionsFullCampaignCollectionOrder = exports.HolidayPackageSellingPointsCollectionOrder = exports.HolidayPackageOrder = exports.HolidayPackageLinkingCollectionsPropositionCollectionOrder = exports.HolidayPackageLinkingCollectionsHolidaySelectionPageCollectionOrder = exports.HolidayPackageFeaturesCollectionOrder = exports.HavenPromiseOrder = exports.GenericTemplateSectionsCollectionOrder = exports.GenericTemplateSafetyMeasuresCollectionOrder = exports.GenericTemplateOrder = exports.FullCampaignTermsAndConditionsCollectionOrder = exports.FullCampaignSellingPointsCollectionOrder = exports.FullCampaignReasonsToBookCollectionOrder = exports.FullCampaignPropositionsCollectionOrder = exports.FullCampaignPromotionsCollectionOrder = exports.FullCampaignParkOffersCollectionOrder = exports.FullCampaignOrder = exports.FullCampaignLinkingCollectionsPromotionComponentCollectionOrder = exports.FullCampaignLinkingCollectionsArticleSectionCollectionOrder = exports.FullCampaignFeaturedPromotionsCollectionOrder = exports.FullCampaignFaqsCollectionOrder = exports.FullCampaignAdvertsCollectionOrder = exports.FocusParkListParksCollectionOrder = exports.FocusParkListOrder = exports.FaqOrder = exports.FaqLinkingCollectionsRegionCollectionOrder = exports.FaqLinkingCollectionsPropositionCollectionOrder = exports.FaqLinkingCollectionsParkCollectionOrder = void 0;
exports.PageMetadataLinkingCollectionsArticlesCollectionOrder = exports.PageMetadataLinkingCollectionsArticleHubCollectionOrder = exports.PageMetadataLinkingCollectionsAllParkPageCollectionOrder = exports.PageMetadataLinkingCollectionsAccommodationTypeCollectionOrder = exports.OwnershipSearchOptionsOrder = exports.OwnershipSearchOptionsLinkingCollectionsFullCampaignCollectionOrder = exports.NotificationOrder = exports.NotificationLinkingCollectionsRegionCollectionOrder = exports.NotificationLinkingCollectionsPropositionSubCategoryCollectionOrder = exports.NotificationLinkingCollectionsPropositionCollectionOrder = exports.NotificationLinkingCollectionsParkCollectionOrder = exports.NotificationLinkingCollectionsHomePageCollectionOrder = exports.NotificationLinkingCollectionsFullCampaignCollectionOrder = exports.NotificationLinkingCollectionsArticlesCollectionOrder = exports.NotificationLinkingCollectionsAllParkPageCollectionOrder = exports.NotificationLinkingCollectionsAccommodationTypeCollectionOrder = exports.MaintenancePeriodOrder = exports.MaintenancePeriodLinkingCollectionsParkFeaturesCollectionOrder = exports.ListAssemblyOrder = exports.ListAssemblyLinkingCollectionsPropositionCollectionOrder = exports.LinkOrder = exports.LinkLinkingCollectionsPropositionCollectionOrder = exports.LinkLinkingCollectionsPromoLinkCollectionOrder = exports.LinkLinkingCollectionsNotificationCollectionOrder = exports.LinkLinkingCollectionsBoxCollectionOrder = exports.ImageResizeStrategy = exports.ImageResizeFocus = exports.ImageOrder = exports.ImageLinkingCollectionsVirtualTourCollectionOrder = exports.ImageLinkingCollectionsVideoCollectionOrder = exports.ImageLinkingCollectionsTestimonialCollectionOrder = exports.ImageLinkingCollectionsSellingPointCollectionOrder = exports.ImageLinkingCollectionsSectionCollectionOrder = exports.ImageLinkingCollectionsSearchPromotionBannerCollectionOrder = exports.ImageLinkingCollectionsSafetyMeasureCollectionOrder = exports.ImageLinkingCollectionsRegionalHolidayCollectionOrder = exports.ImageLinkingCollectionsRegionCollectionOrder = exports.ImageLinkingCollectionsPropositionSubCategoryCollectionOrder = exports.ImageLinkingCollectionsPropositionCollectionOrder = exports.ImageLinkingCollectionsPropositionCategoryCollectionOrder = exports.ImageLinkingCollectionsPromotionCollectionOrder = exports.ImageLinkingCollectionsPromoLinkCollectionOrder = exports.ImageLinkingCollectionsParkOfferCollectionOrder = exports.ImageLinkingCollectionsParkInformationCollectionOrder = exports.ImageLinkingCollectionsParkFeaturesCollectionOrder = exports.ImageLinkingCollectionsParkCollectionOrder = exports.ImageLinkingCollectionsHolidaySelectionPageCollectionOrder = exports.ImageLinkingCollectionsHolidayPackageCollectionOrder = exports.ImageLinkingCollectionsHavenPromiseCollectionOrder = exports.ImageLinkingCollectionsGenericTemplateCollectionOrder = void 0;
exports.PitchTypePitchFeaturesCollectionOrder = exports.PitchTypeParksCollectionOrder = exports.PitchTypeOrder = exports.ParkTestimonialsCollectionOrder = exports.ParkTermsAndConditionsCollectionOrder = exports.ParkSupportedAccommodationGradesCollectionOrder = exports.ParkSellingPointsCollectionOrder = exports.ParkRestrictionOrder = exports.ParkRestrictionLinkingCollectionsParkCollectionOrder = exports.ParkParkRestrictionsCollectionOrder = exports.ParkParkFeaturesCollectionOrder = exports.ParkOrder = exports.ParkOffersCollectionOrder = exports.ParkOfferOrder = exports.ParkOfferLinkingCollectionsRegionalHolidayCollectionOrder = exports.ParkOfferLinkingCollectionsParkCollectionOrder = exports.ParkOfferLinkingCollectionsHomePageCollectionOrder = exports.ParkOfferLinkingCollectionsFullCampaignCollectionOrder = exports.ParkOfferImagesCollectionOrder = exports.ParkLinkingCollectionsRegionalHolidayCollectionOrder = exports.ParkLinkingCollectionsPromotionComponentCollectionOrder = exports.ParkLinkingCollectionsPitchTypeCollectionOrder = exports.ParkLinkingCollectionsFocusParkListCollectionOrder = exports.ParkLinkingCollectionsArticleSectionCollectionOrder = exports.ParkInformationOrder = exports.ParkInformationLinkingCollectionsTestimonialCollectionOrder = exports.ParkInformationLinkingCollectionsParkCollectionOrder = exports.ParkInformationLinkingCollectionsCaravanTypeByParkCollectionOrder = exports.ParkFeaturesVirtualToursCollectionOrder = exports.ParkFeaturesVideosCollectionOrder = exports.ParkFeaturesOrder = exports.ParkFeaturesMaintenancePeriodsCollectionOrder = exports.ParkFeaturesLinkingCollectionsRegionCollectionOrder = exports.ParkFeaturesLinkingCollectionsParkCollectionOrder = exports.ParkFeaturesLinkingCollectionsCyhhParkFacilityCollectionOrder = exports.ParkFeaturesImagesCollectionOrder = exports.ParkFaqsCollectionOrder = exports.ParkExclusiveCollectionOrder = exports.ParkAwardsCollectionOrder = exports.ParkAdvertsCollectionOrder = exports.PageMetadataOrder = exports.PageMetadataLinkingCollectionsTagMetaDataCollectionOrder = exports.PageMetadataLinkingCollectionsRegionCollectionOrder = exports.PageMetadataLinkingCollectionsPropositionSubCategoryCollectionOrder = exports.PageMetadataLinkingCollectionsPropositionCollectionOrder = exports.PageMetadataLinkingCollectionsParkCollectionOrder = exports.PageMetadataLinkingCollectionsHomePageCollectionOrder = exports.PageMetadataLinkingCollectionsHolidaySelectionPageCollectionOrder = exports.PageMetadataLinkingCollectionsGenericTemplateCollectionOrder = exports.PageMetadataLinkingCollectionsFullCampaignCollectionOrder = void 0;
exports.SafetyMeasureLinkingCollectionsAccommodationTypeCollectionOrder = exports.RegionalHolidayReasonsToBookCollectionOrder = exports.RegionalHolidayPromotionsCollectionOrder = exports.RegionalHolidayParksCollectionOrder = exports.RegionalHolidayParkOffersCollectionOrder = exports.RegionalHolidayOrder = exports.RegionTestimonialsCollectionOrder = exports.RegionSellingPointsCollectionOrder = exports.RegionOrder = exports.RegionNearbyTownCitiesCollectionOrder = exports.RegionLinkingCollectionsRegionalHolidayCollectionOrder = exports.RegionLinkingCollectionsPromotionComponentCollectionOrder = exports.RegionLinkingCollectionsParkCollectionOrder = exports.RegionLinkingCollectionsArticleSectionCollectionOrder = exports.RegionHighlightedParkFeaturesCollectionOrder = exports.RegionFaqsCollectionOrder = exports.PropositionTermsAndConditionsCollectionOrder = exports.PropositionSupportedHolidayPackagesCollectionOrder = exports.PropositionSubCategorySafetyMeasuresCollectionOrder = exports.PropositionSubCategoryOrder = exports.PropositionSubCategoryHeroImagesCollectionOrder = exports.PropositionSubCategoryCategoriesCollectionOrder = exports.PropositionSafetyMeasuresCollectionOrder = exports.PropositionPromotionsCollectionOrder = exports.PropositionOrder = exports.PropositionHeroImagesCollectionOrder = exports.PropositionFaqsCollectionOrder = exports.PropositionCategoryVideosCollectionOrder = exports.PropositionCategoryTestimonialsCollectionOrder = exports.PropositionCategoryTermsAndConditionsCollectionOrder = exports.PropositionCategoryOrder = exports.PropositionCategoryLinkingCollectionsPropositionSubCategoryCollectionOrder = exports.PropositionCategoryLinkingCollectionsPropositionCollectionOrder = exports.PropositionCategoryLinkingCollectionsFullCampaignCollectionOrder = exports.PropositionCategoryImagesCollectionOrder = exports.PropositionCategoryExampleImagesCollectionOrder = exports.PropositionCategoryAdvertsCollectionOrder = exports.PropositionCategoriesCollectionOrder = exports.PromotionTermsAndConditionsCollectionOrder = exports.PromotionOrder = exports.PromotionLinkingCollectionsRegionalHolidayCollectionOrder = exports.PromotionLinkingCollectionsPropositionCollectionOrder = exports.PromotionLinkingCollectionsHomePageCollectionOrder = exports.PromotionLinkingCollectionsFullCampaignCollectionOrder = exports.PromotionImagesCollectionOrder = exports.PromotionComponentOrder = exports.PromotionComponentLinkingCollectionsArticlesCollectionOrder = exports.PromoLinkOrder = exports.PromoLinkLinkingCollectionsPromotionComponentCollectionOrder = exports.PromoLinkLinkingCollectionsArticleSectionCollectionOrder = void 0;
exports.SysFieldsFragmentDoc = exports.VirtualTourOrder = exports.VirtualTourLinkingCollectionsParkFeaturesCollectionOrder = exports.VideoOrder = exports.VideoLinkingCollectionsSectionCollectionOrder = exports.VideoLinkingCollectionsPropositionCollectionOrder = exports.VideoLinkingCollectionsPropositionCategoryCollectionOrder = exports.VideoLinkingCollectionsPromotionCollectionOrder = exports.VideoLinkingCollectionsParkOfferCollectionOrder = exports.VideoLinkingCollectionsParkFeaturesCollectionOrder = exports.VideoLinkingCollectionsParkCollectionOrder = exports.VideoLinkingCollectionsFullCampaignCollectionOrder = exports.VideoLinkingCollectionsArticleSectionCollectionOrder = exports.VideoLinkingCollectionsAccommodationGradeCollectionOrder = exports.UmzugMigrationDataOrder = exports.TouringSearchOptionsOrder = exports.TouringSearchOptionsLinkingCollectionsFullCampaignCollectionOrder = exports.TestimonialOrder = exports.TestimonialLinkingCollectionsRegionCollectionOrder = exports.TestimonialLinkingCollectionsPropositionCategoryCollectionOrder = exports.TestimonialLinkingCollectionsParkCollectionOrder = exports.TestimonialLinkingCollectionsHomePageCollectionOrder = exports.TermsOrder = exports.TermsLinkingCollectionsPropositionCollectionOrder = exports.TermsLinkingCollectionsPropositionCategoryCollectionOrder = exports.TermsLinkingCollectionsPromotionCollectionOrder = exports.TermsLinkingCollectionsParkOfferCollectionOrder = exports.TermsLinkingCollectionsParkCollectionOrder = exports.TermsLinkingCollectionsHomePageCollectionOrder = exports.TermsLinkingCollectionsFullCampaignCollectionOrder = exports.TermsLinkingCollectionsArticlesCollectionOrder = exports.TagMetaDataOrder = exports.SellingPointOrder = exports.SellingPointLinkingCollectionsRegionalHolidayCollectionOrder = exports.SellingPointLinkingCollectionsRegionCollectionOrder = exports.SellingPointLinkingCollectionsParkCollectionOrder = exports.SellingPointLinkingCollectionsListAssemblyCollectionOrder = exports.SellingPointLinkingCollectionsHolidayPackageCollectionOrder = exports.SellingPointLinkingCollectionsFullCampaignCollectionOrder = exports.SellingPointLinkingCollectionsAccommodationTypeCollectionOrder = exports.SellingPointLinkingCollectionsAccommodationGradeCollectionOrder = exports.SellingAttributeOrder = exports.SectionOrder = exports.SectionLinkingCollectionsGenericTemplateCollectionOrder = exports.SearchPromotionBannerOrder = exports.SafetyMeasureOrder = exports.SafetyMeasureLinkingCollectionsPropositionSubCategoryCollectionOrder = exports.SafetyMeasureLinkingCollectionsPropositionCollectionOrder = exports.SafetyMeasureLinkingCollectionsListAssemblyCollectionOrder = exports.SafetyMeasureLinkingCollectionsGenericTemplateCollectionOrder = void 0;
exports.AwardFieldsFragmentDoc = exports.RegionFieldsFragmentDoc = exports.ParkFeatureSummaryWithParkFieldsFragmentDoc = exports.ParkFeatureSummaryFieldsFragmentDoc = exports.ParkSeasonsFieldsFragmentDoc = exports.HomepageFieldsFragmentDoc = exports.PromotionFieldsWithMultipleImagesFragmentDoc = exports.HolidaySelectionPageFieldsFragmentDoc = exports.HolidayPackageFieldsFragmentDoc = exports.HolidaySelectionPageSummaryFieldsFragmentDoc = exports.HavenPromiseFieldsFragmentDoc = exports.GenericTemplateFieldsFragmentDoc = exports.SectionFieldsFragmentDoc = exports.FullCampaignFieldsFragmentDoc = exports.FaqFieldsFragmentDoc = exports.PropositionCategoryFieldsFragmentDoc = exports.TestimonialsFieldsFragmentDoc = exports.AdvertFieldsFragmentDoc = exports.PromotionFieldsFragmentDoc = exports.OwnershipSearchOptionsFieldsFragmentDoc = exports.TouringSearchOptionsFieldsFragmentDoc = exports.HolidaySearchParamsFieldsFragmentDoc = exports.FocusParkListFieldsFragmentDoc = exports.ParkSummaryFieldsFragmentDoc = exports.ParkOfferFieldsFragmentDoc = exports.ExtraFieldsFragmentDoc = exports.ExtraBundleFieldsFragmentDoc = exports.CaravanTypeByParkFieldsFragmentDoc = exports.ParkInformationFieldsFragmentDoc = exports.CaravanTypesFieldsFragmentDoc = exports.ArticleHubFieldsFragmentDoc = exports.ArticleHubSectionFieldsFragmentDoc = exports.ArticleSummaryFieldsFragmentDoc = exports.ArticleFieldsFragmentDoc = exports.TermFieldsFragmentDoc = exports.ArticlesDescriptionFieldsFragmentDoc = exports.ArticlesSectionFieldsFragmentDoc = exports.ArticleSectionPromoLinkFieldsFragmentDoc = exports.AllParkPageFieldsFragmentDoc = exports.AccommodationTypeFieldsFragmentDoc = exports.AccommodationGradeFieldsFragmentDoc = exports.AccommodationTypeWithParkFieldsFragmentDoc = exports.AccommodationGradeWithParksFieldsFragmentDoc = exports.VideoFieldsFragmentDoc = exports.PageMetadataAllFragmentDoc = exports.SellingPointFieldsFragmentDoc = exports.SafetyMeasureFieldsFragmentDoc = exports.NotificationFieldsFragmentDoc = exports.LinkFieldsFragmentDoc = exports.ImageFieldsFragmentDoc = void 0;
exports.GetParkByPathDocument = exports.GetAllParkSeasonsDocument = exports.GetParksByParkCodesDocument = exports.GetParkByParkInformationIdDocument = exports.GetParkInformationIdsByParkTypesDocument = exports.FetchHomepageDocument = exports.GetHolidaySelectionPagesSummariesDocument = exports.GetHolidaySelectionPagesByPathDocument = exports.GetHavenPromisesDocument = exports.FetchGenericTemplateDocument = exports.GetCampaignPromotionsDocument = exports.GetFullCampaignByPathDocument = exports.GetFocusParkListByIdDocument = exports.FetchExtrasDocument = exports.FetchExtraBundlesDocument = exports.GetCaravanLimitsDocument = exports.GetCaravanTypesByParkDocument = exports.GetCaravanTypesDocument = exports.GetArticlesByArticleHubSectionIdDocument = exports.GetArticleHubPathsDocument = exports.FetchArticleHubByPathDocument = exports.GetArticleByPathDocument = exports.GetArticlesByIdsDocument = exports.GetArticlesByTagDocument = exports.FetchAllParkPageByTypeDocument = exports.GetAccommodationGradeByNameDocument = exports.GetAccommodationTypeByTypesDocument = exports.GetAccommodationTypePathsDocument = exports.GetAccommodationTypesDocument = exports.GetAccommodationTypeByPathDocument = exports.TermByHolidayTypeFieldsFragmentDoc = exports.TagIdFieldsFragmentDoc = exports.TagMetaDataFieldsFragmentDoc = exports.SellingAttributeFieldsFragmentDoc = exports.RegionArticlesFieldsFragmentDoc = exports.RegionalHolidayFieldsWithoutRegionFragmentDoc = exports.RegionalHolidayFieldsFragmentDoc = exports.SearchPromotionBannerFieldsFragmentDoc = exports.PropositionSummaryFieldsFragmentDoc = exports.PropositionFieldsFragmentDoc = exports.ListAssemblyFieldsFragmentDoc = exports.PropositionSubCategoryFieldsFragmentDoc = exports.PitchFieldsFragmentDoc = exports.PitchParkFieldsFragmentDoc = exports.BoxFieldsFragmentDoc = exports.ParkFieldsFragmentDoc = exports.ParkRestrictionFieldsFragmentDoc = exports.ParkFeaturesFieldsFragmentDoc = exports.MaintenancePeriodFieldsFragmentDoc = exports.VirtualTourFieldsFragmentDoc = void 0;
exports.getSdk = exports.GetTermsByHolidayTypeDocument = exports.GetTagIdsDocument = exports.GetTagMetaDataDocument = exports.GetSellingPointsByTagDocument = exports.FetchSellingAttributesDocument = exports.RelatedRegionArticlesDocument = exports.GetRegionalHolidaysDocument = exports.GetRegionHolidaysByTagDocument = exports.GetRegionalHolidayByPathDocument = exports.GetRegionalHolidayPathsDocument = exports.RegionParksDocument = exports.FetchRegionDocument = exports.GetLastSearchPromotionBannerDocument = exports.GetPropositionSubCategoryByPathDocument = exports.GetPropositionsSummariesByTagDocument = exports.GetPropositionsSummariesDocument = exports.GetPropositionSubCategoriesPathsDocument = exports.GetPropositionByPathDocument = exports.GetParkPromotionByCodeLimitsDocument = exports.GetParkPromotionsByCodeDocument = exports.GetFeaturedParkPromotionsByCodeDocument = exports.GetPitchesDocument = exports.GetAllPathsDocument = exports.FetchParkSummariesByParkTypeDocument = exports.GetParkOffersByHolidayTypeDocument = exports.GetOffersDocument = exports.GetAllParksWithAccommodationGradesDocument = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
var AccommodationGradeImagesCollectionOrder;
(function (AccommodationGradeImagesCollectionOrder) {
    AccommodationGradeImagesCollectionOrder["AltTextAsc"] = "altText_ASC";
    AccommodationGradeImagesCollectionOrder["AltTextDesc"] = "altText_DESC";
    AccommodationGradeImagesCollectionOrder["CaptionOptionalAsc"] = "captionOptional_ASC";
    AccommodationGradeImagesCollectionOrder["CaptionOptionalDesc"] = "captionOptional_DESC";
    AccommodationGradeImagesCollectionOrder["FocusAreaAsc"] = "focusArea_ASC";
    AccommodationGradeImagesCollectionOrder["FocusAreaDesc"] = "focusArea_DESC";
    AccommodationGradeImagesCollectionOrder["NameAsc"] = "name_ASC";
    AccommodationGradeImagesCollectionOrder["NameDesc"] = "name_DESC";
    AccommodationGradeImagesCollectionOrder["SubHeadingAsc"] = "subHeading_ASC";
    AccommodationGradeImagesCollectionOrder["SubHeadingDesc"] = "subHeading_DESC";
    AccommodationGradeImagesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AccommodationGradeImagesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AccommodationGradeImagesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    AccommodationGradeImagesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    AccommodationGradeImagesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AccommodationGradeImagesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AccommodationGradeImagesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AccommodationGradeImagesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(AccommodationGradeImagesCollectionOrder = exports.AccommodationGradeImagesCollectionOrder || (exports.AccommodationGradeImagesCollectionOrder = {}));
var AccommodationGradeLinkingCollectionsAccommodationTypeCollectionOrder;
(function (AccommodationGradeLinkingCollectionsAccommodationTypeCollectionOrder) {
    AccommodationGradeLinkingCollectionsAccommodationTypeCollectionOrder["ChecklistTitleAsc"] = "checklistTitle_ASC";
    AccommodationGradeLinkingCollectionsAccommodationTypeCollectionOrder["ChecklistTitleDesc"] = "checklistTitle_DESC";
    AccommodationGradeLinkingCollectionsAccommodationTypeCollectionOrder["NameAsc"] = "name_ASC";
    AccommodationGradeLinkingCollectionsAccommodationTypeCollectionOrder["NameDesc"] = "name_DESC";
    AccommodationGradeLinkingCollectionsAccommodationTypeCollectionOrder["PathAsc"] = "path_ASC";
    AccommodationGradeLinkingCollectionsAccommodationTypeCollectionOrder["PathDesc"] = "path_DESC";
    AccommodationGradeLinkingCollectionsAccommodationTypeCollectionOrder["SearchAccommodationNameAsc"] = "searchAccommodationName_ASC";
    AccommodationGradeLinkingCollectionsAccommodationTypeCollectionOrder["SearchAccommodationNameDesc"] = "searchAccommodationName_DESC";
    AccommodationGradeLinkingCollectionsAccommodationTypeCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AccommodationGradeLinkingCollectionsAccommodationTypeCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AccommodationGradeLinkingCollectionsAccommodationTypeCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    AccommodationGradeLinkingCollectionsAccommodationTypeCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    AccommodationGradeLinkingCollectionsAccommodationTypeCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AccommodationGradeLinkingCollectionsAccommodationTypeCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AccommodationGradeLinkingCollectionsAccommodationTypeCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AccommodationGradeLinkingCollectionsAccommodationTypeCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    AccommodationGradeLinkingCollectionsAccommodationTypeCollectionOrder["TitleAsc"] = "title_ASC";
    AccommodationGradeLinkingCollectionsAccommodationTypeCollectionOrder["TitleDesc"] = "title_DESC";
})(AccommodationGradeLinkingCollectionsAccommodationTypeCollectionOrder = exports.AccommodationGradeLinkingCollectionsAccommodationTypeCollectionOrder || (exports.AccommodationGradeLinkingCollectionsAccommodationTypeCollectionOrder = {}));
var AccommodationGradeLinkingCollectionsCaravanTypesCollectionOrder;
(function (AccommodationGradeLinkingCollectionsCaravanTypesCollectionOrder) {
    AccommodationGradeLinkingCollectionsCaravanTypesCollectionOrder["CaravanCodeAsc"] = "caravanCode_ASC";
    AccommodationGradeLinkingCollectionsCaravanTypesCollectionOrder["CaravanCodeDesc"] = "caravanCode_DESC";
    AccommodationGradeLinkingCollectionsCaravanTypesCollectionOrder["ContentfulNameAsc"] = "contentfulName_ASC";
    AccommodationGradeLinkingCollectionsCaravanTypesCollectionOrder["ContentfulNameDesc"] = "contentfulName_DESC";
    AccommodationGradeLinkingCollectionsCaravanTypesCollectionOrder["MatterportIdAsc"] = "matterportId_ASC";
    AccommodationGradeLinkingCollectionsCaravanTypesCollectionOrder["MatterportIdDesc"] = "matterportId_DESC";
    AccommodationGradeLinkingCollectionsCaravanTypesCollectionOrder["NameAsc"] = "name_ASC";
    AccommodationGradeLinkingCollectionsCaravanTypesCollectionOrder["NameDesc"] = "name_DESC";
    AccommodationGradeLinkingCollectionsCaravanTypesCollectionOrder["SubTitleAsc"] = "subTitle_ASC";
    AccommodationGradeLinkingCollectionsCaravanTypesCollectionOrder["SubTitleDesc"] = "subTitle_DESC";
    AccommodationGradeLinkingCollectionsCaravanTypesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AccommodationGradeLinkingCollectionsCaravanTypesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AccommodationGradeLinkingCollectionsCaravanTypesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    AccommodationGradeLinkingCollectionsCaravanTypesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    AccommodationGradeLinkingCollectionsCaravanTypesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AccommodationGradeLinkingCollectionsCaravanTypesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AccommodationGradeLinkingCollectionsCaravanTypesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AccommodationGradeLinkingCollectionsCaravanTypesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    AccommodationGradeLinkingCollectionsCaravanTypesCollectionOrder["TitleAsc"] = "title_ASC";
    AccommodationGradeLinkingCollectionsCaravanTypesCollectionOrder["TitleDesc"] = "title_DESC";
})(AccommodationGradeLinkingCollectionsCaravanTypesCollectionOrder = exports.AccommodationGradeLinkingCollectionsCaravanTypesCollectionOrder || (exports.AccommodationGradeLinkingCollectionsCaravanTypesCollectionOrder = {}));
var AccommodationGradeLinkingCollectionsParkCollectionOrder;
(function (AccommodationGradeLinkingCollectionsParkCollectionOrder) {
    AccommodationGradeLinkingCollectionsParkCollectionOrder["ContactNumberAsc"] = "contactNumber_ASC";
    AccommodationGradeLinkingCollectionsParkCollectionOrder["ContactNumberDesc"] = "contactNumber_DESC";
    AccommodationGradeLinkingCollectionsParkCollectionOrder["DirectionsUrlAsc"] = "directionsUrl_ASC";
    AccommodationGradeLinkingCollectionsParkCollectionOrder["DirectionsUrlDesc"] = "directionsUrl_DESC";
    AccommodationGradeLinkingCollectionsParkCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    AccommodationGradeLinkingCollectionsParkCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    AccommodationGradeLinkingCollectionsParkCollectionOrder["NameAsc"] = "name_ASC";
    AccommodationGradeLinkingCollectionsParkCollectionOrder["NameDesc"] = "name_DESC";
    AccommodationGradeLinkingCollectionsParkCollectionOrder["ParkTypeAsc"] = "parkType_ASC";
    AccommodationGradeLinkingCollectionsParkCollectionOrder["ParkTypeDesc"] = "parkType_DESC";
    AccommodationGradeLinkingCollectionsParkCollectionOrder["PathAsc"] = "path_ASC";
    AccommodationGradeLinkingCollectionsParkCollectionOrder["PathDesc"] = "path_DESC";
    AccommodationGradeLinkingCollectionsParkCollectionOrder["RunningCostsAsc"] = "runningCosts_ASC";
    AccommodationGradeLinkingCollectionsParkCollectionOrder["RunningCostsDesc"] = "runningCosts_DESC";
    AccommodationGradeLinkingCollectionsParkCollectionOrder["SiteFeesAsc"] = "siteFees_ASC";
    AccommodationGradeLinkingCollectionsParkCollectionOrder["SiteFeesDesc"] = "siteFees_DESC";
    AccommodationGradeLinkingCollectionsParkCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AccommodationGradeLinkingCollectionsParkCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AccommodationGradeLinkingCollectionsParkCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    AccommodationGradeLinkingCollectionsParkCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    AccommodationGradeLinkingCollectionsParkCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AccommodationGradeLinkingCollectionsParkCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AccommodationGradeLinkingCollectionsParkCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AccommodationGradeLinkingCollectionsParkCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    AccommodationGradeLinkingCollectionsParkCollectionOrder["TaglineAsc"] = "tagline_ASC";
    AccommodationGradeLinkingCollectionsParkCollectionOrder["TaglineDesc"] = "tagline_DESC";
    AccommodationGradeLinkingCollectionsParkCollectionOrder["ThingsToDoTitleAsc"] = "thingsToDoTitle_ASC";
    AccommodationGradeLinkingCollectionsParkCollectionOrder["ThingsToDoTitleDesc"] = "thingsToDoTitle_DESC";
    AccommodationGradeLinkingCollectionsParkCollectionOrder["TitleAsc"] = "title_ASC";
    AccommodationGradeLinkingCollectionsParkCollectionOrder["TitleDesc"] = "title_DESC";
})(AccommodationGradeLinkingCollectionsParkCollectionOrder = exports.AccommodationGradeLinkingCollectionsParkCollectionOrder || (exports.AccommodationGradeLinkingCollectionsParkCollectionOrder = {}));
var AccommodationGradeOrder;
(function (AccommodationGradeOrder) {
    AccommodationGradeOrder["AccessibleAsc"] = "accessible_ASC";
    AccommodationGradeOrder["AccessibleDesc"] = "accessible_DESC";
    AccommodationGradeOrder["IncludesTitleAsc"] = "includesTitle_ASC";
    AccommodationGradeOrder["IncludesTitleDesc"] = "includesTitle_DESC";
    AccommodationGradeOrder["NameAsc"] = "name_ASC";
    AccommodationGradeOrder["NameDesc"] = "name_DESC";
    AccommodationGradeOrder["SearchAccommodationGradeAsc"] = "searchAccommodationGrade_ASC";
    AccommodationGradeOrder["SearchAccommodationGradeDesc"] = "searchAccommodationGrade_DESC";
    AccommodationGradeOrder["SellingPointsTitleAsc"] = "sellingPointsTitle_ASC";
    AccommodationGradeOrder["SellingPointsTitleDesc"] = "sellingPointsTitle_DESC";
    AccommodationGradeOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AccommodationGradeOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AccommodationGradeOrder["SysIdAsc"] = "sys_id_ASC";
    AccommodationGradeOrder["SysIdDesc"] = "sys_id_DESC";
    AccommodationGradeOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AccommodationGradeOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AccommodationGradeOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AccommodationGradeOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    AccommodationGradeOrder["TaglineAsc"] = "tagline_ASC";
    AccommodationGradeOrder["TaglineDesc"] = "tagline_DESC";
})(AccommodationGradeOrder = exports.AccommodationGradeOrder || (exports.AccommodationGradeOrder = {}));
var AccommodationGradeSpacesCollectionOrder;
(function (AccommodationGradeSpacesCollectionOrder) {
    AccommodationGradeSpacesCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    AccommodationGradeSpacesCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    AccommodationGradeSpacesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AccommodationGradeSpacesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AccommodationGradeSpacesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    AccommodationGradeSpacesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    AccommodationGradeSpacesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AccommodationGradeSpacesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AccommodationGradeSpacesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AccommodationGradeSpacesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    AccommodationGradeSpacesCollectionOrder["TitleAsc"] = "title_ASC";
    AccommodationGradeSpacesCollectionOrder["TitleDesc"] = "title_DESC";
    AccommodationGradeSpacesCollectionOrder["UrlAsc"] = "url_ASC";
    AccommodationGradeSpacesCollectionOrder["UrlDesc"] = "url_DESC";
})(AccommodationGradeSpacesCollectionOrder = exports.AccommodationGradeSpacesCollectionOrder || (exports.AccommodationGradeSpacesCollectionOrder = {}));
var AccommodationGradeVideosCollectionOrder;
(function (AccommodationGradeVideosCollectionOrder) {
    AccommodationGradeVideosCollectionOrder["EmbeddedUrlAsc"] = "embeddedUrl_ASC";
    AccommodationGradeVideosCollectionOrder["EmbeddedUrlDesc"] = "embeddedUrl_DESC";
    AccommodationGradeVideosCollectionOrder["NameAsc"] = "name_ASC";
    AccommodationGradeVideosCollectionOrder["NameDesc"] = "name_DESC";
    AccommodationGradeVideosCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AccommodationGradeVideosCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AccommodationGradeVideosCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    AccommodationGradeVideosCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    AccommodationGradeVideosCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AccommodationGradeVideosCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AccommodationGradeVideosCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AccommodationGradeVideosCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    AccommodationGradeVideosCollectionOrder["TitleAsc"] = "title_ASC";
    AccommodationGradeVideosCollectionOrder["TitleDesc"] = "title_DESC";
})(AccommodationGradeVideosCollectionOrder = exports.AccommodationGradeVideosCollectionOrder || (exports.AccommodationGradeVideosCollectionOrder = {}));
var AccommodationTypeAccommodationGradesCollectionOrder;
(function (AccommodationTypeAccommodationGradesCollectionOrder) {
    AccommodationTypeAccommodationGradesCollectionOrder["AccessibleAsc"] = "accessible_ASC";
    AccommodationTypeAccommodationGradesCollectionOrder["AccessibleDesc"] = "accessible_DESC";
    AccommodationTypeAccommodationGradesCollectionOrder["IncludesTitleAsc"] = "includesTitle_ASC";
    AccommodationTypeAccommodationGradesCollectionOrder["IncludesTitleDesc"] = "includesTitle_DESC";
    AccommodationTypeAccommodationGradesCollectionOrder["NameAsc"] = "name_ASC";
    AccommodationTypeAccommodationGradesCollectionOrder["NameDesc"] = "name_DESC";
    AccommodationTypeAccommodationGradesCollectionOrder["SearchAccommodationGradeAsc"] = "searchAccommodationGrade_ASC";
    AccommodationTypeAccommodationGradesCollectionOrder["SearchAccommodationGradeDesc"] = "searchAccommodationGrade_DESC";
    AccommodationTypeAccommodationGradesCollectionOrder["SellingPointsTitleAsc"] = "sellingPointsTitle_ASC";
    AccommodationTypeAccommodationGradesCollectionOrder["SellingPointsTitleDesc"] = "sellingPointsTitle_DESC";
    AccommodationTypeAccommodationGradesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AccommodationTypeAccommodationGradesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AccommodationTypeAccommodationGradesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    AccommodationTypeAccommodationGradesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    AccommodationTypeAccommodationGradesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AccommodationTypeAccommodationGradesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AccommodationTypeAccommodationGradesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AccommodationTypeAccommodationGradesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    AccommodationTypeAccommodationGradesCollectionOrder["TaglineAsc"] = "tagline_ASC";
    AccommodationTypeAccommodationGradesCollectionOrder["TaglineDesc"] = "tagline_DESC";
})(AccommodationTypeAccommodationGradesCollectionOrder = exports.AccommodationTypeAccommodationGradesCollectionOrder || (exports.AccommodationTypeAccommodationGradesCollectionOrder = {}));
var AccommodationTypeChecklistCollectionOrder;
(function (AccommodationTypeChecklistCollectionOrder) {
    AccommodationTypeChecklistCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    AccommodationTypeChecklistCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    AccommodationTypeChecklistCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AccommodationTypeChecklistCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AccommodationTypeChecklistCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    AccommodationTypeChecklistCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    AccommodationTypeChecklistCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AccommodationTypeChecklistCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AccommodationTypeChecklistCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AccommodationTypeChecklistCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    AccommodationTypeChecklistCollectionOrder["TitleAsc"] = "title_ASC";
    AccommodationTypeChecklistCollectionOrder["TitleDesc"] = "title_DESC";
    AccommodationTypeChecklistCollectionOrder["UrlAsc"] = "url_ASC";
    AccommodationTypeChecklistCollectionOrder["UrlDesc"] = "url_DESC";
})(AccommodationTypeChecklistCollectionOrder = exports.AccommodationTypeChecklistCollectionOrder || (exports.AccommodationTypeChecklistCollectionOrder = {}));
var AccommodationTypeOrder;
(function (AccommodationTypeOrder) {
    AccommodationTypeOrder["ChecklistTitleAsc"] = "checklistTitle_ASC";
    AccommodationTypeOrder["ChecklistTitleDesc"] = "checklistTitle_DESC";
    AccommodationTypeOrder["NameAsc"] = "name_ASC";
    AccommodationTypeOrder["NameDesc"] = "name_DESC";
    AccommodationTypeOrder["PathAsc"] = "path_ASC";
    AccommodationTypeOrder["PathDesc"] = "path_DESC";
    AccommodationTypeOrder["SearchAccommodationNameAsc"] = "searchAccommodationName_ASC";
    AccommodationTypeOrder["SearchAccommodationNameDesc"] = "searchAccommodationName_DESC";
    AccommodationTypeOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AccommodationTypeOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AccommodationTypeOrder["SysIdAsc"] = "sys_id_ASC";
    AccommodationTypeOrder["SysIdDesc"] = "sys_id_DESC";
    AccommodationTypeOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AccommodationTypeOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AccommodationTypeOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AccommodationTypeOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    AccommodationTypeOrder["TitleAsc"] = "title_ASC";
    AccommodationTypeOrder["TitleDesc"] = "title_DESC";
})(AccommodationTypeOrder = exports.AccommodationTypeOrder || (exports.AccommodationTypeOrder = {}));
var AccommodationTypeSafetyMeasuresCollectionOrder;
(function (AccommodationTypeSafetyMeasuresCollectionOrder) {
    AccommodationTypeSafetyMeasuresCollectionOrder["NameAsc"] = "name_ASC";
    AccommodationTypeSafetyMeasuresCollectionOrder["NameDesc"] = "name_DESC";
    AccommodationTypeSafetyMeasuresCollectionOrder["PathAsc"] = "path_ASC";
    AccommodationTypeSafetyMeasuresCollectionOrder["PathDesc"] = "path_DESC";
    AccommodationTypeSafetyMeasuresCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AccommodationTypeSafetyMeasuresCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AccommodationTypeSafetyMeasuresCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    AccommodationTypeSafetyMeasuresCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    AccommodationTypeSafetyMeasuresCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AccommodationTypeSafetyMeasuresCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AccommodationTypeSafetyMeasuresCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AccommodationTypeSafetyMeasuresCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    AccommodationTypeSafetyMeasuresCollectionOrder["TitleAsc"] = "title_ASC";
    AccommodationTypeSafetyMeasuresCollectionOrder["TitleDesc"] = "title_DESC";
})(AccommodationTypeSafetyMeasuresCollectionOrder = exports.AccommodationTypeSafetyMeasuresCollectionOrder || (exports.AccommodationTypeSafetyMeasuresCollectionOrder = {}));
var AdvertLinkingCollectionsFullCampaignCollectionOrder;
(function (AdvertLinkingCollectionsFullCampaignCollectionOrder) {
    AdvertLinkingCollectionsFullCampaignCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    AdvertLinkingCollectionsFullCampaignCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    AdvertLinkingCollectionsFullCampaignCollectionOrder["FeaturedParksTitleAsc"] = "featuredParksTitle_ASC";
    AdvertLinkingCollectionsFullCampaignCollectionOrder["FeaturedParksTitleDesc"] = "featuredParksTitle_DESC";
    AdvertLinkingCollectionsFullCampaignCollectionOrder["FeaturedPromotionsTitleAsc"] = "featuredPromotionsTitle_ASC";
    AdvertLinkingCollectionsFullCampaignCollectionOrder["FeaturedPromotionsTitleDesc"] = "featuredPromotionsTitle_DESC";
    AdvertLinkingCollectionsFullCampaignCollectionOrder["IntroductionTitleAsc"] = "introductionTitle_ASC";
    AdvertLinkingCollectionsFullCampaignCollectionOrder["IntroductionTitleDesc"] = "introductionTitle_DESC";
    AdvertLinkingCollectionsFullCampaignCollectionOrder["NameAsc"] = "name_ASC";
    AdvertLinkingCollectionsFullCampaignCollectionOrder["NameDesc"] = "name_DESC";
    AdvertLinkingCollectionsFullCampaignCollectionOrder["PathAsc"] = "path_ASC";
    AdvertLinkingCollectionsFullCampaignCollectionOrder["PathDesc"] = "path_DESC";
    AdvertLinkingCollectionsFullCampaignCollectionOrder["PromotionsTitleAsc"] = "promotionsTitle_ASC";
    AdvertLinkingCollectionsFullCampaignCollectionOrder["PromotionsTitleDesc"] = "promotionsTitle_DESC";
    AdvertLinkingCollectionsFullCampaignCollectionOrder["ReasonsToBookTitleAsc"] = "reasonsToBookTitle_ASC";
    AdvertLinkingCollectionsFullCampaignCollectionOrder["ReasonsToBookTitleDesc"] = "reasonsToBookTitle_DESC";
    AdvertLinkingCollectionsFullCampaignCollectionOrder["SellingPointsTitleAsc"] = "sellingPointsTitle_ASC";
    AdvertLinkingCollectionsFullCampaignCollectionOrder["SellingPointsTitleDesc"] = "sellingPointsTitle_DESC";
    AdvertLinkingCollectionsFullCampaignCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AdvertLinkingCollectionsFullCampaignCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AdvertLinkingCollectionsFullCampaignCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    AdvertLinkingCollectionsFullCampaignCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    AdvertLinkingCollectionsFullCampaignCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AdvertLinkingCollectionsFullCampaignCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AdvertLinkingCollectionsFullCampaignCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AdvertLinkingCollectionsFullCampaignCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    AdvertLinkingCollectionsFullCampaignCollectionOrder["TitleAsc"] = "title_ASC";
    AdvertLinkingCollectionsFullCampaignCollectionOrder["TitleDesc"] = "title_DESC";
})(AdvertLinkingCollectionsFullCampaignCollectionOrder = exports.AdvertLinkingCollectionsFullCampaignCollectionOrder || (exports.AdvertLinkingCollectionsFullCampaignCollectionOrder = {}));
var AdvertLinkingCollectionsHomePageCollectionOrder;
(function (AdvertLinkingCollectionsHomePageCollectionOrder) {
    AdvertLinkingCollectionsHomePageCollectionOrder["DefaultHolidayNumberOfNightsAsc"] = "defaultHolidayNumberOfNights_ASC";
    AdvertLinkingCollectionsHomePageCollectionOrder["DefaultHolidayNumberOfNightsDesc"] = "defaultHolidayNumberOfNights_DESC";
    AdvertLinkingCollectionsHomePageCollectionOrder["NameAsc"] = "name_ASC";
    AdvertLinkingCollectionsHomePageCollectionOrder["NameDesc"] = "name_DESC";
    AdvertLinkingCollectionsHomePageCollectionOrder["PathAsc"] = "path_ASC";
    AdvertLinkingCollectionsHomePageCollectionOrder["PathDesc"] = "path_DESC";
    AdvertLinkingCollectionsHomePageCollectionOrder["SummaryTitleAsc"] = "summaryTitle_ASC";
    AdvertLinkingCollectionsHomePageCollectionOrder["SummaryTitleDesc"] = "summaryTitle_DESC";
    AdvertLinkingCollectionsHomePageCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AdvertLinkingCollectionsHomePageCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AdvertLinkingCollectionsHomePageCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    AdvertLinkingCollectionsHomePageCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    AdvertLinkingCollectionsHomePageCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AdvertLinkingCollectionsHomePageCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AdvertLinkingCollectionsHomePageCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AdvertLinkingCollectionsHomePageCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(AdvertLinkingCollectionsHomePageCollectionOrder = exports.AdvertLinkingCollectionsHomePageCollectionOrder || (exports.AdvertLinkingCollectionsHomePageCollectionOrder = {}));
var AdvertLinkingCollectionsParkCollectionOrder;
(function (AdvertLinkingCollectionsParkCollectionOrder) {
    AdvertLinkingCollectionsParkCollectionOrder["ContactNumberAsc"] = "contactNumber_ASC";
    AdvertLinkingCollectionsParkCollectionOrder["ContactNumberDesc"] = "contactNumber_DESC";
    AdvertLinkingCollectionsParkCollectionOrder["DirectionsUrlAsc"] = "directionsUrl_ASC";
    AdvertLinkingCollectionsParkCollectionOrder["DirectionsUrlDesc"] = "directionsUrl_DESC";
    AdvertLinkingCollectionsParkCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    AdvertLinkingCollectionsParkCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    AdvertLinkingCollectionsParkCollectionOrder["NameAsc"] = "name_ASC";
    AdvertLinkingCollectionsParkCollectionOrder["NameDesc"] = "name_DESC";
    AdvertLinkingCollectionsParkCollectionOrder["ParkTypeAsc"] = "parkType_ASC";
    AdvertLinkingCollectionsParkCollectionOrder["ParkTypeDesc"] = "parkType_DESC";
    AdvertLinkingCollectionsParkCollectionOrder["PathAsc"] = "path_ASC";
    AdvertLinkingCollectionsParkCollectionOrder["PathDesc"] = "path_DESC";
    AdvertLinkingCollectionsParkCollectionOrder["RunningCostsAsc"] = "runningCosts_ASC";
    AdvertLinkingCollectionsParkCollectionOrder["RunningCostsDesc"] = "runningCosts_DESC";
    AdvertLinkingCollectionsParkCollectionOrder["SiteFeesAsc"] = "siteFees_ASC";
    AdvertLinkingCollectionsParkCollectionOrder["SiteFeesDesc"] = "siteFees_DESC";
    AdvertLinkingCollectionsParkCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AdvertLinkingCollectionsParkCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AdvertLinkingCollectionsParkCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    AdvertLinkingCollectionsParkCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    AdvertLinkingCollectionsParkCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AdvertLinkingCollectionsParkCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AdvertLinkingCollectionsParkCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AdvertLinkingCollectionsParkCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    AdvertLinkingCollectionsParkCollectionOrder["TaglineAsc"] = "tagline_ASC";
    AdvertLinkingCollectionsParkCollectionOrder["TaglineDesc"] = "tagline_DESC";
    AdvertLinkingCollectionsParkCollectionOrder["ThingsToDoTitleAsc"] = "thingsToDoTitle_ASC";
    AdvertLinkingCollectionsParkCollectionOrder["ThingsToDoTitleDesc"] = "thingsToDoTitle_DESC";
    AdvertLinkingCollectionsParkCollectionOrder["TitleAsc"] = "title_ASC";
    AdvertLinkingCollectionsParkCollectionOrder["TitleDesc"] = "title_DESC";
})(AdvertLinkingCollectionsParkCollectionOrder = exports.AdvertLinkingCollectionsParkCollectionOrder || (exports.AdvertLinkingCollectionsParkCollectionOrder = {}));
var AdvertLinkingCollectionsPropositionCategoryCollectionOrder;
(function (AdvertLinkingCollectionsPropositionCategoryCollectionOrder) {
    AdvertLinkingCollectionsPropositionCategoryCollectionOrder["CtaTitleAsc"] = "ctaTitle_ASC";
    AdvertLinkingCollectionsPropositionCategoryCollectionOrder["CtaTitleDesc"] = "ctaTitle_DESC";
    AdvertLinkingCollectionsPropositionCategoryCollectionOrder["CtaUrlAsc"] = "ctaUrl_ASC";
    AdvertLinkingCollectionsPropositionCategoryCollectionOrder["CtaUrlDesc"] = "ctaUrl_DESC";
    AdvertLinkingCollectionsPropositionCategoryCollectionOrder["FeaturedParksTitleAsc"] = "featuredParksTitle_ASC";
    AdvertLinkingCollectionsPropositionCategoryCollectionOrder["FeaturedParksTitleDesc"] = "featuredParksTitle_DESC";
    AdvertLinkingCollectionsPropositionCategoryCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    AdvertLinkingCollectionsPropositionCategoryCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    AdvertLinkingCollectionsPropositionCategoryCollectionOrder["NameAsc"] = "name_ASC";
    AdvertLinkingCollectionsPropositionCategoryCollectionOrder["NameDesc"] = "name_DESC";
    AdvertLinkingCollectionsPropositionCategoryCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AdvertLinkingCollectionsPropositionCategoryCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AdvertLinkingCollectionsPropositionCategoryCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    AdvertLinkingCollectionsPropositionCategoryCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    AdvertLinkingCollectionsPropositionCategoryCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AdvertLinkingCollectionsPropositionCategoryCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AdvertLinkingCollectionsPropositionCategoryCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AdvertLinkingCollectionsPropositionCategoryCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(AdvertLinkingCollectionsPropositionCategoryCollectionOrder = exports.AdvertLinkingCollectionsPropositionCategoryCollectionOrder || (exports.AdvertLinkingCollectionsPropositionCategoryCollectionOrder = {}));
var AdvertOrder;
(function (AdvertOrder) {
    AdvertOrder["AnalyticsCategoryAsc"] = "analyticsCategory_ASC";
    AdvertOrder["AnalyticsCategoryDesc"] = "analyticsCategory_DESC";
    AdvertOrder["AnalyticsTypeAsc"] = "analyticsType_ASC";
    AdvertOrder["AnalyticsTypeDesc"] = "analyticsType_DESC";
    AdvertOrder["AnalyticsVariantAsc"] = "analyticsVariant_ASC";
    AdvertOrder["AnalyticsVariantDesc"] = "analyticsVariant_DESC";
    AdvertOrder["CtaAsc"] = "cta_ASC";
    AdvertOrder["CtaDesc"] = "cta_DESC";
    AdvertOrder["DescriptionAsc"] = "description_ASC";
    AdvertOrder["DescriptionDesc"] = "description_DESC";
    AdvertOrder["SubTitleAsc"] = "subTitle_ASC";
    AdvertOrder["SubTitleDesc"] = "subTitle_DESC";
    AdvertOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AdvertOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AdvertOrder["SysIdAsc"] = "sys_id_ASC";
    AdvertOrder["SysIdDesc"] = "sys_id_DESC";
    AdvertOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AdvertOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AdvertOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AdvertOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    AdvertOrder["TitleAsc"] = "title_ASC";
    AdvertOrder["TitleDesc"] = "title_DESC";
    AdvertOrder["UrlAsc"] = "url_ASC";
    AdvertOrder["UrlDesc"] = "url_DESC";
})(AdvertOrder = exports.AdvertOrder || (exports.AdvertOrder = {}));
var AllParkPageOrder;
(function (AllParkPageOrder) {
    AllParkPageOrder["NameAsc"] = "name_ASC";
    AllParkPageOrder["NameDesc"] = "name_DESC";
    AllParkPageOrder["PathAsc"] = "path_ASC";
    AllParkPageOrder["PathDesc"] = "path_DESC";
    AllParkPageOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AllParkPageOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AllParkPageOrder["SysIdAsc"] = "sys_id_ASC";
    AllParkPageOrder["SysIdDesc"] = "sys_id_DESC";
    AllParkPageOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AllParkPageOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AllParkPageOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AllParkPageOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    AllParkPageOrder["TitleAsc"] = "title_ASC";
    AllParkPageOrder["TitleDesc"] = "title_DESC";
    AllParkPageOrder["TypeOfParkPageAsc"] = "typeOfParkPage_ASC";
    AllParkPageOrder["TypeOfParkPageDesc"] = "typeOfParkPage_DESC";
})(AllParkPageOrder = exports.AllParkPageOrder || (exports.AllParkPageOrder = {}));
var ArticleHubArticleHubSectionsCollectionOrder;
(function (ArticleHubArticleHubSectionsCollectionOrder) {
    ArticleHubArticleHubSectionsCollectionOrder["PathAsc"] = "path_ASC";
    ArticleHubArticleHubSectionsCollectionOrder["PathDesc"] = "path_DESC";
    ArticleHubArticleHubSectionsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ArticleHubArticleHubSectionsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ArticleHubArticleHubSectionsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ArticleHubArticleHubSectionsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ArticleHubArticleHubSectionsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ArticleHubArticleHubSectionsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ArticleHubArticleHubSectionsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ArticleHubArticleHubSectionsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ArticleHubArticleHubSectionsCollectionOrder["TitleAsc"] = "title_ASC";
    ArticleHubArticleHubSectionsCollectionOrder["TitleDesc"] = "title_DESC";
})(ArticleHubArticleHubSectionsCollectionOrder = exports.ArticleHubArticleHubSectionsCollectionOrder || (exports.ArticleHubArticleHubSectionsCollectionOrder = {}));
var ArticleHubOrder;
(function (ArticleHubOrder) {
    ArticleHubOrder["PathAsc"] = "path_ASC";
    ArticleHubOrder["PathDesc"] = "path_DESC";
    ArticleHubOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ArticleHubOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ArticleHubOrder["SysIdAsc"] = "sys_id_ASC";
    ArticleHubOrder["SysIdDesc"] = "sys_id_DESC";
    ArticleHubOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ArticleHubOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ArticleHubOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ArticleHubOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ArticleHubOrder["TitleAsc"] = "title_ASC";
    ArticleHubOrder["TitleDesc"] = "title_DESC";
})(ArticleHubOrder = exports.ArticleHubOrder || (exports.ArticleHubOrder = {}));
var ArticleHubSectionArticlesCollectionOrder;
(function (ArticleHubSectionArticlesCollectionOrder) {
    ArticleHubSectionArticlesCollectionOrder["ArticleSummaryAsc"] = "articleSummary_ASC";
    ArticleHubSectionArticlesCollectionOrder["ArticleSummaryDesc"] = "articleSummary_DESC";
    ArticleHubSectionArticlesCollectionOrder["AuthorAsc"] = "author_ASC";
    ArticleHubSectionArticlesCollectionOrder["AuthorDesc"] = "author_DESC";
    ArticleHubSectionArticlesCollectionOrder["HolidayTypeAsc"] = "holidayType_ASC";
    ArticleHubSectionArticlesCollectionOrder["HolidayTypeDesc"] = "holidayType_DESC";
    ArticleHubSectionArticlesCollectionOrder["NameAsc"] = "name_ASC";
    ArticleHubSectionArticlesCollectionOrder["NameDesc"] = "name_DESC";
    ArticleHubSectionArticlesCollectionOrder["PathAsc"] = "path_ASC";
    ArticleHubSectionArticlesCollectionOrder["PathDesc"] = "path_DESC";
    ArticleHubSectionArticlesCollectionOrder["RelatedArticlesTitleAsc"] = "relatedArticlesTitle_ASC";
    ArticleHubSectionArticlesCollectionOrder["RelatedArticlesTitleDesc"] = "relatedArticlesTitle_DESC";
    ArticleHubSectionArticlesCollectionOrder["ShowTableOfContentsAsc"] = "showTableOfContents_ASC";
    ArticleHubSectionArticlesCollectionOrder["ShowTableOfContentsDesc"] = "showTableOfContents_DESC";
    ArticleHubSectionArticlesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ArticleHubSectionArticlesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ArticleHubSectionArticlesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ArticleHubSectionArticlesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ArticleHubSectionArticlesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ArticleHubSectionArticlesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ArticleHubSectionArticlesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ArticleHubSectionArticlesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ArticleHubSectionArticlesCollectionOrder["TitleAsc"] = "title_ASC";
    ArticleHubSectionArticlesCollectionOrder["TitleDesc"] = "title_DESC";
})(ArticleHubSectionArticlesCollectionOrder = exports.ArticleHubSectionArticlesCollectionOrder || (exports.ArticleHubSectionArticlesCollectionOrder = {}));
var ArticleHubSectionLinkingCollectionsArticleHubCollectionOrder;
(function (ArticleHubSectionLinkingCollectionsArticleHubCollectionOrder) {
    ArticleHubSectionLinkingCollectionsArticleHubCollectionOrder["PathAsc"] = "path_ASC";
    ArticleHubSectionLinkingCollectionsArticleHubCollectionOrder["PathDesc"] = "path_DESC";
    ArticleHubSectionLinkingCollectionsArticleHubCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ArticleHubSectionLinkingCollectionsArticleHubCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ArticleHubSectionLinkingCollectionsArticleHubCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ArticleHubSectionLinkingCollectionsArticleHubCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ArticleHubSectionLinkingCollectionsArticleHubCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ArticleHubSectionLinkingCollectionsArticleHubCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ArticleHubSectionLinkingCollectionsArticleHubCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ArticleHubSectionLinkingCollectionsArticleHubCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ArticleHubSectionLinkingCollectionsArticleHubCollectionOrder["TitleAsc"] = "title_ASC";
    ArticleHubSectionLinkingCollectionsArticleHubCollectionOrder["TitleDesc"] = "title_DESC";
})(ArticleHubSectionLinkingCollectionsArticleHubCollectionOrder = exports.ArticleHubSectionLinkingCollectionsArticleHubCollectionOrder || (exports.ArticleHubSectionLinkingCollectionsArticleHubCollectionOrder = {}));
var ArticleHubSectionOrder;
(function (ArticleHubSectionOrder) {
    ArticleHubSectionOrder["PathAsc"] = "path_ASC";
    ArticleHubSectionOrder["PathDesc"] = "path_DESC";
    ArticleHubSectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ArticleHubSectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ArticleHubSectionOrder["SysIdAsc"] = "sys_id_ASC";
    ArticleHubSectionOrder["SysIdDesc"] = "sys_id_DESC";
    ArticleHubSectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ArticleHubSectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ArticleHubSectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ArticleHubSectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ArticleHubSectionOrder["TitleAsc"] = "title_ASC";
    ArticleHubSectionOrder["TitleDesc"] = "title_DESC";
})(ArticleHubSectionOrder = exports.ArticleHubSectionOrder || (exports.ArticleHubSectionOrder = {}));
var ArticleSectionLinkingCollectionsArticlesCollectionOrder;
(function (ArticleSectionLinkingCollectionsArticlesCollectionOrder) {
    ArticleSectionLinkingCollectionsArticlesCollectionOrder["ArticleSummaryAsc"] = "articleSummary_ASC";
    ArticleSectionLinkingCollectionsArticlesCollectionOrder["ArticleSummaryDesc"] = "articleSummary_DESC";
    ArticleSectionLinkingCollectionsArticlesCollectionOrder["AuthorAsc"] = "author_ASC";
    ArticleSectionLinkingCollectionsArticlesCollectionOrder["AuthorDesc"] = "author_DESC";
    ArticleSectionLinkingCollectionsArticlesCollectionOrder["HolidayTypeAsc"] = "holidayType_ASC";
    ArticleSectionLinkingCollectionsArticlesCollectionOrder["HolidayTypeDesc"] = "holidayType_DESC";
    ArticleSectionLinkingCollectionsArticlesCollectionOrder["NameAsc"] = "name_ASC";
    ArticleSectionLinkingCollectionsArticlesCollectionOrder["NameDesc"] = "name_DESC";
    ArticleSectionLinkingCollectionsArticlesCollectionOrder["PathAsc"] = "path_ASC";
    ArticleSectionLinkingCollectionsArticlesCollectionOrder["PathDesc"] = "path_DESC";
    ArticleSectionLinkingCollectionsArticlesCollectionOrder["RelatedArticlesTitleAsc"] = "relatedArticlesTitle_ASC";
    ArticleSectionLinkingCollectionsArticlesCollectionOrder["RelatedArticlesTitleDesc"] = "relatedArticlesTitle_DESC";
    ArticleSectionLinkingCollectionsArticlesCollectionOrder["ShowTableOfContentsAsc"] = "showTableOfContents_ASC";
    ArticleSectionLinkingCollectionsArticlesCollectionOrder["ShowTableOfContentsDesc"] = "showTableOfContents_DESC";
    ArticleSectionLinkingCollectionsArticlesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ArticleSectionLinkingCollectionsArticlesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ArticleSectionLinkingCollectionsArticlesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ArticleSectionLinkingCollectionsArticlesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ArticleSectionLinkingCollectionsArticlesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ArticleSectionLinkingCollectionsArticlesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ArticleSectionLinkingCollectionsArticlesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ArticleSectionLinkingCollectionsArticlesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ArticleSectionLinkingCollectionsArticlesCollectionOrder["TitleAsc"] = "title_ASC";
    ArticleSectionLinkingCollectionsArticlesCollectionOrder["TitleDesc"] = "title_DESC";
})(ArticleSectionLinkingCollectionsArticlesCollectionOrder = exports.ArticleSectionLinkingCollectionsArticlesCollectionOrder || (exports.ArticleSectionLinkingCollectionsArticlesCollectionOrder = {}));
var ArticleSectionOrder;
(function (ArticleSectionOrder) {
    ArticleSectionOrder["CoordinatesAsc"] = "coordinates_ASC";
    ArticleSectionOrder["CoordinatesDesc"] = "coordinates_DESC";
    ArticleSectionOrder["NameAsc"] = "name_ASC";
    ArticleSectionOrder["NameDesc"] = "name_DESC";
    ArticleSectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ArticleSectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ArticleSectionOrder["SysIdAsc"] = "sys_id_ASC";
    ArticleSectionOrder["SysIdDesc"] = "sys_id_DESC";
    ArticleSectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ArticleSectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ArticleSectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ArticleSectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ArticleSectionOrder["TitleAsc"] = "title_ASC";
    ArticleSectionOrder["TitleDesc"] = "title_DESC";
})(ArticleSectionOrder = exports.ArticleSectionOrder || (exports.ArticleSectionOrder = {}));
var ArticlesLinkingCollectionsArticleHubCollectionOrder;
(function (ArticlesLinkingCollectionsArticleHubCollectionOrder) {
    ArticlesLinkingCollectionsArticleHubCollectionOrder["PathAsc"] = "path_ASC";
    ArticlesLinkingCollectionsArticleHubCollectionOrder["PathDesc"] = "path_DESC";
    ArticlesLinkingCollectionsArticleHubCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ArticlesLinkingCollectionsArticleHubCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ArticlesLinkingCollectionsArticleHubCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ArticlesLinkingCollectionsArticleHubCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ArticlesLinkingCollectionsArticleHubCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ArticlesLinkingCollectionsArticleHubCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ArticlesLinkingCollectionsArticleHubCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ArticlesLinkingCollectionsArticleHubCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ArticlesLinkingCollectionsArticleHubCollectionOrder["TitleAsc"] = "title_ASC";
    ArticlesLinkingCollectionsArticleHubCollectionOrder["TitleDesc"] = "title_DESC";
})(ArticlesLinkingCollectionsArticleHubCollectionOrder = exports.ArticlesLinkingCollectionsArticleHubCollectionOrder || (exports.ArticlesLinkingCollectionsArticleHubCollectionOrder = {}));
var ArticlesLinkingCollectionsArticleHubSectionCollectionOrder;
(function (ArticlesLinkingCollectionsArticleHubSectionCollectionOrder) {
    ArticlesLinkingCollectionsArticleHubSectionCollectionOrder["PathAsc"] = "path_ASC";
    ArticlesLinkingCollectionsArticleHubSectionCollectionOrder["PathDesc"] = "path_DESC";
    ArticlesLinkingCollectionsArticleHubSectionCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ArticlesLinkingCollectionsArticleHubSectionCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ArticlesLinkingCollectionsArticleHubSectionCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ArticlesLinkingCollectionsArticleHubSectionCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ArticlesLinkingCollectionsArticleHubSectionCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ArticlesLinkingCollectionsArticleHubSectionCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ArticlesLinkingCollectionsArticleHubSectionCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ArticlesLinkingCollectionsArticleHubSectionCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ArticlesLinkingCollectionsArticleHubSectionCollectionOrder["TitleAsc"] = "title_ASC";
    ArticlesLinkingCollectionsArticleHubSectionCollectionOrder["TitleDesc"] = "title_DESC";
})(ArticlesLinkingCollectionsArticleHubSectionCollectionOrder = exports.ArticlesLinkingCollectionsArticleHubSectionCollectionOrder || (exports.ArticlesLinkingCollectionsArticleHubSectionCollectionOrder = {}));
var ArticlesLinkingCollectionsPromotionComponentCollectionOrder;
(function (ArticlesLinkingCollectionsPromotionComponentCollectionOrder) {
    ArticlesLinkingCollectionsPromotionComponentCollectionOrder["NameAsc"] = "name_ASC";
    ArticlesLinkingCollectionsPromotionComponentCollectionOrder["NameDesc"] = "name_DESC";
    ArticlesLinkingCollectionsPromotionComponentCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ArticlesLinkingCollectionsPromotionComponentCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ArticlesLinkingCollectionsPromotionComponentCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ArticlesLinkingCollectionsPromotionComponentCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ArticlesLinkingCollectionsPromotionComponentCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ArticlesLinkingCollectionsPromotionComponentCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ArticlesLinkingCollectionsPromotionComponentCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ArticlesLinkingCollectionsPromotionComponentCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(ArticlesLinkingCollectionsPromotionComponentCollectionOrder = exports.ArticlesLinkingCollectionsPromotionComponentCollectionOrder || (exports.ArticlesLinkingCollectionsPromotionComponentCollectionOrder = {}));
var ArticlesOrder;
(function (ArticlesOrder) {
    ArticlesOrder["ArticleSummaryAsc"] = "articleSummary_ASC";
    ArticlesOrder["ArticleSummaryDesc"] = "articleSummary_DESC";
    ArticlesOrder["AuthorAsc"] = "author_ASC";
    ArticlesOrder["AuthorDesc"] = "author_DESC";
    ArticlesOrder["HolidayTypeAsc"] = "holidayType_ASC";
    ArticlesOrder["HolidayTypeDesc"] = "holidayType_DESC";
    ArticlesOrder["NameAsc"] = "name_ASC";
    ArticlesOrder["NameDesc"] = "name_DESC";
    ArticlesOrder["PathAsc"] = "path_ASC";
    ArticlesOrder["PathDesc"] = "path_DESC";
    ArticlesOrder["RelatedArticlesTitleAsc"] = "relatedArticlesTitle_ASC";
    ArticlesOrder["RelatedArticlesTitleDesc"] = "relatedArticlesTitle_DESC";
    ArticlesOrder["ShowTableOfContentsAsc"] = "showTableOfContents_ASC";
    ArticlesOrder["ShowTableOfContentsDesc"] = "showTableOfContents_DESC";
    ArticlesOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ArticlesOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ArticlesOrder["SysIdAsc"] = "sys_id_ASC";
    ArticlesOrder["SysIdDesc"] = "sys_id_DESC";
    ArticlesOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ArticlesOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ArticlesOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ArticlesOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ArticlesOrder["TitleAsc"] = "title_ASC";
    ArticlesOrder["TitleDesc"] = "title_DESC";
})(ArticlesOrder = exports.ArticlesOrder || (exports.ArticlesOrder = {}));
var ArticlesTermsAndConditionsCollectionOrder;
(function (ArticlesTermsAndConditionsCollectionOrder) {
    ArticlesTermsAndConditionsCollectionOrder["HolidayTypeAsc"] = "holidayType_ASC";
    ArticlesTermsAndConditionsCollectionOrder["HolidayTypeDesc"] = "holidayType_DESC";
    ArticlesTermsAndConditionsCollectionOrder["NameAsc"] = "name_ASC";
    ArticlesTermsAndConditionsCollectionOrder["NameDesc"] = "name_DESC";
    ArticlesTermsAndConditionsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ArticlesTermsAndConditionsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ArticlesTermsAndConditionsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ArticlesTermsAndConditionsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ArticlesTermsAndConditionsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ArticlesTermsAndConditionsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ArticlesTermsAndConditionsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ArticlesTermsAndConditionsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(ArticlesTermsAndConditionsCollectionOrder = exports.ArticlesTermsAndConditionsCollectionOrder || (exports.ArticlesTermsAndConditionsCollectionOrder = {}));
var AssetOrder;
(function (AssetOrder) {
    AssetOrder["ContentTypeAsc"] = "contentType_ASC";
    AssetOrder["ContentTypeDesc"] = "contentType_DESC";
    AssetOrder["FileNameAsc"] = "fileName_ASC";
    AssetOrder["FileNameDesc"] = "fileName_DESC";
    AssetOrder["HeightAsc"] = "height_ASC";
    AssetOrder["HeightDesc"] = "height_DESC";
    AssetOrder["SizeAsc"] = "size_ASC";
    AssetOrder["SizeDesc"] = "size_DESC";
    AssetOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AssetOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AssetOrder["SysIdAsc"] = "sys_id_ASC";
    AssetOrder["SysIdDesc"] = "sys_id_DESC";
    AssetOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AssetOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AssetOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AssetOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    AssetOrder["UrlAsc"] = "url_ASC";
    AssetOrder["UrlDesc"] = "url_DESC";
    AssetOrder["WidthAsc"] = "width_ASC";
    AssetOrder["WidthDesc"] = "width_DESC";
})(AssetOrder = exports.AssetOrder || (exports.AssetOrder = {}));
var AwardLinkingCollectionsParkCollectionOrder;
(function (AwardLinkingCollectionsParkCollectionOrder) {
    AwardLinkingCollectionsParkCollectionOrder["ContactNumberAsc"] = "contactNumber_ASC";
    AwardLinkingCollectionsParkCollectionOrder["ContactNumberDesc"] = "contactNumber_DESC";
    AwardLinkingCollectionsParkCollectionOrder["DirectionsUrlAsc"] = "directionsUrl_ASC";
    AwardLinkingCollectionsParkCollectionOrder["DirectionsUrlDesc"] = "directionsUrl_DESC";
    AwardLinkingCollectionsParkCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    AwardLinkingCollectionsParkCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    AwardLinkingCollectionsParkCollectionOrder["NameAsc"] = "name_ASC";
    AwardLinkingCollectionsParkCollectionOrder["NameDesc"] = "name_DESC";
    AwardLinkingCollectionsParkCollectionOrder["ParkTypeAsc"] = "parkType_ASC";
    AwardLinkingCollectionsParkCollectionOrder["ParkTypeDesc"] = "parkType_DESC";
    AwardLinkingCollectionsParkCollectionOrder["PathAsc"] = "path_ASC";
    AwardLinkingCollectionsParkCollectionOrder["PathDesc"] = "path_DESC";
    AwardLinkingCollectionsParkCollectionOrder["RunningCostsAsc"] = "runningCosts_ASC";
    AwardLinkingCollectionsParkCollectionOrder["RunningCostsDesc"] = "runningCosts_DESC";
    AwardLinkingCollectionsParkCollectionOrder["SiteFeesAsc"] = "siteFees_ASC";
    AwardLinkingCollectionsParkCollectionOrder["SiteFeesDesc"] = "siteFees_DESC";
    AwardLinkingCollectionsParkCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AwardLinkingCollectionsParkCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AwardLinkingCollectionsParkCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    AwardLinkingCollectionsParkCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    AwardLinkingCollectionsParkCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AwardLinkingCollectionsParkCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AwardLinkingCollectionsParkCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AwardLinkingCollectionsParkCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    AwardLinkingCollectionsParkCollectionOrder["TaglineAsc"] = "tagline_ASC";
    AwardLinkingCollectionsParkCollectionOrder["TaglineDesc"] = "tagline_DESC";
    AwardLinkingCollectionsParkCollectionOrder["ThingsToDoTitleAsc"] = "thingsToDoTitle_ASC";
    AwardLinkingCollectionsParkCollectionOrder["ThingsToDoTitleDesc"] = "thingsToDoTitle_DESC";
    AwardLinkingCollectionsParkCollectionOrder["TitleAsc"] = "title_ASC";
    AwardLinkingCollectionsParkCollectionOrder["TitleDesc"] = "title_DESC";
})(AwardLinkingCollectionsParkCollectionOrder = exports.AwardLinkingCollectionsParkCollectionOrder || (exports.AwardLinkingCollectionsParkCollectionOrder = {}));
var AwardOrder;
(function (AwardOrder) {
    AwardOrder["InternalNameAsc"] = "internalName_ASC";
    AwardOrder["InternalNameDesc"] = "internalName_DESC";
    AwardOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AwardOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AwardOrder["SysIdAsc"] = "sys_id_ASC";
    AwardOrder["SysIdDesc"] = "sys_id_DESC";
    AwardOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AwardOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AwardOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AwardOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    AwardOrder["TitleAsc"] = "title_ASC";
    AwardOrder["TitleDesc"] = "title_DESC";
    AwardOrder["UrlAsc"] = "url_ASC";
    AwardOrder["UrlDesc"] = "url_DESC";
})(AwardOrder = exports.AwardOrder || (exports.AwardOrder = {}));
var BoxLinkingCollectionsCaravanTypeByParkCollectionOrder;
(function (BoxLinkingCollectionsCaravanTypeByParkCollectionOrder) {
    BoxLinkingCollectionsCaravanTypeByParkCollectionOrder["ContentfulNameAsc"] = "contentfulName_ASC";
    BoxLinkingCollectionsCaravanTypeByParkCollectionOrder["ContentfulNameDesc"] = "contentfulName_DESC";
    BoxLinkingCollectionsCaravanTypeByParkCollectionOrder["DisplayNameAsc"] = "displayName_ASC";
    BoxLinkingCollectionsCaravanTypeByParkCollectionOrder["DisplayNameDesc"] = "displayName_DESC";
    BoxLinkingCollectionsCaravanTypeByParkCollectionOrder["MatterportIdAsc"] = "matterportId_ASC";
    BoxLinkingCollectionsCaravanTypeByParkCollectionOrder["MatterportIdDesc"] = "matterportId_DESC";
    BoxLinkingCollectionsCaravanTypeByParkCollectionOrder["SubTitleAsc"] = "subTitle_ASC";
    BoxLinkingCollectionsCaravanTypeByParkCollectionOrder["SubTitleDesc"] = "subTitle_DESC";
    BoxLinkingCollectionsCaravanTypeByParkCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    BoxLinkingCollectionsCaravanTypeByParkCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    BoxLinkingCollectionsCaravanTypeByParkCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    BoxLinkingCollectionsCaravanTypeByParkCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    BoxLinkingCollectionsCaravanTypeByParkCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    BoxLinkingCollectionsCaravanTypeByParkCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    BoxLinkingCollectionsCaravanTypeByParkCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    BoxLinkingCollectionsCaravanTypeByParkCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    BoxLinkingCollectionsCaravanTypeByParkCollectionOrder["TitleAsc"] = "title_ASC";
    BoxLinkingCollectionsCaravanTypeByParkCollectionOrder["TitleDesc"] = "title_DESC";
})(BoxLinkingCollectionsCaravanTypeByParkCollectionOrder = exports.BoxLinkingCollectionsCaravanTypeByParkCollectionOrder || (exports.BoxLinkingCollectionsCaravanTypeByParkCollectionOrder = {}));
var BoxLinkingCollectionsCaravanTypesCollectionOrder;
(function (BoxLinkingCollectionsCaravanTypesCollectionOrder) {
    BoxLinkingCollectionsCaravanTypesCollectionOrder["CaravanCodeAsc"] = "caravanCode_ASC";
    BoxLinkingCollectionsCaravanTypesCollectionOrder["CaravanCodeDesc"] = "caravanCode_DESC";
    BoxLinkingCollectionsCaravanTypesCollectionOrder["ContentfulNameAsc"] = "contentfulName_ASC";
    BoxLinkingCollectionsCaravanTypesCollectionOrder["ContentfulNameDesc"] = "contentfulName_DESC";
    BoxLinkingCollectionsCaravanTypesCollectionOrder["MatterportIdAsc"] = "matterportId_ASC";
    BoxLinkingCollectionsCaravanTypesCollectionOrder["MatterportIdDesc"] = "matterportId_DESC";
    BoxLinkingCollectionsCaravanTypesCollectionOrder["NameAsc"] = "name_ASC";
    BoxLinkingCollectionsCaravanTypesCollectionOrder["NameDesc"] = "name_DESC";
    BoxLinkingCollectionsCaravanTypesCollectionOrder["SubTitleAsc"] = "subTitle_ASC";
    BoxLinkingCollectionsCaravanTypesCollectionOrder["SubTitleDesc"] = "subTitle_DESC";
    BoxLinkingCollectionsCaravanTypesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    BoxLinkingCollectionsCaravanTypesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    BoxLinkingCollectionsCaravanTypesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    BoxLinkingCollectionsCaravanTypesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    BoxLinkingCollectionsCaravanTypesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    BoxLinkingCollectionsCaravanTypesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    BoxLinkingCollectionsCaravanTypesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    BoxLinkingCollectionsCaravanTypesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    BoxLinkingCollectionsCaravanTypesCollectionOrder["TitleAsc"] = "title_ASC";
    BoxLinkingCollectionsCaravanTypesCollectionOrder["TitleDesc"] = "title_DESC";
})(BoxLinkingCollectionsCaravanTypesCollectionOrder = exports.BoxLinkingCollectionsCaravanTypesCollectionOrder || (exports.BoxLinkingCollectionsCaravanTypesCollectionOrder = {}));
var BoxLinkingCollectionsPitchTypeCollectionOrder;
(function (BoxLinkingCollectionsPitchTypeCollectionOrder) {
    BoxLinkingCollectionsPitchTypeCollectionOrder["NameAsc"] = "name_ASC";
    BoxLinkingCollectionsPitchTypeCollectionOrder["NameDesc"] = "name_DESC";
    BoxLinkingCollectionsPitchTypeCollectionOrder["PitchCodeAsc"] = "pitchCode_ASC";
    BoxLinkingCollectionsPitchTypeCollectionOrder["PitchCodeDesc"] = "pitchCode_DESC";
    BoxLinkingCollectionsPitchTypeCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    BoxLinkingCollectionsPitchTypeCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    BoxLinkingCollectionsPitchTypeCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    BoxLinkingCollectionsPitchTypeCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    BoxLinkingCollectionsPitchTypeCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    BoxLinkingCollectionsPitchTypeCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    BoxLinkingCollectionsPitchTypeCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    BoxLinkingCollectionsPitchTypeCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    BoxLinkingCollectionsPitchTypeCollectionOrder["TitleAsc"] = "title_ASC";
    BoxLinkingCollectionsPitchTypeCollectionOrder["TitleDesc"] = "title_DESC";
})(BoxLinkingCollectionsPitchTypeCollectionOrder = exports.BoxLinkingCollectionsPitchTypeCollectionOrder || (exports.BoxLinkingCollectionsPitchTypeCollectionOrder = {}));
var BoxOrder;
(function (BoxOrder) {
    BoxOrder["DescriptionUrlAsc"] = "descriptionUrl_ASC";
    BoxOrder["DescriptionUrlDesc"] = "descriptionUrl_DESC";
    BoxOrder["HrefAsc"] = "href_ASC";
    BoxOrder["HrefDesc"] = "href_DESC";
    BoxOrder["NameAsc"] = "name_ASC";
    BoxOrder["NameDesc"] = "name_DESC";
    BoxOrder["ShowOnPagesAsc"] = "showOnPages_ASC";
    BoxOrder["ShowOnPagesDesc"] = "showOnPages_DESC";
    BoxOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    BoxOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    BoxOrder["SysIdAsc"] = "sys_id_ASC";
    BoxOrder["SysIdDesc"] = "sys_id_DESC";
    BoxOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    BoxOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    BoxOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    BoxOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    BoxOrder["TitleLevelAsc"] = "titleLevel_ASC";
    BoxOrder["TitleLevelDesc"] = "titleLevel_DESC";
    BoxOrder["TitleAsc"] = "title_ASC";
    BoxOrder["TitleDesc"] = "title_DESC";
})(BoxOrder = exports.BoxOrder || (exports.BoxOrder = {}));
var CaravanTypeByParkCaravanFeaturesCollectionOrder;
(function (CaravanTypeByParkCaravanFeaturesCollectionOrder) {
    CaravanTypeByParkCaravanFeaturesCollectionOrder["DescriptionUrlAsc"] = "descriptionUrl_ASC";
    CaravanTypeByParkCaravanFeaturesCollectionOrder["DescriptionUrlDesc"] = "descriptionUrl_DESC";
    CaravanTypeByParkCaravanFeaturesCollectionOrder["HrefAsc"] = "href_ASC";
    CaravanTypeByParkCaravanFeaturesCollectionOrder["HrefDesc"] = "href_DESC";
    CaravanTypeByParkCaravanFeaturesCollectionOrder["NameAsc"] = "name_ASC";
    CaravanTypeByParkCaravanFeaturesCollectionOrder["NameDesc"] = "name_DESC";
    CaravanTypeByParkCaravanFeaturesCollectionOrder["ShowOnPagesAsc"] = "showOnPages_ASC";
    CaravanTypeByParkCaravanFeaturesCollectionOrder["ShowOnPagesDesc"] = "showOnPages_DESC";
    CaravanTypeByParkCaravanFeaturesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    CaravanTypeByParkCaravanFeaturesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    CaravanTypeByParkCaravanFeaturesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    CaravanTypeByParkCaravanFeaturesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    CaravanTypeByParkCaravanFeaturesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    CaravanTypeByParkCaravanFeaturesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    CaravanTypeByParkCaravanFeaturesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    CaravanTypeByParkCaravanFeaturesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    CaravanTypeByParkCaravanFeaturesCollectionOrder["TitleLevelAsc"] = "titleLevel_ASC";
    CaravanTypeByParkCaravanFeaturesCollectionOrder["TitleLevelDesc"] = "titleLevel_DESC";
    CaravanTypeByParkCaravanFeaturesCollectionOrder["TitleAsc"] = "title_ASC";
    CaravanTypeByParkCaravanFeaturesCollectionOrder["TitleDesc"] = "title_DESC";
})(CaravanTypeByParkCaravanFeaturesCollectionOrder = exports.CaravanTypeByParkCaravanFeaturesCollectionOrder || (exports.CaravanTypeByParkCaravanFeaturesCollectionOrder = {}));
var CaravanTypeByParkCaravanImagesCollectionOrder;
(function (CaravanTypeByParkCaravanImagesCollectionOrder) {
    CaravanTypeByParkCaravanImagesCollectionOrder["AltTextAsc"] = "altText_ASC";
    CaravanTypeByParkCaravanImagesCollectionOrder["AltTextDesc"] = "altText_DESC";
    CaravanTypeByParkCaravanImagesCollectionOrder["CaptionOptionalAsc"] = "captionOptional_ASC";
    CaravanTypeByParkCaravanImagesCollectionOrder["CaptionOptionalDesc"] = "captionOptional_DESC";
    CaravanTypeByParkCaravanImagesCollectionOrder["FocusAreaAsc"] = "focusArea_ASC";
    CaravanTypeByParkCaravanImagesCollectionOrder["FocusAreaDesc"] = "focusArea_DESC";
    CaravanTypeByParkCaravanImagesCollectionOrder["NameAsc"] = "name_ASC";
    CaravanTypeByParkCaravanImagesCollectionOrder["NameDesc"] = "name_DESC";
    CaravanTypeByParkCaravanImagesCollectionOrder["SubHeadingAsc"] = "subHeading_ASC";
    CaravanTypeByParkCaravanImagesCollectionOrder["SubHeadingDesc"] = "subHeading_DESC";
    CaravanTypeByParkCaravanImagesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    CaravanTypeByParkCaravanImagesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    CaravanTypeByParkCaravanImagesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    CaravanTypeByParkCaravanImagesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    CaravanTypeByParkCaravanImagesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    CaravanTypeByParkCaravanImagesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    CaravanTypeByParkCaravanImagesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    CaravanTypeByParkCaravanImagesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(CaravanTypeByParkCaravanImagesCollectionOrder = exports.CaravanTypeByParkCaravanImagesCollectionOrder || (exports.CaravanTypeByParkCaravanImagesCollectionOrder = {}));
var CaravanTypeByParkLinkingCollectionsCaravanTypesCollectionOrder;
(function (CaravanTypeByParkLinkingCollectionsCaravanTypesCollectionOrder) {
    CaravanTypeByParkLinkingCollectionsCaravanTypesCollectionOrder["CaravanCodeAsc"] = "caravanCode_ASC";
    CaravanTypeByParkLinkingCollectionsCaravanTypesCollectionOrder["CaravanCodeDesc"] = "caravanCode_DESC";
    CaravanTypeByParkLinkingCollectionsCaravanTypesCollectionOrder["ContentfulNameAsc"] = "contentfulName_ASC";
    CaravanTypeByParkLinkingCollectionsCaravanTypesCollectionOrder["ContentfulNameDesc"] = "contentfulName_DESC";
    CaravanTypeByParkLinkingCollectionsCaravanTypesCollectionOrder["MatterportIdAsc"] = "matterportId_ASC";
    CaravanTypeByParkLinkingCollectionsCaravanTypesCollectionOrder["MatterportIdDesc"] = "matterportId_DESC";
    CaravanTypeByParkLinkingCollectionsCaravanTypesCollectionOrder["NameAsc"] = "name_ASC";
    CaravanTypeByParkLinkingCollectionsCaravanTypesCollectionOrder["NameDesc"] = "name_DESC";
    CaravanTypeByParkLinkingCollectionsCaravanTypesCollectionOrder["SubTitleAsc"] = "subTitle_ASC";
    CaravanTypeByParkLinkingCollectionsCaravanTypesCollectionOrder["SubTitleDesc"] = "subTitle_DESC";
    CaravanTypeByParkLinkingCollectionsCaravanTypesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    CaravanTypeByParkLinkingCollectionsCaravanTypesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    CaravanTypeByParkLinkingCollectionsCaravanTypesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    CaravanTypeByParkLinkingCollectionsCaravanTypesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    CaravanTypeByParkLinkingCollectionsCaravanTypesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    CaravanTypeByParkLinkingCollectionsCaravanTypesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    CaravanTypeByParkLinkingCollectionsCaravanTypesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    CaravanTypeByParkLinkingCollectionsCaravanTypesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    CaravanTypeByParkLinkingCollectionsCaravanTypesCollectionOrder["TitleAsc"] = "title_ASC";
    CaravanTypeByParkLinkingCollectionsCaravanTypesCollectionOrder["TitleDesc"] = "title_DESC";
})(CaravanTypeByParkLinkingCollectionsCaravanTypesCollectionOrder = exports.CaravanTypeByParkLinkingCollectionsCaravanTypesCollectionOrder || (exports.CaravanTypeByParkLinkingCollectionsCaravanTypesCollectionOrder = {}));
var CaravanTypeByParkOrder;
(function (CaravanTypeByParkOrder) {
    CaravanTypeByParkOrder["ContentfulNameAsc"] = "contentfulName_ASC";
    CaravanTypeByParkOrder["ContentfulNameDesc"] = "contentfulName_DESC";
    CaravanTypeByParkOrder["DisplayNameAsc"] = "displayName_ASC";
    CaravanTypeByParkOrder["DisplayNameDesc"] = "displayName_DESC";
    CaravanTypeByParkOrder["MatterportIdAsc"] = "matterportId_ASC";
    CaravanTypeByParkOrder["MatterportIdDesc"] = "matterportId_DESC";
    CaravanTypeByParkOrder["SubTitleAsc"] = "subTitle_ASC";
    CaravanTypeByParkOrder["SubTitleDesc"] = "subTitle_DESC";
    CaravanTypeByParkOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    CaravanTypeByParkOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    CaravanTypeByParkOrder["SysIdAsc"] = "sys_id_ASC";
    CaravanTypeByParkOrder["SysIdDesc"] = "sys_id_DESC";
    CaravanTypeByParkOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    CaravanTypeByParkOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    CaravanTypeByParkOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    CaravanTypeByParkOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    CaravanTypeByParkOrder["TitleAsc"] = "title_ASC";
    CaravanTypeByParkOrder["TitleDesc"] = "title_DESC";
})(CaravanTypeByParkOrder = exports.CaravanTypeByParkOrder || (exports.CaravanTypeByParkOrder = {}));
var CaravanTypesCaravanFeaturesCollectionOrder;
(function (CaravanTypesCaravanFeaturesCollectionOrder) {
    CaravanTypesCaravanFeaturesCollectionOrder["DescriptionUrlAsc"] = "descriptionUrl_ASC";
    CaravanTypesCaravanFeaturesCollectionOrder["DescriptionUrlDesc"] = "descriptionUrl_DESC";
    CaravanTypesCaravanFeaturesCollectionOrder["HrefAsc"] = "href_ASC";
    CaravanTypesCaravanFeaturesCollectionOrder["HrefDesc"] = "href_DESC";
    CaravanTypesCaravanFeaturesCollectionOrder["NameAsc"] = "name_ASC";
    CaravanTypesCaravanFeaturesCollectionOrder["NameDesc"] = "name_DESC";
    CaravanTypesCaravanFeaturesCollectionOrder["ShowOnPagesAsc"] = "showOnPages_ASC";
    CaravanTypesCaravanFeaturesCollectionOrder["ShowOnPagesDesc"] = "showOnPages_DESC";
    CaravanTypesCaravanFeaturesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    CaravanTypesCaravanFeaturesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    CaravanTypesCaravanFeaturesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    CaravanTypesCaravanFeaturesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    CaravanTypesCaravanFeaturesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    CaravanTypesCaravanFeaturesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    CaravanTypesCaravanFeaturesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    CaravanTypesCaravanFeaturesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    CaravanTypesCaravanFeaturesCollectionOrder["TitleLevelAsc"] = "titleLevel_ASC";
    CaravanTypesCaravanFeaturesCollectionOrder["TitleLevelDesc"] = "titleLevel_DESC";
    CaravanTypesCaravanFeaturesCollectionOrder["TitleAsc"] = "title_ASC";
    CaravanTypesCaravanFeaturesCollectionOrder["TitleDesc"] = "title_DESC";
})(CaravanTypesCaravanFeaturesCollectionOrder = exports.CaravanTypesCaravanFeaturesCollectionOrder || (exports.CaravanTypesCaravanFeaturesCollectionOrder = {}));
var CaravanTypesCaravanImagesCollectionOrder;
(function (CaravanTypesCaravanImagesCollectionOrder) {
    CaravanTypesCaravanImagesCollectionOrder["AltTextAsc"] = "altText_ASC";
    CaravanTypesCaravanImagesCollectionOrder["AltTextDesc"] = "altText_DESC";
    CaravanTypesCaravanImagesCollectionOrder["CaptionOptionalAsc"] = "captionOptional_ASC";
    CaravanTypesCaravanImagesCollectionOrder["CaptionOptionalDesc"] = "captionOptional_DESC";
    CaravanTypesCaravanImagesCollectionOrder["FocusAreaAsc"] = "focusArea_ASC";
    CaravanTypesCaravanImagesCollectionOrder["FocusAreaDesc"] = "focusArea_DESC";
    CaravanTypesCaravanImagesCollectionOrder["NameAsc"] = "name_ASC";
    CaravanTypesCaravanImagesCollectionOrder["NameDesc"] = "name_DESC";
    CaravanTypesCaravanImagesCollectionOrder["SubHeadingAsc"] = "subHeading_ASC";
    CaravanTypesCaravanImagesCollectionOrder["SubHeadingDesc"] = "subHeading_DESC";
    CaravanTypesCaravanImagesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    CaravanTypesCaravanImagesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    CaravanTypesCaravanImagesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    CaravanTypesCaravanImagesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    CaravanTypesCaravanImagesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    CaravanTypesCaravanImagesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    CaravanTypesCaravanImagesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    CaravanTypesCaravanImagesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(CaravanTypesCaravanImagesCollectionOrder = exports.CaravanTypesCaravanImagesCollectionOrder || (exports.CaravanTypesCaravanImagesCollectionOrder = {}));
var CaravanTypesCaravansByParkCollectionOrder;
(function (CaravanTypesCaravansByParkCollectionOrder) {
    CaravanTypesCaravansByParkCollectionOrder["ContentfulNameAsc"] = "contentfulName_ASC";
    CaravanTypesCaravansByParkCollectionOrder["ContentfulNameDesc"] = "contentfulName_DESC";
    CaravanTypesCaravansByParkCollectionOrder["DisplayNameAsc"] = "displayName_ASC";
    CaravanTypesCaravansByParkCollectionOrder["DisplayNameDesc"] = "displayName_DESC";
    CaravanTypesCaravansByParkCollectionOrder["MatterportIdAsc"] = "matterportId_ASC";
    CaravanTypesCaravansByParkCollectionOrder["MatterportIdDesc"] = "matterportId_DESC";
    CaravanTypesCaravansByParkCollectionOrder["SubTitleAsc"] = "subTitle_ASC";
    CaravanTypesCaravansByParkCollectionOrder["SubTitleDesc"] = "subTitle_DESC";
    CaravanTypesCaravansByParkCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    CaravanTypesCaravansByParkCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    CaravanTypesCaravansByParkCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    CaravanTypesCaravansByParkCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    CaravanTypesCaravansByParkCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    CaravanTypesCaravansByParkCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    CaravanTypesCaravansByParkCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    CaravanTypesCaravansByParkCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    CaravanTypesCaravansByParkCollectionOrder["TitleAsc"] = "title_ASC";
    CaravanTypesCaravansByParkCollectionOrder["TitleDesc"] = "title_DESC";
})(CaravanTypesCaravansByParkCollectionOrder = exports.CaravanTypesCaravansByParkCollectionOrder || (exports.CaravanTypesCaravansByParkCollectionOrder = {}));
var CaravanTypesOrder;
(function (CaravanTypesOrder) {
    CaravanTypesOrder["CaravanCodeAsc"] = "caravanCode_ASC";
    CaravanTypesOrder["CaravanCodeDesc"] = "caravanCode_DESC";
    CaravanTypesOrder["ContentfulNameAsc"] = "contentfulName_ASC";
    CaravanTypesOrder["ContentfulNameDesc"] = "contentfulName_DESC";
    CaravanTypesOrder["MatterportIdAsc"] = "matterportId_ASC";
    CaravanTypesOrder["MatterportIdDesc"] = "matterportId_DESC";
    CaravanTypesOrder["NameAsc"] = "name_ASC";
    CaravanTypesOrder["NameDesc"] = "name_DESC";
    CaravanTypesOrder["SubTitleAsc"] = "subTitle_ASC";
    CaravanTypesOrder["SubTitleDesc"] = "subTitle_DESC";
    CaravanTypesOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    CaravanTypesOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    CaravanTypesOrder["SysIdAsc"] = "sys_id_ASC";
    CaravanTypesOrder["SysIdDesc"] = "sys_id_DESC";
    CaravanTypesOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    CaravanTypesOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    CaravanTypesOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    CaravanTypesOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    CaravanTypesOrder["TitleAsc"] = "title_ASC";
    CaravanTypesOrder["TitleDesc"] = "title_DESC";
})(CaravanTypesOrder = exports.CaravanTypesOrder || (exports.CaravanTypesOrder = {}));
var CyhhParkFacilityFacilitiesCollectionOrder;
(function (CyhhParkFacilityFacilitiesCollectionOrder) {
    CyhhParkFacilityFacilitiesCollectionOrder["ApiIdAsc"] = "apiId_ASC";
    CyhhParkFacilityFacilitiesCollectionOrder["ApiIdDesc"] = "apiId_DESC";
    CyhhParkFacilityFacilitiesCollectionOrder["DateIntroducedAsc"] = "dateIntroduced_ASC";
    CyhhParkFacilityFacilitiesCollectionOrder["DateIntroducedDesc"] = "dateIntroduced_DESC";
    CyhhParkFacilityFacilitiesCollectionOrder["NameAsc"] = "name_ASC";
    CyhhParkFacilityFacilitiesCollectionOrder["NameDesc"] = "name_DESC";
    CyhhParkFacilityFacilitiesCollectionOrder["PropositionTypeAsc"] = "propositionType_ASC";
    CyhhParkFacilityFacilitiesCollectionOrder["PropositionTypeDesc"] = "propositionType_DESC";
    CyhhParkFacilityFacilitiesCollectionOrder["ShortTitleAsc"] = "shortTitle_ASC";
    CyhhParkFacilityFacilitiesCollectionOrder["ShortTitleDesc"] = "shortTitle_DESC";
    CyhhParkFacilityFacilitiesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    CyhhParkFacilityFacilitiesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    CyhhParkFacilityFacilitiesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    CyhhParkFacilityFacilitiesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    CyhhParkFacilityFacilitiesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    CyhhParkFacilityFacilitiesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    CyhhParkFacilityFacilitiesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    CyhhParkFacilityFacilitiesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    CyhhParkFacilityFacilitiesCollectionOrder["TitleAsc"] = "title_ASC";
    CyhhParkFacilityFacilitiesCollectionOrder["TitleDesc"] = "title_DESC";
    CyhhParkFacilityFacilitiesCollectionOrder["UrlAsc"] = "url_ASC";
    CyhhParkFacilityFacilitiesCollectionOrder["UrlDesc"] = "url_DESC";
})(CyhhParkFacilityFacilitiesCollectionOrder = exports.CyhhParkFacilityFacilitiesCollectionOrder || (exports.CyhhParkFacilityFacilitiesCollectionOrder = {}));
var CyhhParkFacilityOrder;
(function (CyhhParkFacilityOrder) {
    CyhhParkFacilityOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    CyhhParkFacilityOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    CyhhParkFacilityOrder["SysIdAsc"] = "sys_id_ASC";
    CyhhParkFacilityOrder["SysIdDesc"] = "sys_id_DESC";
    CyhhParkFacilityOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    CyhhParkFacilityOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    CyhhParkFacilityOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    CyhhParkFacilityOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    CyhhParkFacilityOrder["TitleAsc"] = "title_ASC";
    CyhhParkFacilityOrder["TitleDesc"] = "title_DESC";
})(CyhhParkFacilityOrder = exports.CyhhParkFacilityOrder || (exports.CyhhParkFacilityOrder = {}));
var EntryOrder;
(function (EntryOrder) {
    EntryOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    EntryOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    EntryOrder["SysIdAsc"] = "sys_id_ASC";
    EntryOrder["SysIdDesc"] = "sys_id_DESC";
    EntryOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    EntryOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    EntryOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    EntryOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(EntryOrder = exports.EntryOrder || (exports.EntryOrder = {}));
var ExtraBundleOrder;
(function (ExtraBundleOrder) {
    ExtraBundleOrder["AllowUserModifyAsc"] = "allowUserModify_ASC";
    ExtraBundleOrder["AllowUserModifyDesc"] = "allowUserModify_DESC";
    ExtraBundleOrder["ConditionalQuantityAsc"] = "conditionalQuantity_ASC";
    ExtraBundleOrder["ConditionalQuantityDesc"] = "conditionalQuantity_DESC";
    ExtraBundleOrder["ExtraIdAsc"] = "extraId_ASC";
    ExtraBundleOrder["ExtraIdDesc"] = "extraId_DESC";
    ExtraBundleOrder["InvoiceIdAsc"] = "invoiceId_ASC";
    ExtraBundleOrder["InvoiceIdDesc"] = "invoiceId_DESC";
    ExtraBundleOrder["InvoiceOnlyAsc"] = "invoiceOnly_ASC";
    ExtraBundleOrder["InvoiceOnlyDesc"] = "invoiceOnly_DESC";
    ExtraBundleOrder["MaxQuantityAsc"] = "maxQuantity_ASC";
    ExtraBundleOrder["MaxQuantityDesc"] = "maxQuantity_DESC";
    ExtraBundleOrder["PriceDescriptionAsc"] = "priceDescription_ASC";
    ExtraBundleOrder["PriceDescriptionDesc"] = "priceDescription_DESC";
    ExtraBundleOrder["RankAsc"] = "rank_ASC";
    ExtraBundleOrder["RankDesc"] = "rank_DESC";
    ExtraBundleOrder["SelectTypeAsc"] = "selectType_ASC";
    ExtraBundleOrder["SelectTypeDesc"] = "selectType_DESC";
    ExtraBundleOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ExtraBundleOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ExtraBundleOrder["SysIdAsc"] = "sys_id_ASC";
    ExtraBundleOrder["SysIdDesc"] = "sys_id_DESC";
    ExtraBundleOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ExtraBundleOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ExtraBundleOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ExtraBundleOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ExtraBundleOrder["TitleAsc"] = "title_ASC";
    ExtraBundleOrder["TitleDesc"] = "title_DESC";
})(ExtraBundleOrder = exports.ExtraBundleOrder || (exports.ExtraBundleOrder = {}));
var ExtraOrder;
(function (ExtraOrder) {
    ExtraOrder["AllowUserModifyAsc"] = "allowUserModify_ASC";
    ExtraOrder["AllowUserModifyDesc"] = "allowUserModify_DESC";
    ExtraOrder["ConditionalQuantityAsc"] = "conditionalQuantity_ASC";
    ExtraOrder["ConditionalQuantityDesc"] = "conditionalQuantity_DESC";
    ExtraOrder["ExtraIdAsc"] = "extraId_ASC";
    ExtraOrder["ExtraIdDesc"] = "extraId_DESC";
    ExtraOrder["InvoiceIdAsc"] = "invoiceId_ASC";
    ExtraOrder["InvoiceIdDesc"] = "invoiceId_DESC";
    ExtraOrder["InvoiceOnlyAsc"] = "invoiceOnly_ASC";
    ExtraOrder["InvoiceOnlyDesc"] = "invoiceOnly_DESC";
    ExtraOrder["MaxQuantityAsc"] = "maxQuantity_ASC";
    ExtraOrder["MaxQuantityDesc"] = "maxQuantity_DESC";
    ExtraOrder["PriceDescriptionAsc"] = "priceDescription_ASC";
    ExtraOrder["PriceDescriptionDesc"] = "priceDescription_DESC";
    ExtraOrder["RankAsc"] = "rank_ASC";
    ExtraOrder["RankDesc"] = "rank_DESC";
    ExtraOrder["SelectTypeAsc"] = "selectType_ASC";
    ExtraOrder["SelectTypeDesc"] = "selectType_DESC";
    ExtraOrder["ShortDescriptionAsc"] = "short_description_ASC";
    ExtraOrder["ShortDescriptionDesc"] = "short_description_DESC";
    ExtraOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ExtraOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ExtraOrder["SysIdAsc"] = "sys_id_ASC";
    ExtraOrder["SysIdDesc"] = "sys_id_DESC";
    ExtraOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ExtraOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ExtraOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ExtraOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(ExtraOrder = exports.ExtraOrder || (exports.ExtraOrder = {}));
var FaqLinkingCollectionsFullCampaignCollectionOrder;
(function (FaqLinkingCollectionsFullCampaignCollectionOrder) {
    FaqLinkingCollectionsFullCampaignCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    FaqLinkingCollectionsFullCampaignCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    FaqLinkingCollectionsFullCampaignCollectionOrder["FeaturedParksTitleAsc"] = "featuredParksTitle_ASC";
    FaqLinkingCollectionsFullCampaignCollectionOrder["FeaturedParksTitleDesc"] = "featuredParksTitle_DESC";
    FaqLinkingCollectionsFullCampaignCollectionOrder["FeaturedPromotionsTitleAsc"] = "featuredPromotionsTitle_ASC";
    FaqLinkingCollectionsFullCampaignCollectionOrder["FeaturedPromotionsTitleDesc"] = "featuredPromotionsTitle_DESC";
    FaqLinkingCollectionsFullCampaignCollectionOrder["IntroductionTitleAsc"] = "introductionTitle_ASC";
    FaqLinkingCollectionsFullCampaignCollectionOrder["IntroductionTitleDesc"] = "introductionTitle_DESC";
    FaqLinkingCollectionsFullCampaignCollectionOrder["NameAsc"] = "name_ASC";
    FaqLinkingCollectionsFullCampaignCollectionOrder["NameDesc"] = "name_DESC";
    FaqLinkingCollectionsFullCampaignCollectionOrder["PathAsc"] = "path_ASC";
    FaqLinkingCollectionsFullCampaignCollectionOrder["PathDesc"] = "path_DESC";
    FaqLinkingCollectionsFullCampaignCollectionOrder["PromotionsTitleAsc"] = "promotionsTitle_ASC";
    FaqLinkingCollectionsFullCampaignCollectionOrder["PromotionsTitleDesc"] = "promotionsTitle_DESC";
    FaqLinkingCollectionsFullCampaignCollectionOrder["ReasonsToBookTitleAsc"] = "reasonsToBookTitle_ASC";
    FaqLinkingCollectionsFullCampaignCollectionOrder["ReasonsToBookTitleDesc"] = "reasonsToBookTitle_DESC";
    FaqLinkingCollectionsFullCampaignCollectionOrder["SellingPointsTitleAsc"] = "sellingPointsTitle_ASC";
    FaqLinkingCollectionsFullCampaignCollectionOrder["SellingPointsTitleDesc"] = "sellingPointsTitle_DESC";
    FaqLinkingCollectionsFullCampaignCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    FaqLinkingCollectionsFullCampaignCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    FaqLinkingCollectionsFullCampaignCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    FaqLinkingCollectionsFullCampaignCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    FaqLinkingCollectionsFullCampaignCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    FaqLinkingCollectionsFullCampaignCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    FaqLinkingCollectionsFullCampaignCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    FaqLinkingCollectionsFullCampaignCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    FaqLinkingCollectionsFullCampaignCollectionOrder["TitleAsc"] = "title_ASC";
    FaqLinkingCollectionsFullCampaignCollectionOrder["TitleDesc"] = "title_DESC";
})(FaqLinkingCollectionsFullCampaignCollectionOrder = exports.FaqLinkingCollectionsFullCampaignCollectionOrder || (exports.FaqLinkingCollectionsFullCampaignCollectionOrder = {}));
var FaqLinkingCollectionsParkCollectionOrder;
(function (FaqLinkingCollectionsParkCollectionOrder) {
    FaqLinkingCollectionsParkCollectionOrder["ContactNumberAsc"] = "contactNumber_ASC";
    FaqLinkingCollectionsParkCollectionOrder["ContactNumberDesc"] = "contactNumber_DESC";
    FaqLinkingCollectionsParkCollectionOrder["DirectionsUrlAsc"] = "directionsUrl_ASC";
    FaqLinkingCollectionsParkCollectionOrder["DirectionsUrlDesc"] = "directionsUrl_DESC";
    FaqLinkingCollectionsParkCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    FaqLinkingCollectionsParkCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    FaqLinkingCollectionsParkCollectionOrder["NameAsc"] = "name_ASC";
    FaqLinkingCollectionsParkCollectionOrder["NameDesc"] = "name_DESC";
    FaqLinkingCollectionsParkCollectionOrder["ParkTypeAsc"] = "parkType_ASC";
    FaqLinkingCollectionsParkCollectionOrder["ParkTypeDesc"] = "parkType_DESC";
    FaqLinkingCollectionsParkCollectionOrder["PathAsc"] = "path_ASC";
    FaqLinkingCollectionsParkCollectionOrder["PathDesc"] = "path_DESC";
    FaqLinkingCollectionsParkCollectionOrder["RunningCostsAsc"] = "runningCosts_ASC";
    FaqLinkingCollectionsParkCollectionOrder["RunningCostsDesc"] = "runningCosts_DESC";
    FaqLinkingCollectionsParkCollectionOrder["SiteFeesAsc"] = "siteFees_ASC";
    FaqLinkingCollectionsParkCollectionOrder["SiteFeesDesc"] = "siteFees_DESC";
    FaqLinkingCollectionsParkCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    FaqLinkingCollectionsParkCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    FaqLinkingCollectionsParkCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    FaqLinkingCollectionsParkCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    FaqLinkingCollectionsParkCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    FaqLinkingCollectionsParkCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    FaqLinkingCollectionsParkCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    FaqLinkingCollectionsParkCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    FaqLinkingCollectionsParkCollectionOrder["TaglineAsc"] = "tagline_ASC";
    FaqLinkingCollectionsParkCollectionOrder["TaglineDesc"] = "tagline_DESC";
    FaqLinkingCollectionsParkCollectionOrder["ThingsToDoTitleAsc"] = "thingsToDoTitle_ASC";
    FaqLinkingCollectionsParkCollectionOrder["ThingsToDoTitleDesc"] = "thingsToDoTitle_DESC";
    FaqLinkingCollectionsParkCollectionOrder["TitleAsc"] = "title_ASC";
    FaqLinkingCollectionsParkCollectionOrder["TitleDesc"] = "title_DESC";
})(FaqLinkingCollectionsParkCollectionOrder = exports.FaqLinkingCollectionsParkCollectionOrder || (exports.FaqLinkingCollectionsParkCollectionOrder = {}));
var FaqLinkingCollectionsPropositionCollectionOrder;
(function (FaqLinkingCollectionsPropositionCollectionOrder) {
    FaqLinkingCollectionsPropositionCollectionOrder["FaqFolderIdAsc"] = "faqFolderId_ASC";
    FaqLinkingCollectionsPropositionCollectionOrder["FaqFolderIdDesc"] = "faqFolderId_DESC";
    FaqLinkingCollectionsPropositionCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    FaqLinkingCollectionsPropositionCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    FaqLinkingCollectionsPropositionCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    FaqLinkingCollectionsPropositionCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    FaqLinkingCollectionsPropositionCollectionOrder["NameAsc"] = "name_ASC";
    FaqLinkingCollectionsPropositionCollectionOrder["NameDesc"] = "name_DESC";
    FaqLinkingCollectionsPropositionCollectionOrder["PathAsc"] = "path_ASC";
    FaqLinkingCollectionsPropositionCollectionOrder["PathDesc"] = "path_DESC";
    FaqLinkingCollectionsPropositionCollectionOrder["RelatedArticlesTitleAsc"] = "relatedArticlesTitle_ASC";
    FaqLinkingCollectionsPropositionCollectionOrder["RelatedArticlesTitleDesc"] = "relatedArticlesTitle_DESC";
    FaqLinkingCollectionsPropositionCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    FaqLinkingCollectionsPropositionCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    FaqLinkingCollectionsPropositionCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    FaqLinkingCollectionsPropositionCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    FaqLinkingCollectionsPropositionCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    FaqLinkingCollectionsPropositionCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    FaqLinkingCollectionsPropositionCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    FaqLinkingCollectionsPropositionCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    FaqLinkingCollectionsPropositionCollectionOrder["TagLineAsc"] = "tagLine_ASC";
    FaqLinkingCollectionsPropositionCollectionOrder["TagLineDesc"] = "tagLine_DESC";
    FaqLinkingCollectionsPropositionCollectionOrder["TitleAsc"] = "title_ASC";
    FaqLinkingCollectionsPropositionCollectionOrder["TitleDesc"] = "title_DESC";
})(FaqLinkingCollectionsPropositionCollectionOrder = exports.FaqLinkingCollectionsPropositionCollectionOrder || (exports.FaqLinkingCollectionsPropositionCollectionOrder = {}));
var FaqLinkingCollectionsRegionCollectionOrder;
(function (FaqLinkingCollectionsRegionCollectionOrder) {
    FaqLinkingCollectionsRegionCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    FaqLinkingCollectionsRegionCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    FaqLinkingCollectionsRegionCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    FaqLinkingCollectionsRegionCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    FaqLinkingCollectionsRegionCollectionOrder["NameAsc"] = "name_ASC";
    FaqLinkingCollectionsRegionCollectionOrder["NameDesc"] = "name_DESC";
    FaqLinkingCollectionsRegionCollectionOrder["NearbyTownCitiesTitleAsc"] = "nearbyTownCitiesTitle_ASC";
    FaqLinkingCollectionsRegionCollectionOrder["NearbyTownCitiesTitleDesc"] = "nearbyTownCitiesTitle_DESC";
    FaqLinkingCollectionsRegionCollectionOrder["PageTypeAsc"] = "pageType_ASC";
    FaqLinkingCollectionsRegionCollectionOrder["PageTypeDesc"] = "pageType_DESC";
    FaqLinkingCollectionsRegionCollectionOrder["PathAsc"] = "path_ASC";
    FaqLinkingCollectionsRegionCollectionOrder["PathDesc"] = "path_DESC";
    FaqLinkingCollectionsRegionCollectionOrder["RegionCodeAsc"] = "regionCode_ASC";
    FaqLinkingCollectionsRegionCollectionOrder["RegionCodeDesc"] = "regionCode_DESC";
    FaqLinkingCollectionsRegionCollectionOrder["RelatedArticlesTitleAsc"] = "relatedArticlesTitle_ASC";
    FaqLinkingCollectionsRegionCollectionOrder["RelatedArticlesTitleDesc"] = "relatedArticlesTitle_DESC";
    FaqLinkingCollectionsRegionCollectionOrder["SearchTitleAsc"] = "searchTitle_ASC";
    FaqLinkingCollectionsRegionCollectionOrder["SearchTitleDesc"] = "searchTitle_DESC";
    FaqLinkingCollectionsRegionCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    FaqLinkingCollectionsRegionCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    FaqLinkingCollectionsRegionCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    FaqLinkingCollectionsRegionCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    FaqLinkingCollectionsRegionCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    FaqLinkingCollectionsRegionCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    FaqLinkingCollectionsRegionCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    FaqLinkingCollectionsRegionCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    FaqLinkingCollectionsRegionCollectionOrder["ThingsToDoTitleAsc"] = "thingsToDoTitle_ASC";
    FaqLinkingCollectionsRegionCollectionOrder["ThingsToDoTitleDesc"] = "thingsToDoTitle_DESC";
    FaqLinkingCollectionsRegionCollectionOrder["TitleAsc"] = "title_ASC";
    FaqLinkingCollectionsRegionCollectionOrder["TitleDesc"] = "title_DESC";
})(FaqLinkingCollectionsRegionCollectionOrder = exports.FaqLinkingCollectionsRegionCollectionOrder || (exports.FaqLinkingCollectionsRegionCollectionOrder = {}));
var FaqOrder;
(function (FaqOrder) {
    FaqOrder["QuestionAsc"] = "question_ASC";
    FaqOrder["QuestionDesc"] = "question_DESC";
    FaqOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    FaqOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    FaqOrder["SysIdAsc"] = "sys_id_ASC";
    FaqOrder["SysIdDesc"] = "sys_id_DESC";
    FaqOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    FaqOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    FaqOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    FaqOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(FaqOrder = exports.FaqOrder || (exports.FaqOrder = {}));
var FocusParkListOrder;
(function (FocusParkListOrder) {
    FocusParkListOrder["InternalNameAsc"] = "internalName_ASC";
    FocusParkListOrder["InternalNameDesc"] = "internalName_DESC";
    FocusParkListOrder["ParkTypeAsc"] = "parkType_ASC";
    FocusParkListOrder["ParkTypeDesc"] = "parkType_DESC";
    FocusParkListOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    FocusParkListOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    FocusParkListOrder["SysIdAsc"] = "sys_id_ASC";
    FocusParkListOrder["SysIdDesc"] = "sys_id_DESC";
    FocusParkListOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    FocusParkListOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    FocusParkListOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    FocusParkListOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    FocusParkListOrder["TitleAsc"] = "title_ASC";
    FocusParkListOrder["TitleDesc"] = "title_DESC";
})(FocusParkListOrder = exports.FocusParkListOrder || (exports.FocusParkListOrder = {}));
var FocusParkListParksCollectionOrder;
(function (FocusParkListParksCollectionOrder) {
    FocusParkListParksCollectionOrder["ContactNumberAsc"] = "contactNumber_ASC";
    FocusParkListParksCollectionOrder["ContactNumberDesc"] = "contactNumber_DESC";
    FocusParkListParksCollectionOrder["DirectionsUrlAsc"] = "directionsUrl_ASC";
    FocusParkListParksCollectionOrder["DirectionsUrlDesc"] = "directionsUrl_DESC";
    FocusParkListParksCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    FocusParkListParksCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    FocusParkListParksCollectionOrder["NameAsc"] = "name_ASC";
    FocusParkListParksCollectionOrder["NameDesc"] = "name_DESC";
    FocusParkListParksCollectionOrder["ParkTypeAsc"] = "parkType_ASC";
    FocusParkListParksCollectionOrder["ParkTypeDesc"] = "parkType_DESC";
    FocusParkListParksCollectionOrder["PathAsc"] = "path_ASC";
    FocusParkListParksCollectionOrder["PathDesc"] = "path_DESC";
    FocusParkListParksCollectionOrder["RunningCostsAsc"] = "runningCosts_ASC";
    FocusParkListParksCollectionOrder["RunningCostsDesc"] = "runningCosts_DESC";
    FocusParkListParksCollectionOrder["SiteFeesAsc"] = "siteFees_ASC";
    FocusParkListParksCollectionOrder["SiteFeesDesc"] = "siteFees_DESC";
    FocusParkListParksCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    FocusParkListParksCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    FocusParkListParksCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    FocusParkListParksCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    FocusParkListParksCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    FocusParkListParksCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    FocusParkListParksCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    FocusParkListParksCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    FocusParkListParksCollectionOrder["TaglineAsc"] = "tagline_ASC";
    FocusParkListParksCollectionOrder["TaglineDesc"] = "tagline_DESC";
    FocusParkListParksCollectionOrder["ThingsToDoTitleAsc"] = "thingsToDoTitle_ASC";
    FocusParkListParksCollectionOrder["ThingsToDoTitleDesc"] = "thingsToDoTitle_DESC";
    FocusParkListParksCollectionOrder["TitleAsc"] = "title_ASC";
    FocusParkListParksCollectionOrder["TitleDesc"] = "title_DESC";
})(FocusParkListParksCollectionOrder = exports.FocusParkListParksCollectionOrder || (exports.FocusParkListParksCollectionOrder = {}));
var FullCampaignAdvertsCollectionOrder;
(function (FullCampaignAdvertsCollectionOrder) {
    FullCampaignAdvertsCollectionOrder["AnalyticsCategoryAsc"] = "analyticsCategory_ASC";
    FullCampaignAdvertsCollectionOrder["AnalyticsCategoryDesc"] = "analyticsCategory_DESC";
    FullCampaignAdvertsCollectionOrder["AnalyticsTypeAsc"] = "analyticsType_ASC";
    FullCampaignAdvertsCollectionOrder["AnalyticsTypeDesc"] = "analyticsType_DESC";
    FullCampaignAdvertsCollectionOrder["AnalyticsVariantAsc"] = "analyticsVariant_ASC";
    FullCampaignAdvertsCollectionOrder["AnalyticsVariantDesc"] = "analyticsVariant_DESC";
    FullCampaignAdvertsCollectionOrder["CtaAsc"] = "cta_ASC";
    FullCampaignAdvertsCollectionOrder["CtaDesc"] = "cta_DESC";
    FullCampaignAdvertsCollectionOrder["DescriptionAsc"] = "description_ASC";
    FullCampaignAdvertsCollectionOrder["DescriptionDesc"] = "description_DESC";
    FullCampaignAdvertsCollectionOrder["SubTitleAsc"] = "subTitle_ASC";
    FullCampaignAdvertsCollectionOrder["SubTitleDesc"] = "subTitle_DESC";
    FullCampaignAdvertsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    FullCampaignAdvertsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    FullCampaignAdvertsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    FullCampaignAdvertsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    FullCampaignAdvertsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    FullCampaignAdvertsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    FullCampaignAdvertsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    FullCampaignAdvertsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    FullCampaignAdvertsCollectionOrder["TitleAsc"] = "title_ASC";
    FullCampaignAdvertsCollectionOrder["TitleDesc"] = "title_DESC";
    FullCampaignAdvertsCollectionOrder["UrlAsc"] = "url_ASC";
    FullCampaignAdvertsCollectionOrder["UrlDesc"] = "url_DESC";
})(FullCampaignAdvertsCollectionOrder = exports.FullCampaignAdvertsCollectionOrder || (exports.FullCampaignAdvertsCollectionOrder = {}));
var FullCampaignFaqsCollectionOrder;
(function (FullCampaignFaqsCollectionOrder) {
    FullCampaignFaqsCollectionOrder["QuestionAsc"] = "question_ASC";
    FullCampaignFaqsCollectionOrder["QuestionDesc"] = "question_DESC";
    FullCampaignFaqsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    FullCampaignFaqsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    FullCampaignFaqsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    FullCampaignFaqsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    FullCampaignFaqsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    FullCampaignFaqsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    FullCampaignFaqsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    FullCampaignFaqsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(FullCampaignFaqsCollectionOrder = exports.FullCampaignFaqsCollectionOrder || (exports.FullCampaignFaqsCollectionOrder = {}));
var FullCampaignFeaturedPromotionsCollectionOrder;
(function (FullCampaignFeaturedPromotionsCollectionOrder) {
    FullCampaignFeaturedPromotionsCollectionOrder["AnalyticsCategoryAsc"] = "analyticsCategory_ASC";
    FullCampaignFeaturedPromotionsCollectionOrder["AnalyticsCategoryDesc"] = "analyticsCategory_DESC";
    FullCampaignFeaturedPromotionsCollectionOrder["AnalyticsTypeAsc"] = "analyticsType_ASC";
    FullCampaignFeaturedPromotionsCollectionOrder["AnalyticsTypeDesc"] = "analyticsType_DESC";
    FullCampaignFeaturedPromotionsCollectionOrder["AnalyticsVariantAsc"] = "analyticsVariant_ASC";
    FullCampaignFeaturedPromotionsCollectionOrder["AnalyticsVariantDesc"] = "analyticsVariant_DESC";
    FullCampaignFeaturedPromotionsCollectionOrder["DurationAsc"] = "duration_ASC";
    FullCampaignFeaturedPromotionsCollectionOrder["DurationDesc"] = "duration_DESC";
    FullCampaignFeaturedPromotionsCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    FullCampaignFeaturedPromotionsCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    FullCampaignFeaturedPromotionsCollectionOrder["MaxPriceAsc"] = "maxPrice_ASC";
    FullCampaignFeaturedPromotionsCollectionOrder["MaxPriceDesc"] = "maxPrice_DESC";
    FullCampaignFeaturedPromotionsCollectionOrder["MinPriceAsc"] = "minPrice_ASC";
    FullCampaignFeaturedPromotionsCollectionOrder["MinPriceDesc"] = "minPrice_DESC";
    FullCampaignFeaturedPromotionsCollectionOrder["PriceAsc"] = "price_ASC";
    FullCampaignFeaturedPromotionsCollectionOrder["PriceDesc"] = "price_DESC";
    FullCampaignFeaturedPromotionsCollectionOrder["SubTitleAsc"] = "subTitle_ASC";
    FullCampaignFeaturedPromotionsCollectionOrder["SubTitleDesc"] = "subTitle_DESC";
    FullCampaignFeaturedPromotionsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    FullCampaignFeaturedPromotionsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    FullCampaignFeaturedPromotionsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    FullCampaignFeaturedPromotionsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    FullCampaignFeaturedPromotionsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    FullCampaignFeaturedPromotionsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    FullCampaignFeaturedPromotionsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    FullCampaignFeaturedPromotionsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    FullCampaignFeaturedPromotionsCollectionOrder["TitleAsc"] = "title_ASC";
    FullCampaignFeaturedPromotionsCollectionOrder["TitleDesc"] = "title_DESC";
    FullCampaignFeaturedPromotionsCollectionOrder["UrlAsc"] = "url_ASC";
    FullCampaignFeaturedPromotionsCollectionOrder["UrlDesc"] = "url_DESC";
})(FullCampaignFeaturedPromotionsCollectionOrder = exports.FullCampaignFeaturedPromotionsCollectionOrder || (exports.FullCampaignFeaturedPromotionsCollectionOrder = {}));
var FullCampaignLinkingCollectionsArticleSectionCollectionOrder;
(function (FullCampaignLinkingCollectionsArticleSectionCollectionOrder) {
    FullCampaignLinkingCollectionsArticleSectionCollectionOrder["CoordinatesAsc"] = "coordinates_ASC";
    FullCampaignLinkingCollectionsArticleSectionCollectionOrder["CoordinatesDesc"] = "coordinates_DESC";
    FullCampaignLinkingCollectionsArticleSectionCollectionOrder["NameAsc"] = "name_ASC";
    FullCampaignLinkingCollectionsArticleSectionCollectionOrder["NameDesc"] = "name_DESC";
    FullCampaignLinkingCollectionsArticleSectionCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    FullCampaignLinkingCollectionsArticleSectionCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    FullCampaignLinkingCollectionsArticleSectionCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    FullCampaignLinkingCollectionsArticleSectionCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    FullCampaignLinkingCollectionsArticleSectionCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    FullCampaignLinkingCollectionsArticleSectionCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    FullCampaignLinkingCollectionsArticleSectionCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    FullCampaignLinkingCollectionsArticleSectionCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    FullCampaignLinkingCollectionsArticleSectionCollectionOrder["TitleAsc"] = "title_ASC";
    FullCampaignLinkingCollectionsArticleSectionCollectionOrder["TitleDesc"] = "title_DESC";
})(FullCampaignLinkingCollectionsArticleSectionCollectionOrder = exports.FullCampaignLinkingCollectionsArticleSectionCollectionOrder || (exports.FullCampaignLinkingCollectionsArticleSectionCollectionOrder = {}));
var FullCampaignLinkingCollectionsPromotionComponentCollectionOrder;
(function (FullCampaignLinkingCollectionsPromotionComponentCollectionOrder) {
    FullCampaignLinkingCollectionsPromotionComponentCollectionOrder["NameAsc"] = "name_ASC";
    FullCampaignLinkingCollectionsPromotionComponentCollectionOrder["NameDesc"] = "name_DESC";
    FullCampaignLinkingCollectionsPromotionComponentCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    FullCampaignLinkingCollectionsPromotionComponentCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    FullCampaignLinkingCollectionsPromotionComponentCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    FullCampaignLinkingCollectionsPromotionComponentCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    FullCampaignLinkingCollectionsPromotionComponentCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    FullCampaignLinkingCollectionsPromotionComponentCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    FullCampaignLinkingCollectionsPromotionComponentCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    FullCampaignLinkingCollectionsPromotionComponentCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(FullCampaignLinkingCollectionsPromotionComponentCollectionOrder = exports.FullCampaignLinkingCollectionsPromotionComponentCollectionOrder || (exports.FullCampaignLinkingCollectionsPromotionComponentCollectionOrder = {}));
var FullCampaignOrder;
(function (FullCampaignOrder) {
    FullCampaignOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    FullCampaignOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    FullCampaignOrder["FeaturedParksTitleAsc"] = "featuredParksTitle_ASC";
    FullCampaignOrder["FeaturedParksTitleDesc"] = "featuredParksTitle_DESC";
    FullCampaignOrder["FeaturedPromotionsTitleAsc"] = "featuredPromotionsTitle_ASC";
    FullCampaignOrder["FeaturedPromotionsTitleDesc"] = "featuredPromotionsTitle_DESC";
    FullCampaignOrder["IntroductionTitleAsc"] = "introductionTitle_ASC";
    FullCampaignOrder["IntroductionTitleDesc"] = "introductionTitle_DESC";
    FullCampaignOrder["NameAsc"] = "name_ASC";
    FullCampaignOrder["NameDesc"] = "name_DESC";
    FullCampaignOrder["PathAsc"] = "path_ASC";
    FullCampaignOrder["PathDesc"] = "path_DESC";
    FullCampaignOrder["PromotionsTitleAsc"] = "promotionsTitle_ASC";
    FullCampaignOrder["PromotionsTitleDesc"] = "promotionsTitle_DESC";
    FullCampaignOrder["ReasonsToBookTitleAsc"] = "reasonsToBookTitle_ASC";
    FullCampaignOrder["ReasonsToBookTitleDesc"] = "reasonsToBookTitle_DESC";
    FullCampaignOrder["SellingPointsTitleAsc"] = "sellingPointsTitle_ASC";
    FullCampaignOrder["SellingPointsTitleDesc"] = "sellingPointsTitle_DESC";
    FullCampaignOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    FullCampaignOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    FullCampaignOrder["SysIdAsc"] = "sys_id_ASC";
    FullCampaignOrder["SysIdDesc"] = "sys_id_DESC";
    FullCampaignOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    FullCampaignOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    FullCampaignOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    FullCampaignOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    FullCampaignOrder["TitleAsc"] = "title_ASC";
    FullCampaignOrder["TitleDesc"] = "title_DESC";
})(FullCampaignOrder = exports.FullCampaignOrder || (exports.FullCampaignOrder = {}));
var FullCampaignParkOffersCollectionOrder;
(function (FullCampaignParkOffersCollectionOrder) {
    FullCampaignParkOffersCollectionOrder["AgeFromAsc"] = "ageFrom_ASC";
    FullCampaignParkOffersCollectionOrder["AgeFromDesc"] = "ageFrom_DESC";
    FullCampaignParkOffersCollectionOrder["CtaTitleAsc"] = "ctaTitle_ASC";
    FullCampaignParkOffersCollectionOrder["CtaTitleDesc"] = "ctaTitle_DESC";
    FullCampaignParkOffersCollectionOrder["CtaUrlAsc"] = "ctaUrl_ASC";
    FullCampaignParkOffersCollectionOrder["CtaUrlDesc"] = "ctaUrl_DESC";
    FullCampaignParkOffersCollectionOrder["EndDateAsc"] = "endDate_ASC";
    FullCampaignParkOffersCollectionOrder["EndDateDesc"] = "endDate_DESC";
    FullCampaignParkOffersCollectionOrder["HolidayTypeAsc"] = "holidayType_ASC";
    FullCampaignParkOffersCollectionOrder["HolidayTypeDesc"] = "holidayType_DESC";
    FullCampaignParkOffersCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    FullCampaignParkOffersCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    FullCampaignParkOffersCollectionOrder["PropositionTypeAsc"] = "propositionType_ASC";
    FullCampaignParkOffersCollectionOrder["PropositionTypeDesc"] = "propositionType_DESC";
    FullCampaignParkOffersCollectionOrder["StartDateAsc"] = "startDate_ASC";
    FullCampaignParkOffersCollectionOrder["StartDateDesc"] = "startDate_DESC";
    FullCampaignParkOffersCollectionOrder["SubTitleAsc"] = "subTitle_ASC";
    FullCampaignParkOffersCollectionOrder["SubTitleDesc"] = "subTitle_DESC";
    FullCampaignParkOffersCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    FullCampaignParkOffersCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    FullCampaignParkOffersCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    FullCampaignParkOffersCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    FullCampaignParkOffersCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    FullCampaignParkOffersCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    FullCampaignParkOffersCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    FullCampaignParkOffersCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    FullCampaignParkOffersCollectionOrder["TitleAsc"] = "title_ASC";
    FullCampaignParkOffersCollectionOrder["TitleDesc"] = "title_DESC";
})(FullCampaignParkOffersCollectionOrder = exports.FullCampaignParkOffersCollectionOrder || (exports.FullCampaignParkOffersCollectionOrder = {}));
var FullCampaignPromotionsCollectionOrder;
(function (FullCampaignPromotionsCollectionOrder) {
    FullCampaignPromotionsCollectionOrder["AnalyticsCategoryAsc"] = "analyticsCategory_ASC";
    FullCampaignPromotionsCollectionOrder["AnalyticsCategoryDesc"] = "analyticsCategory_DESC";
    FullCampaignPromotionsCollectionOrder["AnalyticsTypeAsc"] = "analyticsType_ASC";
    FullCampaignPromotionsCollectionOrder["AnalyticsTypeDesc"] = "analyticsType_DESC";
    FullCampaignPromotionsCollectionOrder["AnalyticsVariantAsc"] = "analyticsVariant_ASC";
    FullCampaignPromotionsCollectionOrder["AnalyticsVariantDesc"] = "analyticsVariant_DESC";
    FullCampaignPromotionsCollectionOrder["DurationAsc"] = "duration_ASC";
    FullCampaignPromotionsCollectionOrder["DurationDesc"] = "duration_DESC";
    FullCampaignPromotionsCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    FullCampaignPromotionsCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    FullCampaignPromotionsCollectionOrder["MaxPriceAsc"] = "maxPrice_ASC";
    FullCampaignPromotionsCollectionOrder["MaxPriceDesc"] = "maxPrice_DESC";
    FullCampaignPromotionsCollectionOrder["MinPriceAsc"] = "minPrice_ASC";
    FullCampaignPromotionsCollectionOrder["MinPriceDesc"] = "minPrice_DESC";
    FullCampaignPromotionsCollectionOrder["PriceAsc"] = "price_ASC";
    FullCampaignPromotionsCollectionOrder["PriceDesc"] = "price_DESC";
    FullCampaignPromotionsCollectionOrder["SubTitleAsc"] = "subTitle_ASC";
    FullCampaignPromotionsCollectionOrder["SubTitleDesc"] = "subTitle_DESC";
    FullCampaignPromotionsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    FullCampaignPromotionsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    FullCampaignPromotionsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    FullCampaignPromotionsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    FullCampaignPromotionsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    FullCampaignPromotionsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    FullCampaignPromotionsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    FullCampaignPromotionsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    FullCampaignPromotionsCollectionOrder["TitleAsc"] = "title_ASC";
    FullCampaignPromotionsCollectionOrder["TitleDesc"] = "title_DESC";
    FullCampaignPromotionsCollectionOrder["UrlAsc"] = "url_ASC";
    FullCampaignPromotionsCollectionOrder["UrlDesc"] = "url_DESC";
})(FullCampaignPromotionsCollectionOrder = exports.FullCampaignPromotionsCollectionOrder || (exports.FullCampaignPromotionsCollectionOrder = {}));
var FullCampaignPropositionsCollectionOrder;
(function (FullCampaignPropositionsCollectionOrder) {
    FullCampaignPropositionsCollectionOrder["CtaTitleAsc"] = "ctaTitle_ASC";
    FullCampaignPropositionsCollectionOrder["CtaTitleDesc"] = "ctaTitle_DESC";
    FullCampaignPropositionsCollectionOrder["CtaUrlAsc"] = "ctaUrl_ASC";
    FullCampaignPropositionsCollectionOrder["CtaUrlDesc"] = "ctaUrl_DESC";
    FullCampaignPropositionsCollectionOrder["FeaturedParksTitleAsc"] = "featuredParksTitle_ASC";
    FullCampaignPropositionsCollectionOrder["FeaturedParksTitleDesc"] = "featuredParksTitle_DESC";
    FullCampaignPropositionsCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    FullCampaignPropositionsCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    FullCampaignPropositionsCollectionOrder["NameAsc"] = "name_ASC";
    FullCampaignPropositionsCollectionOrder["NameDesc"] = "name_DESC";
    FullCampaignPropositionsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    FullCampaignPropositionsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    FullCampaignPropositionsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    FullCampaignPropositionsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    FullCampaignPropositionsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    FullCampaignPropositionsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    FullCampaignPropositionsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    FullCampaignPropositionsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(FullCampaignPropositionsCollectionOrder = exports.FullCampaignPropositionsCollectionOrder || (exports.FullCampaignPropositionsCollectionOrder = {}));
var FullCampaignReasonsToBookCollectionOrder;
(function (FullCampaignReasonsToBookCollectionOrder) {
    FullCampaignReasonsToBookCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    FullCampaignReasonsToBookCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    FullCampaignReasonsToBookCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    FullCampaignReasonsToBookCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    FullCampaignReasonsToBookCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    FullCampaignReasonsToBookCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    FullCampaignReasonsToBookCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    FullCampaignReasonsToBookCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    FullCampaignReasonsToBookCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    FullCampaignReasonsToBookCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    FullCampaignReasonsToBookCollectionOrder["TitleAsc"] = "title_ASC";
    FullCampaignReasonsToBookCollectionOrder["TitleDesc"] = "title_DESC";
    FullCampaignReasonsToBookCollectionOrder["UrlAsc"] = "url_ASC";
    FullCampaignReasonsToBookCollectionOrder["UrlDesc"] = "url_DESC";
})(FullCampaignReasonsToBookCollectionOrder = exports.FullCampaignReasonsToBookCollectionOrder || (exports.FullCampaignReasonsToBookCollectionOrder = {}));
var FullCampaignSellingPointsCollectionOrder;
(function (FullCampaignSellingPointsCollectionOrder) {
    FullCampaignSellingPointsCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    FullCampaignSellingPointsCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    FullCampaignSellingPointsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    FullCampaignSellingPointsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    FullCampaignSellingPointsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    FullCampaignSellingPointsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    FullCampaignSellingPointsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    FullCampaignSellingPointsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    FullCampaignSellingPointsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    FullCampaignSellingPointsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    FullCampaignSellingPointsCollectionOrder["TitleAsc"] = "title_ASC";
    FullCampaignSellingPointsCollectionOrder["TitleDesc"] = "title_DESC";
    FullCampaignSellingPointsCollectionOrder["UrlAsc"] = "url_ASC";
    FullCampaignSellingPointsCollectionOrder["UrlDesc"] = "url_DESC";
})(FullCampaignSellingPointsCollectionOrder = exports.FullCampaignSellingPointsCollectionOrder || (exports.FullCampaignSellingPointsCollectionOrder = {}));
var FullCampaignTermsAndConditionsCollectionOrder;
(function (FullCampaignTermsAndConditionsCollectionOrder) {
    FullCampaignTermsAndConditionsCollectionOrder["HolidayTypeAsc"] = "holidayType_ASC";
    FullCampaignTermsAndConditionsCollectionOrder["HolidayTypeDesc"] = "holidayType_DESC";
    FullCampaignTermsAndConditionsCollectionOrder["NameAsc"] = "name_ASC";
    FullCampaignTermsAndConditionsCollectionOrder["NameDesc"] = "name_DESC";
    FullCampaignTermsAndConditionsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    FullCampaignTermsAndConditionsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    FullCampaignTermsAndConditionsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    FullCampaignTermsAndConditionsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    FullCampaignTermsAndConditionsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    FullCampaignTermsAndConditionsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    FullCampaignTermsAndConditionsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    FullCampaignTermsAndConditionsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(FullCampaignTermsAndConditionsCollectionOrder = exports.FullCampaignTermsAndConditionsCollectionOrder || (exports.FullCampaignTermsAndConditionsCollectionOrder = {}));
var GenericTemplateOrder;
(function (GenericTemplateOrder) {
    GenericTemplateOrder["NameAsc"] = "name_ASC";
    GenericTemplateOrder["NameDesc"] = "name_DESC";
    GenericTemplateOrder["PathAsc"] = "path_ASC";
    GenericTemplateOrder["PathDesc"] = "path_DESC";
    GenericTemplateOrder["ShowTableOfContentsAsc"] = "showTableOfContents_ASC";
    GenericTemplateOrder["ShowTableOfContentsDesc"] = "showTableOfContents_DESC";
    GenericTemplateOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    GenericTemplateOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    GenericTemplateOrder["SysIdAsc"] = "sys_id_ASC";
    GenericTemplateOrder["SysIdDesc"] = "sys_id_DESC";
    GenericTemplateOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    GenericTemplateOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    GenericTemplateOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    GenericTemplateOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    GenericTemplateOrder["TitleAsc"] = "title_ASC";
    GenericTemplateOrder["TitleDesc"] = "title_DESC";
})(GenericTemplateOrder = exports.GenericTemplateOrder || (exports.GenericTemplateOrder = {}));
var GenericTemplateSafetyMeasuresCollectionOrder;
(function (GenericTemplateSafetyMeasuresCollectionOrder) {
    GenericTemplateSafetyMeasuresCollectionOrder["NameAsc"] = "name_ASC";
    GenericTemplateSafetyMeasuresCollectionOrder["NameDesc"] = "name_DESC";
    GenericTemplateSafetyMeasuresCollectionOrder["PathAsc"] = "path_ASC";
    GenericTemplateSafetyMeasuresCollectionOrder["PathDesc"] = "path_DESC";
    GenericTemplateSafetyMeasuresCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    GenericTemplateSafetyMeasuresCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    GenericTemplateSafetyMeasuresCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    GenericTemplateSafetyMeasuresCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    GenericTemplateSafetyMeasuresCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    GenericTemplateSafetyMeasuresCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    GenericTemplateSafetyMeasuresCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    GenericTemplateSafetyMeasuresCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    GenericTemplateSafetyMeasuresCollectionOrder["TitleAsc"] = "title_ASC";
    GenericTemplateSafetyMeasuresCollectionOrder["TitleDesc"] = "title_DESC";
})(GenericTemplateSafetyMeasuresCollectionOrder = exports.GenericTemplateSafetyMeasuresCollectionOrder || (exports.GenericTemplateSafetyMeasuresCollectionOrder = {}));
var GenericTemplateSectionsCollectionOrder;
(function (GenericTemplateSectionsCollectionOrder) {
    GenericTemplateSectionsCollectionOrder["NameAsc"] = "name_ASC";
    GenericTemplateSectionsCollectionOrder["NameDesc"] = "name_DESC";
    GenericTemplateSectionsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    GenericTemplateSectionsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    GenericTemplateSectionsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    GenericTemplateSectionsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    GenericTemplateSectionsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    GenericTemplateSectionsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    GenericTemplateSectionsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    GenericTemplateSectionsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    GenericTemplateSectionsCollectionOrder["TitleAsc"] = "title_ASC";
    GenericTemplateSectionsCollectionOrder["TitleDesc"] = "title_DESC";
})(GenericTemplateSectionsCollectionOrder = exports.GenericTemplateSectionsCollectionOrder || (exports.GenericTemplateSectionsCollectionOrder = {}));
var HavenPromiseOrder;
(function (HavenPromiseOrder) {
    HavenPromiseOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    HavenPromiseOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    HavenPromiseOrder["SysIdAsc"] = "sys_id_ASC";
    HavenPromiseOrder["SysIdDesc"] = "sys_id_DESC";
    HavenPromiseOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    HavenPromiseOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    HavenPromiseOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    HavenPromiseOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    HavenPromiseOrder["TitleAsc"] = "title_ASC";
    HavenPromiseOrder["TitleDesc"] = "title_DESC";
})(HavenPromiseOrder = exports.HavenPromiseOrder || (exports.HavenPromiseOrder = {}));
var HolidayPackageFeaturesCollectionOrder;
(function (HolidayPackageFeaturesCollectionOrder) {
    HolidayPackageFeaturesCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    HolidayPackageFeaturesCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    HolidayPackageFeaturesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    HolidayPackageFeaturesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    HolidayPackageFeaturesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    HolidayPackageFeaturesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    HolidayPackageFeaturesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    HolidayPackageFeaturesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    HolidayPackageFeaturesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    HolidayPackageFeaturesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    HolidayPackageFeaturesCollectionOrder["TitleAsc"] = "title_ASC";
    HolidayPackageFeaturesCollectionOrder["TitleDesc"] = "title_DESC";
    HolidayPackageFeaturesCollectionOrder["UrlAsc"] = "url_ASC";
    HolidayPackageFeaturesCollectionOrder["UrlDesc"] = "url_DESC";
})(HolidayPackageFeaturesCollectionOrder = exports.HolidayPackageFeaturesCollectionOrder || (exports.HolidayPackageFeaturesCollectionOrder = {}));
var HolidayPackageLinkingCollectionsHolidaySelectionPageCollectionOrder;
(function (HolidayPackageLinkingCollectionsHolidaySelectionPageCollectionOrder) {
    HolidayPackageLinkingCollectionsHolidaySelectionPageCollectionOrder["NameAsc"] = "name_ASC";
    HolidayPackageLinkingCollectionsHolidaySelectionPageCollectionOrder["NameDesc"] = "name_DESC";
    HolidayPackageLinkingCollectionsHolidaySelectionPageCollectionOrder["PathAsc"] = "path_ASC";
    HolidayPackageLinkingCollectionsHolidaySelectionPageCollectionOrder["PathDesc"] = "path_DESC";
    HolidayPackageLinkingCollectionsHolidaySelectionPageCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    HolidayPackageLinkingCollectionsHolidaySelectionPageCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    HolidayPackageLinkingCollectionsHolidaySelectionPageCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    HolidayPackageLinkingCollectionsHolidaySelectionPageCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    HolidayPackageLinkingCollectionsHolidaySelectionPageCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    HolidayPackageLinkingCollectionsHolidaySelectionPageCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    HolidayPackageLinkingCollectionsHolidaySelectionPageCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    HolidayPackageLinkingCollectionsHolidaySelectionPageCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    HolidayPackageLinkingCollectionsHolidaySelectionPageCollectionOrder["TitleAsc"] = "title_ASC";
    HolidayPackageLinkingCollectionsHolidaySelectionPageCollectionOrder["TitleDesc"] = "title_DESC";
})(HolidayPackageLinkingCollectionsHolidaySelectionPageCollectionOrder = exports.HolidayPackageLinkingCollectionsHolidaySelectionPageCollectionOrder || (exports.HolidayPackageLinkingCollectionsHolidaySelectionPageCollectionOrder = {}));
var HolidayPackageLinkingCollectionsPropositionCollectionOrder;
(function (HolidayPackageLinkingCollectionsPropositionCollectionOrder) {
    HolidayPackageLinkingCollectionsPropositionCollectionOrder["FaqFolderIdAsc"] = "faqFolderId_ASC";
    HolidayPackageLinkingCollectionsPropositionCollectionOrder["FaqFolderIdDesc"] = "faqFolderId_DESC";
    HolidayPackageLinkingCollectionsPropositionCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    HolidayPackageLinkingCollectionsPropositionCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    HolidayPackageLinkingCollectionsPropositionCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    HolidayPackageLinkingCollectionsPropositionCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    HolidayPackageLinkingCollectionsPropositionCollectionOrder["NameAsc"] = "name_ASC";
    HolidayPackageLinkingCollectionsPropositionCollectionOrder["NameDesc"] = "name_DESC";
    HolidayPackageLinkingCollectionsPropositionCollectionOrder["PathAsc"] = "path_ASC";
    HolidayPackageLinkingCollectionsPropositionCollectionOrder["PathDesc"] = "path_DESC";
    HolidayPackageLinkingCollectionsPropositionCollectionOrder["RelatedArticlesTitleAsc"] = "relatedArticlesTitle_ASC";
    HolidayPackageLinkingCollectionsPropositionCollectionOrder["RelatedArticlesTitleDesc"] = "relatedArticlesTitle_DESC";
    HolidayPackageLinkingCollectionsPropositionCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    HolidayPackageLinkingCollectionsPropositionCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    HolidayPackageLinkingCollectionsPropositionCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    HolidayPackageLinkingCollectionsPropositionCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    HolidayPackageLinkingCollectionsPropositionCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    HolidayPackageLinkingCollectionsPropositionCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    HolidayPackageLinkingCollectionsPropositionCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    HolidayPackageLinkingCollectionsPropositionCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    HolidayPackageLinkingCollectionsPropositionCollectionOrder["TagLineAsc"] = "tagLine_ASC";
    HolidayPackageLinkingCollectionsPropositionCollectionOrder["TagLineDesc"] = "tagLine_DESC";
    HolidayPackageLinkingCollectionsPropositionCollectionOrder["TitleAsc"] = "title_ASC";
    HolidayPackageLinkingCollectionsPropositionCollectionOrder["TitleDesc"] = "title_DESC";
})(HolidayPackageLinkingCollectionsPropositionCollectionOrder = exports.HolidayPackageLinkingCollectionsPropositionCollectionOrder || (exports.HolidayPackageLinkingCollectionsPropositionCollectionOrder = {}));
var HolidayPackageOrder;
(function (HolidayPackageOrder) {
    HolidayPackageOrder["FeaturesTitleAsc"] = "featuresTitle_ASC";
    HolidayPackageOrder["FeaturesTitleDesc"] = "featuresTitle_DESC";
    HolidayPackageOrder["SellingPointsTitleAsc"] = "sellingPointsTitle_ASC";
    HolidayPackageOrder["SellingPointsTitleDesc"] = "sellingPointsTitle_DESC";
    HolidayPackageOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    HolidayPackageOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    HolidayPackageOrder["SysIdAsc"] = "sys_id_ASC";
    HolidayPackageOrder["SysIdDesc"] = "sys_id_DESC";
    HolidayPackageOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    HolidayPackageOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    HolidayPackageOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    HolidayPackageOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    HolidayPackageOrder["TitleAsc"] = "title_ASC";
    HolidayPackageOrder["TitleDesc"] = "title_DESC";
})(HolidayPackageOrder = exports.HolidayPackageOrder || (exports.HolidayPackageOrder = {}));
var HolidayPackageSellingPointsCollectionOrder;
(function (HolidayPackageSellingPointsCollectionOrder) {
    HolidayPackageSellingPointsCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    HolidayPackageSellingPointsCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    HolidayPackageSellingPointsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    HolidayPackageSellingPointsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    HolidayPackageSellingPointsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    HolidayPackageSellingPointsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    HolidayPackageSellingPointsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    HolidayPackageSellingPointsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    HolidayPackageSellingPointsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    HolidayPackageSellingPointsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    HolidayPackageSellingPointsCollectionOrder["TitleAsc"] = "title_ASC";
    HolidayPackageSellingPointsCollectionOrder["TitleDesc"] = "title_DESC";
    HolidayPackageSellingPointsCollectionOrder["UrlAsc"] = "url_ASC";
    HolidayPackageSellingPointsCollectionOrder["UrlDesc"] = "url_DESC";
})(HolidayPackageSellingPointsCollectionOrder = exports.HolidayPackageSellingPointsCollectionOrder || (exports.HolidayPackageSellingPointsCollectionOrder = {}));
var HolidaySearchParametersLinkingCollectionsFullCampaignCollectionOrder;
(function (HolidaySearchParametersLinkingCollectionsFullCampaignCollectionOrder) {
    HolidaySearchParametersLinkingCollectionsFullCampaignCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    HolidaySearchParametersLinkingCollectionsFullCampaignCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    HolidaySearchParametersLinkingCollectionsFullCampaignCollectionOrder["FeaturedParksTitleAsc"] = "featuredParksTitle_ASC";
    HolidaySearchParametersLinkingCollectionsFullCampaignCollectionOrder["FeaturedParksTitleDesc"] = "featuredParksTitle_DESC";
    HolidaySearchParametersLinkingCollectionsFullCampaignCollectionOrder["FeaturedPromotionsTitleAsc"] = "featuredPromotionsTitle_ASC";
    HolidaySearchParametersLinkingCollectionsFullCampaignCollectionOrder["FeaturedPromotionsTitleDesc"] = "featuredPromotionsTitle_DESC";
    HolidaySearchParametersLinkingCollectionsFullCampaignCollectionOrder["IntroductionTitleAsc"] = "introductionTitle_ASC";
    HolidaySearchParametersLinkingCollectionsFullCampaignCollectionOrder["IntroductionTitleDesc"] = "introductionTitle_DESC";
    HolidaySearchParametersLinkingCollectionsFullCampaignCollectionOrder["NameAsc"] = "name_ASC";
    HolidaySearchParametersLinkingCollectionsFullCampaignCollectionOrder["NameDesc"] = "name_DESC";
    HolidaySearchParametersLinkingCollectionsFullCampaignCollectionOrder["PathAsc"] = "path_ASC";
    HolidaySearchParametersLinkingCollectionsFullCampaignCollectionOrder["PathDesc"] = "path_DESC";
    HolidaySearchParametersLinkingCollectionsFullCampaignCollectionOrder["PromotionsTitleAsc"] = "promotionsTitle_ASC";
    HolidaySearchParametersLinkingCollectionsFullCampaignCollectionOrder["PromotionsTitleDesc"] = "promotionsTitle_DESC";
    HolidaySearchParametersLinkingCollectionsFullCampaignCollectionOrder["ReasonsToBookTitleAsc"] = "reasonsToBookTitle_ASC";
    HolidaySearchParametersLinkingCollectionsFullCampaignCollectionOrder["ReasonsToBookTitleDesc"] = "reasonsToBookTitle_DESC";
    HolidaySearchParametersLinkingCollectionsFullCampaignCollectionOrder["SellingPointsTitleAsc"] = "sellingPointsTitle_ASC";
    HolidaySearchParametersLinkingCollectionsFullCampaignCollectionOrder["SellingPointsTitleDesc"] = "sellingPointsTitle_DESC";
    HolidaySearchParametersLinkingCollectionsFullCampaignCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    HolidaySearchParametersLinkingCollectionsFullCampaignCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    HolidaySearchParametersLinkingCollectionsFullCampaignCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    HolidaySearchParametersLinkingCollectionsFullCampaignCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    HolidaySearchParametersLinkingCollectionsFullCampaignCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    HolidaySearchParametersLinkingCollectionsFullCampaignCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    HolidaySearchParametersLinkingCollectionsFullCampaignCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    HolidaySearchParametersLinkingCollectionsFullCampaignCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    HolidaySearchParametersLinkingCollectionsFullCampaignCollectionOrder["TitleAsc"] = "title_ASC";
    HolidaySearchParametersLinkingCollectionsFullCampaignCollectionOrder["TitleDesc"] = "title_DESC";
})(HolidaySearchParametersLinkingCollectionsFullCampaignCollectionOrder = exports.HolidaySearchParametersLinkingCollectionsFullCampaignCollectionOrder || (exports.HolidaySearchParametersLinkingCollectionsFullCampaignCollectionOrder = {}));
var HolidaySearchParametersLinkingCollectionsPromotionCollectionOrder;
(function (HolidaySearchParametersLinkingCollectionsPromotionCollectionOrder) {
    HolidaySearchParametersLinkingCollectionsPromotionCollectionOrder["AnalyticsCategoryAsc"] = "analyticsCategory_ASC";
    HolidaySearchParametersLinkingCollectionsPromotionCollectionOrder["AnalyticsCategoryDesc"] = "analyticsCategory_DESC";
    HolidaySearchParametersLinkingCollectionsPromotionCollectionOrder["AnalyticsTypeAsc"] = "analyticsType_ASC";
    HolidaySearchParametersLinkingCollectionsPromotionCollectionOrder["AnalyticsTypeDesc"] = "analyticsType_DESC";
    HolidaySearchParametersLinkingCollectionsPromotionCollectionOrder["AnalyticsVariantAsc"] = "analyticsVariant_ASC";
    HolidaySearchParametersLinkingCollectionsPromotionCollectionOrder["AnalyticsVariantDesc"] = "analyticsVariant_DESC";
    HolidaySearchParametersLinkingCollectionsPromotionCollectionOrder["DurationAsc"] = "duration_ASC";
    HolidaySearchParametersLinkingCollectionsPromotionCollectionOrder["DurationDesc"] = "duration_DESC";
    HolidaySearchParametersLinkingCollectionsPromotionCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    HolidaySearchParametersLinkingCollectionsPromotionCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    HolidaySearchParametersLinkingCollectionsPromotionCollectionOrder["MaxPriceAsc"] = "maxPrice_ASC";
    HolidaySearchParametersLinkingCollectionsPromotionCollectionOrder["MaxPriceDesc"] = "maxPrice_DESC";
    HolidaySearchParametersLinkingCollectionsPromotionCollectionOrder["MinPriceAsc"] = "minPrice_ASC";
    HolidaySearchParametersLinkingCollectionsPromotionCollectionOrder["MinPriceDesc"] = "minPrice_DESC";
    HolidaySearchParametersLinkingCollectionsPromotionCollectionOrder["PriceAsc"] = "price_ASC";
    HolidaySearchParametersLinkingCollectionsPromotionCollectionOrder["PriceDesc"] = "price_DESC";
    HolidaySearchParametersLinkingCollectionsPromotionCollectionOrder["SubTitleAsc"] = "subTitle_ASC";
    HolidaySearchParametersLinkingCollectionsPromotionCollectionOrder["SubTitleDesc"] = "subTitle_DESC";
    HolidaySearchParametersLinkingCollectionsPromotionCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    HolidaySearchParametersLinkingCollectionsPromotionCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    HolidaySearchParametersLinkingCollectionsPromotionCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    HolidaySearchParametersLinkingCollectionsPromotionCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    HolidaySearchParametersLinkingCollectionsPromotionCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    HolidaySearchParametersLinkingCollectionsPromotionCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    HolidaySearchParametersLinkingCollectionsPromotionCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    HolidaySearchParametersLinkingCollectionsPromotionCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    HolidaySearchParametersLinkingCollectionsPromotionCollectionOrder["TitleAsc"] = "title_ASC";
    HolidaySearchParametersLinkingCollectionsPromotionCollectionOrder["TitleDesc"] = "title_DESC";
    HolidaySearchParametersLinkingCollectionsPromotionCollectionOrder["UrlAsc"] = "url_ASC";
    HolidaySearchParametersLinkingCollectionsPromotionCollectionOrder["UrlDesc"] = "url_DESC";
})(HolidaySearchParametersLinkingCollectionsPromotionCollectionOrder = exports.HolidaySearchParametersLinkingCollectionsPromotionCollectionOrder || (exports.HolidaySearchParametersLinkingCollectionsPromotionCollectionOrder = {}));
var HolidaySearchParametersOrder;
(function (HolidaySearchParametersOrder) {
    HolidaySearchParametersOrder["AccessibleVansAsc"] = "accessibleVans_ASC";
    HolidaySearchParametersOrder["AccessibleVansDesc"] = "accessibleVans_DESC";
    HolidaySearchParametersOrder["DogFriendlyAsc"] = "dogFriendly_ASC";
    HolidaySearchParametersOrder["DogFriendlyDesc"] = "dogFriendly_DESC";
    HolidaySearchParametersOrder["EndDateAsc"] = "endDate_ASC";
    HolidaySearchParametersOrder["EndDateDesc"] = "endDate_DESC";
    HolidaySearchParametersOrder["HolidayTypeAsc"] = "holidayType_ASC";
    HolidaySearchParametersOrder["HolidayTypeDesc"] = "holidayType_DESC";
    HolidaySearchParametersOrder["StartDateAsc"] = "startDate_ASC";
    HolidaySearchParametersOrder["StartDateDesc"] = "startDate_DESC";
    HolidaySearchParametersOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    HolidaySearchParametersOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    HolidaySearchParametersOrder["SysIdAsc"] = "sys_id_ASC";
    HolidaySearchParametersOrder["SysIdDesc"] = "sys_id_DESC";
    HolidaySearchParametersOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    HolidaySearchParametersOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    HolidaySearchParametersOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    HolidaySearchParametersOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    HolidaySearchParametersOrder["TitleAsc"] = "title_ASC";
    HolidaySearchParametersOrder["TitleDesc"] = "title_DESC";
})(HolidaySearchParametersOrder = exports.HolidaySearchParametersOrder || (exports.HolidaySearchParametersOrder = {}));
var HolidaySelectionPageHolidayPackagesCollectionOrder;
(function (HolidaySelectionPageHolidayPackagesCollectionOrder) {
    HolidaySelectionPageHolidayPackagesCollectionOrder["FeaturesTitleAsc"] = "featuresTitle_ASC";
    HolidaySelectionPageHolidayPackagesCollectionOrder["FeaturesTitleDesc"] = "featuresTitle_DESC";
    HolidaySelectionPageHolidayPackagesCollectionOrder["SellingPointsTitleAsc"] = "sellingPointsTitle_ASC";
    HolidaySelectionPageHolidayPackagesCollectionOrder["SellingPointsTitleDesc"] = "sellingPointsTitle_DESC";
    HolidaySelectionPageHolidayPackagesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    HolidaySelectionPageHolidayPackagesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    HolidaySelectionPageHolidayPackagesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    HolidaySelectionPageHolidayPackagesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    HolidaySelectionPageHolidayPackagesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    HolidaySelectionPageHolidayPackagesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    HolidaySelectionPageHolidayPackagesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    HolidaySelectionPageHolidayPackagesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    HolidaySelectionPageHolidayPackagesCollectionOrder["TitleAsc"] = "title_ASC";
    HolidaySelectionPageHolidayPackagesCollectionOrder["TitleDesc"] = "title_DESC";
})(HolidaySelectionPageHolidayPackagesCollectionOrder = exports.HolidaySelectionPageHolidayPackagesCollectionOrder || (exports.HolidaySelectionPageHolidayPackagesCollectionOrder = {}));
var HolidaySelectionPageOrder;
(function (HolidaySelectionPageOrder) {
    HolidaySelectionPageOrder["NameAsc"] = "name_ASC";
    HolidaySelectionPageOrder["NameDesc"] = "name_DESC";
    HolidaySelectionPageOrder["PathAsc"] = "path_ASC";
    HolidaySelectionPageOrder["PathDesc"] = "path_DESC";
    HolidaySelectionPageOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    HolidaySelectionPageOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    HolidaySelectionPageOrder["SysIdAsc"] = "sys_id_ASC";
    HolidaySelectionPageOrder["SysIdDesc"] = "sys_id_DESC";
    HolidaySelectionPageOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    HolidaySelectionPageOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    HolidaySelectionPageOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    HolidaySelectionPageOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    HolidaySelectionPageOrder["TitleAsc"] = "title_ASC";
    HolidaySelectionPageOrder["TitleDesc"] = "title_DESC";
})(HolidaySelectionPageOrder = exports.HolidaySelectionPageOrder || (exports.HolidaySelectionPageOrder = {}));
var HomePageAdvertsCollectionOrder;
(function (HomePageAdvertsCollectionOrder) {
    HomePageAdvertsCollectionOrder["AnalyticsCategoryAsc"] = "analyticsCategory_ASC";
    HomePageAdvertsCollectionOrder["AnalyticsCategoryDesc"] = "analyticsCategory_DESC";
    HomePageAdvertsCollectionOrder["AnalyticsTypeAsc"] = "analyticsType_ASC";
    HomePageAdvertsCollectionOrder["AnalyticsTypeDesc"] = "analyticsType_DESC";
    HomePageAdvertsCollectionOrder["AnalyticsVariantAsc"] = "analyticsVariant_ASC";
    HomePageAdvertsCollectionOrder["AnalyticsVariantDesc"] = "analyticsVariant_DESC";
    HomePageAdvertsCollectionOrder["CtaAsc"] = "cta_ASC";
    HomePageAdvertsCollectionOrder["CtaDesc"] = "cta_DESC";
    HomePageAdvertsCollectionOrder["DescriptionAsc"] = "description_ASC";
    HomePageAdvertsCollectionOrder["DescriptionDesc"] = "description_DESC";
    HomePageAdvertsCollectionOrder["SubTitleAsc"] = "subTitle_ASC";
    HomePageAdvertsCollectionOrder["SubTitleDesc"] = "subTitle_DESC";
    HomePageAdvertsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    HomePageAdvertsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    HomePageAdvertsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    HomePageAdvertsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    HomePageAdvertsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    HomePageAdvertsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    HomePageAdvertsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    HomePageAdvertsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    HomePageAdvertsCollectionOrder["TitleAsc"] = "title_ASC";
    HomePageAdvertsCollectionOrder["TitleDesc"] = "title_DESC";
    HomePageAdvertsCollectionOrder["UrlAsc"] = "url_ASC";
    HomePageAdvertsCollectionOrder["UrlDesc"] = "url_DESC";
})(HomePageAdvertsCollectionOrder = exports.HomePageAdvertsCollectionOrder || (exports.HomePageAdvertsCollectionOrder = {}));
var HomePageCommercialSellingPointsCollectionOrder;
(function (HomePageCommercialSellingPointsCollectionOrder) {
    HomePageCommercialSellingPointsCollectionOrder["AnalyticsCategoryAsc"] = "analyticsCategory_ASC";
    HomePageCommercialSellingPointsCollectionOrder["AnalyticsCategoryDesc"] = "analyticsCategory_DESC";
    HomePageCommercialSellingPointsCollectionOrder["AnalyticsTypeAsc"] = "analyticsType_ASC";
    HomePageCommercialSellingPointsCollectionOrder["AnalyticsTypeDesc"] = "analyticsType_DESC";
    HomePageCommercialSellingPointsCollectionOrder["AnalyticsVariantAsc"] = "analyticsVariant_ASC";
    HomePageCommercialSellingPointsCollectionOrder["AnalyticsVariantDesc"] = "analyticsVariant_DESC";
    HomePageCommercialSellingPointsCollectionOrder["DurationAsc"] = "duration_ASC";
    HomePageCommercialSellingPointsCollectionOrder["DurationDesc"] = "duration_DESC";
    HomePageCommercialSellingPointsCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    HomePageCommercialSellingPointsCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    HomePageCommercialSellingPointsCollectionOrder["MaxPriceAsc"] = "maxPrice_ASC";
    HomePageCommercialSellingPointsCollectionOrder["MaxPriceDesc"] = "maxPrice_DESC";
    HomePageCommercialSellingPointsCollectionOrder["MinPriceAsc"] = "minPrice_ASC";
    HomePageCommercialSellingPointsCollectionOrder["MinPriceDesc"] = "minPrice_DESC";
    HomePageCommercialSellingPointsCollectionOrder["PriceAsc"] = "price_ASC";
    HomePageCommercialSellingPointsCollectionOrder["PriceDesc"] = "price_DESC";
    HomePageCommercialSellingPointsCollectionOrder["SubTitleAsc"] = "subTitle_ASC";
    HomePageCommercialSellingPointsCollectionOrder["SubTitleDesc"] = "subTitle_DESC";
    HomePageCommercialSellingPointsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    HomePageCommercialSellingPointsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    HomePageCommercialSellingPointsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    HomePageCommercialSellingPointsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    HomePageCommercialSellingPointsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    HomePageCommercialSellingPointsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    HomePageCommercialSellingPointsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    HomePageCommercialSellingPointsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    HomePageCommercialSellingPointsCollectionOrder["TitleAsc"] = "title_ASC";
    HomePageCommercialSellingPointsCollectionOrder["TitleDesc"] = "title_DESC";
    HomePageCommercialSellingPointsCollectionOrder["UrlAsc"] = "url_ASC";
    HomePageCommercialSellingPointsCollectionOrder["UrlDesc"] = "url_DESC";
})(HomePageCommercialSellingPointsCollectionOrder = exports.HomePageCommercialSellingPointsCollectionOrder || (exports.HomePageCommercialSellingPointsCollectionOrder = {}));
var HomePageOrder;
(function (HomePageOrder) {
    HomePageOrder["DefaultHolidayNumberOfNightsAsc"] = "defaultHolidayNumberOfNights_ASC";
    HomePageOrder["DefaultHolidayNumberOfNightsDesc"] = "defaultHolidayNumberOfNights_DESC";
    HomePageOrder["NameAsc"] = "name_ASC";
    HomePageOrder["NameDesc"] = "name_DESC";
    HomePageOrder["PathAsc"] = "path_ASC";
    HomePageOrder["PathDesc"] = "path_DESC";
    HomePageOrder["SummaryTitleAsc"] = "summaryTitle_ASC";
    HomePageOrder["SummaryTitleDesc"] = "summaryTitle_DESC";
    HomePageOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    HomePageOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    HomePageOrder["SysIdAsc"] = "sys_id_ASC";
    HomePageOrder["SysIdDesc"] = "sys_id_DESC";
    HomePageOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    HomePageOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    HomePageOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    HomePageOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(HomePageOrder = exports.HomePageOrder || (exports.HomePageOrder = {}));
var HomePageParkOffersCollectionOrder;
(function (HomePageParkOffersCollectionOrder) {
    HomePageParkOffersCollectionOrder["AgeFromAsc"] = "ageFrom_ASC";
    HomePageParkOffersCollectionOrder["AgeFromDesc"] = "ageFrom_DESC";
    HomePageParkOffersCollectionOrder["CtaTitleAsc"] = "ctaTitle_ASC";
    HomePageParkOffersCollectionOrder["CtaTitleDesc"] = "ctaTitle_DESC";
    HomePageParkOffersCollectionOrder["CtaUrlAsc"] = "ctaUrl_ASC";
    HomePageParkOffersCollectionOrder["CtaUrlDesc"] = "ctaUrl_DESC";
    HomePageParkOffersCollectionOrder["EndDateAsc"] = "endDate_ASC";
    HomePageParkOffersCollectionOrder["EndDateDesc"] = "endDate_DESC";
    HomePageParkOffersCollectionOrder["HolidayTypeAsc"] = "holidayType_ASC";
    HomePageParkOffersCollectionOrder["HolidayTypeDesc"] = "holidayType_DESC";
    HomePageParkOffersCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    HomePageParkOffersCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    HomePageParkOffersCollectionOrder["PropositionTypeAsc"] = "propositionType_ASC";
    HomePageParkOffersCollectionOrder["PropositionTypeDesc"] = "propositionType_DESC";
    HomePageParkOffersCollectionOrder["StartDateAsc"] = "startDate_ASC";
    HomePageParkOffersCollectionOrder["StartDateDesc"] = "startDate_DESC";
    HomePageParkOffersCollectionOrder["SubTitleAsc"] = "subTitle_ASC";
    HomePageParkOffersCollectionOrder["SubTitleDesc"] = "subTitle_DESC";
    HomePageParkOffersCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    HomePageParkOffersCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    HomePageParkOffersCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    HomePageParkOffersCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    HomePageParkOffersCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    HomePageParkOffersCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    HomePageParkOffersCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    HomePageParkOffersCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    HomePageParkOffersCollectionOrder["TitleAsc"] = "title_ASC";
    HomePageParkOffersCollectionOrder["TitleDesc"] = "title_DESC";
})(HomePageParkOffersCollectionOrder = exports.HomePageParkOffersCollectionOrder || (exports.HomePageParkOffersCollectionOrder = {}));
var HomePagePromotionsCollectionOrder;
(function (HomePagePromotionsCollectionOrder) {
    HomePagePromotionsCollectionOrder["AnalyticsCategoryAsc"] = "analyticsCategory_ASC";
    HomePagePromotionsCollectionOrder["AnalyticsCategoryDesc"] = "analyticsCategory_DESC";
    HomePagePromotionsCollectionOrder["AnalyticsTypeAsc"] = "analyticsType_ASC";
    HomePagePromotionsCollectionOrder["AnalyticsTypeDesc"] = "analyticsType_DESC";
    HomePagePromotionsCollectionOrder["AnalyticsVariantAsc"] = "analyticsVariant_ASC";
    HomePagePromotionsCollectionOrder["AnalyticsVariantDesc"] = "analyticsVariant_DESC";
    HomePagePromotionsCollectionOrder["DurationAsc"] = "duration_ASC";
    HomePagePromotionsCollectionOrder["DurationDesc"] = "duration_DESC";
    HomePagePromotionsCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    HomePagePromotionsCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    HomePagePromotionsCollectionOrder["MaxPriceAsc"] = "maxPrice_ASC";
    HomePagePromotionsCollectionOrder["MaxPriceDesc"] = "maxPrice_DESC";
    HomePagePromotionsCollectionOrder["MinPriceAsc"] = "minPrice_ASC";
    HomePagePromotionsCollectionOrder["MinPriceDesc"] = "minPrice_DESC";
    HomePagePromotionsCollectionOrder["PriceAsc"] = "price_ASC";
    HomePagePromotionsCollectionOrder["PriceDesc"] = "price_DESC";
    HomePagePromotionsCollectionOrder["SubTitleAsc"] = "subTitle_ASC";
    HomePagePromotionsCollectionOrder["SubTitleDesc"] = "subTitle_DESC";
    HomePagePromotionsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    HomePagePromotionsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    HomePagePromotionsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    HomePagePromotionsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    HomePagePromotionsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    HomePagePromotionsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    HomePagePromotionsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    HomePagePromotionsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    HomePagePromotionsCollectionOrder["TitleAsc"] = "title_ASC";
    HomePagePromotionsCollectionOrder["TitleDesc"] = "title_DESC";
    HomePagePromotionsCollectionOrder["UrlAsc"] = "url_ASC";
    HomePagePromotionsCollectionOrder["UrlDesc"] = "url_DESC";
})(HomePagePromotionsCollectionOrder = exports.HomePagePromotionsCollectionOrder || (exports.HomePagePromotionsCollectionOrder = {}));
var HomePageTermsCollectionOrder;
(function (HomePageTermsCollectionOrder) {
    HomePageTermsCollectionOrder["HolidayTypeAsc"] = "holidayType_ASC";
    HomePageTermsCollectionOrder["HolidayTypeDesc"] = "holidayType_DESC";
    HomePageTermsCollectionOrder["NameAsc"] = "name_ASC";
    HomePageTermsCollectionOrder["NameDesc"] = "name_DESC";
    HomePageTermsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    HomePageTermsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    HomePageTermsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    HomePageTermsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    HomePageTermsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    HomePageTermsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    HomePageTermsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    HomePageTermsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(HomePageTermsCollectionOrder = exports.HomePageTermsCollectionOrder || (exports.HomePageTermsCollectionOrder = {}));
var HomePageTestimonialsCollectionOrder;
(function (HomePageTestimonialsCollectionOrder) {
    HomePageTestimonialsCollectionOrder["AuthorAsc"] = "author_ASC";
    HomePageTestimonialsCollectionOrder["AuthorDesc"] = "author_DESC";
    HomePageTestimonialsCollectionOrder["HolidayTypeAsc"] = "holidayType_ASC";
    HomePageTestimonialsCollectionOrder["HolidayTypeDesc"] = "holidayType_DESC";
    HomePageTestimonialsCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    HomePageTestimonialsCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    HomePageTestimonialsCollectionOrder["RoleAsc"] = "role_ASC";
    HomePageTestimonialsCollectionOrder["RoleDesc"] = "role_DESC";
    HomePageTestimonialsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    HomePageTestimonialsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    HomePageTestimonialsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    HomePageTestimonialsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    HomePageTestimonialsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    HomePageTestimonialsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    HomePageTestimonialsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    HomePageTestimonialsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(HomePageTestimonialsCollectionOrder = exports.HomePageTestimonialsCollectionOrder || (exports.HomePageTestimonialsCollectionOrder = {}));
var ImageFormat;
(function (ImageFormat) {
    ImageFormat["Avif"] = "AVIF";
    /** JPG image format. */
    ImageFormat["Jpg"] = "JPG";
    /**
     * Progressive JPG format stores multiple passes of an image in progressively higher detail.
     *         When a progressive image is loading, the viewer will first see a lower quality pixelated version which
     *         will gradually improve in detail, until the image is fully downloaded. This is to display an image as
     *         early as possible to make the layout look as designed.
     */
    ImageFormat["JpgProgressive"] = "JPG_PROGRESSIVE";
    /** PNG image format */
    ImageFormat["Png"] = "PNG";
    /**
     * 8-bit PNG images support up to 256 colors and weigh less than the standard 24-bit PNG equivalent.
     *         The 8-bit PNG format is mostly used for simple images, such as icons or logos.
     */
    ImageFormat["Png8"] = "PNG8";
    /** WebP image format. */
    ImageFormat["Webp"] = "WEBP";
})(ImageFormat = exports.ImageFormat || (exports.ImageFormat = {}));
var ImageLinkingCollectionsAccommodationGradeCollectionOrder;
(function (ImageLinkingCollectionsAccommodationGradeCollectionOrder) {
    ImageLinkingCollectionsAccommodationGradeCollectionOrder["AccessibleAsc"] = "accessible_ASC";
    ImageLinkingCollectionsAccommodationGradeCollectionOrder["AccessibleDesc"] = "accessible_DESC";
    ImageLinkingCollectionsAccommodationGradeCollectionOrder["IncludesTitleAsc"] = "includesTitle_ASC";
    ImageLinkingCollectionsAccommodationGradeCollectionOrder["IncludesTitleDesc"] = "includesTitle_DESC";
    ImageLinkingCollectionsAccommodationGradeCollectionOrder["NameAsc"] = "name_ASC";
    ImageLinkingCollectionsAccommodationGradeCollectionOrder["NameDesc"] = "name_DESC";
    ImageLinkingCollectionsAccommodationGradeCollectionOrder["SearchAccommodationGradeAsc"] = "searchAccommodationGrade_ASC";
    ImageLinkingCollectionsAccommodationGradeCollectionOrder["SearchAccommodationGradeDesc"] = "searchAccommodationGrade_DESC";
    ImageLinkingCollectionsAccommodationGradeCollectionOrder["SellingPointsTitleAsc"] = "sellingPointsTitle_ASC";
    ImageLinkingCollectionsAccommodationGradeCollectionOrder["SellingPointsTitleDesc"] = "sellingPointsTitle_DESC";
    ImageLinkingCollectionsAccommodationGradeCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ImageLinkingCollectionsAccommodationGradeCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ImageLinkingCollectionsAccommodationGradeCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ImageLinkingCollectionsAccommodationGradeCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ImageLinkingCollectionsAccommodationGradeCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ImageLinkingCollectionsAccommodationGradeCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ImageLinkingCollectionsAccommodationGradeCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ImageLinkingCollectionsAccommodationGradeCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ImageLinkingCollectionsAccommodationGradeCollectionOrder["TaglineAsc"] = "tagline_ASC";
    ImageLinkingCollectionsAccommodationGradeCollectionOrder["TaglineDesc"] = "tagline_DESC";
})(ImageLinkingCollectionsAccommodationGradeCollectionOrder = exports.ImageLinkingCollectionsAccommodationGradeCollectionOrder || (exports.ImageLinkingCollectionsAccommodationGradeCollectionOrder = {}));
var ImageLinkingCollectionsAccommodationTypeCollectionOrder;
(function (ImageLinkingCollectionsAccommodationTypeCollectionOrder) {
    ImageLinkingCollectionsAccommodationTypeCollectionOrder["ChecklistTitleAsc"] = "checklistTitle_ASC";
    ImageLinkingCollectionsAccommodationTypeCollectionOrder["ChecklistTitleDesc"] = "checklistTitle_DESC";
    ImageLinkingCollectionsAccommodationTypeCollectionOrder["NameAsc"] = "name_ASC";
    ImageLinkingCollectionsAccommodationTypeCollectionOrder["NameDesc"] = "name_DESC";
    ImageLinkingCollectionsAccommodationTypeCollectionOrder["PathAsc"] = "path_ASC";
    ImageLinkingCollectionsAccommodationTypeCollectionOrder["PathDesc"] = "path_DESC";
    ImageLinkingCollectionsAccommodationTypeCollectionOrder["SearchAccommodationNameAsc"] = "searchAccommodationName_ASC";
    ImageLinkingCollectionsAccommodationTypeCollectionOrder["SearchAccommodationNameDesc"] = "searchAccommodationName_DESC";
    ImageLinkingCollectionsAccommodationTypeCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ImageLinkingCollectionsAccommodationTypeCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ImageLinkingCollectionsAccommodationTypeCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ImageLinkingCollectionsAccommodationTypeCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ImageLinkingCollectionsAccommodationTypeCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ImageLinkingCollectionsAccommodationTypeCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ImageLinkingCollectionsAccommodationTypeCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ImageLinkingCollectionsAccommodationTypeCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ImageLinkingCollectionsAccommodationTypeCollectionOrder["TitleAsc"] = "title_ASC";
    ImageLinkingCollectionsAccommodationTypeCollectionOrder["TitleDesc"] = "title_DESC";
})(ImageLinkingCollectionsAccommodationTypeCollectionOrder = exports.ImageLinkingCollectionsAccommodationTypeCollectionOrder || (exports.ImageLinkingCollectionsAccommodationTypeCollectionOrder = {}));
var ImageLinkingCollectionsAdvertCollectionOrder;
(function (ImageLinkingCollectionsAdvertCollectionOrder) {
    ImageLinkingCollectionsAdvertCollectionOrder["AnalyticsCategoryAsc"] = "analyticsCategory_ASC";
    ImageLinkingCollectionsAdvertCollectionOrder["AnalyticsCategoryDesc"] = "analyticsCategory_DESC";
    ImageLinkingCollectionsAdvertCollectionOrder["AnalyticsTypeAsc"] = "analyticsType_ASC";
    ImageLinkingCollectionsAdvertCollectionOrder["AnalyticsTypeDesc"] = "analyticsType_DESC";
    ImageLinkingCollectionsAdvertCollectionOrder["AnalyticsVariantAsc"] = "analyticsVariant_ASC";
    ImageLinkingCollectionsAdvertCollectionOrder["AnalyticsVariantDesc"] = "analyticsVariant_DESC";
    ImageLinkingCollectionsAdvertCollectionOrder["CtaAsc"] = "cta_ASC";
    ImageLinkingCollectionsAdvertCollectionOrder["CtaDesc"] = "cta_DESC";
    ImageLinkingCollectionsAdvertCollectionOrder["DescriptionAsc"] = "description_ASC";
    ImageLinkingCollectionsAdvertCollectionOrder["DescriptionDesc"] = "description_DESC";
    ImageLinkingCollectionsAdvertCollectionOrder["SubTitleAsc"] = "subTitle_ASC";
    ImageLinkingCollectionsAdvertCollectionOrder["SubTitleDesc"] = "subTitle_DESC";
    ImageLinkingCollectionsAdvertCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ImageLinkingCollectionsAdvertCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ImageLinkingCollectionsAdvertCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ImageLinkingCollectionsAdvertCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ImageLinkingCollectionsAdvertCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ImageLinkingCollectionsAdvertCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ImageLinkingCollectionsAdvertCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ImageLinkingCollectionsAdvertCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ImageLinkingCollectionsAdvertCollectionOrder["TitleAsc"] = "title_ASC";
    ImageLinkingCollectionsAdvertCollectionOrder["TitleDesc"] = "title_DESC";
    ImageLinkingCollectionsAdvertCollectionOrder["UrlAsc"] = "url_ASC";
    ImageLinkingCollectionsAdvertCollectionOrder["UrlDesc"] = "url_DESC";
})(ImageLinkingCollectionsAdvertCollectionOrder = exports.ImageLinkingCollectionsAdvertCollectionOrder || (exports.ImageLinkingCollectionsAdvertCollectionOrder = {}));
var ImageLinkingCollectionsArticleSectionCollectionOrder;
(function (ImageLinkingCollectionsArticleSectionCollectionOrder) {
    ImageLinkingCollectionsArticleSectionCollectionOrder["CoordinatesAsc"] = "coordinates_ASC";
    ImageLinkingCollectionsArticleSectionCollectionOrder["CoordinatesDesc"] = "coordinates_DESC";
    ImageLinkingCollectionsArticleSectionCollectionOrder["NameAsc"] = "name_ASC";
    ImageLinkingCollectionsArticleSectionCollectionOrder["NameDesc"] = "name_DESC";
    ImageLinkingCollectionsArticleSectionCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ImageLinkingCollectionsArticleSectionCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ImageLinkingCollectionsArticleSectionCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ImageLinkingCollectionsArticleSectionCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ImageLinkingCollectionsArticleSectionCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ImageLinkingCollectionsArticleSectionCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ImageLinkingCollectionsArticleSectionCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ImageLinkingCollectionsArticleSectionCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ImageLinkingCollectionsArticleSectionCollectionOrder["TitleAsc"] = "title_ASC";
    ImageLinkingCollectionsArticleSectionCollectionOrder["TitleDesc"] = "title_DESC";
})(ImageLinkingCollectionsArticleSectionCollectionOrder = exports.ImageLinkingCollectionsArticleSectionCollectionOrder || (exports.ImageLinkingCollectionsArticleSectionCollectionOrder = {}));
var ImageLinkingCollectionsArticlesCollectionOrder;
(function (ImageLinkingCollectionsArticlesCollectionOrder) {
    ImageLinkingCollectionsArticlesCollectionOrder["ArticleSummaryAsc"] = "articleSummary_ASC";
    ImageLinkingCollectionsArticlesCollectionOrder["ArticleSummaryDesc"] = "articleSummary_DESC";
    ImageLinkingCollectionsArticlesCollectionOrder["AuthorAsc"] = "author_ASC";
    ImageLinkingCollectionsArticlesCollectionOrder["AuthorDesc"] = "author_DESC";
    ImageLinkingCollectionsArticlesCollectionOrder["HolidayTypeAsc"] = "holidayType_ASC";
    ImageLinkingCollectionsArticlesCollectionOrder["HolidayTypeDesc"] = "holidayType_DESC";
    ImageLinkingCollectionsArticlesCollectionOrder["NameAsc"] = "name_ASC";
    ImageLinkingCollectionsArticlesCollectionOrder["NameDesc"] = "name_DESC";
    ImageLinkingCollectionsArticlesCollectionOrder["PathAsc"] = "path_ASC";
    ImageLinkingCollectionsArticlesCollectionOrder["PathDesc"] = "path_DESC";
    ImageLinkingCollectionsArticlesCollectionOrder["RelatedArticlesTitleAsc"] = "relatedArticlesTitle_ASC";
    ImageLinkingCollectionsArticlesCollectionOrder["RelatedArticlesTitleDesc"] = "relatedArticlesTitle_DESC";
    ImageLinkingCollectionsArticlesCollectionOrder["ShowTableOfContentsAsc"] = "showTableOfContents_ASC";
    ImageLinkingCollectionsArticlesCollectionOrder["ShowTableOfContentsDesc"] = "showTableOfContents_DESC";
    ImageLinkingCollectionsArticlesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ImageLinkingCollectionsArticlesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ImageLinkingCollectionsArticlesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ImageLinkingCollectionsArticlesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ImageLinkingCollectionsArticlesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ImageLinkingCollectionsArticlesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ImageLinkingCollectionsArticlesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ImageLinkingCollectionsArticlesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ImageLinkingCollectionsArticlesCollectionOrder["TitleAsc"] = "title_ASC";
    ImageLinkingCollectionsArticlesCollectionOrder["TitleDesc"] = "title_DESC";
})(ImageLinkingCollectionsArticlesCollectionOrder = exports.ImageLinkingCollectionsArticlesCollectionOrder || (exports.ImageLinkingCollectionsArticlesCollectionOrder = {}));
var ImageLinkingCollectionsAwardCollectionOrder;
(function (ImageLinkingCollectionsAwardCollectionOrder) {
    ImageLinkingCollectionsAwardCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    ImageLinkingCollectionsAwardCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    ImageLinkingCollectionsAwardCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ImageLinkingCollectionsAwardCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ImageLinkingCollectionsAwardCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ImageLinkingCollectionsAwardCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ImageLinkingCollectionsAwardCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ImageLinkingCollectionsAwardCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ImageLinkingCollectionsAwardCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ImageLinkingCollectionsAwardCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ImageLinkingCollectionsAwardCollectionOrder["TitleAsc"] = "title_ASC";
    ImageLinkingCollectionsAwardCollectionOrder["TitleDesc"] = "title_DESC";
    ImageLinkingCollectionsAwardCollectionOrder["UrlAsc"] = "url_ASC";
    ImageLinkingCollectionsAwardCollectionOrder["UrlDesc"] = "url_DESC";
})(ImageLinkingCollectionsAwardCollectionOrder = exports.ImageLinkingCollectionsAwardCollectionOrder || (exports.ImageLinkingCollectionsAwardCollectionOrder = {}));
var ImageLinkingCollectionsBoxCollectionOrder;
(function (ImageLinkingCollectionsBoxCollectionOrder) {
    ImageLinkingCollectionsBoxCollectionOrder["DescriptionUrlAsc"] = "descriptionUrl_ASC";
    ImageLinkingCollectionsBoxCollectionOrder["DescriptionUrlDesc"] = "descriptionUrl_DESC";
    ImageLinkingCollectionsBoxCollectionOrder["HrefAsc"] = "href_ASC";
    ImageLinkingCollectionsBoxCollectionOrder["HrefDesc"] = "href_DESC";
    ImageLinkingCollectionsBoxCollectionOrder["NameAsc"] = "name_ASC";
    ImageLinkingCollectionsBoxCollectionOrder["NameDesc"] = "name_DESC";
    ImageLinkingCollectionsBoxCollectionOrder["ShowOnPagesAsc"] = "showOnPages_ASC";
    ImageLinkingCollectionsBoxCollectionOrder["ShowOnPagesDesc"] = "showOnPages_DESC";
    ImageLinkingCollectionsBoxCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ImageLinkingCollectionsBoxCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ImageLinkingCollectionsBoxCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ImageLinkingCollectionsBoxCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ImageLinkingCollectionsBoxCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ImageLinkingCollectionsBoxCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ImageLinkingCollectionsBoxCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ImageLinkingCollectionsBoxCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ImageLinkingCollectionsBoxCollectionOrder["TitleLevelAsc"] = "titleLevel_ASC";
    ImageLinkingCollectionsBoxCollectionOrder["TitleLevelDesc"] = "titleLevel_DESC";
    ImageLinkingCollectionsBoxCollectionOrder["TitleAsc"] = "title_ASC";
    ImageLinkingCollectionsBoxCollectionOrder["TitleDesc"] = "title_DESC";
})(ImageLinkingCollectionsBoxCollectionOrder = exports.ImageLinkingCollectionsBoxCollectionOrder || (exports.ImageLinkingCollectionsBoxCollectionOrder = {}));
var ImageLinkingCollectionsCaravanTypeByParkCollectionOrder;
(function (ImageLinkingCollectionsCaravanTypeByParkCollectionOrder) {
    ImageLinkingCollectionsCaravanTypeByParkCollectionOrder["ContentfulNameAsc"] = "contentfulName_ASC";
    ImageLinkingCollectionsCaravanTypeByParkCollectionOrder["ContentfulNameDesc"] = "contentfulName_DESC";
    ImageLinkingCollectionsCaravanTypeByParkCollectionOrder["DisplayNameAsc"] = "displayName_ASC";
    ImageLinkingCollectionsCaravanTypeByParkCollectionOrder["DisplayNameDesc"] = "displayName_DESC";
    ImageLinkingCollectionsCaravanTypeByParkCollectionOrder["MatterportIdAsc"] = "matterportId_ASC";
    ImageLinkingCollectionsCaravanTypeByParkCollectionOrder["MatterportIdDesc"] = "matterportId_DESC";
    ImageLinkingCollectionsCaravanTypeByParkCollectionOrder["SubTitleAsc"] = "subTitle_ASC";
    ImageLinkingCollectionsCaravanTypeByParkCollectionOrder["SubTitleDesc"] = "subTitle_DESC";
    ImageLinkingCollectionsCaravanTypeByParkCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ImageLinkingCollectionsCaravanTypeByParkCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ImageLinkingCollectionsCaravanTypeByParkCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ImageLinkingCollectionsCaravanTypeByParkCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ImageLinkingCollectionsCaravanTypeByParkCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ImageLinkingCollectionsCaravanTypeByParkCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ImageLinkingCollectionsCaravanTypeByParkCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ImageLinkingCollectionsCaravanTypeByParkCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ImageLinkingCollectionsCaravanTypeByParkCollectionOrder["TitleAsc"] = "title_ASC";
    ImageLinkingCollectionsCaravanTypeByParkCollectionOrder["TitleDesc"] = "title_DESC";
})(ImageLinkingCollectionsCaravanTypeByParkCollectionOrder = exports.ImageLinkingCollectionsCaravanTypeByParkCollectionOrder || (exports.ImageLinkingCollectionsCaravanTypeByParkCollectionOrder = {}));
var ImageLinkingCollectionsCaravanTypesCollectionOrder;
(function (ImageLinkingCollectionsCaravanTypesCollectionOrder) {
    ImageLinkingCollectionsCaravanTypesCollectionOrder["CaravanCodeAsc"] = "caravanCode_ASC";
    ImageLinkingCollectionsCaravanTypesCollectionOrder["CaravanCodeDesc"] = "caravanCode_DESC";
    ImageLinkingCollectionsCaravanTypesCollectionOrder["ContentfulNameAsc"] = "contentfulName_ASC";
    ImageLinkingCollectionsCaravanTypesCollectionOrder["ContentfulNameDesc"] = "contentfulName_DESC";
    ImageLinkingCollectionsCaravanTypesCollectionOrder["MatterportIdAsc"] = "matterportId_ASC";
    ImageLinkingCollectionsCaravanTypesCollectionOrder["MatterportIdDesc"] = "matterportId_DESC";
    ImageLinkingCollectionsCaravanTypesCollectionOrder["NameAsc"] = "name_ASC";
    ImageLinkingCollectionsCaravanTypesCollectionOrder["NameDesc"] = "name_DESC";
    ImageLinkingCollectionsCaravanTypesCollectionOrder["SubTitleAsc"] = "subTitle_ASC";
    ImageLinkingCollectionsCaravanTypesCollectionOrder["SubTitleDesc"] = "subTitle_DESC";
    ImageLinkingCollectionsCaravanTypesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ImageLinkingCollectionsCaravanTypesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ImageLinkingCollectionsCaravanTypesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ImageLinkingCollectionsCaravanTypesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ImageLinkingCollectionsCaravanTypesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ImageLinkingCollectionsCaravanTypesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ImageLinkingCollectionsCaravanTypesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ImageLinkingCollectionsCaravanTypesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ImageLinkingCollectionsCaravanTypesCollectionOrder["TitleAsc"] = "title_ASC";
    ImageLinkingCollectionsCaravanTypesCollectionOrder["TitleDesc"] = "title_DESC";
})(ImageLinkingCollectionsCaravanTypesCollectionOrder = exports.ImageLinkingCollectionsCaravanTypesCollectionOrder || (exports.ImageLinkingCollectionsCaravanTypesCollectionOrder = {}));
var ImageLinkingCollectionsFullCampaignCollectionOrder;
(function (ImageLinkingCollectionsFullCampaignCollectionOrder) {
    ImageLinkingCollectionsFullCampaignCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    ImageLinkingCollectionsFullCampaignCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    ImageLinkingCollectionsFullCampaignCollectionOrder["FeaturedParksTitleAsc"] = "featuredParksTitle_ASC";
    ImageLinkingCollectionsFullCampaignCollectionOrder["FeaturedParksTitleDesc"] = "featuredParksTitle_DESC";
    ImageLinkingCollectionsFullCampaignCollectionOrder["FeaturedPromotionsTitleAsc"] = "featuredPromotionsTitle_ASC";
    ImageLinkingCollectionsFullCampaignCollectionOrder["FeaturedPromotionsTitleDesc"] = "featuredPromotionsTitle_DESC";
    ImageLinkingCollectionsFullCampaignCollectionOrder["IntroductionTitleAsc"] = "introductionTitle_ASC";
    ImageLinkingCollectionsFullCampaignCollectionOrder["IntroductionTitleDesc"] = "introductionTitle_DESC";
    ImageLinkingCollectionsFullCampaignCollectionOrder["NameAsc"] = "name_ASC";
    ImageLinkingCollectionsFullCampaignCollectionOrder["NameDesc"] = "name_DESC";
    ImageLinkingCollectionsFullCampaignCollectionOrder["PathAsc"] = "path_ASC";
    ImageLinkingCollectionsFullCampaignCollectionOrder["PathDesc"] = "path_DESC";
    ImageLinkingCollectionsFullCampaignCollectionOrder["PromotionsTitleAsc"] = "promotionsTitle_ASC";
    ImageLinkingCollectionsFullCampaignCollectionOrder["PromotionsTitleDesc"] = "promotionsTitle_DESC";
    ImageLinkingCollectionsFullCampaignCollectionOrder["ReasonsToBookTitleAsc"] = "reasonsToBookTitle_ASC";
    ImageLinkingCollectionsFullCampaignCollectionOrder["ReasonsToBookTitleDesc"] = "reasonsToBookTitle_DESC";
    ImageLinkingCollectionsFullCampaignCollectionOrder["SellingPointsTitleAsc"] = "sellingPointsTitle_ASC";
    ImageLinkingCollectionsFullCampaignCollectionOrder["SellingPointsTitleDesc"] = "sellingPointsTitle_DESC";
    ImageLinkingCollectionsFullCampaignCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ImageLinkingCollectionsFullCampaignCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ImageLinkingCollectionsFullCampaignCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ImageLinkingCollectionsFullCampaignCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ImageLinkingCollectionsFullCampaignCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ImageLinkingCollectionsFullCampaignCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ImageLinkingCollectionsFullCampaignCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ImageLinkingCollectionsFullCampaignCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ImageLinkingCollectionsFullCampaignCollectionOrder["TitleAsc"] = "title_ASC";
    ImageLinkingCollectionsFullCampaignCollectionOrder["TitleDesc"] = "title_DESC";
})(ImageLinkingCollectionsFullCampaignCollectionOrder = exports.ImageLinkingCollectionsFullCampaignCollectionOrder || (exports.ImageLinkingCollectionsFullCampaignCollectionOrder = {}));
var ImageLinkingCollectionsGenericTemplateCollectionOrder;
(function (ImageLinkingCollectionsGenericTemplateCollectionOrder) {
    ImageLinkingCollectionsGenericTemplateCollectionOrder["NameAsc"] = "name_ASC";
    ImageLinkingCollectionsGenericTemplateCollectionOrder["NameDesc"] = "name_DESC";
    ImageLinkingCollectionsGenericTemplateCollectionOrder["PathAsc"] = "path_ASC";
    ImageLinkingCollectionsGenericTemplateCollectionOrder["PathDesc"] = "path_DESC";
    ImageLinkingCollectionsGenericTemplateCollectionOrder["ShowTableOfContentsAsc"] = "showTableOfContents_ASC";
    ImageLinkingCollectionsGenericTemplateCollectionOrder["ShowTableOfContentsDesc"] = "showTableOfContents_DESC";
    ImageLinkingCollectionsGenericTemplateCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ImageLinkingCollectionsGenericTemplateCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ImageLinkingCollectionsGenericTemplateCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ImageLinkingCollectionsGenericTemplateCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ImageLinkingCollectionsGenericTemplateCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ImageLinkingCollectionsGenericTemplateCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ImageLinkingCollectionsGenericTemplateCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ImageLinkingCollectionsGenericTemplateCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ImageLinkingCollectionsGenericTemplateCollectionOrder["TitleAsc"] = "title_ASC";
    ImageLinkingCollectionsGenericTemplateCollectionOrder["TitleDesc"] = "title_DESC";
})(ImageLinkingCollectionsGenericTemplateCollectionOrder = exports.ImageLinkingCollectionsGenericTemplateCollectionOrder || (exports.ImageLinkingCollectionsGenericTemplateCollectionOrder = {}));
var ImageLinkingCollectionsHavenPromiseCollectionOrder;
(function (ImageLinkingCollectionsHavenPromiseCollectionOrder) {
    ImageLinkingCollectionsHavenPromiseCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ImageLinkingCollectionsHavenPromiseCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ImageLinkingCollectionsHavenPromiseCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ImageLinkingCollectionsHavenPromiseCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ImageLinkingCollectionsHavenPromiseCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ImageLinkingCollectionsHavenPromiseCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ImageLinkingCollectionsHavenPromiseCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ImageLinkingCollectionsHavenPromiseCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ImageLinkingCollectionsHavenPromiseCollectionOrder["TitleAsc"] = "title_ASC";
    ImageLinkingCollectionsHavenPromiseCollectionOrder["TitleDesc"] = "title_DESC";
})(ImageLinkingCollectionsHavenPromiseCollectionOrder = exports.ImageLinkingCollectionsHavenPromiseCollectionOrder || (exports.ImageLinkingCollectionsHavenPromiseCollectionOrder = {}));
var ImageLinkingCollectionsHolidayPackageCollectionOrder;
(function (ImageLinkingCollectionsHolidayPackageCollectionOrder) {
    ImageLinkingCollectionsHolidayPackageCollectionOrder["FeaturesTitleAsc"] = "featuresTitle_ASC";
    ImageLinkingCollectionsHolidayPackageCollectionOrder["FeaturesTitleDesc"] = "featuresTitle_DESC";
    ImageLinkingCollectionsHolidayPackageCollectionOrder["SellingPointsTitleAsc"] = "sellingPointsTitle_ASC";
    ImageLinkingCollectionsHolidayPackageCollectionOrder["SellingPointsTitleDesc"] = "sellingPointsTitle_DESC";
    ImageLinkingCollectionsHolidayPackageCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ImageLinkingCollectionsHolidayPackageCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ImageLinkingCollectionsHolidayPackageCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ImageLinkingCollectionsHolidayPackageCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ImageLinkingCollectionsHolidayPackageCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ImageLinkingCollectionsHolidayPackageCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ImageLinkingCollectionsHolidayPackageCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ImageLinkingCollectionsHolidayPackageCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ImageLinkingCollectionsHolidayPackageCollectionOrder["TitleAsc"] = "title_ASC";
    ImageLinkingCollectionsHolidayPackageCollectionOrder["TitleDesc"] = "title_DESC";
})(ImageLinkingCollectionsHolidayPackageCollectionOrder = exports.ImageLinkingCollectionsHolidayPackageCollectionOrder || (exports.ImageLinkingCollectionsHolidayPackageCollectionOrder = {}));
var ImageLinkingCollectionsHolidaySelectionPageCollectionOrder;
(function (ImageLinkingCollectionsHolidaySelectionPageCollectionOrder) {
    ImageLinkingCollectionsHolidaySelectionPageCollectionOrder["NameAsc"] = "name_ASC";
    ImageLinkingCollectionsHolidaySelectionPageCollectionOrder["NameDesc"] = "name_DESC";
    ImageLinkingCollectionsHolidaySelectionPageCollectionOrder["PathAsc"] = "path_ASC";
    ImageLinkingCollectionsHolidaySelectionPageCollectionOrder["PathDesc"] = "path_DESC";
    ImageLinkingCollectionsHolidaySelectionPageCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ImageLinkingCollectionsHolidaySelectionPageCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ImageLinkingCollectionsHolidaySelectionPageCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ImageLinkingCollectionsHolidaySelectionPageCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ImageLinkingCollectionsHolidaySelectionPageCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ImageLinkingCollectionsHolidaySelectionPageCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ImageLinkingCollectionsHolidaySelectionPageCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ImageLinkingCollectionsHolidaySelectionPageCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ImageLinkingCollectionsHolidaySelectionPageCollectionOrder["TitleAsc"] = "title_ASC";
    ImageLinkingCollectionsHolidaySelectionPageCollectionOrder["TitleDesc"] = "title_DESC";
})(ImageLinkingCollectionsHolidaySelectionPageCollectionOrder = exports.ImageLinkingCollectionsHolidaySelectionPageCollectionOrder || (exports.ImageLinkingCollectionsHolidaySelectionPageCollectionOrder = {}));
var ImageLinkingCollectionsParkCollectionOrder;
(function (ImageLinkingCollectionsParkCollectionOrder) {
    ImageLinkingCollectionsParkCollectionOrder["ContactNumberAsc"] = "contactNumber_ASC";
    ImageLinkingCollectionsParkCollectionOrder["ContactNumberDesc"] = "contactNumber_DESC";
    ImageLinkingCollectionsParkCollectionOrder["DirectionsUrlAsc"] = "directionsUrl_ASC";
    ImageLinkingCollectionsParkCollectionOrder["DirectionsUrlDesc"] = "directionsUrl_DESC";
    ImageLinkingCollectionsParkCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    ImageLinkingCollectionsParkCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    ImageLinkingCollectionsParkCollectionOrder["NameAsc"] = "name_ASC";
    ImageLinkingCollectionsParkCollectionOrder["NameDesc"] = "name_DESC";
    ImageLinkingCollectionsParkCollectionOrder["ParkTypeAsc"] = "parkType_ASC";
    ImageLinkingCollectionsParkCollectionOrder["ParkTypeDesc"] = "parkType_DESC";
    ImageLinkingCollectionsParkCollectionOrder["PathAsc"] = "path_ASC";
    ImageLinkingCollectionsParkCollectionOrder["PathDesc"] = "path_DESC";
    ImageLinkingCollectionsParkCollectionOrder["RunningCostsAsc"] = "runningCosts_ASC";
    ImageLinkingCollectionsParkCollectionOrder["RunningCostsDesc"] = "runningCosts_DESC";
    ImageLinkingCollectionsParkCollectionOrder["SiteFeesAsc"] = "siteFees_ASC";
    ImageLinkingCollectionsParkCollectionOrder["SiteFeesDesc"] = "siteFees_DESC";
    ImageLinkingCollectionsParkCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ImageLinkingCollectionsParkCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ImageLinkingCollectionsParkCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ImageLinkingCollectionsParkCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ImageLinkingCollectionsParkCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ImageLinkingCollectionsParkCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ImageLinkingCollectionsParkCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ImageLinkingCollectionsParkCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ImageLinkingCollectionsParkCollectionOrder["TaglineAsc"] = "tagline_ASC";
    ImageLinkingCollectionsParkCollectionOrder["TaglineDesc"] = "tagline_DESC";
    ImageLinkingCollectionsParkCollectionOrder["ThingsToDoTitleAsc"] = "thingsToDoTitle_ASC";
    ImageLinkingCollectionsParkCollectionOrder["ThingsToDoTitleDesc"] = "thingsToDoTitle_DESC";
    ImageLinkingCollectionsParkCollectionOrder["TitleAsc"] = "title_ASC";
    ImageLinkingCollectionsParkCollectionOrder["TitleDesc"] = "title_DESC";
})(ImageLinkingCollectionsParkCollectionOrder = exports.ImageLinkingCollectionsParkCollectionOrder || (exports.ImageLinkingCollectionsParkCollectionOrder = {}));
var ImageLinkingCollectionsParkFeaturesCollectionOrder;
(function (ImageLinkingCollectionsParkFeaturesCollectionOrder) {
    ImageLinkingCollectionsParkFeaturesCollectionOrder["ApiIdAsc"] = "apiId_ASC";
    ImageLinkingCollectionsParkFeaturesCollectionOrder["ApiIdDesc"] = "apiId_DESC";
    ImageLinkingCollectionsParkFeaturesCollectionOrder["DateIntroducedAsc"] = "dateIntroduced_ASC";
    ImageLinkingCollectionsParkFeaturesCollectionOrder["DateIntroducedDesc"] = "dateIntroduced_DESC";
    ImageLinkingCollectionsParkFeaturesCollectionOrder["NameAsc"] = "name_ASC";
    ImageLinkingCollectionsParkFeaturesCollectionOrder["NameDesc"] = "name_DESC";
    ImageLinkingCollectionsParkFeaturesCollectionOrder["PropositionTypeAsc"] = "propositionType_ASC";
    ImageLinkingCollectionsParkFeaturesCollectionOrder["PropositionTypeDesc"] = "propositionType_DESC";
    ImageLinkingCollectionsParkFeaturesCollectionOrder["ShortTitleAsc"] = "shortTitle_ASC";
    ImageLinkingCollectionsParkFeaturesCollectionOrder["ShortTitleDesc"] = "shortTitle_DESC";
    ImageLinkingCollectionsParkFeaturesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ImageLinkingCollectionsParkFeaturesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ImageLinkingCollectionsParkFeaturesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ImageLinkingCollectionsParkFeaturesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ImageLinkingCollectionsParkFeaturesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ImageLinkingCollectionsParkFeaturesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ImageLinkingCollectionsParkFeaturesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ImageLinkingCollectionsParkFeaturesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ImageLinkingCollectionsParkFeaturesCollectionOrder["TitleAsc"] = "title_ASC";
    ImageLinkingCollectionsParkFeaturesCollectionOrder["TitleDesc"] = "title_DESC";
    ImageLinkingCollectionsParkFeaturesCollectionOrder["UrlAsc"] = "url_ASC";
    ImageLinkingCollectionsParkFeaturesCollectionOrder["UrlDesc"] = "url_DESC";
})(ImageLinkingCollectionsParkFeaturesCollectionOrder = exports.ImageLinkingCollectionsParkFeaturesCollectionOrder || (exports.ImageLinkingCollectionsParkFeaturesCollectionOrder = {}));
var ImageLinkingCollectionsParkInformationCollectionOrder;
(function (ImageLinkingCollectionsParkInformationCollectionOrder) {
    ImageLinkingCollectionsParkInformationCollectionOrder["ActivitiesUrlAsc"] = "activitiesUrl_ASC";
    ImageLinkingCollectionsParkInformationCollectionOrder["ActivitiesUrlDesc"] = "activitiesUrl_DESC";
    ImageLinkingCollectionsParkInformationCollectionOrder["AddressParkNameAsc"] = "addressParkName_ASC";
    ImageLinkingCollectionsParkInformationCollectionOrder["AddressParkNameDesc"] = "addressParkName_DESC";
    ImageLinkingCollectionsParkInformationCollectionOrder["CountryAsc"] = "country_ASC";
    ImageLinkingCollectionsParkInformationCollectionOrder["CountryDesc"] = "country_DESC";
    ImageLinkingCollectionsParkInformationCollectionOrder["CountyAsc"] = "county_ASC";
    ImageLinkingCollectionsParkInformationCollectionOrder["CountyDesc"] = "county_DESC";
    ImageLinkingCollectionsParkInformationCollectionOrder["LatlngAsc"] = "latlng_ASC";
    ImageLinkingCollectionsParkInformationCollectionOrder["LatlngDesc"] = "latlng_DESC";
    ImageLinkingCollectionsParkInformationCollectionOrder["ParkCodeAsc"] = "parkCode_ASC";
    ImageLinkingCollectionsParkInformationCollectionOrder["ParkCodeDesc"] = "parkCode_DESC";
    ImageLinkingCollectionsParkInformationCollectionOrder["ParkNameAsc"] = "parkName_ASC";
    ImageLinkingCollectionsParkInformationCollectionOrder["ParkNameDesc"] = "parkName_DESC";
    ImageLinkingCollectionsParkInformationCollectionOrder["PostcodeAsc"] = "postcode_ASC";
    ImageLinkingCollectionsParkInformationCollectionOrder["PostcodeDesc"] = "postcode_DESC";
    ImageLinkingCollectionsParkInformationCollectionOrder["RegionCodeAsc"] = "regionCode_ASC";
    ImageLinkingCollectionsParkInformationCollectionOrder["RegionCodeDesc"] = "regionCode_DESC";
    ImageLinkingCollectionsParkInformationCollectionOrder["RegionNameAsc"] = "regionName_ASC";
    ImageLinkingCollectionsParkInformationCollectionOrder["RegionNameDesc"] = "regionName_DESC";
    ImageLinkingCollectionsParkInformationCollectionOrder["StreetAddressAsc"] = "streetAddress_ASC";
    ImageLinkingCollectionsParkInformationCollectionOrder["StreetAddressDesc"] = "streetAddress_DESC";
    ImageLinkingCollectionsParkInformationCollectionOrder["SubRegionAsc"] = "subRegion_ASC";
    ImageLinkingCollectionsParkInformationCollectionOrder["SubRegionDesc"] = "subRegion_DESC";
    ImageLinkingCollectionsParkInformationCollectionOrder["SuburbAsc"] = "suburb_ASC";
    ImageLinkingCollectionsParkInformationCollectionOrder["SuburbDesc"] = "suburb_DESC";
    ImageLinkingCollectionsParkInformationCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ImageLinkingCollectionsParkInformationCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ImageLinkingCollectionsParkInformationCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ImageLinkingCollectionsParkInformationCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ImageLinkingCollectionsParkInformationCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ImageLinkingCollectionsParkInformationCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ImageLinkingCollectionsParkInformationCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ImageLinkingCollectionsParkInformationCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ImageLinkingCollectionsParkInformationCollectionOrder["TownAsc"] = "town_ASC";
    ImageLinkingCollectionsParkInformationCollectionOrder["TownDesc"] = "town_DESC";
})(ImageLinkingCollectionsParkInformationCollectionOrder = exports.ImageLinkingCollectionsParkInformationCollectionOrder || (exports.ImageLinkingCollectionsParkInformationCollectionOrder = {}));
var ImageLinkingCollectionsParkOfferCollectionOrder;
(function (ImageLinkingCollectionsParkOfferCollectionOrder) {
    ImageLinkingCollectionsParkOfferCollectionOrder["AgeFromAsc"] = "ageFrom_ASC";
    ImageLinkingCollectionsParkOfferCollectionOrder["AgeFromDesc"] = "ageFrom_DESC";
    ImageLinkingCollectionsParkOfferCollectionOrder["CtaTitleAsc"] = "ctaTitle_ASC";
    ImageLinkingCollectionsParkOfferCollectionOrder["CtaTitleDesc"] = "ctaTitle_DESC";
    ImageLinkingCollectionsParkOfferCollectionOrder["CtaUrlAsc"] = "ctaUrl_ASC";
    ImageLinkingCollectionsParkOfferCollectionOrder["CtaUrlDesc"] = "ctaUrl_DESC";
    ImageLinkingCollectionsParkOfferCollectionOrder["EndDateAsc"] = "endDate_ASC";
    ImageLinkingCollectionsParkOfferCollectionOrder["EndDateDesc"] = "endDate_DESC";
    ImageLinkingCollectionsParkOfferCollectionOrder["HolidayTypeAsc"] = "holidayType_ASC";
    ImageLinkingCollectionsParkOfferCollectionOrder["HolidayTypeDesc"] = "holidayType_DESC";
    ImageLinkingCollectionsParkOfferCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    ImageLinkingCollectionsParkOfferCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    ImageLinkingCollectionsParkOfferCollectionOrder["PropositionTypeAsc"] = "propositionType_ASC";
    ImageLinkingCollectionsParkOfferCollectionOrder["PropositionTypeDesc"] = "propositionType_DESC";
    ImageLinkingCollectionsParkOfferCollectionOrder["StartDateAsc"] = "startDate_ASC";
    ImageLinkingCollectionsParkOfferCollectionOrder["StartDateDesc"] = "startDate_DESC";
    ImageLinkingCollectionsParkOfferCollectionOrder["SubTitleAsc"] = "subTitle_ASC";
    ImageLinkingCollectionsParkOfferCollectionOrder["SubTitleDesc"] = "subTitle_DESC";
    ImageLinkingCollectionsParkOfferCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ImageLinkingCollectionsParkOfferCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ImageLinkingCollectionsParkOfferCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ImageLinkingCollectionsParkOfferCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ImageLinkingCollectionsParkOfferCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ImageLinkingCollectionsParkOfferCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ImageLinkingCollectionsParkOfferCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ImageLinkingCollectionsParkOfferCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ImageLinkingCollectionsParkOfferCollectionOrder["TitleAsc"] = "title_ASC";
    ImageLinkingCollectionsParkOfferCollectionOrder["TitleDesc"] = "title_DESC";
})(ImageLinkingCollectionsParkOfferCollectionOrder = exports.ImageLinkingCollectionsParkOfferCollectionOrder || (exports.ImageLinkingCollectionsParkOfferCollectionOrder = {}));
var ImageLinkingCollectionsPromoLinkCollectionOrder;
(function (ImageLinkingCollectionsPromoLinkCollectionOrder) {
    ImageLinkingCollectionsPromoLinkCollectionOrder["NameAsc"] = "name_ASC";
    ImageLinkingCollectionsPromoLinkCollectionOrder["NameDesc"] = "name_DESC";
    ImageLinkingCollectionsPromoLinkCollectionOrder["ReadMoreAsc"] = "readMore_ASC";
    ImageLinkingCollectionsPromoLinkCollectionOrder["ReadMoreDesc"] = "readMore_DESC";
    ImageLinkingCollectionsPromoLinkCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ImageLinkingCollectionsPromoLinkCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ImageLinkingCollectionsPromoLinkCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ImageLinkingCollectionsPromoLinkCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ImageLinkingCollectionsPromoLinkCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ImageLinkingCollectionsPromoLinkCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ImageLinkingCollectionsPromoLinkCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ImageLinkingCollectionsPromoLinkCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(ImageLinkingCollectionsPromoLinkCollectionOrder = exports.ImageLinkingCollectionsPromoLinkCollectionOrder || (exports.ImageLinkingCollectionsPromoLinkCollectionOrder = {}));
var ImageLinkingCollectionsPromotionCollectionOrder;
(function (ImageLinkingCollectionsPromotionCollectionOrder) {
    ImageLinkingCollectionsPromotionCollectionOrder["AnalyticsCategoryAsc"] = "analyticsCategory_ASC";
    ImageLinkingCollectionsPromotionCollectionOrder["AnalyticsCategoryDesc"] = "analyticsCategory_DESC";
    ImageLinkingCollectionsPromotionCollectionOrder["AnalyticsTypeAsc"] = "analyticsType_ASC";
    ImageLinkingCollectionsPromotionCollectionOrder["AnalyticsTypeDesc"] = "analyticsType_DESC";
    ImageLinkingCollectionsPromotionCollectionOrder["AnalyticsVariantAsc"] = "analyticsVariant_ASC";
    ImageLinkingCollectionsPromotionCollectionOrder["AnalyticsVariantDesc"] = "analyticsVariant_DESC";
    ImageLinkingCollectionsPromotionCollectionOrder["DurationAsc"] = "duration_ASC";
    ImageLinkingCollectionsPromotionCollectionOrder["DurationDesc"] = "duration_DESC";
    ImageLinkingCollectionsPromotionCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    ImageLinkingCollectionsPromotionCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    ImageLinkingCollectionsPromotionCollectionOrder["MaxPriceAsc"] = "maxPrice_ASC";
    ImageLinkingCollectionsPromotionCollectionOrder["MaxPriceDesc"] = "maxPrice_DESC";
    ImageLinkingCollectionsPromotionCollectionOrder["MinPriceAsc"] = "minPrice_ASC";
    ImageLinkingCollectionsPromotionCollectionOrder["MinPriceDesc"] = "minPrice_DESC";
    ImageLinkingCollectionsPromotionCollectionOrder["PriceAsc"] = "price_ASC";
    ImageLinkingCollectionsPromotionCollectionOrder["PriceDesc"] = "price_DESC";
    ImageLinkingCollectionsPromotionCollectionOrder["SubTitleAsc"] = "subTitle_ASC";
    ImageLinkingCollectionsPromotionCollectionOrder["SubTitleDesc"] = "subTitle_DESC";
    ImageLinkingCollectionsPromotionCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ImageLinkingCollectionsPromotionCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ImageLinkingCollectionsPromotionCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ImageLinkingCollectionsPromotionCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ImageLinkingCollectionsPromotionCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ImageLinkingCollectionsPromotionCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ImageLinkingCollectionsPromotionCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ImageLinkingCollectionsPromotionCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ImageLinkingCollectionsPromotionCollectionOrder["TitleAsc"] = "title_ASC";
    ImageLinkingCollectionsPromotionCollectionOrder["TitleDesc"] = "title_DESC";
    ImageLinkingCollectionsPromotionCollectionOrder["UrlAsc"] = "url_ASC";
    ImageLinkingCollectionsPromotionCollectionOrder["UrlDesc"] = "url_DESC";
})(ImageLinkingCollectionsPromotionCollectionOrder = exports.ImageLinkingCollectionsPromotionCollectionOrder || (exports.ImageLinkingCollectionsPromotionCollectionOrder = {}));
var ImageLinkingCollectionsPropositionCategoryCollectionOrder;
(function (ImageLinkingCollectionsPropositionCategoryCollectionOrder) {
    ImageLinkingCollectionsPropositionCategoryCollectionOrder["CtaTitleAsc"] = "ctaTitle_ASC";
    ImageLinkingCollectionsPropositionCategoryCollectionOrder["CtaTitleDesc"] = "ctaTitle_DESC";
    ImageLinkingCollectionsPropositionCategoryCollectionOrder["CtaUrlAsc"] = "ctaUrl_ASC";
    ImageLinkingCollectionsPropositionCategoryCollectionOrder["CtaUrlDesc"] = "ctaUrl_DESC";
    ImageLinkingCollectionsPropositionCategoryCollectionOrder["FeaturedParksTitleAsc"] = "featuredParksTitle_ASC";
    ImageLinkingCollectionsPropositionCategoryCollectionOrder["FeaturedParksTitleDesc"] = "featuredParksTitle_DESC";
    ImageLinkingCollectionsPropositionCategoryCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    ImageLinkingCollectionsPropositionCategoryCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    ImageLinkingCollectionsPropositionCategoryCollectionOrder["NameAsc"] = "name_ASC";
    ImageLinkingCollectionsPropositionCategoryCollectionOrder["NameDesc"] = "name_DESC";
    ImageLinkingCollectionsPropositionCategoryCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ImageLinkingCollectionsPropositionCategoryCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ImageLinkingCollectionsPropositionCategoryCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ImageLinkingCollectionsPropositionCategoryCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ImageLinkingCollectionsPropositionCategoryCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ImageLinkingCollectionsPropositionCategoryCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ImageLinkingCollectionsPropositionCategoryCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ImageLinkingCollectionsPropositionCategoryCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(ImageLinkingCollectionsPropositionCategoryCollectionOrder = exports.ImageLinkingCollectionsPropositionCategoryCollectionOrder || (exports.ImageLinkingCollectionsPropositionCategoryCollectionOrder = {}));
var ImageLinkingCollectionsPropositionCollectionOrder;
(function (ImageLinkingCollectionsPropositionCollectionOrder) {
    ImageLinkingCollectionsPropositionCollectionOrder["FaqFolderIdAsc"] = "faqFolderId_ASC";
    ImageLinkingCollectionsPropositionCollectionOrder["FaqFolderIdDesc"] = "faqFolderId_DESC";
    ImageLinkingCollectionsPropositionCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    ImageLinkingCollectionsPropositionCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    ImageLinkingCollectionsPropositionCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    ImageLinkingCollectionsPropositionCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    ImageLinkingCollectionsPropositionCollectionOrder["NameAsc"] = "name_ASC";
    ImageLinkingCollectionsPropositionCollectionOrder["NameDesc"] = "name_DESC";
    ImageLinkingCollectionsPropositionCollectionOrder["PathAsc"] = "path_ASC";
    ImageLinkingCollectionsPropositionCollectionOrder["PathDesc"] = "path_DESC";
    ImageLinkingCollectionsPropositionCollectionOrder["RelatedArticlesTitleAsc"] = "relatedArticlesTitle_ASC";
    ImageLinkingCollectionsPropositionCollectionOrder["RelatedArticlesTitleDesc"] = "relatedArticlesTitle_DESC";
    ImageLinkingCollectionsPropositionCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ImageLinkingCollectionsPropositionCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ImageLinkingCollectionsPropositionCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ImageLinkingCollectionsPropositionCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ImageLinkingCollectionsPropositionCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ImageLinkingCollectionsPropositionCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ImageLinkingCollectionsPropositionCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ImageLinkingCollectionsPropositionCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ImageLinkingCollectionsPropositionCollectionOrder["TagLineAsc"] = "tagLine_ASC";
    ImageLinkingCollectionsPropositionCollectionOrder["TagLineDesc"] = "tagLine_DESC";
    ImageLinkingCollectionsPropositionCollectionOrder["TitleAsc"] = "title_ASC";
    ImageLinkingCollectionsPropositionCollectionOrder["TitleDesc"] = "title_DESC";
})(ImageLinkingCollectionsPropositionCollectionOrder = exports.ImageLinkingCollectionsPropositionCollectionOrder || (exports.ImageLinkingCollectionsPropositionCollectionOrder = {}));
var ImageLinkingCollectionsPropositionSubCategoryCollectionOrder;
(function (ImageLinkingCollectionsPropositionSubCategoryCollectionOrder) {
    ImageLinkingCollectionsPropositionSubCategoryCollectionOrder["NameAsc"] = "name_ASC";
    ImageLinkingCollectionsPropositionSubCategoryCollectionOrder["NameDesc"] = "name_DESC";
    ImageLinkingCollectionsPropositionSubCategoryCollectionOrder["PathAsc"] = "path_ASC";
    ImageLinkingCollectionsPropositionSubCategoryCollectionOrder["PathDesc"] = "path_DESC";
    ImageLinkingCollectionsPropositionSubCategoryCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ImageLinkingCollectionsPropositionSubCategoryCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ImageLinkingCollectionsPropositionSubCategoryCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ImageLinkingCollectionsPropositionSubCategoryCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ImageLinkingCollectionsPropositionSubCategoryCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ImageLinkingCollectionsPropositionSubCategoryCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ImageLinkingCollectionsPropositionSubCategoryCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ImageLinkingCollectionsPropositionSubCategoryCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ImageLinkingCollectionsPropositionSubCategoryCollectionOrder["TitleAsc"] = "title_ASC";
    ImageLinkingCollectionsPropositionSubCategoryCollectionOrder["TitleDesc"] = "title_DESC";
})(ImageLinkingCollectionsPropositionSubCategoryCollectionOrder = exports.ImageLinkingCollectionsPropositionSubCategoryCollectionOrder || (exports.ImageLinkingCollectionsPropositionSubCategoryCollectionOrder = {}));
var ImageLinkingCollectionsRegionCollectionOrder;
(function (ImageLinkingCollectionsRegionCollectionOrder) {
    ImageLinkingCollectionsRegionCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    ImageLinkingCollectionsRegionCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    ImageLinkingCollectionsRegionCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    ImageLinkingCollectionsRegionCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    ImageLinkingCollectionsRegionCollectionOrder["NameAsc"] = "name_ASC";
    ImageLinkingCollectionsRegionCollectionOrder["NameDesc"] = "name_DESC";
    ImageLinkingCollectionsRegionCollectionOrder["NearbyTownCitiesTitleAsc"] = "nearbyTownCitiesTitle_ASC";
    ImageLinkingCollectionsRegionCollectionOrder["NearbyTownCitiesTitleDesc"] = "nearbyTownCitiesTitle_DESC";
    ImageLinkingCollectionsRegionCollectionOrder["PageTypeAsc"] = "pageType_ASC";
    ImageLinkingCollectionsRegionCollectionOrder["PageTypeDesc"] = "pageType_DESC";
    ImageLinkingCollectionsRegionCollectionOrder["PathAsc"] = "path_ASC";
    ImageLinkingCollectionsRegionCollectionOrder["PathDesc"] = "path_DESC";
    ImageLinkingCollectionsRegionCollectionOrder["RegionCodeAsc"] = "regionCode_ASC";
    ImageLinkingCollectionsRegionCollectionOrder["RegionCodeDesc"] = "regionCode_DESC";
    ImageLinkingCollectionsRegionCollectionOrder["RelatedArticlesTitleAsc"] = "relatedArticlesTitle_ASC";
    ImageLinkingCollectionsRegionCollectionOrder["RelatedArticlesTitleDesc"] = "relatedArticlesTitle_DESC";
    ImageLinkingCollectionsRegionCollectionOrder["SearchTitleAsc"] = "searchTitle_ASC";
    ImageLinkingCollectionsRegionCollectionOrder["SearchTitleDesc"] = "searchTitle_DESC";
    ImageLinkingCollectionsRegionCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ImageLinkingCollectionsRegionCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ImageLinkingCollectionsRegionCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ImageLinkingCollectionsRegionCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ImageLinkingCollectionsRegionCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ImageLinkingCollectionsRegionCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ImageLinkingCollectionsRegionCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ImageLinkingCollectionsRegionCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ImageLinkingCollectionsRegionCollectionOrder["ThingsToDoTitleAsc"] = "thingsToDoTitle_ASC";
    ImageLinkingCollectionsRegionCollectionOrder["ThingsToDoTitleDesc"] = "thingsToDoTitle_DESC";
    ImageLinkingCollectionsRegionCollectionOrder["TitleAsc"] = "title_ASC";
    ImageLinkingCollectionsRegionCollectionOrder["TitleDesc"] = "title_DESC";
})(ImageLinkingCollectionsRegionCollectionOrder = exports.ImageLinkingCollectionsRegionCollectionOrder || (exports.ImageLinkingCollectionsRegionCollectionOrder = {}));
var ImageLinkingCollectionsRegionalHolidayCollectionOrder;
(function (ImageLinkingCollectionsRegionalHolidayCollectionOrder) {
    ImageLinkingCollectionsRegionalHolidayCollectionOrder["HolidayTypeAsc"] = "holidayType_ASC";
    ImageLinkingCollectionsRegionalHolidayCollectionOrder["HolidayTypeDesc"] = "holidayType_DESC";
    ImageLinkingCollectionsRegionalHolidayCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    ImageLinkingCollectionsRegionalHolidayCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    ImageLinkingCollectionsRegionalHolidayCollectionOrder["PathAsc"] = "path_ASC";
    ImageLinkingCollectionsRegionalHolidayCollectionOrder["PathDesc"] = "path_DESC";
    ImageLinkingCollectionsRegionalHolidayCollectionOrder["ReasonsToBookTitleAsc"] = "reasonsToBookTitle_ASC";
    ImageLinkingCollectionsRegionalHolidayCollectionOrder["ReasonsToBookTitleDesc"] = "reasonsToBookTitle_DESC";
    ImageLinkingCollectionsRegionalHolidayCollectionOrder["ShortDescriptionAsc"] = "shortDescription_ASC";
    ImageLinkingCollectionsRegionalHolidayCollectionOrder["ShortDescriptionDesc"] = "shortDescription_DESC";
    ImageLinkingCollectionsRegionalHolidayCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ImageLinkingCollectionsRegionalHolidayCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ImageLinkingCollectionsRegionalHolidayCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ImageLinkingCollectionsRegionalHolidayCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ImageLinkingCollectionsRegionalHolidayCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ImageLinkingCollectionsRegionalHolidayCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ImageLinkingCollectionsRegionalHolidayCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ImageLinkingCollectionsRegionalHolidayCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ImageLinkingCollectionsRegionalHolidayCollectionOrder["TitleAsc"] = "title_ASC";
    ImageLinkingCollectionsRegionalHolidayCollectionOrder["TitleDesc"] = "title_DESC";
})(ImageLinkingCollectionsRegionalHolidayCollectionOrder = exports.ImageLinkingCollectionsRegionalHolidayCollectionOrder || (exports.ImageLinkingCollectionsRegionalHolidayCollectionOrder = {}));
var ImageLinkingCollectionsSafetyMeasureCollectionOrder;
(function (ImageLinkingCollectionsSafetyMeasureCollectionOrder) {
    ImageLinkingCollectionsSafetyMeasureCollectionOrder["NameAsc"] = "name_ASC";
    ImageLinkingCollectionsSafetyMeasureCollectionOrder["NameDesc"] = "name_DESC";
    ImageLinkingCollectionsSafetyMeasureCollectionOrder["PathAsc"] = "path_ASC";
    ImageLinkingCollectionsSafetyMeasureCollectionOrder["PathDesc"] = "path_DESC";
    ImageLinkingCollectionsSafetyMeasureCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ImageLinkingCollectionsSafetyMeasureCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ImageLinkingCollectionsSafetyMeasureCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ImageLinkingCollectionsSafetyMeasureCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ImageLinkingCollectionsSafetyMeasureCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ImageLinkingCollectionsSafetyMeasureCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ImageLinkingCollectionsSafetyMeasureCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ImageLinkingCollectionsSafetyMeasureCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ImageLinkingCollectionsSafetyMeasureCollectionOrder["TitleAsc"] = "title_ASC";
    ImageLinkingCollectionsSafetyMeasureCollectionOrder["TitleDesc"] = "title_DESC";
})(ImageLinkingCollectionsSafetyMeasureCollectionOrder = exports.ImageLinkingCollectionsSafetyMeasureCollectionOrder || (exports.ImageLinkingCollectionsSafetyMeasureCollectionOrder = {}));
var ImageLinkingCollectionsSearchPromotionBannerCollectionOrder;
(function (ImageLinkingCollectionsSearchPromotionBannerCollectionOrder) {
    ImageLinkingCollectionsSearchPromotionBannerCollectionOrder["AlwaysVisibleAsc"] = "alwaysVisible_ASC";
    ImageLinkingCollectionsSearchPromotionBannerCollectionOrder["AlwaysVisibleDesc"] = "alwaysVisible_DESC";
    ImageLinkingCollectionsSearchPromotionBannerCollectionOrder["ButtonLabelAsc"] = "buttonLabel_ASC";
    ImageLinkingCollectionsSearchPromotionBannerCollectionOrder["ButtonLabelDesc"] = "buttonLabel_DESC";
    ImageLinkingCollectionsSearchPromotionBannerCollectionOrder["DarkAsc"] = "dark_ASC";
    ImageLinkingCollectionsSearchPromotionBannerCollectionOrder["DarkDesc"] = "dark_DESC";
    ImageLinkingCollectionsSearchPromotionBannerCollectionOrder["EndDateAsc"] = "endDate_ASC";
    ImageLinkingCollectionsSearchPromotionBannerCollectionOrder["EndDateDesc"] = "endDate_DESC";
    ImageLinkingCollectionsSearchPromotionBannerCollectionOrder["ImageTypeAsc"] = "imageType_ASC";
    ImageLinkingCollectionsSearchPromotionBannerCollectionOrder["ImageTypeDesc"] = "imageType_DESC";
    ImageLinkingCollectionsSearchPromotionBannerCollectionOrder["RedirectUrlAsc"] = "redirectUrl_ASC";
    ImageLinkingCollectionsSearchPromotionBannerCollectionOrder["RedirectUrlDesc"] = "redirectUrl_DESC";
    ImageLinkingCollectionsSearchPromotionBannerCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ImageLinkingCollectionsSearchPromotionBannerCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ImageLinkingCollectionsSearchPromotionBannerCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ImageLinkingCollectionsSearchPromotionBannerCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ImageLinkingCollectionsSearchPromotionBannerCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ImageLinkingCollectionsSearchPromotionBannerCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ImageLinkingCollectionsSearchPromotionBannerCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ImageLinkingCollectionsSearchPromotionBannerCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ImageLinkingCollectionsSearchPromotionBannerCollectionOrder["TitleAsc"] = "title_ASC";
    ImageLinkingCollectionsSearchPromotionBannerCollectionOrder["TitleDesc"] = "title_DESC";
})(ImageLinkingCollectionsSearchPromotionBannerCollectionOrder = exports.ImageLinkingCollectionsSearchPromotionBannerCollectionOrder || (exports.ImageLinkingCollectionsSearchPromotionBannerCollectionOrder = {}));
var ImageLinkingCollectionsSectionCollectionOrder;
(function (ImageLinkingCollectionsSectionCollectionOrder) {
    ImageLinkingCollectionsSectionCollectionOrder["NameAsc"] = "name_ASC";
    ImageLinkingCollectionsSectionCollectionOrder["NameDesc"] = "name_DESC";
    ImageLinkingCollectionsSectionCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ImageLinkingCollectionsSectionCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ImageLinkingCollectionsSectionCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ImageLinkingCollectionsSectionCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ImageLinkingCollectionsSectionCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ImageLinkingCollectionsSectionCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ImageLinkingCollectionsSectionCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ImageLinkingCollectionsSectionCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ImageLinkingCollectionsSectionCollectionOrder["TitleAsc"] = "title_ASC";
    ImageLinkingCollectionsSectionCollectionOrder["TitleDesc"] = "title_DESC";
})(ImageLinkingCollectionsSectionCollectionOrder = exports.ImageLinkingCollectionsSectionCollectionOrder || (exports.ImageLinkingCollectionsSectionCollectionOrder = {}));
var ImageLinkingCollectionsSellingPointCollectionOrder;
(function (ImageLinkingCollectionsSellingPointCollectionOrder) {
    ImageLinkingCollectionsSellingPointCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    ImageLinkingCollectionsSellingPointCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    ImageLinkingCollectionsSellingPointCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ImageLinkingCollectionsSellingPointCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ImageLinkingCollectionsSellingPointCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ImageLinkingCollectionsSellingPointCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ImageLinkingCollectionsSellingPointCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ImageLinkingCollectionsSellingPointCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ImageLinkingCollectionsSellingPointCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ImageLinkingCollectionsSellingPointCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ImageLinkingCollectionsSellingPointCollectionOrder["TitleAsc"] = "title_ASC";
    ImageLinkingCollectionsSellingPointCollectionOrder["TitleDesc"] = "title_DESC";
    ImageLinkingCollectionsSellingPointCollectionOrder["UrlAsc"] = "url_ASC";
    ImageLinkingCollectionsSellingPointCollectionOrder["UrlDesc"] = "url_DESC";
})(ImageLinkingCollectionsSellingPointCollectionOrder = exports.ImageLinkingCollectionsSellingPointCollectionOrder || (exports.ImageLinkingCollectionsSellingPointCollectionOrder = {}));
var ImageLinkingCollectionsTestimonialCollectionOrder;
(function (ImageLinkingCollectionsTestimonialCollectionOrder) {
    ImageLinkingCollectionsTestimonialCollectionOrder["AuthorAsc"] = "author_ASC";
    ImageLinkingCollectionsTestimonialCollectionOrder["AuthorDesc"] = "author_DESC";
    ImageLinkingCollectionsTestimonialCollectionOrder["HolidayTypeAsc"] = "holidayType_ASC";
    ImageLinkingCollectionsTestimonialCollectionOrder["HolidayTypeDesc"] = "holidayType_DESC";
    ImageLinkingCollectionsTestimonialCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    ImageLinkingCollectionsTestimonialCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    ImageLinkingCollectionsTestimonialCollectionOrder["RoleAsc"] = "role_ASC";
    ImageLinkingCollectionsTestimonialCollectionOrder["RoleDesc"] = "role_DESC";
    ImageLinkingCollectionsTestimonialCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ImageLinkingCollectionsTestimonialCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ImageLinkingCollectionsTestimonialCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ImageLinkingCollectionsTestimonialCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ImageLinkingCollectionsTestimonialCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ImageLinkingCollectionsTestimonialCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ImageLinkingCollectionsTestimonialCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ImageLinkingCollectionsTestimonialCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(ImageLinkingCollectionsTestimonialCollectionOrder = exports.ImageLinkingCollectionsTestimonialCollectionOrder || (exports.ImageLinkingCollectionsTestimonialCollectionOrder = {}));
var ImageLinkingCollectionsVideoCollectionOrder;
(function (ImageLinkingCollectionsVideoCollectionOrder) {
    ImageLinkingCollectionsVideoCollectionOrder["EmbeddedUrlAsc"] = "embeddedUrl_ASC";
    ImageLinkingCollectionsVideoCollectionOrder["EmbeddedUrlDesc"] = "embeddedUrl_DESC";
    ImageLinkingCollectionsVideoCollectionOrder["NameAsc"] = "name_ASC";
    ImageLinkingCollectionsVideoCollectionOrder["NameDesc"] = "name_DESC";
    ImageLinkingCollectionsVideoCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ImageLinkingCollectionsVideoCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ImageLinkingCollectionsVideoCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ImageLinkingCollectionsVideoCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ImageLinkingCollectionsVideoCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ImageLinkingCollectionsVideoCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ImageLinkingCollectionsVideoCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ImageLinkingCollectionsVideoCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ImageLinkingCollectionsVideoCollectionOrder["TitleAsc"] = "title_ASC";
    ImageLinkingCollectionsVideoCollectionOrder["TitleDesc"] = "title_DESC";
})(ImageLinkingCollectionsVideoCollectionOrder = exports.ImageLinkingCollectionsVideoCollectionOrder || (exports.ImageLinkingCollectionsVideoCollectionOrder = {}));
var ImageLinkingCollectionsVirtualTourCollectionOrder;
(function (ImageLinkingCollectionsVirtualTourCollectionOrder) {
    ImageLinkingCollectionsVirtualTourCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ImageLinkingCollectionsVirtualTourCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ImageLinkingCollectionsVirtualTourCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ImageLinkingCollectionsVirtualTourCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ImageLinkingCollectionsVirtualTourCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ImageLinkingCollectionsVirtualTourCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ImageLinkingCollectionsVirtualTourCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ImageLinkingCollectionsVirtualTourCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ImageLinkingCollectionsVirtualTourCollectionOrder["TitleAsc"] = "title_ASC";
    ImageLinkingCollectionsVirtualTourCollectionOrder["TitleDesc"] = "title_DESC";
    ImageLinkingCollectionsVirtualTourCollectionOrder["UrlAsc"] = "url_ASC";
    ImageLinkingCollectionsVirtualTourCollectionOrder["UrlDesc"] = "url_DESC";
})(ImageLinkingCollectionsVirtualTourCollectionOrder = exports.ImageLinkingCollectionsVirtualTourCollectionOrder || (exports.ImageLinkingCollectionsVirtualTourCollectionOrder = {}));
var ImageOrder;
(function (ImageOrder) {
    ImageOrder["AltTextAsc"] = "altText_ASC";
    ImageOrder["AltTextDesc"] = "altText_DESC";
    ImageOrder["CaptionOptionalAsc"] = "captionOptional_ASC";
    ImageOrder["CaptionOptionalDesc"] = "captionOptional_DESC";
    ImageOrder["FocusAreaAsc"] = "focusArea_ASC";
    ImageOrder["FocusAreaDesc"] = "focusArea_DESC";
    ImageOrder["NameAsc"] = "name_ASC";
    ImageOrder["NameDesc"] = "name_DESC";
    ImageOrder["SubHeadingAsc"] = "subHeading_ASC";
    ImageOrder["SubHeadingDesc"] = "subHeading_DESC";
    ImageOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ImageOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ImageOrder["SysIdAsc"] = "sys_id_ASC";
    ImageOrder["SysIdDesc"] = "sys_id_DESC";
    ImageOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ImageOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ImageOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ImageOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(ImageOrder = exports.ImageOrder || (exports.ImageOrder = {}));
var ImageResizeFocus;
(function (ImageResizeFocus) {
    /** Focus the resizing on the bottom. */
    ImageResizeFocus["Bottom"] = "BOTTOM";
    /** Focus the resizing on the bottom left. */
    ImageResizeFocus["BottomLeft"] = "BOTTOM_LEFT";
    /** Focus the resizing on the bottom right. */
    ImageResizeFocus["BottomRight"] = "BOTTOM_RIGHT";
    /** Focus the resizing on the center. */
    ImageResizeFocus["Center"] = "CENTER";
    /** Focus the resizing on the largest face. */
    ImageResizeFocus["Face"] = "FACE";
    /** Focus the resizing on the area containing all the faces. */
    ImageResizeFocus["Faces"] = "FACES";
    /** Focus the resizing on the left. */
    ImageResizeFocus["Left"] = "LEFT";
    /** Focus the resizing on the right. */
    ImageResizeFocus["Right"] = "RIGHT";
    /** Focus the resizing on the top. */
    ImageResizeFocus["Top"] = "TOP";
    /** Focus the resizing on the top left. */
    ImageResizeFocus["TopLeft"] = "TOP_LEFT";
    /** Focus the resizing on the top right. */
    ImageResizeFocus["TopRight"] = "TOP_RIGHT";
})(ImageResizeFocus = exports.ImageResizeFocus || (exports.ImageResizeFocus = {}));
var ImageResizeStrategy;
(function (ImageResizeStrategy) {
    /** Crops a part of the original image to fit into the specified dimensions. */
    ImageResizeStrategy["Crop"] = "CROP";
    /** Resizes the image to the specified dimensions, cropping the image if needed. */
    ImageResizeStrategy["Fill"] = "FILL";
    /** Resizes the image to fit into the specified dimensions. */
    ImageResizeStrategy["Fit"] = "FIT";
    /**
     * Resizes the image to the specified dimensions, padding the image if needed.
     *         Uses desired background color as padding color.
     */
    ImageResizeStrategy["Pad"] = "PAD";
    /** Resizes the image to the specified dimensions, changing the original aspect ratio if needed. */
    ImageResizeStrategy["Scale"] = "SCALE";
    /** Creates a thumbnail from the image. */
    ImageResizeStrategy["Thumb"] = "THUMB";
})(ImageResizeStrategy = exports.ImageResizeStrategy || (exports.ImageResizeStrategy = {}));
var LinkLinkingCollectionsBoxCollectionOrder;
(function (LinkLinkingCollectionsBoxCollectionOrder) {
    LinkLinkingCollectionsBoxCollectionOrder["DescriptionUrlAsc"] = "descriptionUrl_ASC";
    LinkLinkingCollectionsBoxCollectionOrder["DescriptionUrlDesc"] = "descriptionUrl_DESC";
    LinkLinkingCollectionsBoxCollectionOrder["HrefAsc"] = "href_ASC";
    LinkLinkingCollectionsBoxCollectionOrder["HrefDesc"] = "href_DESC";
    LinkLinkingCollectionsBoxCollectionOrder["NameAsc"] = "name_ASC";
    LinkLinkingCollectionsBoxCollectionOrder["NameDesc"] = "name_DESC";
    LinkLinkingCollectionsBoxCollectionOrder["ShowOnPagesAsc"] = "showOnPages_ASC";
    LinkLinkingCollectionsBoxCollectionOrder["ShowOnPagesDesc"] = "showOnPages_DESC";
    LinkLinkingCollectionsBoxCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    LinkLinkingCollectionsBoxCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    LinkLinkingCollectionsBoxCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    LinkLinkingCollectionsBoxCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    LinkLinkingCollectionsBoxCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    LinkLinkingCollectionsBoxCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    LinkLinkingCollectionsBoxCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    LinkLinkingCollectionsBoxCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    LinkLinkingCollectionsBoxCollectionOrder["TitleLevelAsc"] = "titleLevel_ASC";
    LinkLinkingCollectionsBoxCollectionOrder["TitleLevelDesc"] = "titleLevel_DESC";
    LinkLinkingCollectionsBoxCollectionOrder["TitleAsc"] = "title_ASC";
    LinkLinkingCollectionsBoxCollectionOrder["TitleDesc"] = "title_DESC";
})(LinkLinkingCollectionsBoxCollectionOrder = exports.LinkLinkingCollectionsBoxCollectionOrder || (exports.LinkLinkingCollectionsBoxCollectionOrder = {}));
var LinkLinkingCollectionsNotificationCollectionOrder;
(function (LinkLinkingCollectionsNotificationCollectionOrder) {
    LinkLinkingCollectionsNotificationCollectionOrder["DismissibleAsc"] = "dismissible_ASC";
    LinkLinkingCollectionsNotificationCollectionOrder["DismissibleDesc"] = "dismissible_DESC";
    LinkLinkingCollectionsNotificationCollectionOrder["EnabledAsc"] = "enabled_ASC";
    LinkLinkingCollectionsNotificationCollectionOrder["EnabledDesc"] = "enabled_DESC";
    LinkLinkingCollectionsNotificationCollectionOrder["MessageAsc"] = "message_ASC";
    LinkLinkingCollectionsNotificationCollectionOrder["MessageDesc"] = "message_DESC";
    LinkLinkingCollectionsNotificationCollectionOrder["NameAsc"] = "name_ASC";
    LinkLinkingCollectionsNotificationCollectionOrder["NameDesc"] = "name_DESC";
    LinkLinkingCollectionsNotificationCollectionOrder["ShowInfoIconAsc"] = "showInfoIcon_ASC";
    LinkLinkingCollectionsNotificationCollectionOrder["ShowInfoIconDesc"] = "showInfoIcon_DESC";
    LinkLinkingCollectionsNotificationCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    LinkLinkingCollectionsNotificationCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    LinkLinkingCollectionsNotificationCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    LinkLinkingCollectionsNotificationCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    LinkLinkingCollectionsNotificationCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    LinkLinkingCollectionsNotificationCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    LinkLinkingCollectionsNotificationCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    LinkLinkingCollectionsNotificationCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    LinkLinkingCollectionsNotificationCollectionOrder["TitleAsc"] = "title_ASC";
    LinkLinkingCollectionsNotificationCollectionOrder["TitleDesc"] = "title_DESC";
    LinkLinkingCollectionsNotificationCollectionOrder["TypeAsc"] = "type_ASC";
    LinkLinkingCollectionsNotificationCollectionOrder["TypeDesc"] = "type_DESC";
})(LinkLinkingCollectionsNotificationCollectionOrder = exports.LinkLinkingCollectionsNotificationCollectionOrder || (exports.LinkLinkingCollectionsNotificationCollectionOrder = {}));
var LinkLinkingCollectionsPromoLinkCollectionOrder;
(function (LinkLinkingCollectionsPromoLinkCollectionOrder) {
    LinkLinkingCollectionsPromoLinkCollectionOrder["NameAsc"] = "name_ASC";
    LinkLinkingCollectionsPromoLinkCollectionOrder["NameDesc"] = "name_DESC";
    LinkLinkingCollectionsPromoLinkCollectionOrder["ReadMoreAsc"] = "readMore_ASC";
    LinkLinkingCollectionsPromoLinkCollectionOrder["ReadMoreDesc"] = "readMore_DESC";
    LinkLinkingCollectionsPromoLinkCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    LinkLinkingCollectionsPromoLinkCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    LinkLinkingCollectionsPromoLinkCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    LinkLinkingCollectionsPromoLinkCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    LinkLinkingCollectionsPromoLinkCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    LinkLinkingCollectionsPromoLinkCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    LinkLinkingCollectionsPromoLinkCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    LinkLinkingCollectionsPromoLinkCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(LinkLinkingCollectionsPromoLinkCollectionOrder = exports.LinkLinkingCollectionsPromoLinkCollectionOrder || (exports.LinkLinkingCollectionsPromoLinkCollectionOrder = {}));
var LinkLinkingCollectionsPropositionCollectionOrder;
(function (LinkLinkingCollectionsPropositionCollectionOrder) {
    LinkLinkingCollectionsPropositionCollectionOrder["FaqFolderIdAsc"] = "faqFolderId_ASC";
    LinkLinkingCollectionsPropositionCollectionOrder["FaqFolderIdDesc"] = "faqFolderId_DESC";
    LinkLinkingCollectionsPropositionCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    LinkLinkingCollectionsPropositionCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    LinkLinkingCollectionsPropositionCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    LinkLinkingCollectionsPropositionCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    LinkLinkingCollectionsPropositionCollectionOrder["NameAsc"] = "name_ASC";
    LinkLinkingCollectionsPropositionCollectionOrder["NameDesc"] = "name_DESC";
    LinkLinkingCollectionsPropositionCollectionOrder["PathAsc"] = "path_ASC";
    LinkLinkingCollectionsPropositionCollectionOrder["PathDesc"] = "path_DESC";
    LinkLinkingCollectionsPropositionCollectionOrder["RelatedArticlesTitleAsc"] = "relatedArticlesTitle_ASC";
    LinkLinkingCollectionsPropositionCollectionOrder["RelatedArticlesTitleDesc"] = "relatedArticlesTitle_DESC";
    LinkLinkingCollectionsPropositionCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    LinkLinkingCollectionsPropositionCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    LinkLinkingCollectionsPropositionCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    LinkLinkingCollectionsPropositionCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    LinkLinkingCollectionsPropositionCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    LinkLinkingCollectionsPropositionCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    LinkLinkingCollectionsPropositionCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    LinkLinkingCollectionsPropositionCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    LinkLinkingCollectionsPropositionCollectionOrder["TagLineAsc"] = "tagLine_ASC";
    LinkLinkingCollectionsPropositionCollectionOrder["TagLineDesc"] = "tagLine_DESC";
    LinkLinkingCollectionsPropositionCollectionOrder["TitleAsc"] = "title_ASC";
    LinkLinkingCollectionsPropositionCollectionOrder["TitleDesc"] = "title_DESC";
})(LinkLinkingCollectionsPropositionCollectionOrder = exports.LinkLinkingCollectionsPropositionCollectionOrder || (exports.LinkLinkingCollectionsPropositionCollectionOrder = {}));
var LinkOrder;
(function (LinkOrder) {
    LinkOrder["DescriptionAsc"] = "description_ASC";
    LinkOrder["DescriptionDesc"] = "description_DESC";
    LinkOrder["EntryNameAsc"] = "entryName_ASC";
    LinkOrder["EntryNameDesc"] = "entryName_DESC";
    LinkOrder["NameAsc"] = "name_ASC";
    LinkOrder["NameDesc"] = "name_DESC";
    LinkOrder["OpenNewWindowAsc"] = "openNewWindow_ASC";
    LinkOrder["OpenNewWindowDesc"] = "openNewWindow_DESC";
    LinkOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    LinkOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    LinkOrder["SysIdAsc"] = "sys_id_ASC";
    LinkOrder["SysIdDesc"] = "sys_id_DESC";
    LinkOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    LinkOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    LinkOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    LinkOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    LinkOrder["UrlAsc"] = "url_ASC";
    LinkOrder["UrlDesc"] = "url_DESC";
})(LinkOrder = exports.LinkOrder || (exports.LinkOrder = {}));
var ListAssemblyLinkingCollectionsPropositionCollectionOrder;
(function (ListAssemblyLinkingCollectionsPropositionCollectionOrder) {
    ListAssemblyLinkingCollectionsPropositionCollectionOrder["FaqFolderIdAsc"] = "faqFolderId_ASC";
    ListAssemblyLinkingCollectionsPropositionCollectionOrder["FaqFolderIdDesc"] = "faqFolderId_DESC";
    ListAssemblyLinkingCollectionsPropositionCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    ListAssemblyLinkingCollectionsPropositionCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    ListAssemblyLinkingCollectionsPropositionCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    ListAssemblyLinkingCollectionsPropositionCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    ListAssemblyLinkingCollectionsPropositionCollectionOrder["NameAsc"] = "name_ASC";
    ListAssemblyLinkingCollectionsPropositionCollectionOrder["NameDesc"] = "name_DESC";
    ListAssemblyLinkingCollectionsPropositionCollectionOrder["PathAsc"] = "path_ASC";
    ListAssemblyLinkingCollectionsPropositionCollectionOrder["PathDesc"] = "path_DESC";
    ListAssemblyLinkingCollectionsPropositionCollectionOrder["RelatedArticlesTitleAsc"] = "relatedArticlesTitle_ASC";
    ListAssemblyLinkingCollectionsPropositionCollectionOrder["RelatedArticlesTitleDesc"] = "relatedArticlesTitle_DESC";
    ListAssemblyLinkingCollectionsPropositionCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ListAssemblyLinkingCollectionsPropositionCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ListAssemblyLinkingCollectionsPropositionCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ListAssemblyLinkingCollectionsPropositionCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ListAssemblyLinkingCollectionsPropositionCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ListAssemblyLinkingCollectionsPropositionCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ListAssemblyLinkingCollectionsPropositionCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ListAssemblyLinkingCollectionsPropositionCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ListAssemblyLinkingCollectionsPropositionCollectionOrder["TagLineAsc"] = "tagLine_ASC";
    ListAssemblyLinkingCollectionsPropositionCollectionOrder["TagLineDesc"] = "tagLine_DESC";
    ListAssemblyLinkingCollectionsPropositionCollectionOrder["TitleAsc"] = "title_ASC";
    ListAssemblyLinkingCollectionsPropositionCollectionOrder["TitleDesc"] = "title_DESC";
})(ListAssemblyLinkingCollectionsPropositionCollectionOrder = exports.ListAssemblyLinkingCollectionsPropositionCollectionOrder || (exports.ListAssemblyLinkingCollectionsPropositionCollectionOrder = {}));
var ListAssemblyOrder;
(function (ListAssemblyOrder) {
    ListAssemblyOrder["HeaderAsc"] = "header_ASC";
    ListAssemblyOrder["HeaderDesc"] = "header_DESC";
    ListAssemblyOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ListAssemblyOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ListAssemblyOrder["SysIdAsc"] = "sys_id_ASC";
    ListAssemblyOrder["SysIdDesc"] = "sys_id_DESC";
    ListAssemblyOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ListAssemblyOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ListAssemblyOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ListAssemblyOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(ListAssemblyOrder = exports.ListAssemblyOrder || (exports.ListAssemblyOrder = {}));
var MaintenancePeriodLinkingCollectionsParkFeaturesCollectionOrder;
(function (MaintenancePeriodLinkingCollectionsParkFeaturesCollectionOrder) {
    MaintenancePeriodLinkingCollectionsParkFeaturesCollectionOrder["ApiIdAsc"] = "apiId_ASC";
    MaintenancePeriodLinkingCollectionsParkFeaturesCollectionOrder["ApiIdDesc"] = "apiId_DESC";
    MaintenancePeriodLinkingCollectionsParkFeaturesCollectionOrder["DateIntroducedAsc"] = "dateIntroduced_ASC";
    MaintenancePeriodLinkingCollectionsParkFeaturesCollectionOrder["DateIntroducedDesc"] = "dateIntroduced_DESC";
    MaintenancePeriodLinkingCollectionsParkFeaturesCollectionOrder["NameAsc"] = "name_ASC";
    MaintenancePeriodLinkingCollectionsParkFeaturesCollectionOrder["NameDesc"] = "name_DESC";
    MaintenancePeriodLinkingCollectionsParkFeaturesCollectionOrder["PropositionTypeAsc"] = "propositionType_ASC";
    MaintenancePeriodLinkingCollectionsParkFeaturesCollectionOrder["PropositionTypeDesc"] = "propositionType_DESC";
    MaintenancePeriodLinkingCollectionsParkFeaturesCollectionOrder["ShortTitleAsc"] = "shortTitle_ASC";
    MaintenancePeriodLinkingCollectionsParkFeaturesCollectionOrder["ShortTitleDesc"] = "shortTitle_DESC";
    MaintenancePeriodLinkingCollectionsParkFeaturesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    MaintenancePeriodLinkingCollectionsParkFeaturesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    MaintenancePeriodLinkingCollectionsParkFeaturesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    MaintenancePeriodLinkingCollectionsParkFeaturesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    MaintenancePeriodLinkingCollectionsParkFeaturesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    MaintenancePeriodLinkingCollectionsParkFeaturesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    MaintenancePeriodLinkingCollectionsParkFeaturesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    MaintenancePeriodLinkingCollectionsParkFeaturesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    MaintenancePeriodLinkingCollectionsParkFeaturesCollectionOrder["TitleAsc"] = "title_ASC";
    MaintenancePeriodLinkingCollectionsParkFeaturesCollectionOrder["TitleDesc"] = "title_DESC";
    MaintenancePeriodLinkingCollectionsParkFeaturesCollectionOrder["UrlAsc"] = "url_ASC";
    MaintenancePeriodLinkingCollectionsParkFeaturesCollectionOrder["UrlDesc"] = "url_DESC";
})(MaintenancePeriodLinkingCollectionsParkFeaturesCollectionOrder = exports.MaintenancePeriodLinkingCollectionsParkFeaturesCollectionOrder || (exports.MaintenancePeriodLinkingCollectionsParkFeaturesCollectionOrder = {}));
var MaintenancePeriodOrder;
(function (MaintenancePeriodOrder) {
    MaintenancePeriodOrder["EndDateAsc"] = "endDate_ASC";
    MaintenancePeriodOrder["EndDateDesc"] = "endDate_DESC";
    MaintenancePeriodOrder["StartDateAsc"] = "startDate_ASC";
    MaintenancePeriodOrder["StartDateDesc"] = "startDate_DESC";
    MaintenancePeriodOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    MaintenancePeriodOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    MaintenancePeriodOrder["SysIdAsc"] = "sys_id_ASC";
    MaintenancePeriodOrder["SysIdDesc"] = "sys_id_DESC";
    MaintenancePeriodOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    MaintenancePeriodOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    MaintenancePeriodOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    MaintenancePeriodOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    MaintenancePeriodOrder["TitleAsc"] = "title_ASC";
    MaintenancePeriodOrder["TitleDesc"] = "title_DESC";
})(MaintenancePeriodOrder = exports.MaintenancePeriodOrder || (exports.MaintenancePeriodOrder = {}));
var NotificationLinkingCollectionsAccommodationTypeCollectionOrder;
(function (NotificationLinkingCollectionsAccommodationTypeCollectionOrder) {
    NotificationLinkingCollectionsAccommodationTypeCollectionOrder["ChecklistTitleAsc"] = "checklistTitle_ASC";
    NotificationLinkingCollectionsAccommodationTypeCollectionOrder["ChecklistTitleDesc"] = "checklistTitle_DESC";
    NotificationLinkingCollectionsAccommodationTypeCollectionOrder["NameAsc"] = "name_ASC";
    NotificationLinkingCollectionsAccommodationTypeCollectionOrder["NameDesc"] = "name_DESC";
    NotificationLinkingCollectionsAccommodationTypeCollectionOrder["PathAsc"] = "path_ASC";
    NotificationLinkingCollectionsAccommodationTypeCollectionOrder["PathDesc"] = "path_DESC";
    NotificationLinkingCollectionsAccommodationTypeCollectionOrder["SearchAccommodationNameAsc"] = "searchAccommodationName_ASC";
    NotificationLinkingCollectionsAccommodationTypeCollectionOrder["SearchAccommodationNameDesc"] = "searchAccommodationName_DESC";
    NotificationLinkingCollectionsAccommodationTypeCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    NotificationLinkingCollectionsAccommodationTypeCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    NotificationLinkingCollectionsAccommodationTypeCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    NotificationLinkingCollectionsAccommodationTypeCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    NotificationLinkingCollectionsAccommodationTypeCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    NotificationLinkingCollectionsAccommodationTypeCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    NotificationLinkingCollectionsAccommodationTypeCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    NotificationLinkingCollectionsAccommodationTypeCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    NotificationLinkingCollectionsAccommodationTypeCollectionOrder["TitleAsc"] = "title_ASC";
    NotificationLinkingCollectionsAccommodationTypeCollectionOrder["TitleDesc"] = "title_DESC";
})(NotificationLinkingCollectionsAccommodationTypeCollectionOrder = exports.NotificationLinkingCollectionsAccommodationTypeCollectionOrder || (exports.NotificationLinkingCollectionsAccommodationTypeCollectionOrder = {}));
var NotificationLinkingCollectionsAllParkPageCollectionOrder;
(function (NotificationLinkingCollectionsAllParkPageCollectionOrder) {
    NotificationLinkingCollectionsAllParkPageCollectionOrder["NameAsc"] = "name_ASC";
    NotificationLinkingCollectionsAllParkPageCollectionOrder["NameDesc"] = "name_DESC";
    NotificationLinkingCollectionsAllParkPageCollectionOrder["PathAsc"] = "path_ASC";
    NotificationLinkingCollectionsAllParkPageCollectionOrder["PathDesc"] = "path_DESC";
    NotificationLinkingCollectionsAllParkPageCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    NotificationLinkingCollectionsAllParkPageCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    NotificationLinkingCollectionsAllParkPageCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    NotificationLinkingCollectionsAllParkPageCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    NotificationLinkingCollectionsAllParkPageCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    NotificationLinkingCollectionsAllParkPageCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    NotificationLinkingCollectionsAllParkPageCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    NotificationLinkingCollectionsAllParkPageCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    NotificationLinkingCollectionsAllParkPageCollectionOrder["TitleAsc"] = "title_ASC";
    NotificationLinkingCollectionsAllParkPageCollectionOrder["TitleDesc"] = "title_DESC";
    NotificationLinkingCollectionsAllParkPageCollectionOrder["TypeOfParkPageAsc"] = "typeOfParkPage_ASC";
    NotificationLinkingCollectionsAllParkPageCollectionOrder["TypeOfParkPageDesc"] = "typeOfParkPage_DESC";
})(NotificationLinkingCollectionsAllParkPageCollectionOrder = exports.NotificationLinkingCollectionsAllParkPageCollectionOrder || (exports.NotificationLinkingCollectionsAllParkPageCollectionOrder = {}));
var NotificationLinkingCollectionsArticlesCollectionOrder;
(function (NotificationLinkingCollectionsArticlesCollectionOrder) {
    NotificationLinkingCollectionsArticlesCollectionOrder["ArticleSummaryAsc"] = "articleSummary_ASC";
    NotificationLinkingCollectionsArticlesCollectionOrder["ArticleSummaryDesc"] = "articleSummary_DESC";
    NotificationLinkingCollectionsArticlesCollectionOrder["AuthorAsc"] = "author_ASC";
    NotificationLinkingCollectionsArticlesCollectionOrder["AuthorDesc"] = "author_DESC";
    NotificationLinkingCollectionsArticlesCollectionOrder["HolidayTypeAsc"] = "holidayType_ASC";
    NotificationLinkingCollectionsArticlesCollectionOrder["HolidayTypeDesc"] = "holidayType_DESC";
    NotificationLinkingCollectionsArticlesCollectionOrder["NameAsc"] = "name_ASC";
    NotificationLinkingCollectionsArticlesCollectionOrder["NameDesc"] = "name_DESC";
    NotificationLinkingCollectionsArticlesCollectionOrder["PathAsc"] = "path_ASC";
    NotificationLinkingCollectionsArticlesCollectionOrder["PathDesc"] = "path_DESC";
    NotificationLinkingCollectionsArticlesCollectionOrder["RelatedArticlesTitleAsc"] = "relatedArticlesTitle_ASC";
    NotificationLinkingCollectionsArticlesCollectionOrder["RelatedArticlesTitleDesc"] = "relatedArticlesTitle_DESC";
    NotificationLinkingCollectionsArticlesCollectionOrder["ShowTableOfContentsAsc"] = "showTableOfContents_ASC";
    NotificationLinkingCollectionsArticlesCollectionOrder["ShowTableOfContentsDesc"] = "showTableOfContents_DESC";
    NotificationLinkingCollectionsArticlesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    NotificationLinkingCollectionsArticlesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    NotificationLinkingCollectionsArticlesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    NotificationLinkingCollectionsArticlesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    NotificationLinkingCollectionsArticlesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    NotificationLinkingCollectionsArticlesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    NotificationLinkingCollectionsArticlesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    NotificationLinkingCollectionsArticlesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    NotificationLinkingCollectionsArticlesCollectionOrder["TitleAsc"] = "title_ASC";
    NotificationLinkingCollectionsArticlesCollectionOrder["TitleDesc"] = "title_DESC";
})(NotificationLinkingCollectionsArticlesCollectionOrder = exports.NotificationLinkingCollectionsArticlesCollectionOrder || (exports.NotificationLinkingCollectionsArticlesCollectionOrder = {}));
var NotificationLinkingCollectionsFullCampaignCollectionOrder;
(function (NotificationLinkingCollectionsFullCampaignCollectionOrder) {
    NotificationLinkingCollectionsFullCampaignCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    NotificationLinkingCollectionsFullCampaignCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    NotificationLinkingCollectionsFullCampaignCollectionOrder["FeaturedParksTitleAsc"] = "featuredParksTitle_ASC";
    NotificationLinkingCollectionsFullCampaignCollectionOrder["FeaturedParksTitleDesc"] = "featuredParksTitle_DESC";
    NotificationLinkingCollectionsFullCampaignCollectionOrder["FeaturedPromotionsTitleAsc"] = "featuredPromotionsTitle_ASC";
    NotificationLinkingCollectionsFullCampaignCollectionOrder["FeaturedPromotionsTitleDesc"] = "featuredPromotionsTitle_DESC";
    NotificationLinkingCollectionsFullCampaignCollectionOrder["IntroductionTitleAsc"] = "introductionTitle_ASC";
    NotificationLinkingCollectionsFullCampaignCollectionOrder["IntroductionTitleDesc"] = "introductionTitle_DESC";
    NotificationLinkingCollectionsFullCampaignCollectionOrder["NameAsc"] = "name_ASC";
    NotificationLinkingCollectionsFullCampaignCollectionOrder["NameDesc"] = "name_DESC";
    NotificationLinkingCollectionsFullCampaignCollectionOrder["PathAsc"] = "path_ASC";
    NotificationLinkingCollectionsFullCampaignCollectionOrder["PathDesc"] = "path_DESC";
    NotificationLinkingCollectionsFullCampaignCollectionOrder["PromotionsTitleAsc"] = "promotionsTitle_ASC";
    NotificationLinkingCollectionsFullCampaignCollectionOrder["PromotionsTitleDesc"] = "promotionsTitle_DESC";
    NotificationLinkingCollectionsFullCampaignCollectionOrder["ReasonsToBookTitleAsc"] = "reasonsToBookTitle_ASC";
    NotificationLinkingCollectionsFullCampaignCollectionOrder["ReasonsToBookTitleDesc"] = "reasonsToBookTitle_DESC";
    NotificationLinkingCollectionsFullCampaignCollectionOrder["SellingPointsTitleAsc"] = "sellingPointsTitle_ASC";
    NotificationLinkingCollectionsFullCampaignCollectionOrder["SellingPointsTitleDesc"] = "sellingPointsTitle_DESC";
    NotificationLinkingCollectionsFullCampaignCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    NotificationLinkingCollectionsFullCampaignCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    NotificationLinkingCollectionsFullCampaignCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    NotificationLinkingCollectionsFullCampaignCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    NotificationLinkingCollectionsFullCampaignCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    NotificationLinkingCollectionsFullCampaignCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    NotificationLinkingCollectionsFullCampaignCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    NotificationLinkingCollectionsFullCampaignCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    NotificationLinkingCollectionsFullCampaignCollectionOrder["TitleAsc"] = "title_ASC";
    NotificationLinkingCollectionsFullCampaignCollectionOrder["TitleDesc"] = "title_DESC";
})(NotificationLinkingCollectionsFullCampaignCollectionOrder = exports.NotificationLinkingCollectionsFullCampaignCollectionOrder || (exports.NotificationLinkingCollectionsFullCampaignCollectionOrder = {}));
var NotificationLinkingCollectionsHomePageCollectionOrder;
(function (NotificationLinkingCollectionsHomePageCollectionOrder) {
    NotificationLinkingCollectionsHomePageCollectionOrder["DefaultHolidayNumberOfNightsAsc"] = "defaultHolidayNumberOfNights_ASC";
    NotificationLinkingCollectionsHomePageCollectionOrder["DefaultHolidayNumberOfNightsDesc"] = "defaultHolidayNumberOfNights_DESC";
    NotificationLinkingCollectionsHomePageCollectionOrder["NameAsc"] = "name_ASC";
    NotificationLinkingCollectionsHomePageCollectionOrder["NameDesc"] = "name_DESC";
    NotificationLinkingCollectionsHomePageCollectionOrder["PathAsc"] = "path_ASC";
    NotificationLinkingCollectionsHomePageCollectionOrder["PathDesc"] = "path_DESC";
    NotificationLinkingCollectionsHomePageCollectionOrder["SummaryTitleAsc"] = "summaryTitle_ASC";
    NotificationLinkingCollectionsHomePageCollectionOrder["SummaryTitleDesc"] = "summaryTitle_DESC";
    NotificationLinkingCollectionsHomePageCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    NotificationLinkingCollectionsHomePageCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    NotificationLinkingCollectionsHomePageCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    NotificationLinkingCollectionsHomePageCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    NotificationLinkingCollectionsHomePageCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    NotificationLinkingCollectionsHomePageCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    NotificationLinkingCollectionsHomePageCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    NotificationLinkingCollectionsHomePageCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(NotificationLinkingCollectionsHomePageCollectionOrder = exports.NotificationLinkingCollectionsHomePageCollectionOrder || (exports.NotificationLinkingCollectionsHomePageCollectionOrder = {}));
var NotificationLinkingCollectionsParkCollectionOrder;
(function (NotificationLinkingCollectionsParkCollectionOrder) {
    NotificationLinkingCollectionsParkCollectionOrder["ContactNumberAsc"] = "contactNumber_ASC";
    NotificationLinkingCollectionsParkCollectionOrder["ContactNumberDesc"] = "contactNumber_DESC";
    NotificationLinkingCollectionsParkCollectionOrder["DirectionsUrlAsc"] = "directionsUrl_ASC";
    NotificationLinkingCollectionsParkCollectionOrder["DirectionsUrlDesc"] = "directionsUrl_DESC";
    NotificationLinkingCollectionsParkCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    NotificationLinkingCollectionsParkCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    NotificationLinkingCollectionsParkCollectionOrder["NameAsc"] = "name_ASC";
    NotificationLinkingCollectionsParkCollectionOrder["NameDesc"] = "name_DESC";
    NotificationLinkingCollectionsParkCollectionOrder["ParkTypeAsc"] = "parkType_ASC";
    NotificationLinkingCollectionsParkCollectionOrder["ParkTypeDesc"] = "parkType_DESC";
    NotificationLinkingCollectionsParkCollectionOrder["PathAsc"] = "path_ASC";
    NotificationLinkingCollectionsParkCollectionOrder["PathDesc"] = "path_DESC";
    NotificationLinkingCollectionsParkCollectionOrder["RunningCostsAsc"] = "runningCosts_ASC";
    NotificationLinkingCollectionsParkCollectionOrder["RunningCostsDesc"] = "runningCosts_DESC";
    NotificationLinkingCollectionsParkCollectionOrder["SiteFeesAsc"] = "siteFees_ASC";
    NotificationLinkingCollectionsParkCollectionOrder["SiteFeesDesc"] = "siteFees_DESC";
    NotificationLinkingCollectionsParkCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    NotificationLinkingCollectionsParkCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    NotificationLinkingCollectionsParkCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    NotificationLinkingCollectionsParkCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    NotificationLinkingCollectionsParkCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    NotificationLinkingCollectionsParkCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    NotificationLinkingCollectionsParkCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    NotificationLinkingCollectionsParkCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    NotificationLinkingCollectionsParkCollectionOrder["TaglineAsc"] = "tagline_ASC";
    NotificationLinkingCollectionsParkCollectionOrder["TaglineDesc"] = "tagline_DESC";
    NotificationLinkingCollectionsParkCollectionOrder["ThingsToDoTitleAsc"] = "thingsToDoTitle_ASC";
    NotificationLinkingCollectionsParkCollectionOrder["ThingsToDoTitleDesc"] = "thingsToDoTitle_DESC";
    NotificationLinkingCollectionsParkCollectionOrder["TitleAsc"] = "title_ASC";
    NotificationLinkingCollectionsParkCollectionOrder["TitleDesc"] = "title_DESC";
})(NotificationLinkingCollectionsParkCollectionOrder = exports.NotificationLinkingCollectionsParkCollectionOrder || (exports.NotificationLinkingCollectionsParkCollectionOrder = {}));
var NotificationLinkingCollectionsPropositionCollectionOrder;
(function (NotificationLinkingCollectionsPropositionCollectionOrder) {
    NotificationLinkingCollectionsPropositionCollectionOrder["FaqFolderIdAsc"] = "faqFolderId_ASC";
    NotificationLinkingCollectionsPropositionCollectionOrder["FaqFolderIdDesc"] = "faqFolderId_DESC";
    NotificationLinkingCollectionsPropositionCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    NotificationLinkingCollectionsPropositionCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    NotificationLinkingCollectionsPropositionCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    NotificationLinkingCollectionsPropositionCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    NotificationLinkingCollectionsPropositionCollectionOrder["NameAsc"] = "name_ASC";
    NotificationLinkingCollectionsPropositionCollectionOrder["NameDesc"] = "name_DESC";
    NotificationLinkingCollectionsPropositionCollectionOrder["PathAsc"] = "path_ASC";
    NotificationLinkingCollectionsPropositionCollectionOrder["PathDesc"] = "path_DESC";
    NotificationLinkingCollectionsPropositionCollectionOrder["RelatedArticlesTitleAsc"] = "relatedArticlesTitle_ASC";
    NotificationLinkingCollectionsPropositionCollectionOrder["RelatedArticlesTitleDesc"] = "relatedArticlesTitle_DESC";
    NotificationLinkingCollectionsPropositionCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    NotificationLinkingCollectionsPropositionCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    NotificationLinkingCollectionsPropositionCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    NotificationLinkingCollectionsPropositionCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    NotificationLinkingCollectionsPropositionCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    NotificationLinkingCollectionsPropositionCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    NotificationLinkingCollectionsPropositionCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    NotificationLinkingCollectionsPropositionCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    NotificationLinkingCollectionsPropositionCollectionOrder["TagLineAsc"] = "tagLine_ASC";
    NotificationLinkingCollectionsPropositionCollectionOrder["TagLineDesc"] = "tagLine_DESC";
    NotificationLinkingCollectionsPropositionCollectionOrder["TitleAsc"] = "title_ASC";
    NotificationLinkingCollectionsPropositionCollectionOrder["TitleDesc"] = "title_DESC";
})(NotificationLinkingCollectionsPropositionCollectionOrder = exports.NotificationLinkingCollectionsPropositionCollectionOrder || (exports.NotificationLinkingCollectionsPropositionCollectionOrder = {}));
var NotificationLinkingCollectionsPropositionSubCategoryCollectionOrder;
(function (NotificationLinkingCollectionsPropositionSubCategoryCollectionOrder) {
    NotificationLinkingCollectionsPropositionSubCategoryCollectionOrder["NameAsc"] = "name_ASC";
    NotificationLinkingCollectionsPropositionSubCategoryCollectionOrder["NameDesc"] = "name_DESC";
    NotificationLinkingCollectionsPropositionSubCategoryCollectionOrder["PathAsc"] = "path_ASC";
    NotificationLinkingCollectionsPropositionSubCategoryCollectionOrder["PathDesc"] = "path_DESC";
    NotificationLinkingCollectionsPropositionSubCategoryCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    NotificationLinkingCollectionsPropositionSubCategoryCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    NotificationLinkingCollectionsPropositionSubCategoryCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    NotificationLinkingCollectionsPropositionSubCategoryCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    NotificationLinkingCollectionsPropositionSubCategoryCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    NotificationLinkingCollectionsPropositionSubCategoryCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    NotificationLinkingCollectionsPropositionSubCategoryCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    NotificationLinkingCollectionsPropositionSubCategoryCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    NotificationLinkingCollectionsPropositionSubCategoryCollectionOrder["TitleAsc"] = "title_ASC";
    NotificationLinkingCollectionsPropositionSubCategoryCollectionOrder["TitleDesc"] = "title_DESC";
})(NotificationLinkingCollectionsPropositionSubCategoryCollectionOrder = exports.NotificationLinkingCollectionsPropositionSubCategoryCollectionOrder || (exports.NotificationLinkingCollectionsPropositionSubCategoryCollectionOrder = {}));
var NotificationLinkingCollectionsRegionCollectionOrder;
(function (NotificationLinkingCollectionsRegionCollectionOrder) {
    NotificationLinkingCollectionsRegionCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    NotificationLinkingCollectionsRegionCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    NotificationLinkingCollectionsRegionCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    NotificationLinkingCollectionsRegionCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    NotificationLinkingCollectionsRegionCollectionOrder["NameAsc"] = "name_ASC";
    NotificationLinkingCollectionsRegionCollectionOrder["NameDesc"] = "name_DESC";
    NotificationLinkingCollectionsRegionCollectionOrder["NearbyTownCitiesTitleAsc"] = "nearbyTownCitiesTitle_ASC";
    NotificationLinkingCollectionsRegionCollectionOrder["NearbyTownCitiesTitleDesc"] = "nearbyTownCitiesTitle_DESC";
    NotificationLinkingCollectionsRegionCollectionOrder["PageTypeAsc"] = "pageType_ASC";
    NotificationLinkingCollectionsRegionCollectionOrder["PageTypeDesc"] = "pageType_DESC";
    NotificationLinkingCollectionsRegionCollectionOrder["PathAsc"] = "path_ASC";
    NotificationLinkingCollectionsRegionCollectionOrder["PathDesc"] = "path_DESC";
    NotificationLinkingCollectionsRegionCollectionOrder["RegionCodeAsc"] = "regionCode_ASC";
    NotificationLinkingCollectionsRegionCollectionOrder["RegionCodeDesc"] = "regionCode_DESC";
    NotificationLinkingCollectionsRegionCollectionOrder["RelatedArticlesTitleAsc"] = "relatedArticlesTitle_ASC";
    NotificationLinkingCollectionsRegionCollectionOrder["RelatedArticlesTitleDesc"] = "relatedArticlesTitle_DESC";
    NotificationLinkingCollectionsRegionCollectionOrder["SearchTitleAsc"] = "searchTitle_ASC";
    NotificationLinkingCollectionsRegionCollectionOrder["SearchTitleDesc"] = "searchTitle_DESC";
    NotificationLinkingCollectionsRegionCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    NotificationLinkingCollectionsRegionCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    NotificationLinkingCollectionsRegionCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    NotificationLinkingCollectionsRegionCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    NotificationLinkingCollectionsRegionCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    NotificationLinkingCollectionsRegionCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    NotificationLinkingCollectionsRegionCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    NotificationLinkingCollectionsRegionCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    NotificationLinkingCollectionsRegionCollectionOrder["ThingsToDoTitleAsc"] = "thingsToDoTitle_ASC";
    NotificationLinkingCollectionsRegionCollectionOrder["ThingsToDoTitleDesc"] = "thingsToDoTitle_DESC";
    NotificationLinkingCollectionsRegionCollectionOrder["TitleAsc"] = "title_ASC";
    NotificationLinkingCollectionsRegionCollectionOrder["TitleDesc"] = "title_DESC";
})(NotificationLinkingCollectionsRegionCollectionOrder = exports.NotificationLinkingCollectionsRegionCollectionOrder || (exports.NotificationLinkingCollectionsRegionCollectionOrder = {}));
var NotificationOrder;
(function (NotificationOrder) {
    NotificationOrder["DismissibleAsc"] = "dismissible_ASC";
    NotificationOrder["DismissibleDesc"] = "dismissible_DESC";
    NotificationOrder["EnabledAsc"] = "enabled_ASC";
    NotificationOrder["EnabledDesc"] = "enabled_DESC";
    NotificationOrder["MessageAsc"] = "message_ASC";
    NotificationOrder["MessageDesc"] = "message_DESC";
    NotificationOrder["NameAsc"] = "name_ASC";
    NotificationOrder["NameDesc"] = "name_DESC";
    NotificationOrder["ShowInfoIconAsc"] = "showInfoIcon_ASC";
    NotificationOrder["ShowInfoIconDesc"] = "showInfoIcon_DESC";
    NotificationOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    NotificationOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    NotificationOrder["SysIdAsc"] = "sys_id_ASC";
    NotificationOrder["SysIdDesc"] = "sys_id_DESC";
    NotificationOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    NotificationOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    NotificationOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    NotificationOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    NotificationOrder["TitleAsc"] = "title_ASC";
    NotificationOrder["TitleDesc"] = "title_DESC";
    NotificationOrder["TypeAsc"] = "type_ASC";
    NotificationOrder["TypeDesc"] = "type_DESC";
})(NotificationOrder = exports.NotificationOrder || (exports.NotificationOrder = {}));
var OwnershipSearchOptionsLinkingCollectionsFullCampaignCollectionOrder;
(function (OwnershipSearchOptionsLinkingCollectionsFullCampaignCollectionOrder) {
    OwnershipSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    OwnershipSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    OwnershipSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["FeaturedParksTitleAsc"] = "featuredParksTitle_ASC";
    OwnershipSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["FeaturedParksTitleDesc"] = "featuredParksTitle_DESC";
    OwnershipSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["FeaturedPromotionsTitleAsc"] = "featuredPromotionsTitle_ASC";
    OwnershipSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["FeaturedPromotionsTitleDesc"] = "featuredPromotionsTitle_DESC";
    OwnershipSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["IntroductionTitleAsc"] = "introductionTitle_ASC";
    OwnershipSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["IntroductionTitleDesc"] = "introductionTitle_DESC";
    OwnershipSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["NameAsc"] = "name_ASC";
    OwnershipSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["NameDesc"] = "name_DESC";
    OwnershipSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["PathAsc"] = "path_ASC";
    OwnershipSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["PathDesc"] = "path_DESC";
    OwnershipSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["PromotionsTitleAsc"] = "promotionsTitle_ASC";
    OwnershipSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["PromotionsTitleDesc"] = "promotionsTitle_DESC";
    OwnershipSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["ReasonsToBookTitleAsc"] = "reasonsToBookTitle_ASC";
    OwnershipSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["ReasonsToBookTitleDesc"] = "reasonsToBookTitle_DESC";
    OwnershipSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["SellingPointsTitleAsc"] = "sellingPointsTitle_ASC";
    OwnershipSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["SellingPointsTitleDesc"] = "sellingPointsTitle_DESC";
    OwnershipSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    OwnershipSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    OwnershipSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    OwnershipSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    OwnershipSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    OwnershipSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    OwnershipSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    OwnershipSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    OwnershipSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["TitleAsc"] = "title_ASC";
    OwnershipSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["TitleDesc"] = "title_DESC";
})(OwnershipSearchOptionsLinkingCollectionsFullCampaignCollectionOrder = exports.OwnershipSearchOptionsLinkingCollectionsFullCampaignCollectionOrder || (exports.OwnershipSearchOptionsLinkingCollectionsFullCampaignCollectionOrder = {}));
var OwnershipSearchOptionsOrder;
(function (OwnershipSearchOptionsOrder) {
    OwnershipSearchOptionsOrder["NumberOfBedroomsAsc"] = "numberOfBedrooms_ASC";
    OwnershipSearchOptionsOrder["NumberOfBedroomsDesc"] = "numberOfBedrooms_DESC";
    OwnershipSearchOptionsOrder["PriceRangeAsc"] = "priceRange_ASC";
    OwnershipSearchOptionsOrder["PriceRangeDesc"] = "priceRange_DESC";
    OwnershipSearchOptionsOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    OwnershipSearchOptionsOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    OwnershipSearchOptionsOrder["SysIdAsc"] = "sys_id_ASC";
    OwnershipSearchOptionsOrder["SysIdDesc"] = "sys_id_DESC";
    OwnershipSearchOptionsOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    OwnershipSearchOptionsOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    OwnershipSearchOptionsOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    OwnershipSearchOptionsOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    OwnershipSearchOptionsOrder["TitleAsc"] = "title_ASC";
    OwnershipSearchOptionsOrder["TitleDesc"] = "title_DESC";
})(OwnershipSearchOptionsOrder = exports.OwnershipSearchOptionsOrder || (exports.OwnershipSearchOptionsOrder = {}));
var PageMetadataLinkingCollectionsAccommodationTypeCollectionOrder;
(function (PageMetadataLinkingCollectionsAccommodationTypeCollectionOrder) {
    PageMetadataLinkingCollectionsAccommodationTypeCollectionOrder["ChecklistTitleAsc"] = "checklistTitle_ASC";
    PageMetadataLinkingCollectionsAccommodationTypeCollectionOrder["ChecklistTitleDesc"] = "checklistTitle_DESC";
    PageMetadataLinkingCollectionsAccommodationTypeCollectionOrder["NameAsc"] = "name_ASC";
    PageMetadataLinkingCollectionsAccommodationTypeCollectionOrder["NameDesc"] = "name_DESC";
    PageMetadataLinkingCollectionsAccommodationTypeCollectionOrder["PathAsc"] = "path_ASC";
    PageMetadataLinkingCollectionsAccommodationTypeCollectionOrder["PathDesc"] = "path_DESC";
    PageMetadataLinkingCollectionsAccommodationTypeCollectionOrder["SearchAccommodationNameAsc"] = "searchAccommodationName_ASC";
    PageMetadataLinkingCollectionsAccommodationTypeCollectionOrder["SearchAccommodationNameDesc"] = "searchAccommodationName_DESC";
    PageMetadataLinkingCollectionsAccommodationTypeCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PageMetadataLinkingCollectionsAccommodationTypeCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PageMetadataLinkingCollectionsAccommodationTypeCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PageMetadataLinkingCollectionsAccommodationTypeCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PageMetadataLinkingCollectionsAccommodationTypeCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PageMetadataLinkingCollectionsAccommodationTypeCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PageMetadataLinkingCollectionsAccommodationTypeCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PageMetadataLinkingCollectionsAccommodationTypeCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    PageMetadataLinkingCollectionsAccommodationTypeCollectionOrder["TitleAsc"] = "title_ASC";
    PageMetadataLinkingCollectionsAccommodationTypeCollectionOrder["TitleDesc"] = "title_DESC";
})(PageMetadataLinkingCollectionsAccommodationTypeCollectionOrder = exports.PageMetadataLinkingCollectionsAccommodationTypeCollectionOrder || (exports.PageMetadataLinkingCollectionsAccommodationTypeCollectionOrder = {}));
var PageMetadataLinkingCollectionsAllParkPageCollectionOrder;
(function (PageMetadataLinkingCollectionsAllParkPageCollectionOrder) {
    PageMetadataLinkingCollectionsAllParkPageCollectionOrder["NameAsc"] = "name_ASC";
    PageMetadataLinkingCollectionsAllParkPageCollectionOrder["NameDesc"] = "name_DESC";
    PageMetadataLinkingCollectionsAllParkPageCollectionOrder["PathAsc"] = "path_ASC";
    PageMetadataLinkingCollectionsAllParkPageCollectionOrder["PathDesc"] = "path_DESC";
    PageMetadataLinkingCollectionsAllParkPageCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PageMetadataLinkingCollectionsAllParkPageCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PageMetadataLinkingCollectionsAllParkPageCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PageMetadataLinkingCollectionsAllParkPageCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PageMetadataLinkingCollectionsAllParkPageCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PageMetadataLinkingCollectionsAllParkPageCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PageMetadataLinkingCollectionsAllParkPageCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PageMetadataLinkingCollectionsAllParkPageCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    PageMetadataLinkingCollectionsAllParkPageCollectionOrder["TitleAsc"] = "title_ASC";
    PageMetadataLinkingCollectionsAllParkPageCollectionOrder["TitleDesc"] = "title_DESC";
    PageMetadataLinkingCollectionsAllParkPageCollectionOrder["TypeOfParkPageAsc"] = "typeOfParkPage_ASC";
    PageMetadataLinkingCollectionsAllParkPageCollectionOrder["TypeOfParkPageDesc"] = "typeOfParkPage_DESC";
})(PageMetadataLinkingCollectionsAllParkPageCollectionOrder = exports.PageMetadataLinkingCollectionsAllParkPageCollectionOrder || (exports.PageMetadataLinkingCollectionsAllParkPageCollectionOrder = {}));
var PageMetadataLinkingCollectionsArticleHubCollectionOrder;
(function (PageMetadataLinkingCollectionsArticleHubCollectionOrder) {
    PageMetadataLinkingCollectionsArticleHubCollectionOrder["PathAsc"] = "path_ASC";
    PageMetadataLinkingCollectionsArticleHubCollectionOrder["PathDesc"] = "path_DESC";
    PageMetadataLinkingCollectionsArticleHubCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PageMetadataLinkingCollectionsArticleHubCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PageMetadataLinkingCollectionsArticleHubCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PageMetadataLinkingCollectionsArticleHubCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PageMetadataLinkingCollectionsArticleHubCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PageMetadataLinkingCollectionsArticleHubCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PageMetadataLinkingCollectionsArticleHubCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PageMetadataLinkingCollectionsArticleHubCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    PageMetadataLinkingCollectionsArticleHubCollectionOrder["TitleAsc"] = "title_ASC";
    PageMetadataLinkingCollectionsArticleHubCollectionOrder["TitleDesc"] = "title_DESC";
})(PageMetadataLinkingCollectionsArticleHubCollectionOrder = exports.PageMetadataLinkingCollectionsArticleHubCollectionOrder || (exports.PageMetadataLinkingCollectionsArticleHubCollectionOrder = {}));
var PageMetadataLinkingCollectionsArticlesCollectionOrder;
(function (PageMetadataLinkingCollectionsArticlesCollectionOrder) {
    PageMetadataLinkingCollectionsArticlesCollectionOrder["ArticleSummaryAsc"] = "articleSummary_ASC";
    PageMetadataLinkingCollectionsArticlesCollectionOrder["ArticleSummaryDesc"] = "articleSummary_DESC";
    PageMetadataLinkingCollectionsArticlesCollectionOrder["AuthorAsc"] = "author_ASC";
    PageMetadataLinkingCollectionsArticlesCollectionOrder["AuthorDesc"] = "author_DESC";
    PageMetadataLinkingCollectionsArticlesCollectionOrder["HolidayTypeAsc"] = "holidayType_ASC";
    PageMetadataLinkingCollectionsArticlesCollectionOrder["HolidayTypeDesc"] = "holidayType_DESC";
    PageMetadataLinkingCollectionsArticlesCollectionOrder["NameAsc"] = "name_ASC";
    PageMetadataLinkingCollectionsArticlesCollectionOrder["NameDesc"] = "name_DESC";
    PageMetadataLinkingCollectionsArticlesCollectionOrder["PathAsc"] = "path_ASC";
    PageMetadataLinkingCollectionsArticlesCollectionOrder["PathDesc"] = "path_DESC";
    PageMetadataLinkingCollectionsArticlesCollectionOrder["RelatedArticlesTitleAsc"] = "relatedArticlesTitle_ASC";
    PageMetadataLinkingCollectionsArticlesCollectionOrder["RelatedArticlesTitleDesc"] = "relatedArticlesTitle_DESC";
    PageMetadataLinkingCollectionsArticlesCollectionOrder["ShowTableOfContentsAsc"] = "showTableOfContents_ASC";
    PageMetadataLinkingCollectionsArticlesCollectionOrder["ShowTableOfContentsDesc"] = "showTableOfContents_DESC";
    PageMetadataLinkingCollectionsArticlesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PageMetadataLinkingCollectionsArticlesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PageMetadataLinkingCollectionsArticlesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PageMetadataLinkingCollectionsArticlesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PageMetadataLinkingCollectionsArticlesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PageMetadataLinkingCollectionsArticlesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PageMetadataLinkingCollectionsArticlesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PageMetadataLinkingCollectionsArticlesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    PageMetadataLinkingCollectionsArticlesCollectionOrder["TitleAsc"] = "title_ASC";
    PageMetadataLinkingCollectionsArticlesCollectionOrder["TitleDesc"] = "title_DESC";
})(PageMetadataLinkingCollectionsArticlesCollectionOrder = exports.PageMetadataLinkingCollectionsArticlesCollectionOrder || (exports.PageMetadataLinkingCollectionsArticlesCollectionOrder = {}));
var PageMetadataLinkingCollectionsFullCampaignCollectionOrder;
(function (PageMetadataLinkingCollectionsFullCampaignCollectionOrder) {
    PageMetadataLinkingCollectionsFullCampaignCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    PageMetadataLinkingCollectionsFullCampaignCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    PageMetadataLinkingCollectionsFullCampaignCollectionOrder["FeaturedParksTitleAsc"] = "featuredParksTitle_ASC";
    PageMetadataLinkingCollectionsFullCampaignCollectionOrder["FeaturedParksTitleDesc"] = "featuredParksTitle_DESC";
    PageMetadataLinkingCollectionsFullCampaignCollectionOrder["FeaturedPromotionsTitleAsc"] = "featuredPromotionsTitle_ASC";
    PageMetadataLinkingCollectionsFullCampaignCollectionOrder["FeaturedPromotionsTitleDesc"] = "featuredPromotionsTitle_DESC";
    PageMetadataLinkingCollectionsFullCampaignCollectionOrder["IntroductionTitleAsc"] = "introductionTitle_ASC";
    PageMetadataLinkingCollectionsFullCampaignCollectionOrder["IntroductionTitleDesc"] = "introductionTitle_DESC";
    PageMetadataLinkingCollectionsFullCampaignCollectionOrder["NameAsc"] = "name_ASC";
    PageMetadataLinkingCollectionsFullCampaignCollectionOrder["NameDesc"] = "name_DESC";
    PageMetadataLinkingCollectionsFullCampaignCollectionOrder["PathAsc"] = "path_ASC";
    PageMetadataLinkingCollectionsFullCampaignCollectionOrder["PathDesc"] = "path_DESC";
    PageMetadataLinkingCollectionsFullCampaignCollectionOrder["PromotionsTitleAsc"] = "promotionsTitle_ASC";
    PageMetadataLinkingCollectionsFullCampaignCollectionOrder["PromotionsTitleDesc"] = "promotionsTitle_DESC";
    PageMetadataLinkingCollectionsFullCampaignCollectionOrder["ReasonsToBookTitleAsc"] = "reasonsToBookTitle_ASC";
    PageMetadataLinkingCollectionsFullCampaignCollectionOrder["ReasonsToBookTitleDesc"] = "reasonsToBookTitle_DESC";
    PageMetadataLinkingCollectionsFullCampaignCollectionOrder["SellingPointsTitleAsc"] = "sellingPointsTitle_ASC";
    PageMetadataLinkingCollectionsFullCampaignCollectionOrder["SellingPointsTitleDesc"] = "sellingPointsTitle_DESC";
    PageMetadataLinkingCollectionsFullCampaignCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PageMetadataLinkingCollectionsFullCampaignCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PageMetadataLinkingCollectionsFullCampaignCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PageMetadataLinkingCollectionsFullCampaignCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PageMetadataLinkingCollectionsFullCampaignCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PageMetadataLinkingCollectionsFullCampaignCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PageMetadataLinkingCollectionsFullCampaignCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PageMetadataLinkingCollectionsFullCampaignCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    PageMetadataLinkingCollectionsFullCampaignCollectionOrder["TitleAsc"] = "title_ASC";
    PageMetadataLinkingCollectionsFullCampaignCollectionOrder["TitleDesc"] = "title_DESC";
})(PageMetadataLinkingCollectionsFullCampaignCollectionOrder = exports.PageMetadataLinkingCollectionsFullCampaignCollectionOrder || (exports.PageMetadataLinkingCollectionsFullCampaignCollectionOrder = {}));
var PageMetadataLinkingCollectionsGenericTemplateCollectionOrder;
(function (PageMetadataLinkingCollectionsGenericTemplateCollectionOrder) {
    PageMetadataLinkingCollectionsGenericTemplateCollectionOrder["NameAsc"] = "name_ASC";
    PageMetadataLinkingCollectionsGenericTemplateCollectionOrder["NameDesc"] = "name_DESC";
    PageMetadataLinkingCollectionsGenericTemplateCollectionOrder["PathAsc"] = "path_ASC";
    PageMetadataLinkingCollectionsGenericTemplateCollectionOrder["PathDesc"] = "path_DESC";
    PageMetadataLinkingCollectionsGenericTemplateCollectionOrder["ShowTableOfContentsAsc"] = "showTableOfContents_ASC";
    PageMetadataLinkingCollectionsGenericTemplateCollectionOrder["ShowTableOfContentsDesc"] = "showTableOfContents_DESC";
    PageMetadataLinkingCollectionsGenericTemplateCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PageMetadataLinkingCollectionsGenericTemplateCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PageMetadataLinkingCollectionsGenericTemplateCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PageMetadataLinkingCollectionsGenericTemplateCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PageMetadataLinkingCollectionsGenericTemplateCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PageMetadataLinkingCollectionsGenericTemplateCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PageMetadataLinkingCollectionsGenericTemplateCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PageMetadataLinkingCollectionsGenericTemplateCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    PageMetadataLinkingCollectionsGenericTemplateCollectionOrder["TitleAsc"] = "title_ASC";
    PageMetadataLinkingCollectionsGenericTemplateCollectionOrder["TitleDesc"] = "title_DESC";
})(PageMetadataLinkingCollectionsGenericTemplateCollectionOrder = exports.PageMetadataLinkingCollectionsGenericTemplateCollectionOrder || (exports.PageMetadataLinkingCollectionsGenericTemplateCollectionOrder = {}));
var PageMetadataLinkingCollectionsHolidaySelectionPageCollectionOrder;
(function (PageMetadataLinkingCollectionsHolidaySelectionPageCollectionOrder) {
    PageMetadataLinkingCollectionsHolidaySelectionPageCollectionOrder["NameAsc"] = "name_ASC";
    PageMetadataLinkingCollectionsHolidaySelectionPageCollectionOrder["NameDesc"] = "name_DESC";
    PageMetadataLinkingCollectionsHolidaySelectionPageCollectionOrder["PathAsc"] = "path_ASC";
    PageMetadataLinkingCollectionsHolidaySelectionPageCollectionOrder["PathDesc"] = "path_DESC";
    PageMetadataLinkingCollectionsHolidaySelectionPageCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PageMetadataLinkingCollectionsHolidaySelectionPageCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PageMetadataLinkingCollectionsHolidaySelectionPageCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PageMetadataLinkingCollectionsHolidaySelectionPageCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PageMetadataLinkingCollectionsHolidaySelectionPageCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PageMetadataLinkingCollectionsHolidaySelectionPageCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PageMetadataLinkingCollectionsHolidaySelectionPageCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PageMetadataLinkingCollectionsHolidaySelectionPageCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    PageMetadataLinkingCollectionsHolidaySelectionPageCollectionOrder["TitleAsc"] = "title_ASC";
    PageMetadataLinkingCollectionsHolidaySelectionPageCollectionOrder["TitleDesc"] = "title_DESC";
})(PageMetadataLinkingCollectionsHolidaySelectionPageCollectionOrder = exports.PageMetadataLinkingCollectionsHolidaySelectionPageCollectionOrder || (exports.PageMetadataLinkingCollectionsHolidaySelectionPageCollectionOrder = {}));
var PageMetadataLinkingCollectionsHomePageCollectionOrder;
(function (PageMetadataLinkingCollectionsHomePageCollectionOrder) {
    PageMetadataLinkingCollectionsHomePageCollectionOrder["DefaultHolidayNumberOfNightsAsc"] = "defaultHolidayNumberOfNights_ASC";
    PageMetadataLinkingCollectionsHomePageCollectionOrder["DefaultHolidayNumberOfNightsDesc"] = "defaultHolidayNumberOfNights_DESC";
    PageMetadataLinkingCollectionsHomePageCollectionOrder["NameAsc"] = "name_ASC";
    PageMetadataLinkingCollectionsHomePageCollectionOrder["NameDesc"] = "name_DESC";
    PageMetadataLinkingCollectionsHomePageCollectionOrder["PathAsc"] = "path_ASC";
    PageMetadataLinkingCollectionsHomePageCollectionOrder["PathDesc"] = "path_DESC";
    PageMetadataLinkingCollectionsHomePageCollectionOrder["SummaryTitleAsc"] = "summaryTitle_ASC";
    PageMetadataLinkingCollectionsHomePageCollectionOrder["SummaryTitleDesc"] = "summaryTitle_DESC";
    PageMetadataLinkingCollectionsHomePageCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PageMetadataLinkingCollectionsHomePageCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PageMetadataLinkingCollectionsHomePageCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PageMetadataLinkingCollectionsHomePageCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PageMetadataLinkingCollectionsHomePageCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PageMetadataLinkingCollectionsHomePageCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PageMetadataLinkingCollectionsHomePageCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PageMetadataLinkingCollectionsHomePageCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(PageMetadataLinkingCollectionsHomePageCollectionOrder = exports.PageMetadataLinkingCollectionsHomePageCollectionOrder || (exports.PageMetadataLinkingCollectionsHomePageCollectionOrder = {}));
var PageMetadataLinkingCollectionsParkCollectionOrder;
(function (PageMetadataLinkingCollectionsParkCollectionOrder) {
    PageMetadataLinkingCollectionsParkCollectionOrder["ContactNumberAsc"] = "contactNumber_ASC";
    PageMetadataLinkingCollectionsParkCollectionOrder["ContactNumberDesc"] = "contactNumber_DESC";
    PageMetadataLinkingCollectionsParkCollectionOrder["DirectionsUrlAsc"] = "directionsUrl_ASC";
    PageMetadataLinkingCollectionsParkCollectionOrder["DirectionsUrlDesc"] = "directionsUrl_DESC";
    PageMetadataLinkingCollectionsParkCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    PageMetadataLinkingCollectionsParkCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    PageMetadataLinkingCollectionsParkCollectionOrder["NameAsc"] = "name_ASC";
    PageMetadataLinkingCollectionsParkCollectionOrder["NameDesc"] = "name_DESC";
    PageMetadataLinkingCollectionsParkCollectionOrder["ParkTypeAsc"] = "parkType_ASC";
    PageMetadataLinkingCollectionsParkCollectionOrder["ParkTypeDesc"] = "parkType_DESC";
    PageMetadataLinkingCollectionsParkCollectionOrder["PathAsc"] = "path_ASC";
    PageMetadataLinkingCollectionsParkCollectionOrder["PathDesc"] = "path_DESC";
    PageMetadataLinkingCollectionsParkCollectionOrder["RunningCostsAsc"] = "runningCosts_ASC";
    PageMetadataLinkingCollectionsParkCollectionOrder["RunningCostsDesc"] = "runningCosts_DESC";
    PageMetadataLinkingCollectionsParkCollectionOrder["SiteFeesAsc"] = "siteFees_ASC";
    PageMetadataLinkingCollectionsParkCollectionOrder["SiteFeesDesc"] = "siteFees_DESC";
    PageMetadataLinkingCollectionsParkCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PageMetadataLinkingCollectionsParkCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PageMetadataLinkingCollectionsParkCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PageMetadataLinkingCollectionsParkCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PageMetadataLinkingCollectionsParkCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PageMetadataLinkingCollectionsParkCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PageMetadataLinkingCollectionsParkCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PageMetadataLinkingCollectionsParkCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    PageMetadataLinkingCollectionsParkCollectionOrder["TaglineAsc"] = "tagline_ASC";
    PageMetadataLinkingCollectionsParkCollectionOrder["TaglineDesc"] = "tagline_DESC";
    PageMetadataLinkingCollectionsParkCollectionOrder["ThingsToDoTitleAsc"] = "thingsToDoTitle_ASC";
    PageMetadataLinkingCollectionsParkCollectionOrder["ThingsToDoTitleDesc"] = "thingsToDoTitle_DESC";
    PageMetadataLinkingCollectionsParkCollectionOrder["TitleAsc"] = "title_ASC";
    PageMetadataLinkingCollectionsParkCollectionOrder["TitleDesc"] = "title_DESC";
})(PageMetadataLinkingCollectionsParkCollectionOrder = exports.PageMetadataLinkingCollectionsParkCollectionOrder || (exports.PageMetadataLinkingCollectionsParkCollectionOrder = {}));
var PageMetadataLinkingCollectionsPropositionCollectionOrder;
(function (PageMetadataLinkingCollectionsPropositionCollectionOrder) {
    PageMetadataLinkingCollectionsPropositionCollectionOrder["FaqFolderIdAsc"] = "faqFolderId_ASC";
    PageMetadataLinkingCollectionsPropositionCollectionOrder["FaqFolderIdDesc"] = "faqFolderId_DESC";
    PageMetadataLinkingCollectionsPropositionCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    PageMetadataLinkingCollectionsPropositionCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    PageMetadataLinkingCollectionsPropositionCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    PageMetadataLinkingCollectionsPropositionCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    PageMetadataLinkingCollectionsPropositionCollectionOrder["NameAsc"] = "name_ASC";
    PageMetadataLinkingCollectionsPropositionCollectionOrder["NameDesc"] = "name_DESC";
    PageMetadataLinkingCollectionsPropositionCollectionOrder["PathAsc"] = "path_ASC";
    PageMetadataLinkingCollectionsPropositionCollectionOrder["PathDesc"] = "path_DESC";
    PageMetadataLinkingCollectionsPropositionCollectionOrder["RelatedArticlesTitleAsc"] = "relatedArticlesTitle_ASC";
    PageMetadataLinkingCollectionsPropositionCollectionOrder["RelatedArticlesTitleDesc"] = "relatedArticlesTitle_DESC";
    PageMetadataLinkingCollectionsPropositionCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PageMetadataLinkingCollectionsPropositionCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PageMetadataLinkingCollectionsPropositionCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PageMetadataLinkingCollectionsPropositionCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PageMetadataLinkingCollectionsPropositionCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PageMetadataLinkingCollectionsPropositionCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PageMetadataLinkingCollectionsPropositionCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PageMetadataLinkingCollectionsPropositionCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    PageMetadataLinkingCollectionsPropositionCollectionOrder["TagLineAsc"] = "tagLine_ASC";
    PageMetadataLinkingCollectionsPropositionCollectionOrder["TagLineDesc"] = "tagLine_DESC";
    PageMetadataLinkingCollectionsPropositionCollectionOrder["TitleAsc"] = "title_ASC";
    PageMetadataLinkingCollectionsPropositionCollectionOrder["TitleDesc"] = "title_DESC";
})(PageMetadataLinkingCollectionsPropositionCollectionOrder = exports.PageMetadataLinkingCollectionsPropositionCollectionOrder || (exports.PageMetadataLinkingCollectionsPropositionCollectionOrder = {}));
var PageMetadataLinkingCollectionsPropositionSubCategoryCollectionOrder;
(function (PageMetadataLinkingCollectionsPropositionSubCategoryCollectionOrder) {
    PageMetadataLinkingCollectionsPropositionSubCategoryCollectionOrder["NameAsc"] = "name_ASC";
    PageMetadataLinkingCollectionsPropositionSubCategoryCollectionOrder["NameDesc"] = "name_DESC";
    PageMetadataLinkingCollectionsPropositionSubCategoryCollectionOrder["PathAsc"] = "path_ASC";
    PageMetadataLinkingCollectionsPropositionSubCategoryCollectionOrder["PathDesc"] = "path_DESC";
    PageMetadataLinkingCollectionsPropositionSubCategoryCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PageMetadataLinkingCollectionsPropositionSubCategoryCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PageMetadataLinkingCollectionsPropositionSubCategoryCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PageMetadataLinkingCollectionsPropositionSubCategoryCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PageMetadataLinkingCollectionsPropositionSubCategoryCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PageMetadataLinkingCollectionsPropositionSubCategoryCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PageMetadataLinkingCollectionsPropositionSubCategoryCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PageMetadataLinkingCollectionsPropositionSubCategoryCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    PageMetadataLinkingCollectionsPropositionSubCategoryCollectionOrder["TitleAsc"] = "title_ASC";
    PageMetadataLinkingCollectionsPropositionSubCategoryCollectionOrder["TitleDesc"] = "title_DESC";
})(PageMetadataLinkingCollectionsPropositionSubCategoryCollectionOrder = exports.PageMetadataLinkingCollectionsPropositionSubCategoryCollectionOrder || (exports.PageMetadataLinkingCollectionsPropositionSubCategoryCollectionOrder = {}));
var PageMetadataLinkingCollectionsRegionCollectionOrder;
(function (PageMetadataLinkingCollectionsRegionCollectionOrder) {
    PageMetadataLinkingCollectionsRegionCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    PageMetadataLinkingCollectionsRegionCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    PageMetadataLinkingCollectionsRegionCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    PageMetadataLinkingCollectionsRegionCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    PageMetadataLinkingCollectionsRegionCollectionOrder["NameAsc"] = "name_ASC";
    PageMetadataLinkingCollectionsRegionCollectionOrder["NameDesc"] = "name_DESC";
    PageMetadataLinkingCollectionsRegionCollectionOrder["NearbyTownCitiesTitleAsc"] = "nearbyTownCitiesTitle_ASC";
    PageMetadataLinkingCollectionsRegionCollectionOrder["NearbyTownCitiesTitleDesc"] = "nearbyTownCitiesTitle_DESC";
    PageMetadataLinkingCollectionsRegionCollectionOrder["PageTypeAsc"] = "pageType_ASC";
    PageMetadataLinkingCollectionsRegionCollectionOrder["PageTypeDesc"] = "pageType_DESC";
    PageMetadataLinkingCollectionsRegionCollectionOrder["PathAsc"] = "path_ASC";
    PageMetadataLinkingCollectionsRegionCollectionOrder["PathDesc"] = "path_DESC";
    PageMetadataLinkingCollectionsRegionCollectionOrder["RegionCodeAsc"] = "regionCode_ASC";
    PageMetadataLinkingCollectionsRegionCollectionOrder["RegionCodeDesc"] = "regionCode_DESC";
    PageMetadataLinkingCollectionsRegionCollectionOrder["RelatedArticlesTitleAsc"] = "relatedArticlesTitle_ASC";
    PageMetadataLinkingCollectionsRegionCollectionOrder["RelatedArticlesTitleDesc"] = "relatedArticlesTitle_DESC";
    PageMetadataLinkingCollectionsRegionCollectionOrder["SearchTitleAsc"] = "searchTitle_ASC";
    PageMetadataLinkingCollectionsRegionCollectionOrder["SearchTitleDesc"] = "searchTitle_DESC";
    PageMetadataLinkingCollectionsRegionCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PageMetadataLinkingCollectionsRegionCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PageMetadataLinkingCollectionsRegionCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PageMetadataLinkingCollectionsRegionCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PageMetadataLinkingCollectionsRegionCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PageMetadataLinkingCollectionsRegionCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PageMetadataLinkingCollectionsRegionCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PageMetadataLinkingCollectionsRegionCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    PageMetadataLinkingCollectionsRegionCollectionOrder["ThingsToDoTitleAsc"] = "thingsToDoTitle_ASC";
    PageMetadataLinkingCollectionsRegionCollectionOrder["ThingsToDoTitleDesc"] = "thingsToDoTitle_DESC";
    PageMetadataLinkingCollectionsRegionCollectionOrder["TitleAsc"] = "title_ASC";
    PageMetadataLinkingCollectionsRegionCollectionOrder["TitleDesc"] = "title_DESC";
})(PageMetadataLinkingCollectionsRegionCollectionOrder = exports.PageMetadataLinkingCollectionsRegionCollectionOrder || (exports.PageMetadataLinkingCollectionsRegionCollectionOrder = {}));
var PageMetadataLinkingCollectionsTagMetaDataCollectionOrder;
(function (PageMetadataLinkingCollectionsTagMetaDataCollectionOrder) {
    PageMetadataLinkingCollectionsTagMetaDataCollectionOrder["NameAsc"] = "name_ASC";
    PageMetadataLinkingCollectionsTagMetaDataCollectionOrder["NameDesc"] = "name_DESC";
    PageMetadataLinkingCollectionsTagMetaDataCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PageMetadataLinkingCollectionsTagMetaDataCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PageMetadataLinkingCollectionsTagMetaDataCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PageMetadataLinkingCollectionsTagMetaDataCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PageMetadataLinkingCollectionsTagMetaDataCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PageMetadataLinkingCollectionsTagMetaDataCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PageMetadataLinkingCollectionsTagMetaDataCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PageMetadataLinkingCollectionsTagMetaDataCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(PageMetadataLinkingCollectionsTagMetaDataCollectionOrder = exports.PageMetadataLinkingCollectionsTagMetaDataCollectionOrder || (exports.PageMetadataLinkingCollectionsTagMetaDataCollectionOrder = {}));
var PageMetadataOrder;
(function (PageMetadataOrder) {
    PageMetadataOrder["AuthorAsc"] = "author_ASC";
    PageMetadataOrder["AuthorDesc"] = "author_DESC";
    PageMetadataOrder["CanonicalAsc"] = "canonical_ASC";
    PageMetadataOrder["CanonicalDesc"] = "canonical_DESC";
    PageMetadataOrder["DisableRobotsAsc"] = "disableRobots_ASC";
    PageMetadataOrder["DisableRobotsDesc"] = "disableRobots_DESC";
    PageMetadataOrder["DisableSitemapAsc"] = "disableSitemap_ASC";
    PageMetadataOrder["DisableSitemapDesc"] = "disableSitemap_DESC";
    PageMetadataOrder["GoogleAnalyticsPageNameAsc"] = "googleAnalyticsPageName_ASC";
    PageMetadataOrder["GoogleAnalyticsPageNameDesc"] = "googleAnalyticsPageName_DESC";
    PageMetadataOrder["GoogleAnalyticsPageSubTypeAsc"] = "googleAnalyticsPageSubType_ASC";
    PageMetadataOrder["GoogleAnalyticsPageSubTypeDesc"] = "googleAnalyticsPageSubType_DESC";
    PageMetadataOrder["GoogleAnalyticsPageTypeAsc"] = "googleAnalyticsPageType_ASC";
    PageMetadataOrder["GoogleAnalyticsPageTypeDesc"] = "googleAnalyticsPageType_DESC";
    PageMetadataOrder["NameAsc"] = "name_ASC";
    PageMetadataOrder["NameDesc"] = "name_DESC";
    PageMetadataOrder["OgImageAsc"] = "ogImage_ASC";
    PageMetadataOrder["OgImageDesc"] = "ogImage_DESC";
    PageMetadataOrder["OgLocaleAsc"] = "ogLocale_ASC";
    PageMetadataOrder["OgLocaleDesc"] = "ogLocale_DESC";
    PageMetadataOrder["OgSiteNameAsc"] = "ogSiteName_ASC";
    PageMetadataOrder["OgSiteNameDesc"] = "ogSiteName_DESC";
    PageMetadataOrder["OgTitleAsc"] = "ogTitle_ASC";
    PageMetadataOrder["OgTitleDesc"] = "ogTitle_DESC";
    PageMetadataOrder["OgTypeAsc"] = "ogType_ASC";
    PageMetadataOrder["OgTypeDesc"] = "ogType_DESC";
    PageMetadataOrder["OgUrlAsc"] = "ogUrl_ASC";
    PageMetadataOrder["OgUrlDesc"] = "ogUrl_DESC";
    PageMetadataOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PageMetadataOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PageMetadataOrder["SysIdAsc"] = "sys_id_ASC";
    PageMetadataOrder["SysIdDesc"] = "sys_id_DESC";
    PageMetadataOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PageMetadataOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PageMetadataOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PageMetadataOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    PageMetadataOrder["TitleAsc"] = "title_ASC";
    PageMetadataOrder["TitleDesc"] = "title_DESC";
})(PageMetadataOrder = exports.PageMetadataOrder || (exports.PageMetadataOrder = {}));
var ParkAdvertsCollectionOrder;
(function (ParkAdvertsCollectionOrder) {
    ParkAdvertsCollectionOrder["AnalyticsCategoryAsc"] = "analyticsCategory_ASC";
    ParkAdvertsCollectionOrder["AnalyticsCategoryDesc"] = "analyticsCategory_DESC";
    ParkAdvertsCollectionOrder["AnalyticsTypeAsc"] = "analyticsType_ASC";
    ParkAdvertsCollectionOrder["AnalyticsTypeDesc"] = "analyticsType_DESC";
    ParkAdvertsCollectionOrder["AnalyticsVariantAsc"] = "analyticsVariant_ASC";
    ParkAdvertsCollectionOrder["AnalyticsVariantDesc"] = "analyticsVariant_DESC";
    ParkAdvertsCollectionOrder["CtaAsc"] = "cta_ASC";
    ParkAdvertsCollectionOrder["CtaDesc"] = "cta_DESC";
    ParkAdvertsCollectionOrder["DescriptionAsc"] = "description_ASC";
    ParkAdvertsCollectionOrder["DescriptionDesc"] = "description_DESC";
    ParkAdvertsCollectionOrder["SubTitleAsc"] = "subTitle_ASC";
    ParkAdvertsCollectionOrder["SubTitleDesc"] = "subTitle_DESC";
    ParkAdvertsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkAdvertsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkAdvertsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ParkAdvertsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ParkAdvertsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkAdvertsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkAdvertsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkAdvertsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ParkAdvertsCollectionOrder["TitleAsc"] = "title_ASC";
    ParkAdvertsCollectionOrder["TitleDesc"] = "title_DESC";
    ParkAdvertsCollectionOrder["UrlAsc"] = "url_ASC";
    ParkAdvertsCollectionOrder["UrlDesc"] = "url_DESC";
})(ParkAdvertsCollectionOrder = exports.ParkAdvertsCollectionOrder || (exports.ParkAdvertsCollectionOrder = {}));
var ParkAwardsCollectionOrder;
(function (ParkAwardsCollectionOrder) {
    ParkAwardsCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    ParkAwardsCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    ParkAwardsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkAwardsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkAwardsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ParkAwardsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ParkAwardsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkAwardsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkAwardsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkAwardsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ParkAwardsCollectionOrder["TitleAsc"] = "title_ASC";
    ParkAwardsCollectionOrder["TitleDesc"] = "title_DESC";
    ParkAwardsCollectionOrder["UrlAsc"] = "url_ASC";
    ParkAwardsCollectionOrder["UrlDesc"] = "url_DESC";
})(ParkAwardsCollectionOrder = exports.ParkAwardsCollectionOrder || (exports.ParkAwardsCollectionOrder = {}));
var ParkExclusiveCollectionOrder;
(function (ParkExclusiveCollectionOrder) {
    ParkExclusiveCollectionOrder["ApiIdAsc"] = "apiId_ASC";
    ParkExclusiveCollectionOrder["ApiIdDesc"] = "apiId_DESC";
    ParkExclusiveCollectionOrder["DateIntroducedAsc"] = "dateIntroduced_ASC";
    ParkExclusiveCollectionOrder["DateIntroducedDesc"] = "dateIntroduced_DESC";
    ParkExclusiveCollectionOrder["NameAsc"] = "name_ASC";
    ParkExclusiveCollectionOrder["NameDesc"] = "name_DESC";
    ParkExclusiveCollectionOrder["PropositionTypeAsc"] = "propositionType_ASC";
    ParkExclusiveCollectionOrder["PropositionTypeDesc"] = "propositionType_DESC";
    ParkExclusiveCollectionOrder["ShortTitleAsc"] = "shortTitle_ASC";
    ParkExclusiveCollectionOrder["ShortTitleDesc"] = "shortTitle_DESC";
    ParkExclusiveCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkExclusiveCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkExclusiveCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ParkExclusiveCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ParkExclusiveCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkExclusiveCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkExclusiveCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkExclusiveCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ParkExclusiveCollectionOrder["TitleAsc"] = "title_ASC";
    ParkExclusiveCollectionOrder["TitleDesc"] = "title_DESC";
    ParkExclusiveCollectionOrder["UrlAsc"] = "url_ASC";
    ParkExclusiveCollectionOrder["UrlDesc"] = "url_DESC";
})(ParkExclusiveCollectionOrder = exports.ParkExclusiveCollectionOrder || (exports.ParkExclusiveCollectionOrder = {}));
var ParkFaqsCollectionOrder;
(function (ParkFaqsCollectionOrder) {
    ParkFaqsCollectionOrder["QuestionAsc"] = "question_ASC";
    ParkFaqsCollectionOrder["QuestionDesc"] = "question_DESC";
    ParkFaqsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkFaqsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkFaqsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ParkFaqsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ParkFaqsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkFaqsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkFaqsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkFaqsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(ParkFaqsCollectionOrder = exports.ParkFaqsCollectionOrder || (exports.ParkFaqsCollectionOrder = {}));
var ParkFeaturesImagesCollectionOrder;
(function (ParkFeaturesImagesCollectionOrder) {
    ParkFeaturesImagesCollectionOrder["AltTextAsc"] = "altText_ASC";
    ParkFeaturesImagesCollectionOrder["AltTextDesc"] = "altText_DESC";
    ParkFeaturesImagesCollectionOrder["CaptionOptionalAsc"] = "captionOptional_ASC";
    ParkFeaturesImagesCollectionOrder["CaptionOptionalDesc"] = "captionOptional_DESC";
    ParkFeaturesImagesCollectionOrder["FocusAreaAsc"] = "focusArea_ASC";
    ParkFeaturesImagesCollectionOrder["FocusAreaDesc"] = "focusArea_DESC";
    ParkFeaturesImagesCollectionOrder["NameAsc"] = "name_ASC";
    ParkFeaturesImagesCollectionOrder["NameDesc"] = "name_DESC";
    ParkFeaturesImagesCollectionOrder["SubHeadingAsc"] = "subHeading_ASC";
    ParkFeaturesImagesCollectionOrder["SubHeadingDesc"] = "subHeading_DESC";
    ParkFeaturesImagesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkFeaturesImagesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkFeaturesImagesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ParkFeaturesImagesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ParkFeaturesImagesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkFeaturesImagesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkFeaturesImagesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkFeaturesImagesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(ParkFeaturesImagesCollectionOrder = exports.ParkFeaturesImagesCollectionOrder || (exports.ParkFeaturesImagesCollectionOrder = {}));
var ParkFeaturesLinkingCollectionsCyhhParkFacilityCollectionOrder;
(function (ParkFeaturesLinkingCollectionsCyhhParkFacilityCollectionOrder) {
    ParkFeaturesLinkingCollectionsCyhhParkFacilityCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkFeaturesLinkingCollectionsCyhhParkFacilityCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkFeaturesLinkingCollectionsCyhhParkFacilityCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ParkFeaturesLinkingCollectionsCyhhParkFacilityCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ParkFeaturesLinkingCollectionsCyhhParkFacilityCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkFeaturesLinkingCollectionsCyhhParkFacilityCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkFeaturesLinkingCollectionsCyhhParkFacilityCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkFeaturesLinkingCollectionsCyhhParkFacilityCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ParkFeaturesLinkingCollectionsCyhhParkFacilityCollectionOrder["TitleAsc"] = "title_ASC";
    ParkFeaturesLinkingCollectionsCyhhParkFacilityCollectionOrder["TitleDesc"] = "title_DESC";
})(ParkFeaturesLinkingCollectionsCyhhParkFacilityCollectionOrder = exports.ParkFeaturesLinkingCollectionsCyhhParkFacilityCollectionOrder || (exports.ParkFeaturesLinkingCollectionsCyhhParkFacilityCollectionOrder = {}));
var ParkFeaturesLinkingCollectionsParkCollectionOrder;
(function (ParkFeaturesLinkingCollectionsParkCollectionOrder) {
    ParkFeaturesLinkingCollectionsParkCollectionOrder["ContactNumberAsc"] = "contactNumber_ASC";
    ParkFeaturesLinkingCollectionsParkCollectionOrder["ContactNumberDesc"] = "contactNumber_DESC";
    ParkFeaturesLinkingCollectionsParkCollectionOrder["DirectionsUrlAsc"] = "directionsUrl_ASC";
    ParkFeaturesLinkingCollectionsParkCollectionOrder["DirectionsUrlDesc"] = "directionsUrl_DESC";
    ParkFeaturesLinkingCollectionsParkCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    ParkFeaturesLinkingCollectionsParkCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    ParkFeaturesLinkingCollectionsParkCollectionOrder["NameAsc"] = "name_ASC";
    ParkFeaturesLinkingCollectionsParkCollectionOrder["NameDesc"] = "name_DESC";
    ParkFeaturesLinkingCollectionsParkCollectionOrder["ParkTypeAsc"] = "parkType_ASC";
    ParkFeaturesLinkingCollectionsParkCollectionOrder["ParkTypeDesc"] = "parkType_DESC";
    ParkFeaturesLinkingCollectionsParkCollectionOrder["PathAsc"] = "path_ASC";
    ParkFeaturesLinkingCollectionsParkCollectionOrder["PathDesc"] = "path_DESC";
    ParkFeaturesLinkingCollectionsParkCollectionOrder["RunningCostsAsc"] = "runningCosts_ASC";
    ParkFeaturesLinkingCollectionsParkCollectionOrder["RunningCostsDesc"] = "runningCosts_DESC";
    ParkFeaturesLinkingCollectionsParkCollectionOrder["SiteFeesAsc"] = "siteFees_ASC";
    ParkFeaturesLinkingCollectionsParkCollectionOrder["SiteFeesDesc"] = "siteFees_DESC";
    ParkFeaturesLinkingCollectionsParkCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkFeaturesLinkingCollectionsParkCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkFeaturesLinkingCollectionsParkCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ParkFeaturesLinkingCollectionsParkCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ParkFeaturesLinkingCollectionsParkCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkFeaturesLinkingCollectionsParkCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkFeaturesLinkingCollectionsParkCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkFeaturesLinkingCollectionsParkCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ParkFeaturesLinkingCollectionsParkCollectionOrder["TaglineAsc"] = "tagline_ASC";
    ParkFeaturesLinkingCollectionsParkCollectionOrder["TaglineDesc"] = "tagline_DESC";
    ParkFeaturesLinkingCollectionsParkCollectionOrder["ThingsToDoTitleAsc"] = "thingsToDoTitle_ASC";
    ParkFeaturesLinkingCollectionsParkCollectionOrder["ThingsToDoTitleDesc"] = "thingsToDoTitle_DESC";
    ParkFeaturesLinkingCollectionsParkCollectionOrder["TitleAsc"] = "title_ASC";
    ParkFeaturesLinkingCollectionsParkCollectionOrder["TitleDesc"] = "title_DESC";
})(ParkFeaturesLinkingCollectionsParkCollectionOrder = exports.ParkFeaturesLinkingCollectionsParkCollectionOrder || (exports.ParkFeaturesLinkingCollectionsParkCollectionOrder = {}));
var ParkFeaturesLinkingCollectionsRegionCollectionOrder;
(function (ParkFeaturesLinkingCollectionsRegionCollectionOrder) {
    ParkFeaturesLinkingCollectionsRegionCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    ParkFeaturesLinkingCollectionsRegionCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    ParkFeaturesLinkingCollectionsRegionCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    ParkFeaturesLinkingCollectionsRegionCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    ParkFeaturesLinkingCollectionsRegionCollectionOrder["NameAsc"] = "name_ASC";
    ParkFeaturesLinkingCollectionsRegionCollectionOrder["NameDesc"] = "name_DESC";
    ParkFeaturesLinkingCollectionsRegionCollectionOrder["NearbyTownCitiesTitleAsc"] = "nearbyTownCitiesTitle_ASC";
    ParkFeaturesLinkingCollectionsRegionCollectionOrder["NearbyTownCitiesTitleDesc"] = "nearbyTownCitiesTitle_DESC";
    ParkFeaturesLinkingCollectionsRegionCollectionOrder["PageTypeAsc"] = "pageType_ASC";
    ParkFeaturesLinkingCollectionsRegionCollectionOrder["PageTypeDesc"] = "pageType_DESC";
    ParkFeaturesLinkingCollectionsRegionCollectionOrder["PathAsc"] = "path_ASC";
    ParkFeaturesLinkingCollectionsRegionCollectionOrder["PathDesc"] = "path_DESC";
    ParkFeaturesLinkingCollectionsRegionCollectionOrder["RegionCodeAsc"] = "regionCode_ASC";
    ParkFeaturesLinkingCollectionsRegionCollectionOrder["RegionCodeDesc"] = "regionCode_DESC";
    ParkFeaturesLinkingCollectionsRegionCollectionOrder["RelatedArticlesTitleAsc"] = "relatedArticlesTitle_ASC";
    ParkFeaturesLinkingCollectionsRegionCollectionOrder["RelatedArticlesTitleDesc"] = "relatedArticlesTitle_DESC";
    ParkFeaturesLinkingCollectionsRegionCollectionOrder["SearchTitleAsc"] = "searchTitle_ASC";
    ParkFeaturesLinkingCollectionsRegionCollectionOrder["SearchTitleDesc"] = "searchTitle_DESC";
    ParkFeaturesLinkingCollectionsRegionCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkFeaturesLinkingCollectionsRegionCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkFeaturesLinkingCollectionsRegionCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ParkFeaturesLinkingCollectionsRegionCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ParkFeaturesLinkingCollectionsRegionCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkFeaturesLinkingCollectionsRegionCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkFeaturesLinkingCollectionsRegionCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkFeaturesLinkingCollectionsRegionCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ParkFeaturesLinkingCollectionsRegionCollectionOrder["ThingsToDoTitleAsc"] = "thingsToDoTitle_ASC";
    ParkFeaturesLinkingCollectionsRegionCollectionOrder["ThingsToDoTitleDesc"] = "thingsToDoTitle_DESC";
    ParkFeaturesLinkingCollectionsRegionCollectionOrder["TitleAsc"] = "title_ASC";
    ParkFeaturesLinkingCollectionsRegionCollectionOrder["TitleDesc"] = "title_DESC";
})(ParkFeaturesLinkingCollectionsRegionCollectionOrder = exports.ParkFeaturesLinkingCollectionsRegionCollectionOrder || (exports.ParkFeaturesLinkingCollectionsRegionCollectionOrder = {}));
var ParkFeaturesMaintenancePeriodsCollectionOrder;
(function (ParkFeaturesMaintenancePeriodsCollectionOrder) {
    ParkFeaturesMaintenancePeriodsCollectionOrder["EndDateAsc"] = "endDate_ASC";
    ParkFeaturesMaintenancePeriodsCollectionOrder["EndDateDesc"] = "endDate_DESC";
    ParkFeaturesMaintenancePeriodsCollectionOrder["StartDateAsc"] = "startDate_ASC";
    ParkFeaturesMaintenancePeriodsCollectionOrder["StartDateDesc"] = "startDate_DESC";
    ParkFeaturesMaintenancePeriodsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkFeaturesMaintenancePeriodsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkFeaturesMaintenancePeriodsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ParkFeaturesMaintenancePeriodsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ParkFeaturesMaintenancePeriodsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkFeaturesMaintenancePeriodsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkFeaturesMaintenancePeriodsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkFeaturesMaintenancePeriodsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ParkFeaturesMaintenancePeriodsCollectionOrder["TitleAsc"] = "title_ASC";
    ParkFeaturesMaintenancePeriodsCollectionOrder["TitleDesc"] = "title_DESC";
})(ParkFeaturesMaintenancePeriodsCollectionOrder = exports.ParkFeaturesMaintenancePeriodsCollectionOrder || (exports.ParkFeaturesMaintenancePeriodsCollectionOrder = {}));
var ParkFeaturesOrder;
(function (ParkFeaturesOrder) {
    ParkFeaturesOrder["ApiIdAsc"] = "apiId_ASC";
    ParkFeaturesOrder["ApiIdDesc"] = "apiId_DESC";
    ParkFeaturesOrder["DateIntroducedAsc"] = "dateIntroduced_ASC";
    ParkFeaturesOrder["DateIntroducedDesc"] = "dateIntroduced_DESC";
    ParkFeaturesOrder["NameAsc"] = "name_ASC";
    ParkFeaturesOrder["NameDesc"] = "name_DESC";
    ParkFeaturesOrder["PropositionTypeAsc"] = "propositionType_ASC";
    ParkFeaturesOrder["PropositionTypeDesc"] = "propositionType_DESC";
    ParkFeaturesOrder["ShortTitleAsc"] = "shortTitle_ASC";
    ParkFeaturesOrder["ShortTitleDesc"] = "shortTitle_DESC";
    ParkFeaturesOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkFeaturesOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkFeaturesOrder["SysIdAsc"] = "sys_id_ASC";
    ParkFeaturesOrder["SysIdDesc"] = "sys_id_DESC";
    ParkFeaturesOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkFeaturesOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkFeaturesOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkFeaturesOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ParkFeaturesOrder["TitleAsc"] = "title_ASC";
    ParkFeaturesOrder["TitleDesc"] = "title_DESC";
    ParkFeaturesOrder["UrlAsc"] = "url_ASC";
    ParkFeaturesOrder["UrlDesc"] = "url_DESC";
})(ParkFeaturesOrder = exports.ParkFeaturesOrder || (exports.ParkFeaturesOrder = {}));
var ParkFeaturesVideosCollectionOrder;
(function (ParkFeaturesVideosCollectionOrder) {
    ParkFeaturesVideosCollectionOrder["EmbeddedUrlAsc"] = "embeddedUrl_ASC";
    ParkFeaturesVideosCollectionOrder["EmbeddedUrlDesc"] = "embeddedUrl_DESC";
    ParkFeaturesVideosCollectionOrder["NameAsc"] = "name_ASC";
    ParkFeaturesVideosCollectionOrder["NameDesc"] = "name_DESC";
    ParkFeaturesVideosCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkFeaturesVideosCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkFeaturesVideosCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ParkFeaturesVideosCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ParkFeaturesVideosCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkFeaturesVideosCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkFeaturesVideosCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkFeaturesVideosCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ParkFeaturesVideosCollectionOrder["TitleAsc"] = "title_ASC";
    ParkFeaturesVideosCollectionOrder["TitleDesc"] = "title_DESC";
})(ParkFeaturesVideosCollectionOrder = exports.ParkFeaturesVideosCollectionOrder || (exports.ParkFeaturesVideosCollectionOrder = {}));
var ParkFeaturesVirtualToursCollectionOrder;
(function (ParkFeaturesVirtualToursCollectionOrder) {
    ParkFeaturesVirtualToursCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkFeaturesVirtualToursCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkFeaturesVirtualToursCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ParkFeaturesVirtualToursCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ParkFeaturesVirtualToursCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkFeaturesVirtualToursCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkFeaturesVirtualToursCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkFeaturesVirtualToursCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ParkFeaturesVirtualToursCollectionOrder["TitleAsc"] = "title_ASC";
    ParkFeaturesVirtualToursCollectionOrder["TitleDesc"] = "title_DESC";
    ParkFeaturesVirtualToursCollectionOrder["UrlAsc"] = "url_ASC";
    ParkFeaturesVirtualToursCollectionOrder["UrlDesc"] = "url_DESC";
})(ParkFeaturesVirtualToursCollectionOrder = exports.ParkFeaturesVirtualToursCollectionOrder || (exports.ParkFeaturesVirtualToursCollectionOrder = {}));
var ParkInformationLinkingCollectionsCaravanTypeByParkCollectionOrder;
(function (ParkInformationLinkingCollectionsCaravanTypeByParkCollectionOrder) {
    ParkInformationLinkingCollectionsCaravanTypeByParkCollectionOrder["ContentfulNameAsc"] = "contentfulName_ASC";
    ParkInformationLinkingCollectionsCaravanTypeByParkCollectionOrder["ContentfulNameDesc"] = "contentfulName_DESC";
    ParkInformationLinkingCollectionsCaravanTypeByParkCollectionOrder["DisplayNameAsc"] = "displayName_ASC";
    ParkInformationLinkingCollectionsCaravanTypeByParkCollectionOrder["DisplayNameDesc"] = "displayName_DESC";
    ParkInformationLinkingCollectionsCaravanTypeByParkCollectionOrder["MatterportIdAsc"] = "matterportId_ASC";
    ParkInformationLinkingCollectionsCaravanTypeByParkCollectionOrder["MatterportIdDesc"] = "matterportId_DESC";
    ParkInformationLinkingCollectionsCaravanTypeByParkCollectionOrder["SubTitleAsc"] = "subTitle_ASC";
    ParkInformationLinkingCollectionsCaravanTypeByParkCollectionOrder["SubTitleDesc"] = "subTitle_DESC";
    ParkInformationLinkingCollectionsCaravanTypeByParkCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkInformationLinkingCollectionsCaravanTypeByParkCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkInformationLinkingCollectionsCaravanTypeByParkCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ParkInformationLinkingCollectionsCaravanTypeByParkCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ParkInformationLinkingCollectionsCaravanTypeByParkCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkInformationLinkingCollectionsCaravanTypeByParkCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkInformationLinkingCollectionsCaravanTypeByParkCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkInformationLinkingCollectionsCaravanTypeByParkCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ParkInformationLinkingCollectionsCaravanTypeByParkCollectionOrder["TitleAsc"] = "title_ASC";
    ParkInformationLinkingCollectionsCaravanTypeByParkCollectionOrder["TitleDesc"] = "title_DESC";
})(ParkInformationLinkingCollectionsCaravanTypeByParkCollectionOrder = exports.ParkInformationLinkingCollectionsCaravanTypeByParkCollectionOrder || (exports.ParkInformationLinkingCollectionsCaravanTypeByParkCollectionOrder = {}));
var ParkInformationLinkingCollectionsParkCollectionOrder;
(function (ParkInformationLinkingCollectionsParkCollectionOrder) {
    ParkInformationLinkingCollectionsParkCollectionOrder["ContactNumberAsc"] = "contactNumber_ASC";
    ParkInformationLinkingCollectionsParkCollectionOrder["ContactNumberDesc"] = "contactNumber_DESC";
    ParkInformationLinkingCollectionsParkCollectionOrder["DirectionsUrlAsc"] = "directionsUrl_ASC";
    ParkInformationLinkingCollectionsParkCollectionOrder["DirectionsUrlDesc"] = "directionsUrl_DESC";
    ParkInformationLinkingCollectionsParkCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    ParkInformationLinkingCollectionsParkCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    ParkInformationLinkingCollectionsParkCollectionOrder["NameAsc"] = "name_ASC";
    ParkInformationLinkingCollectionsParkCollectionOrder["NameDesc"] = "name_DESC";
    ParkInformationLinkingCollectionsParkCollectionOrder["ParkTypeAsc"] = "parkType_ASC";
    ParkInformationLinkingCollectionsParkCollectionOrder["ParkTypeDesc"] = "parkType_DESC";
    ParkInformationLinkingCollectionsParkCollectionOrder["PathAsc"] = "path_ASC";
    ParkInformationLinkingCollectionsParkCollectionOrder["PathDesc"] = "path_DESC";
    ParkInformationLinkingCollectionsParkCollectionOrder["RunningCostsAsc"] = "runningCosts_ASC";
    ParkInformationLinkingCollectionsParkCollectionOrder["RunningCostsDesc"] = "runningCosts_DESC";
    ParkInformationLinkingCollectionsParkCollectionOrder["SiteFeesAsc"] = "siteFees_ASC";
    ParkInformationLinkingCollectionsParkCollectionOrder["SiteFeesDesc"] = "siteFees_DESC";
    ParkInformationLinkingCollectionsParkCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkInformationLinkingCollectionsParkCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkInformationLinkingCollectionsParkCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ParkInformationLinkingCollectionsParkCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ParkInformationLinkingCollectionsParkCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkInformationLinkingCollectionsParkCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkInformationLinkingCollectionsParkCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkInformationLinkingCollectionsParkCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ParkInformationLinkingCollectionsParkCollectionOrder["TaglineAsc"] = "tagline_ASC";
    ParkInformationLinkingCollectionsParkCollectionOrder["TaglineDesc"] = "tagline_DESC";
    ParkInformationLinkingCollectionsParkCollectionOrder["ThingsToDoTitleAsc"] = "thingsToDoTitle_ASC";
    ParkInformationLinkingCollectionsParkCollectionOrder["ThingsToDoTitleDesc"] = "thingsToDoTitle_DESC";
    ParkInformationLinkingCollectionsParkCollectionOrder["TitleAsc"] = "title_ASC";
    ParkInformationLinkingCollectionsParkCollectionOrder["TitleDesc"] = "title_DESC";
})(ParkInformationLinkingCollectionsParkCollectionOrder = exports.ParkInformationLinkingCollectionsParkCollectionOrder || (exports.ParkInformationLinkingCollectionsParkCollectionOrder = {}));
var ParkInformationLinkingCollectionsTestimonialCollectionOrder;
(function (ParkInformationLinkingCollectionsTestimonialCollectionOrder) {
    ParkInformationLinkingCollectionsTestimonialCollectionOrder["AuthorAsc"] = "author_ASC";
    ParkInformationLinkingCollectionsTestimonialCollectionOrder["AuthorDesc"] = "author_DESC";
    ParkInformationLinkingCollectionsTestimonialCollectionOrder["HolidayTypeAsc"] = "holidayType_ASC";
    ParkInformationLinkingCollectionsTestimonialCollectionOrder["HolidayTypeDesc"] = "holidayType_DESC";
    ParkInformationLinkingCollectionsTestimonialCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    ParkInformationLinkingCollectionsTestimonialCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    ParkInformationLinkingCollectionsTestimonialCollectionOrder["RoleAsc"] = "role_ASC";
    ParkInformationLinkingCollectionsTestimonialCollectionOrder["RoleDesc"] = "role_DESC";
    ParkInformationLinkingCollectionsTestimonialCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkInformationLinkingCollectionsTestimonialCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkInformationLinkingCollectionsTestimonialCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ParkInformationLinkingCollectionsTestimonialCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ParkInformationLinkingCollectionsTestimonialCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkInformationLinkingCollectionsTestimonialCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkInformationLinkingCollectionsTestimonialCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkInformationLinkingCollectionsTestimonialCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(ParkInformationLinkingCollectionsTestimonialCollectionOrder = exports.ParkInformationLinkingCollectionsTestimonialCollectionOrder || (exports.ParkInformationLinkingCollectionsTestimonialCollectionOrder = {}));
var ParkInformationOrder;
(function (ParkInformationOrder) {
    ParkInformationOrder["ActivitiesUrlAsc"] = "activitiesUrl_ASC";
    ParkInformationOrder["ActivitiesUrlDesc"] = "activitiesUrl_DESC";
    ParkInformationOrder["AddressParkNameAsc"] = "addressParkName_ASC";
    ParkInformationOrder["AddressParkNameDesc"] = "addressParkName_DESC";
    ParkInformationOrder["CountryAsc"] = "country_ASC";
    ParkInformationOrder["CountryDesc"] = "country_DESC";
    ParkInformationOrder["CountyAsc"] = "county_ASC";
    ParkInformationOrder["CountyDesc"] = "county_DESC";
    ParkInformationOrder["LatlngAsc"] = "latlng_ASC";
    ParkInformationOrder["LatlngDesc"] = "latlng_DESC";
    ParkInformationOrder["ParkCodeAsc"] = "parkCode_ASC";
    ParkInformationOrder["ParkCodeDesc"] = "parkCode_DESC";
    ParkInformationOrder["ParkNameAsc"] = "parkName_ASC";
    ParkInformationOrder["ParkNameDesc"] = "parkName_DESC";
    ParkInformationOrder["PostcodeAsc"] = "postcode_ASC";
    ParkInformationOrder["PostcodeDesc"] = "postcode_DESC";
    ParkInformationOrder["RegionCodeAsc"] = "regionCode_ASC";
    ParkInformationOrder["RegionCodeDesc"] = "regionCode_DESC";
    ParkInformationOrder["RegionNameAsc"] = "regionName_ASC";
    ParkInformationOrder["RegionNameDesc"] = "regionName_DESC";
    ParkInformationOrder["StreetAddressAsc"] = "streetAddress_ASC";
    ParkInformationOrder["StreetAddressDesc"] = "streetAddress_DESC";
    ParkInformationOrder["SubRegionAsc"] = "subRegion_ASC";
    ParkInformationOrder["SubRegionDesc"] = "subRegion_DESC";
    ParkInformationOrder["SuburbAsc"] = "suburb_ASC";
    ParkInformationOrder["SuburbDesc"] = "suburb_DESC";
    ParkInformationOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkInformationOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkInformationOrder["SysIdAsc"] = "sys_id_ASC";
    ParkInformationOrder["SysIdDesc"] = "sys_id_DESC";
    ParkInformationOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkInformationOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkInformationOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkInformationOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ParkInformationOrder["TownAsc"] = "town_ASC";
    ParkInformationOrder["TownDesc"] = "town_DESC";
})(ParkInformationOrder = exports.ParkInformationOrder || (exports.ParkInformationOrder = {}));
var ParkLinkingCollectionsArticleSectionCollectionOrder;
(function (ParkLinkingCollectionsArticleSectionCollectionOrder) {
    ParkLinkingCollectionsArticleSectionCollectionOrder["CoordinatesAsc"] = "coordinates_ASC";
    ParkLinkingCollectionsArticleSectionCollectionOrder["CoordinatesDesc"] = "coordinates_DESC";
    ParkLinkingCollectionsArticleSectionCollectionOrder["NameAsc"] = "name_ASC";
    ParkLinkingCollectionsArticleSectionCollectionOrder["NameDesc"] = "name_DESC";
    ParkLinkingCollectionsArticleSectionCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkLinkingCollectionsArticleSectionCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkLinkingCollectionsArticleSectionCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ParkLinkingCollectionsArticleSectionCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ParkLinkingCollectionsArticleSectionCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkLinkingCollectionsArticleSectionCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkLinkingCollectionsArticleSectionCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkLinkingCollectionsArticleSectionCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ParkLinkingCollectionsArticleSectionCollectionOrder["TitleAsc"] = "title_ASC";
    ParkLinkingCollectionsArticleSectionCollectionOrder["TitleDesc"] = "title_DESC";
})(ParkLinkingCollectionsArticleSectionCollectionOrder = exports.ParkLinkingCollectionsArticleSectionCollectionOrder || (exports.ParkLinkingCollectionsArticleSectionCollectionOrder = {}));
var ParkLinkingCollectionsFocusParkListCollectionOrder;
(function (ParkLinkingCollectionsFocusParkListCollectionOrder) {
    ParkLinkingCollectionsFocusParkListCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    ParkLinkingCollectionsFocusParkListCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    ParkLinkingCollectionsFocusParkListCollectionOrder["ParkTypeAsc"] = "parkType_ASC";
    ParkLinkingCollectionsFocusParkListCollectionOrder["ParkTypeDesc"] = "parkType_DESC";
    ParkLinkingCollectionsFocusParkListCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkLinkingCollectionsFocusParkListCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkLinkingCollectionsFocusParkListCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ParkLinkingCollectionsFocusParkListCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ParkLinkingCollectionsFocusParkListCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkLinkingCollectionsFocusParkListCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkLinkingCollectionsFocusParkListCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkLinkingCollectionsFocusParkListCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ParkLinkingCollectionsFocusParkListCollectionOrder["TitleAsc"] = "title_ASC";
    ParkLinkingCollectionsFocusParkListCollectionOrder["TitleDesc"] = "title_DESC";
})(ParkLinkingCollectionsFocusParkListCollectionOrder = exports.ParkLinkingCollectionsFocusParkListCollectionOrder || (exports.ParkLinkingCollectionsFocusParkListCollectionOrder = {}));
var ParkLinkingCollectionsPitchTypeCollectionOrder;
(function (ParkLinkingCollectionsPitchTypeCollectionOrder) {
    ParkLinkingCollectionsPitchTypeCollectionOrder["NameAsc"] = "name_ASC";
    ParkLinkingCollectionsPitchTypeCollectionOrder["NameDesc"] = "name_DESC";
    ParkLinkingCollectionsPitchTypeCollectionOrder["PitchCodeAsc"] = "pitchCode_ASC";
    ParkLinkingCollectionsPitchTypeCollectionOrder["PitchCodeDesc"] = "pitchCode_DESC";
    ParkLinkingCollectionsPitchTypeCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkLinkingCollectionsPitchTypeCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkLinkingCollectionsPitchTypeCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ParkLinkingCollectionsPitchTypeCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ParkLinkingCollectionsPitchTypeCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkLinkingCollectionsPitchTypeCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkLinkingCollectionsPitchTypeCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkLinkingCollectionsPitchTypeCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ParkLinkingCollectionsPitchTypeCollectionOrder["TitleAsc"] = "title_ASC";
    ParkLinkingCollectionsPitchTypeCollectionOrder["TitleDesc"] = "title_DESC";
})(ParkLinkingCollectionsPitchTypeCollectionOrder = exports.ParkLinkingCollectionsPitchTypeCollectionOrder || (exports.ParkLinkingCollectionsPitchTypeCollectionOrder = {}));
var ParkLinkingCollectionsPromotionComponentCollectionOrder;
(function (ParkLinkingCollectionsPromotionComponentCollectionOrder) {
    ParkLinkingCollectionsPromotionComponentCollectionOrder["NameAsc"] = "name_ASC";
    ParkLinkingCollectionsPromotionComponentCollectionOrder["NameDesc"] = "name_DESC";
    ParkLinkingCollectionsPromotionComponentCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkLinkingCollectionsPromotionComponentCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkLinkingCollectionsPromotionComponentCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ParkLinkingCollectionsPromotionComponentCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ParkLinkingCollectionsPromotionComponentCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkLinkingCollectionsPromotionComponentCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkLinkingCollectionsPromotionComponentCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkLinkingCollectionsPromotionComponentCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(ParkLinkingCollectionsPromotionComponentCollectionOrder = exports.ParkLinkingCollectionsPromotionComponentCollectionOrder || (exports.ParkLinkingCollectionsPromotionComponentCollectionOrder = {}));
var ParkLinkingCollectionsRegionalHolidayCollectionOrder;
(function (ParkLinkingCollectionsRegionalHolidayCollectionOrder) {
    ParkLinkingCollectionsRegionalHolidayCollectionOrder["HolidayTypeAsc"] = "holidayType_ASC";
    ParkLinkingCollectionsRegionalHolidayCollectionOrder["HolidayTypeDesc"] = "holidayType_DESC";
    ParkLinkingCollectionsRegionalHolidayCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    ParkLinkingCollectionsRegionalHolidayCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    ParkLinkingCollectionsRegionalHolidayCollectionOrder["PathAsc"] = "path_ASC";
    ParkLinkingCollectionsRegionalHolidayCollectionOrder["PathDesc"] = "path_DESC";
    ParkLinkingCollectionsRegionalHolidayCollectionOrder["ReasonsToBookTitleAsc"] = "reasonsToBookTitle_ASC";
    ParkLinkingCollectionsRegionalHolidayCollectionOrder["ReasonsToBookTitleDesc"] = "reasonsToBookTitle_DESC";
    ParkLinkingCollectionsRegionalHolidayCollectionOrder["ShortDescriptionAsc"] = "shortDescription_ASC";
    ParkLinkingCollectionsRegionalHolidayCollectionOrder["ShortDescriptionDesc"] = "shortDescription_DESC";
    ParkLinkingCollectionsRegionalHolidayCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkLinkingCollectionsRegionalHolidayCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkLinkingCollectionsRegionalHolidayCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ParkLinkingCollectionsRegionalHolidayCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ParkLinkingCollectionsRegionalHolidayCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkLinkingCollectionsRegionalHolidayCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkLinkingCollectionsRegionalHolidayCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkLinkingCollectionsRegionalHolidayCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ParkLinkingCollectionsRegionalHolidayCollectionOrder["TitleAsc"] = "title_ASC";
    ParkLinkingCollectionsRegionalHolidayCollectionOrder["TitleDesc"] = "title_DESC";
})(ParkLinkingCollectionsRegionalHolidayCollectionOrder = exports.ParkLinkingCollectionsRegionalHolidayCollectionOrder || (exports.ParkLinkingCollectionsRegionalHolidayCollectionOrder = {}));
var ParkOfferImagesCollectionOrder;
(function (ParkOfferImagesCollectionOrder) {
    ParkOfferImagesCollectionOrder["AltTextAsc"] = "altText_ASC";
    ParkOfferImagesCollectionOrder["AltTextDesc"] = "altText_DESC";
    ParkOfferImagesCollectionOrder["CaptionOptionalAsc"] = "captionOptional_ASC";
    ParkOfferImagesCollectionOrder["CaptionOptionalDesc"] = "captionOptional_DESC";
    ParkOfferImagesCollectionOrder["FocusAreaAsc"] = "focusArea_ASC";
    ParkOfferImagesCollectionOrder["FocusAreaDesc"] = "focusArea_DESC";
    ParkOfferImagesCollectionOrder["NameAsc"] = "name_ASC";
    ParkOfferImagesCollectionOrder["NameDesc"] = "name_DESC";
    ParkOfferImagesCollectionOrder["SubHeadingAsc"] = "subHeading_ASC";
    ParkOfferImagesCollectionOrder["SubHeadingDesc"] = "subHeading_DESC";
    ParkOfferImagesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkOfferImagesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkOfferImagesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ParkOfferImagesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ParkOfferImagesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkOfferImagesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkOfferImagesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkOfferImagesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(ParkOfferImagesCollectionOrder = exports.ParkOfferImagesCollectionOrder || (exports.ParkOfferImagesCollectionOrder = {}));
var ParkOfferLinkingCollectionsFullCampaignCollectionOrder;
(function (ParkOfferLinkingCollectionsFullCampaignCollectionOrder) {
    ParkOfferLinkingCollectionsFullCampaignCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    ParkOfferLinkingCollectionsFullCampaignCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    ParkOfferLinkingCollectionsFullCampaignCollectionOrder["FeaturedParksTitleAsc"] = "featuredParksTitle_ASC";
    ParkOfferLinkingCollectionsFullCampaignCollectionOrder["FeaturedParksTitleDesc"] = "featuredParksTitle_DESC";
    ParkOfferLinkingCollectionsFullCampaignCollectionOrder["FeaturedPromotionsTitleAsc"] = "featuredPromotionsTitle_ASC";
    ParkOfferLinkingCollectionsFullCampaignCollectionOrder["FeaturedPromotionsTitleDesc"] = "featuredPromotionsTitle_DESC";
    ParkOfferLinkingCollectionsFullCampaignCollectionOrder["IntroductionTitleAsc"] = "introductionTitle_ASC";
    ParkOfferLinkingCollectionsFullCampaignCollectionOrder["IntroductionTitleDesc"] = "introductionTitle_DESC";
    ParkOfferLinkingCollectionsFullCampaignCollectionOrder["NameAsc"] = "name_ASC";
    ParkOfferLinkingCollectionsFullCampaignCollectionOrder["NameDesc"] = "name_DESC";
    ParkOfferLinkingCollectionsFullCampaignCollectionOrder["PathAsc"] = "path_ASC";
    ParkOfferLinkingCollectionsFullCampaignCollectionOrder["PathDesc"] = "path_DESC";
    ParkOfferLinkingCollectionsFullCampaignCollectionOrder["PromotionsTitleAsc"] = "promotionsTitle_ASC";
    ParkOfferLinkingCollectionsFullCampaignCollectionOrder["PromotionsTitleDesc"] = "promotionsTitle_DESC";
    ParkOfferLinkingCollectionsFullCampaignCollectionOrder["ReasonsToBookTitleAsc"] = "reasonsToBookTitle_ASC";
    ParkOfferLinkingCollectionsFullCampaignCollectionOrder["ReasonsToBookTitleDesc"] = "reasonsToBookTitle_DESC";
    ParkOfferLinkingCollectionsFullCampaignCollectionOrder["SellingPointsTitleAsc"] = "sellingPointsTitle_ASC";
    ParkOfferLinkingCollectionsFullCampaignCollectionOrder["SellingPointsTitleDesc"] = "sellingPointsTitle_DESC";
    ParkOfferLinkingCollectionsFullCampaignCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkOfferLinkingCollectionsFullCampaignCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkOfferLinkingCollectionsFullCampaignCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ParkOfferLinkingCollectionsFullCampaignCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ParkOfferLinkingCollectionsFullCampaignCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkOfferLinkingCollectionsFullCampaignCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkOfferLinkingCollectionsFullCampaignCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkOfferLinkingCollectionsFullCampaignCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ParkOfferLinkingCollectionsFullCampaignCollectionOrder["TitleAsc"] = "title_ASC";
    ParkOfferLinkingCollectionsFullCampaignCollectionOrder["TitleDesc"] = "title_DESC";
})(ParkOfferLinkingCollectionsFullCampaignCollectionOrder = exports.ParkOfferLinkingCollectionsFullCampaignCollectionOrder || (exports.ParkOfferLinkingCollectionsFullCampaignCollectionOrder = {}));
var ParkOfferLinkingCollectionsHomePageCollectionOrder;
(function (ParkOfferLinkingCollectionsHomePageCollectionOrder) {
    ParkOfferLinkingCollectionsHomePageCollectionOrder["DefaultHolidayNumberOfNightsAsc"] = "defaultHolidayNumberOfNights_ASC";
    ParkOfferLinkingCollectionsHomePageCollectionOrder["DefaultHolidayNumberOfNightsDesc"] = "defaultHolidayNumberOfNights_DESC";
    ParkOfferLinkingCollectionsHomePageCollectionOrder["NameAsc"] = "name_ASC";
    ParkOfferLinkingCollectionsHomePageCollectionOrder["NameDesc"] = "name_DESC";
    ParkOfferLinkingCollectionsHomePageCollectionOrder["PathAsc"] = "path_ASC";
    ParkOfferLinkingCollectionsHomePageCollectionOrder["PathDesc"] = "path_DESC";
    ParkOfferLinkingCollectionsHomePageCollectionOrder["SummaryTitleAsc"] = "summaryTitle_ASC";
    ParkOfferLinkingCollectionsHomePageCollectionOrder["SummaryTitleDesc"] = "summaryTitle_DESC";
    ParkOfferLinkingCollectionsHomePageCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkOfferLinkingCollectionsHomePageCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkOfferLinkingCollectionsHomePageCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ParkOfferLinkingCollectionsHomePageCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ParkOfferLinkingCollectionsHomePageCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkOfferLinkingCollectionsHomePageCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkOfferLinkingCollectionsHomePageCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkOfferLinkingCollectionsHomePageCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(ParkOfferLinkingCollectionsHomePageCollectionOrder = exports.ParkOfferLinkingCollectionsHomePageCollectionOrder || (exports.ParkOfferLinkingCollectionsHomePageCollectionOrder = {}));
var ParkOfferLinkingCollectionsParkCollectionOrder;
(function (ParkOfferLinkingCollectionsParkCollectionOrder) {
    ParkOfferLinkingCollectionsParkCollectionOrder["ContactNumberAsc"] = "contactNumber_ASC";
    ParkOfferLinkingCollectionsParkCollectionOrder["ContactNumberDesc"] = "contactNumber_DESC";
    ParkOfferLinkingCollectionsParkCollectionOrder["DirectionsUrlAsc"] = "directionsUrl_ASC";
    ParkOfferLinkingCollectionsParkCollectionOrder["DirectionsUrlDesc"] = "directionsUrl_DESC";
    ParkOfferLinkingCollectionsParkCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    ParkOfferLinkingCollectionsParkCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    ParkOfferLinkingCollectionsParkCollectionOrder["NameAsc"] = "name_ASC";
    ParkOfferLinkingCollectionsParkCollectionOrder["NameDesc"] = "name_DESC";
    ParkOfferLinkingCollectionsParkCollectionOrder["ParkTypeAsc"] = "parkType_ASC";
    ParkOfferLinkingCollectionsParkCollectionOrder["ParkTypeDesc"] = "parkType_DESC";
    ParkOfferLinkingCollectionsParkCollectionOrder["PathAsc"] = "path_ASC";
    ParkOfferLinkingCollectionsParkCollectionOrder["PathDesc"] = "path_DESC";
    ParkOfferLinkingCollectionsParkCollectionOrder["RunningCostsAsc"] = "runningCosts_ASC";
    ParkOfferLinkingCollectionsParkCollectionOrder["RunningCostsDesc"] = "runningCosts_DESC";
    ParkOfferLinkingCollectionsParkCollectionOrder["SiteFeesAsc"] = "siteFees_ASC";
    ParkOfferLinkingCollectionsParkCollectionOrder["SiteFeesDesc"] = "siteFees_DESC";
    ParkOfferLinkingCollectionsParkCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkOfferLinkingCollectionsParkCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkOfferLinkingCollectionsParkCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ParkOfferLinkingCollectionsParkCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ParkOfferLinkingCollectionsParkCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkOfferLinkingCollectionsParkCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkOfferLinkingCollectionsParkCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkOfferLinkingCollectionsParkCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ParkOfferLinkingCollectionsParkCollectionOrder["TaglineAsc"] = "tagline_ASC";
    ParkOfferLinkingCollectionsParkCollectionOrder["TaglineDesc"] = "tagline_DESC";
    ParkOfferLinkingCollectionsParkCollectionOrder["ThingsToDoTitleAsc"] = "thingsToDoTitle_ASC";
    ParkOfferLinkingCollectionsParkCollectionOrder["ThingsToDoTitleDesc"] = "thingsToDoTitle_DESC";
    ParkOfferLinkingCollectionsParkCollectionOrder["TitleAsc"] = "title_ASC";
    ParkOfferLinkingCollectionsParkCollectionOrder["TitleDesc"] = "title_DESC";
})(ParkOfferLinkingCollectionsParkCollectionOrder = exports.ParkOfferLinkingCollectionsParkCollectionOrder || (exports.ParkOfferLinkingCollectionsParkCollectionOrder = {}));
var ParkOfferLinkingCollectionsRegionalHolidayCollectionOrder;
(function (ParkOfferLinkingCollectionsRegionalHolidayCollectionOrder) {
    ParkOfferLinkingCollectionsRegionalHolidayCollectionOrder["HolidayTypeAsc"] = "holidayType_ASC";
    ParkOfferLinkingCollectionsRegionalHolidayCollectionOrder["HolidayTypeDesc"] = "holidayType_DESC";
    ParkOfferLinkingCollectionsRegionalHolidayCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    ParkOfferLinkingCollectionsRegionalHolidayCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    ParkOfferLinkingCollectionsRegionalHolidayCollectionOrder["PathAsc"] = "path_ASC";
    ParkOfferLinkingCollectionsRegionalHolidayCollectionOrder["PathDesc"] = "path_DESC";
    ParkOfferLinkingCollectionsRegionalHolidayCollectionOrder["ReasonsToBookTitleAsc"] = "reasonsToBookTitle_ASC";
    ParkOfferLinkingCollectionsRegionalHolidayCollectionOrder["ReasonsToBookTitleDesc"] = "reasonsToBookTitle_DESC";
    ParkOfferLinkingCollectionsRegionalHolidayCollectionOrder["ShortDescriptionAsc"] = "shortDescription_ASC";
    ParkOfferLinkingCollectionsRegionalHolidayCollectionOrder["ShortDescriptionDesc"] = "shortDescription_DESC";
    ParkOfferLinkingCollectionsRegionalHolidayCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkOfferLinkingCollectionsRegionalHolidayCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkOfferLinkingCollectionsRegionalHolidayCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ParkOfferLinkingCollectionsRegionalHolidayCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ParkOfferLinkingCollectionsRegionalHolidayCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkOfferLinkingCollectionsRegionalHolidayCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkOfferLinkingCollectionsRegionalHolidayCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkOfferLinkingCollectionsRegionalHolidayCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ParkOfferLinkingCollectionsRegionalHolidayCollectionOrder["TitleAsc"] = "title_ASC";
    ParkOfferLinkingCollectionsRegionalHolidayCollectionOrder["TitleDesc"] = "title_DESC";
})(ParkOfferLinkingCollectionsRegionalHolidayCollectionOrder = exports.ParkOfferLinkingCollectionsRegionalHolidayCollectionOrder || (exports.ParkOfferLinkingCollectionsRegionalHolidayCollectionOrder = {}));
var ParkOfferOrder;
(function (ParkOfferOrder) {
    ParkOfferOrder["AgeFromAsc"] = "ageFrom_ASC";
    ParkOfferOrder["AgeFromDesc"] = "ageFrom_DESC";
    ParkOfferOrder["CtaTitleAsc"] = "ctaTitle_ASC";
    ParkOfferOrder["CtaTitleDesc"] = "ctaTitle_DESC";
    ParkOfferOrder["CtaUrlAsc"] = "ctaUrl_ASC";
    ParkOfferOrder["CtaUrlDesc"] = "ctaUrl_DESC";
    ParkOfferOrder["EndDateAsc"] = "endDate_ASC";
    ParkOfferOrder["EndDateDesc"] = "endDate_DESC";
    ParkOfferOrder["HolidayTypeAsc"] = "holidayType_ASC";
    ParkOfferOrder["HolidayTypeDesc"] = "holidayType_DESC";
    ParkOfferOrder["InternalNameAsc"] = "internalName_ASC";
    ParkOfferOrder["InternalNameDesc"] = "internalName_DESC";
    ParkOfferOrder["PropositionTypeAsc"] = "propositionType_ASC";
    ParkOfferOrder["PropositionTypeDesc"] = "propositionType_DESC";
    ParkOfferOrder["StartDateAsc"] = "startDate_ASC";
    ParkOfferOrder["StartDateDesc"] = "startDate_DESC";
    ParkOfferOrder["SubTitleAsc"] = "subTitle_ASC";
    ParkOfferOrder["SubTitleDesc"] = "subTitle_DESC";
    ParkOfferOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkOfferOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkOfferOrder["SysIdAsc"] = "sys_id_ASC";
    ParkOfferOrder["SysIdDesc"] = "sys_id_DESC";
    ParkOfferOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkOfferOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkOfferOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkOfferOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ParkOfferOrder["TitleAsc"] = "title_ASC";
    ParkOfferOrder["TitleDesc"] = "title_DESC";
})(ParkOfferOrder = exports.ParkOfferOrder || (exports.ParkOfferOrder = {}));
var ParkOffersCollectionOrder;
(function (ParkOffersCollectionOrder) {
    ParkOffersCollectionOrder["AgeFromAsc"] = "ageFrom_ASC";
    ParkOffersCollectionOrder["AgeFromDesc"] = "ageFrom_DESC";
    ParkOffersCollectionOrder["CtaTitleAsc"] = "ctaTitle_ASC";
    ParkOffersCollectionOrder["CtaTitleDesc"] = "ctaTitle_DESC";
    ParkOffersCollectionOrder["CtaUrlAsc"] = "ctaUrl_ASC";
    ParkOffersCollectionOrder["CtaUrlDesc"] = "ctaUrl_DESC";
    ParkOffersCollectionOrder["EndDateAsc"] = "endDate_ASC";
    ParkOffersCollectionOrder["EndDateDesc"] = "endDate_DESC";
    ParkOffersCollectionOrder["HolidayTypeAsc"] = "holidayType_ASC";
    ParkOffersCollectionOrder["HolidayTypeDesc"] = "holidayType_DESC";
    ParkOffersCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    ParkOffersCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    ParkOffersCollectionOrder["PropositionTypeAsc"] = "propositionType_ASC";
    ParkOffersCollectionOrder["PropositionTypeDesc"] = "propositionType_DESC";
    ParkOffersCollectionOrder["StartDateAsc"] = "startDate_ASC";
    ParkOffersCollectionOrder["StartDateDesc"] = "startDate_DESC";
    ParkOffersCollectionOrder["SubTitleAsc"] = "subTitle_ASC";
    ParkOffersCollectionOrder["SubTitleDesc"] = "subTitle_DESC";
    ParkOffersCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkOffersCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkOffersCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ParkOffersCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ParkOffersCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkOffersCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkOffersCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkOffersCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ParkOffersCollectionOrder["TitleAsc"] = "title_ASC";
    ParkOffersCollectionOrder["TitleDesc"] = "title_DESC";
})(ParkOffersCollectionOrder = exports.ParkOffersCollectionOrder || (exports.ParkOffersCollectionOrder = {}));
var ParkOrder;
(function (ParkOrder) {
    ParkOrder["ContactNumberAsc"] = "contactNumber_ASC";
    ParkOrder["ContactNumberDesc"] = "contactNumber_DESC";
    ParkOrder["DirectionsUrlAsc"] = "directionsUrl_ASC";
    ParkOrder["DirectionsUrlDesc"] = "directionsUrl_DESC";
    ParkOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    ParkOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    ParkOrder["NameAsc"] = "name_ASC";
    ParkOrder["NameDesc"] = "name_DESC";
    ParkOrder["ParkTypeAsc"] = "parkType_ASC";
    ParkOrder["ParkTypeDesc"] = "parkType_DESC";
    ParkOrder["PathAsc"] = "path_ASC";
    ParkOrder["PathDesc"] = "path_DESC";
    ParkOrder["RunningCostsAsc"] = "runningCosts_ASC";
    ParkOrder["RunningCostsDesc"] = "runningCosts_DESC";
    ParkOrder["SiteFeesAsc"] = "siteFees_ASC";
    ParkOrder["SiteFeesDesc"] = "siteFees_DESC";
    ParkOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkOrder["SysIdAsc"] = "sys_id_ASC";
    ParkOrder["SysIdDesc"] = "sys_id_DESC";
    ParkOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ParkOrder["TaglineAsc"] = "tagline_ASC";
    ParkOrder["TaglineDesc"] = "tagline_DESC";
    ParkOrder["ThingsToDoTitleAsc"] = "thingsToDoTitle_ASC";
    ParkOrder["ThingsToDoTitleDesc"] = "thingsToDoTitle_DESC";
    ParkOrder["TitleAsc"] = "title_ASC";
    ParkOrder["TitleDesc"] = "title_DESC";
})(ParkOrder = exports.ParkOrder || (exports.ParkOrder = {}));
var ParkParkFeaturesCollectionOrder;
(function (ParkParkFeaturesCollectionOrder) {
    ParkParkFeaturesCollectionOrder["ApiIdAsc"] = "apiId_ASC";
    ParkParkFeaturesCollectionOrder["ApiIdDesc"] = "apiId_DESC";
    ParkParkFeaturesCollectionOrder["DateIntroducedAsc"] = "dateIntroduced_ASC";
    ParkParkFeaturesCollectionOrder["DateIntroducedDesc"] = "dateIntroduced_DESC";
    ParkParkFeaturesCollectionOrder["NameAsc"] = "name_ASC";
    ParkParkFeaturesCollectionOrder["NameDesc"] = "name_DESC";
    ParkParkFeaturesCollectionOrder["PropositionTypeAsc"] = "propositionType_ASC";
    ParkParkFeaturesCollectionOrder["PropositionTypeDesc"] = "propositionType_DESC";
    ParkParkFeaturesCollectionOrder["ShortTitleAsc"] = "shortTitle_ASC";
    ParkParkFeaturesCollectionOrder["ShortTitleDesc"] = "shortTitle_DESC";
    ParkParkFeaturesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkParkFeaturesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkParkFeaturesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ParkParkFeaturesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ParkParkFeaturesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkParkFeaturesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkParkFeaturesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkParkFeaturesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ParkParkFeaturesCollectionOrder["TitleAsc"] = "title_ASC";
    ParkParkFeaturesCollectionOrder["TitleDesc"] = "title_DESC";
    ParkParkFeaturesCollectionOrder["UrlAsc"] = "url_ASC";
    ParkParkFeaturesCollectionOrder["UrlDesc"] = "url_DESC";
})(ParkParkFeaturesCollectionOrder = exports.ParkParkFeaturesCollectionOrder || (exports.ParkParkFeaturesCollectionOrder = {}));
var ParkParkRestrictionsCollectionOrder;
(function (ParkParkRestrictionsCollectionOrder) {
    ParkParkRestrictionsCollectionOrder["NameAsc"] = "name_ASC";
    ParkParkRestrictionsCollectionOrder["NameDesc"] = "name_DESC";
    ParkParkRestrictionsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkParkRestrictionsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkParkRestrictionsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ParkParkRestrictionsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ParkParkRestrictionsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkParkRestrictionsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkParkRestrictionsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkParkRestrictionsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ParkParkRestrictionsCollectionOrder["TitleAsc"] = "title_ASC";
    ParkParkRestrictionsCollectionOrder["TitleDesc"] = "title_DESC";
})(ParkParkRestrictionsCollectionOrder = exports.ParkParkRestrictionsCollectionOrder || (exports.ParkParkRestrictionsCollectionOrder = {}));
var ParkRestrictionLinkingCollectionsParkCollectionOrder;
(function (ParkRestrictionLinkingCollectionsParkCollectionOrder) {
    ParkRestrictionLinkingCollectionsParkCollectionOrder["ContactNumberAsc"] = "contactNumber_ASC";
    ParkRestrictionLinkingCollectionsParkCollectionOrder["ContactNumberDesc"] = "contactNumber_DESC";
    ParkRestrictionLinkingCollectionsParkCollectionOrder["DirectionsUrlAsc"] = "directionsUrl_ASC";
    ParkRestrictionLinkingCollectionsParkCollectionOrder["DirectionsUrlDesc"] = "directionsUrl_DESC";
    ParkRestrictionLinkingCollectionsParkCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    ParkRestrictionLinkingCollectionsParkCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    ParkRestrictionLinkingCollectionsParkCollectionOrder["NameAsc"] = "name_ASC";
    ParkRestrictionLinkingCollectionsParkCollectionOrder["NameDesc"] = "name_DESC";
    ParkRestrictionLinkingCollectionsParkCollectionOrder["ParkTypeAsc"] = "parkType_ASC";
    ParkRestrictionLinkingCollectionsParkCollectionOrder["ParkTypeDesc"] = "parkType_DESC";
    ParkRestrictionLinkingCollectionsParkCollectionOrder["PathAsc"] = "path_ASC";
    ParkRestrictionLinkingCollectionsParkCollectionOrder["PathDesc"] = "path_DESC";
    ParkRestrictionLinkingCollectionsParkCollectionOrder["RunningCostsAsc"] = "runningCosts_ASC";
    ParkRestrictionLinkingCollectionsParkCollectionOrder["RunningCostsDesc"] = "runningCosts_DESC";
    ParkRestrictionLinkingCollectionsParkCollectionOrder["SiteFeesAsc"] = "siteFees_ASC";
    ParkRestrictionLinkingCollectionsParkCollectionOrder["SiteFeesDesc"] = "siteFees_DESC";
    ParkRestrictionLinkingCollectionsParkCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkRestrictionLinkingCollectionsParkCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkRestrictionLinkingCollectionsParkCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ParkRestrictionLinkingCollectionsParkCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ParkRestrictionLinkingCollectionsParkCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkRestrictionLinkingCollectionsParkCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkRestrictionLinkingCollectionsParkCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkRestrictionLinkingCollectionsParkCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ParkRestrictionLinkingCollectionsParkCollectionOrder["TaglineAsc"] = "tagline_ASC";
    ParkRestrictionLinkingCollectionsParkCollectionOrder["TaglineDesc"] = "tagline_DESC";
    ParkRestrictionLinkingCollectionsParkCollectionOrder["ThingsToDoTitleAsc"] = "thingsToDoTitle_ASC";
    ParkRestrictionLinkingCollectionsParkCollectionOrder["ThingsToDoTitleDesc"] = "thingsToDoTitle_DESC";
    ParkRestrictionLinkingCollectionsParkCollectionOrder["TitleAsc"] = "title_ASC";
    ParkRestrictionLinkingCollectionsParkCollectionOrder["TitleDesc"] = "title_DESC";
})(ParkRestrictionLinkingCollectionsParkCollectionOrder = exports.ParkRestrictionLinkingCollectionsParkCollectionOrder || (exports.ParkRestrictionLinkingCollectionsParkCollectionOrder = {}));
var ParkRestrictionOrder;
(function (ParkRestrictionOrder) {
    ParkRestrictionOrder["NameAsc"] = "name_ASC";
    ParkRestrictionOrder["NameDesc"] = "name_DESC";
    ParkRestrictionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkRestrictionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkRestrictionOrder["SysIdAsc"] = "sys_id_ASC";
    ParkRestrictionOrder["SysIdDesc"] = "sys_id_DESC";
    ParkRestrictionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkRestrictionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkRestrictionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkRestrictionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ParkRestrictionOrder["TitleAsc"] = "title_ASC";
    ParkRestrictionOrder["TitleDesc"] = "title_DESC";
})(ParkRestrictionOrder = exports.ParkRestrictionOrder || (exports.ParkRestrictionOrder = {}));
var ParkSellingPointsCollectionOrder;
(function (ParkSellingPointsCollectionOrder) {
    ParkSellingPointsCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    ParkSellingPointsCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    ParkSellingPointsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkSellingPointsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkSellingPointsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ParkSellingPointsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ParkSellingPointsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkSellingPointsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkSellingPointsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkSellingPointsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ParkSellingPointsCollectionOrder["TitleAsc"] = "title_ASC";
    ParkSellingPointsCollectionOrder["TitleDesc"] = "title_DESC";
    ParkSellingPointsCollectionOrder["UrlAsc"] = "url_ASC";
    ParkSellingPointsCollectionOrder["UrlDesc"] = "url_DESC";
})(ParkSellingPointsCollectionOrder = exports.ParkSellingPointsCollectionOrder || (exports.ParkSellingPointsCollectionOrder = {}));
var ParkSupportedAccommodationGradesCollectionOrder;
(function (ParkSupportedAccommodationGradesCollectionOrder) {
    ParkSupportedAccommodationGradesCollectionOrder["AccessibleAsc"] = "accessible_ASC";
    ParkSupportedAccommodationGradesCollectionOrder["AccessibleDesc"] = "accessible_DESC";
    ParkSupportedAccommodationGradesCollectionOrder["IncludesTitleAsc"] = "includesTitle_ASC";
    ParkSupportedAccommodationGradesCollectionOrder["IncludesTitleDesc"] = "includesTitle_DESC";
    ParkSupportedAccommodationGradesCollectionOrder["NameAsc"] = "name_ASC";
    ParkSupportedAccommodationGradesCollectionOrder["NameDesc"] = "name_DESC";
    ParkSupportedAccommodationGradesCollectionOrder["SearchAccommodationGradeAsc"] = "searchAccommodationGrade_ASC";
    ParkSupportedAccommodationGradesCollectionOrder["SearchAccommodationGradeDesc"] = "searchAccommodationGrade_DESC";
    ParkSupportedAccommodationGradesCollectionOrder["SellingPointsTitleAsc"] = "sellingPointsTitle_ASC";
    ParkSupportedAccommodationGradesCollectionOrder["SellingPointsTitleDesc"] = "sellingPointsTitle_DESC";
    ParkSupportedAccommodationGradesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkSupportedAccommodationGradesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkSupportedAccommodationGradesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ParkSupportedAccommodationGradesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ParkSupportedAccommodationGradesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkSupportedAccommodationGradesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkSupportedAccommodationGradesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkSupportedAccommodationGradesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ParkSupportedAccommodationGradesCollectionOrder["TaglineAsc"] = "tagline_ASC";
    ParkSupportedAccommodationGradesCollectionOrder["TaglineDesc"] = "tagline_DESC";
})(ParkSupportedAccommodationGradesCollectionOrder = exports.ParkSupportedAccommodationGradesCollectionOrder || (exports.ParkSupportedAccommodationGradesCollectionOrder = {}));
var ParkTermsAndConditionsCollectionOrder;
(function (ParkTermsAndConditionsCollectionOrder) {
    ParkTermsAndConditionsCollectionOrder["HolidayTypeAsc"] = "holidayType_ASC";
    ParkTermsAndConditionsCollectionOrder["HolidayTypeDesc"] = "holidayType_DESC";
    ParkTermsAndConditionsCollectionOrder["NameAsc"] = "name_ASC";
    ParkTermsAndConditionsCollectionOrder["NameDesc"] = "name_DESC";
    ParkTermsAndConditionsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkTermsAndConditionsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkTermsAndConditionsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ParkTermsAndConditionsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ParkTermsAndConditionsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkTermsAndConditionsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkTermsAndConditionsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkTermsAndConditionsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(ParkTermsAndConditionsCollectionOrder = exports.ParkTermsAndConditionsCollectionOrder || (exports.ParkTermsAndConditionsCollectionOrder = {}));
var ParkTestimonialsCollectionOrder;
(function (ParkTestimonialsCollectionOrder) {
    ParkTestimonialsCollectionOrder["AuthorAsc"] = "author_ASC";
    ParkTestimonialsCollectionOrder["AuthorDesc"] = "author_DESC";
    ParkTestimonialsCollectionOrder["HolidayTypeAsc"] = "holidayType_ASC";
    ParkTestimonialsCollectionOrder["HolidayTypeDesc"] = "holidayType_DESC";
    ParkTestimonialsCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    ParkTestimonialsCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    ParkTestimonialsCollectionOrder["RoleAsc"] = "role_ASC";
    ParkTestimonialsCollectionOrder["RoleDesc"] = "role_DESC";
    ParkTestimonialsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ParkTestimonialsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ParkTestimonialsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ParkTestimonialsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ParkTestimonialsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ParkTestimonialsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ParkTestimonialsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ParkTestimonialsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(ParkTestimonialsCollectionOrder = exports.ParkTestimonialsCollectionOrder || (exports.ParkTestimonialsCollectionOrder = {}));
var PitchTypeOrder;
(function (PitchTypeOrder) {
    PitchTypeOrder["NameAsc"] = "name_ASC";
    PitchTypeOrder["NameDesc"] = "name_DESC";
    PitchTypeOrder["PitchCodeAsc"] = "pitchCode_ASC";
    PitchTypeOrder["PitchCodeDesc"] = "pitchCode_DESC";
    PitchTypeOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PitchTypeOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PitchTypeOrder["SysIdAsc"] = "sys_id_ASC";
    PitchTypeOrder["SysIdDesc"] = "sys_id_DESC";
    PitchTypeOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PitchTypeOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PitchTypeOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PitchTypeOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    PitchTypeOrder["TitleAsc"] = "title_ASC";
    PitchTypeOrder["TitleDesc"] = "title_DESC";
})(PitchTypeOrder = exports.PitchTypeOrder || (exports.PitchTypeOrder = {}));
var PitchTypeParksCollectionOrder;
(function (PitchTypeParksCollectionOrder) {
    PitchTypeParksCollectionOrder["ContactNumberAsc"] = "contactNumber_ASC";
    PitchTypeParksCollectionOrder["ContactNumberDesc"] = "contactNumber_DESC";
    PitchTypeParksCollectionOrder["DirectionsUrlAsc"] = "directionsUrl_ASC";
    PitchTypeParksCollectionOrder["DirectionsUrlDesc"] = "directionsUrl_DESC";
    PitchTypeParksCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    PitchTypeParksCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    PitchTypeParksCollectionOrder["NameAsc"] = "name_ASC";
    PitchTypeParksCollectionOrder["NameDesc"] = "name_DESC";
    PitchTypeParksCollectionOrder["ParkTypeAsc"] = "parkType_ASC";
    PitchTypeParksCollectionOrder["ParkTypeDesc"] = "parkType_DESC";
    PitchTypeParksCollectionOrder["PathAsc"] = "path_ASC";
    PitchTypeParksCollectionOrder["PathDesc"] = "path_DESC";
    PitchTypeParksCollectionOrder["RunningCostsAsc"] = "runningCosts_ASC";
    PitchTypeParksCollectionOrder["RunningCostsDesc"] = "runningCosts_DESC";
    PitchTypeParksCollectionOrder["SiteFeesAsc"] = "siteFees_ASC";
    PitchTypeParksCollectionOrder["SiteFeesDesc"] = "siteFees_DESC";
    PitchTypeParksCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PitchTypeParksCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PitchTypeParksCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PitchTypeParksCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PitchTypeParksCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PitchTypeParksCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PitchTypeParksCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PitchTypeParksCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    PitchTypeParksCollectionOrder["TaglineAsc"] = "tagline_ASC";
    PitchTypeParksCollectionOrder["TaglineDesc"] = "tagline_DESC";
    PitchTypeParksCollectionOrder["ThingsToDoTitleAsc"] = "thingsToDoTitle_ASC";
    PitchTypeParksCollectionOrder["ThingsToDoTitleDesc"] = "thingsToDoTitle_DESC";
    PitchTypeParksCollectionOrder["TitleAsc"] = "title_ASC";
    PitchTypeParksCollectionOrder["TitleDesc"] = "title_DESC";
})(PitchTypeParksCollectionOrder = exports.PitchTypeParksCollectionOrder || (exports.PitchTypeParksCollectionOrder = {}));
var PitchTypePitchFeaturesCollectionOrder;
(function (PitchTypePitchFeaturesCollectionOrder) {
    PitchTypePitchFeaturesCollectionOrder["DescriptionUrlAsc"] = "descriptionUrl_ASC";
    PitchTypePitchFeaturesCollectionOrder["DescriptionUrlDesc"] = "descriptionUrl_DESC";
    PitchTypePitchFeaturesCollectionOrder["HrefAsc"] = "href_ASC";
    PitchTypePitchFeaturesCollectionOrder["HrefDesc"] = "href_DESC";
    PitchTypePitchFeaturesCollectionOrder["NameAsc"] = "name_ASC";
    PitchTypePitchFeaturesCollectionOrder["NameDesc"] = "name_DESC";
    PitchTypePitchFeaturesCollectionOrder["ShowOnPagesAsc"] = "showOnPages_ASC";
    PitchTypePitchFeaturesCollectionOrder["ShowOnPagesDesc"] = "showOnPages_DESC";
    PitchTypePitchFeaturesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PitchTypePitchFeaturesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PitchTypePitchFeaturesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PitchTypePitchFeaturesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PitchTypePitchFeaturesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PitchTypePitchFeaturesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PitchTypePitchFeaturesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PitchTypePitchFeaturesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    PitchTypePitchFeaturesCollectionOrder["TitleLevelAsc"] = "titleLevel_ASC";
    PitchTypePitchFeaturesCollectionOrder["TitleLevelDesc"] = "titleLevel_DESC";
    PitchTypePitchFeaturesCollectionOrder["TitleAsc"] = "title_ASC";
    PitchTypePitchFeaturesCollectionOrder["TitleDesc"] = "title_DESC";
})(PitchTypePitchFeaturesCollectionOrder = exports.PitchTypePitchFeaturesCollectionOrder || (exports.PitchTypePitchFeaturesCollectionOrder = {}));
var PromoLinkLinkingCollectionsArticleSectionCollectionOrder;
(function (PromoLinkLinkingCollectionsArticleSectionCollectionOrder) {
    PromoLinkLinkingCollectionsArticleSectionCollectionOrder["CoordinatesAsc"] = "coordinates_ASC";
    PromoLinkLinkingCollectionsArticleSectionCollectionOrder["CoordinatesDesc"] = "coordinates_DESC";
    PromoLinkLinkingCollectionsArticleSectionCollectionOrder["NameAsc"] = "name_ASC";
    PromoLinkLinkingCollectionsArticleSectionCollectionOrder["NameDesc"] = "name_DESC";
    PromoLinkLinkingCollectionsArticleSectionCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PromoLinkLinkingCollectionsArticleSectionCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PromoLinkLinkingCollectionsArticleSectionCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PromoLinkLinkingCollectionsArticleSectionCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PromoLinkLinkingCollectionsArticleSectionCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PromoLinkLinkingCollectionsArticleSectionCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PromoLinkLinkingCollectionsArticleSectionCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PromoLinkLinkingCollectionsArticleSectionCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    PromoLinkLinkingCollectionsArticleSectionCollectionOrder["TitleAsc"] = "title_ASC";
    PromoLinkLinkingCollectionsArticleSectionCollectionOrder["TitleDesc"] = "title_DESC";
})(PromoLinkLinkingCollectionsArticleSectionCollectionOrder = exports.PromoLinkLinkingCollectionsArticleSectionCollectionOrder || (exports.PromoLinkLinkingCollectionsArticleSectionCollectionOrder = {}));
var PromoLinkLinkingCollectionsPromotionComponentCollectionOrder;
(function (PromoLinkLinkingCollectionsPromotionComponentCollectionOrder) {
    PromoLinkLinkingCollectionsPromotionComponentCollectionOrder["NameAsc"] = "name_ASC";
    PromoLinkLinkingCollectionsPromotionComponentCollectionOrder["NameDesc"] = "name_DESC";
    PromoLinkLinkingCollectionsPromotionComponentCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PromoLinkLinkingCollectionsPromotionComponentCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PromoLinkLinkingCollectionsPromotionComponentCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PromoLinkLinkingCollectionsPromotionComponentCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PromoLinkLinkingCollectionsPromotionComponentCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PromoLinkLinkingCollectionsPromotionComponentCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PromoLinkLinkingCollectionsPromotionComponentCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PromoLinkLinkingCollectionsPromotionComponentCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(PromoLinkLinkingCollectionsPromotionComponentCollectionOrder = exports.PromoLinkLinkingCollectionsPromotionComponentCollectionOrder || (exports.PromoLinkLinkingCollectionsPromotionComponentCollectionOrder = {}));
var PromoLinkOrder;
(function (PromoLinkOrder) {
    PromoLinkOrder["NameAsc"] = "name_ASC";
    PromoLinkOrder["NameDesc"] = "name_DESC";
    PromoLinkOrder["ReadMoreAsc"] = "readMore_ASC";
    PromoLinkOrder["ReadMoreDesc"] = "readMore_DESC";
    PromoLinkOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PromoLinkOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PromoLinkOrder["SysIdAsc"] = "sys_id_ASC";
    PromoLinkOrder["SysIdDesc"] = "sys_id_DESC";
    PromoLinkOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PromoLinkOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PromoLinkOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PromoLinkOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(PromoLinkOrder = exports.PromoLinkOrder || (exports.PromoLinkOrder = {}));
var PromotionComponentLinkingCollectionsArticlesCollectionOrder;
(function (PromotionComponentLinkingCollectionsArticlesCollectionOrder) {
    PromotionComponentLinkingCollectionsArticlesCollectionOrder["ArticleSummaryAsc"] = "articleSummary_ASC";
    PromotionComponentLinkingCollectionsArticlesCollectionOrder["ArticleSummaryDesc"] = "articleSummary_DESC";
    PromotionComponentLinkingCollectionsArticlesCollectionOrder["AuthorAsc"] = "author_ASC";
    PromotionComponentLinkingCollectionsArticlesCollectionOrder["AuthorDesc"] = "author_DESC";
    PromotionComponentLinkingCollectionsArticlesCollectionOrder["HolidayTypeAsc"] = "holidayType_ASC";
    PromotionComponentLinkingCollectionsArticlesCollectionOrder["HolidayTypeDesc"] = "holidayType_DESC";
    PromotionComponentLinkingCollectionsArticlesCollectionOrder["NameAsc"] = "name_ASC";
    PromotionComponentLinkingCollectionsArticlesCollectionOrder["NameDesc"] = "name_DESC";
    PromotionComponentLinkingCollectionsArticlesCollectionOrder["PathAsc"] = "path_ASC";
    PromotionComponentLinkingCollectionsArticlesCollectionOrder["PathDesc"] = "path_DESC";
    PromotionComponentLinkingCollectionsArticlesCollectionOrder["RelatedArticlesTitleAsc"] = "relatedArticlesTitle_ASC";
    PromotionComponentLinkingCollectionsArticlesCollectionOrder["RelatedArticlesTitleDesc"] = "relatedArticlesTitle_DESC";
    PromotionComponentLinkingCollectionsArticlesCollectionOrder["ShowTableOfContentsAsc"] = "showTableOfContents_ASC";
    PromotionComponentLinkingCollectionsArticlesCollectionOrder["ShowTableOfContentsDesc"] = "showTableOfContents_DESC";
    PromotionComponentLinkingCollectionsArticlesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PromotionComponentLinkingCollectionsArticlesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PromotionComponentLinkingCollectionsArticlesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PromotionComponentLinkingCollectionsArticlesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PromotionComponentLinkingCollectionsArticlesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PromotionComponentLinkingCollectionsArticlesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PromotionComponentLinkingCollectionsArticlesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PromotionComponentLinkingCollectionsArticlesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    PromotionComponentLinkingCollectionsArticlesCollectionOrder["TitleAsc"] = "title_ASC";
    PromotionComponentLinkingCollectionsArticlesCollectionOrder["TitleDesc"] = "title_DESC";
})(PromotionComponentLinkingCollectionsArticlesCollectionOrder = exports.PromotionComponentLinkingCollectionsArticlesCollectionOrder || (exports.PromotionComponentLinkingCollectionsArticlesCollectionOrder = {}));
var PromotionComponentOrder;
(function (PromotionComponentOrder) {
    PromotionComponentOrder["NameAsc"] = "name_ASC";
    PromotionComponentOrder["NameDesc"] = "name_DESC";
    PromotionComponentOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PromotionComponentOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PromotionComponentOrder["SysIdAsc"] = "sys_id_ASC";
    PromotionComponentOrder["SysIdDesc"] = "sys_id_DESC";
    PromotionComponentOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PromotionComponentOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PromotionComponentOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PromotionComponentOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(PromotionComponentOrder = exports.PromotionComponentOrder || (exports.PromotionComponentOrder = {}));
var PromotionImagesCollectionOrder;
(function (PromotionImagesCollectionOrder) {
    PromotionImagesCollectionOrder["AltTextAsc"] = "altText_ASC";
    PromotionImagesCollectionOrder["AltTextDesc"] = "altText_DESC";
    PromotionImagesCollectionOrder["CaptionOptionalAsc"] = "captionOptional_ASC";
    PromotionImagesCollectionOrder["CaptionOptionalDesc"] = "captionOptional_DESC";
    PromotionImagesCollectionOrder["FocusAreaAsc"] = "focusArea_ASC";
    PromotionImagesCollectionOrder["FocusAreaDesc"] = "focusArea_DESC";
    PromotionImagesCollectionOrder["NameAsc"] = "name_ASC";
    PromotionImagesCollectionOrder["NameDesc"] = "name_DESC";
    PromotionImagesCollectionOrder["SubHeadingAsc"] = "subHeading_ASC";
    PromotionImagesCollectionOrder["SubHeadingDesc"] = "subHeading_DESC";
    PromotionImagesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PromotionImagesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PromotionImagesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PromotionImagesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PromotionImagesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PromotionImagesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PromotionImagesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PromotionImagesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(PromotionImagesCollectionOrder = exports.PromotionImagesCollectionOrder || (exports.PromotionImagesCollectionOrder = {}));
var PromotionLinkingCollectionsFullCampaignCollectionOrder;
(function (PromotionLinkingCollectionsFullCampaignCollectionOrder) {
    PromotionLinkingCollectionsFullCampaignCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    PromotionLinkingCollectionsFullCampaignCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    PromotionLinkingCollectionsFullCampaignCollectionOrder["FeaturedParksTitleAsc"] = "featuredParksTitle_ASC";
    PromotionLinkingCollectionsFullCampaignCollectionOrder["FeaturedParksTitleDesc"] = "featuredParksTitle_DESC";
    PromotionLinkingCollectionsFullCampaignCollectionOrder["FeaturedPromotionsTitleAsc"] = "featuredPromotionsTitle_ASC";
    PromotionLinkingCollectionsFullCampaignCollectionOrder["FeaturedPromotionsTitleDesc"] = "featuredPromotionsTitle_DESC";
    PromotionLinkingCollectionsFullCampaignCollectionOrder["IntroductionTitleAsc"] = "introductionTitle_ASC";
    PromotionLinkingCollectionsFullCampaignCollectionOrder["IntroductionTitleDesc"] = "introductionTitle_DESC";
    PromotionLinkingCollectionsFullCampaignCollectionOrder["NameAsc"] = "name_ASC";
    PromotionLinkingCollectionsFullCampaignCollectionOrder["NameDesc"] = "name_DESC";
    PromotionLinkingCollectionsFullCampaignCollectionOrder["PathAsc"] = "path_ASC";
    PromotionLinkingCollectionsFullCampaignCollectionOrder["PathDesc"] = "path_DESC";
    PromotionLinkingCollectionsFullCampaignCollectionOrder["PromotionsTitleAsc"] = "promotionsTitle_ASC";
    PromotionLinkingCollectionsFullCampaignCollectionOrder["PromotionsTitleDesc"] = "promotionsTitle_DESC";
    PromotionLinkingCollectionsFullCampaignCollectionOrder["ReasonsToBookTitleAsc"] = "reasonsToBookTitle_ASC";
    PromotionLinkingCollectionsFullCampaignCollectionOrder["ReasonsToBookTitleDesc"] = "reasonsToBookTitle_DESC";
    PromotionLinkingCollectionsFullCampaignCollectionOrder["SellingPointsTitleAsc"] = "sellingPointsTitle_ASC";
    PromotionLinkingCollectionsFullCampaignCollectionOrder["SellingPointsTitleDesc"] = "sellingPointsTitle_DESC";
    PromotionLinkingCollectionsFullCampaignCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PromotionLinkingCollectionsFullCampaignCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PromotionLinkingCollectionsFullCampaignCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PromotionLinkingCollectionsFullCampaignCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PromotionLinkingCollectionsFullCampaignCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PromotionLinkingCollectionsFullCampaignCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PromotionLinkingCollectionsFullCampaignCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PromotionLinkingCollectionsFullCampaignCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    PromotionLinkingCollectionsFullCampaignCollectionOrder["TitleAsc"] = "title_ASC";
    PromotionLinkingCollectionsFullCampaignCollectionOrder["TitleDesc"] = "title_DESC";
})(PromotionLinkingCollectionsFullCampaignCollectionOrder = exports.PromotionLinkingCollectionsFullCampaignCollectionOrder || (exports.PromotionLinkingCollectionsFullCampaignCollectionOrder = {}));
var PromotionLinkingCollectionsHomePageCollectionOrder;
(function (PromotionLinkingCollectionsHomePageCollectionOrder) {
    PromotionLinkingCollectionsHomePageCollectionOrder["DefaultHolidayNumberOfNightsAsc"] = "defaultHolidayNumberOfNights_ASC";
    PromotionLinkingCollectionsHomePageCollectionOrder["DefaultHolidayNumberOfNightsDesc"] = "defaultHolidayNumberOfNights_DESC";
    PromotionLinkingCollectionsHomePageCollectionOrder["NameAsc"] = "name_ASC";
    PromotionLinkingCollectionsHomePageCollectionOrder["NameDesc"] = "name_DESC";
    PromotionLinkingCollectionsHomePageCollectionOrder["PathAsc"] = "path_ASC";
    PromotionLinkingCollectionsHomePageCollectionOrder["PathDesc"] = "path_DESC";
    PromotionLinkingCollectionsHomePageCollectionOrder["SummaryTitleAsc"] = "summaryTitle_ASC";
    PromotionLinkingCollectionsHomePageCollectionOrder["SummaryTitleDesc"] = "summaryTitle_DESC";
    PromotionLinkingCollectionsHomePageCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PromotionLinkingCollectionsHomePageCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PromotionLinkingCollectionsHomePageCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PromotionLinkingCollectionsHomePageCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PromotionLinkingCollectionsHomePageCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PromotionLinkingCollectionsHomePageCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PromotionLinkingCollectionsHomePageCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PromotionLinkingCollectionsHomePageCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(PromotionLinkingCollectionsHomePageCollectionOrder = exports.PromotionLinkingCollectionsHomePageCollectionOrder || (exports.PromotionLinkingCollectionsHomePageCollectionOrder = {}));
var PromotionLinkingCollectionsPropositionCollectionOrder;
(function (PromotionLinkingCollectionsPropositionCollectionOrder) {
    PromotionLinkingCollectionsPropositionCollectionOrder["FaqFolderIdAsc"] = "faqFolderId_ASC";
    PromotionLinkingCollectionsPropositionCollectionOrder["FaqFolderIdDesc"] = "faqFolderId_DESC";
    PromotionLinkingCollectionsPropositionCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    PromotionLinkingCollectionsPropositionCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    PromotionLinkingCollectionsPropositionCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    PromotionLinkingCollectionsPropositionCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    PromotionLinkingCollectionsPropositionCollectionOrder["NameAsc"] = "name_ASC";
    PromotionLinkingCollectionsPropositionCollectionOrder["NameDesc"] = "name_DESC";
    PromotionLinkingCollectionsPropositionCollectionOrder["PathAsc"] = "path_ASC";
    PromotionLinkingCollectionsPropositionCollectionOrder["PathDesc"] = "path_DESC";
    PromotionLinkingCollectionsPropositionCollectionOrder["RelatedArticlesTitleAsc"] = "relatedArticlesTitle_ASC";
    PromotionLinkingCollectionsPropositionCollectionOrder["RelatedArticlesTitleDesc"] = "relatedArticlesTitle_DESC";
    PromotionLinkingCollectionsPropositionCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PromotionLinkingCollectionsPropositionCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PromotionLinkingCollectionsPropositionCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PromotionLinkingCollectionsPropositionCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PromotionLinkingCollectionsPropositionCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PromotionLinkingCollectionsPropositionCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PromotionLinkingCollectionsPropositionCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PromotionLinkingCollectionsPropositionCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    PromotionLinkingCollectionsPropositionCollectionOrder["TagLineAsc"] = "tagLine_ASC";
    PromotionLinkingCollectionsPropositionCollectionOrder["TagLineDesc"] = "tagLine_DESC";
    PromotionLinkingCollectionsPropositionCollectionOrder["TitleAsc"] = "title_ASC";
    PromotionLinkingCollectionsPropositionCollectionOrder["TitleDesc"] = "title_DESC";
})(PromotionLinkingCollectionsPropositionCollectionOrder = exports.PromotionLinkingCollectionsPropositionCollectionOrder || (exports.PromotionLinkingCollectionsPropositionCollectionOrder = {}));
var PromotionLinkingCollectionsRegionalHolidayCollectionOrder;
(function (PromotionLinkingCollectionsRegionalHolidayCollectionOrder) {
    PromotionLinkingCollectionsRegionalHolidayCollectionOrder["HolidayTypeAsc"] = "holidayType_ASC";
    PromotionLinkingCollectionsRegionalHolidayCollectionOrder["HolidayTypeDesc"] = "holidayType_DESC";
    PromotionLinkingCollectionsRegionalHolidayCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    PromotionLinkingCollectionsRegionalHolidayCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    PromotionLinkingCollectionsRegionalHolidayCollectionOrder["PathAsc"] = "path_ASC";
    PromotionLinkingCollectionsRegionalHolidayCollectionOrder["PathDesc"] = "path_DESC";
    PromotionLinkingCollectionsRegionalHolidayCollectionOrder["ReasonsToBookTitleAsc"] = "reasonsToBookTitle_ASC";
    PromotionLinkingCollectionsRegionalHolidayCollectionOrder["ReasonsToBookTitleDesc"] = "reasonsToBookTitle_DESC";
    PromotionLinkingCollectionsRegionalHolidayCollectionOrder["ShortDescriptionAsc"] = "shortDescription_ASC";
    PromotionLinkingCollectionsRegionalHolidayCollectionOrder["ShortDescriptionDesc"] = "shortDescription_DESC";
    PromotionLinkingCollectionsRegionalHolidayCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PromotionLinkingCollectionsRegionalHolidayCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PromotionLinkingCollectionsRegionalHolidayCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PromotionLinkingCollectionsRegionalHolidayCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PromotionLinkingCollectionsRegionalHolidayCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PromotionLinkingCollectionsRegionalHolidayCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PromotionLinkingCollectionsRegionalHolidayCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PromotionLinkingCollectionsRegionalHolidayCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    PromotionLinkingCollectionsRegionalHolidayCollectionOrder["TitleAsc"] = "title_ASC";
    PromotionLinkingCollectionsRegionalHolidayCollectionOrder["TitleDesc"] = "title_DESC";
})(PromotionLinkingCollectionsRegionalHolidayCollectionOrder = exports.PromotionLinkingCollectionsRegionalHolidayCollectionOrder || (exports.PromotionLinkingCollectionsRegionalHolidayCollectionOrder = {}));
var PromotionOrder;
(function (PromotionOrder) {
    PromotionOrder["AnalyticsCategoryAsc"] = "analyticsCategory_ASC";
    PromotionOrder["AnalyticsCategoryDesc"] = "analyticsCategory_DESC";
    PromotionOrder["AnalyticsTypeAsc"] = "analyticsType_ASC";
    PromotionOrder["AnalyticsTypeDesc"] = "analyticsType_DESC";
    PromotionOrder["AnalyticsVariantAsc"] = "analyticsVariant_ASC";
    PromotionOrder["AnalyticsVariantDesc"] = "analyticsVariant_DESC";
    PromotionOrder["DurationAsc"] = "duration_ASC";
    PromotionOrder["DurationDesc"] = "duration_DESC";
    PromotionOrder["InternalNameAsc"] = "internalName_ASC";
    PromotionOrder["InternalNameDesc"] = "internalName_DESC";
    PromotionOrder["MaxPriceAsc"] = "maxPrice_ASC";
    PromotionOrder["MaxPriceDesc"] = "maxPrice_DESC";
    PromotionOrder["MinPriceAsc"] = "minPrice_ASC";
    PromotionOrder["MinPriceDesc"] = "minPrice_DESC";
    PromotionOrder["PriceAsc"] = "price_ASC";
    PromotionOrder["PriceDesc"] = "price_DESC";
    PromotionOrder["SubTitleAsc"] = "subTitle_ASC";
    PromotionOrder["SubTitleDesc"] = "subTitle_DESC";
    PromotionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PromotionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PromotionOrder["SysIdAsc"] = "sys_id_ASC";
    PromotionOrder["SysIdDesc"] = "sys_id_DESC";
    PromotionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PromotionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PromotionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PromotionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    PromotionOrder["TitleAsc"] = "title_ASC";
    PromotionOrder["TitleDesc"] = "title_DESC";
    PromotionOrder["UrlAsc"] = "url_ASC";
    PromotionOrder["UrlDesc"] = "url_DESC";
})(PromotionOrder = exports.PromotionOrder || (exports.PromotionOrder = {}));
var PromotionTermsAndConditionsCollectionOrder;
(function (PromotionTermsAndConditionsCollectionOrder) {
    PromotionTermsAndConditionsCollectionOrder["HolidayTypeAsc"] = "holidayType_ASC";
    PromotionTermsAndConditionsCollectionOrder["HolidayTypeDesc"] = "holidayType_DESC";
    PromotionTermsAndConditionsCollectionOrder["NameAsc"] = "name_ASC";
    PromotionTermsAndConditionsCollectionOrder["NameDesc"] = "name_DESC";
    PromotionTermsAndConditionsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PromotionTermsAndConditionsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PromotionTermsAndConditionsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PromotionTermsAndConditionsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PromotionTermsAndConditionsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PromotionTermsAndConditionsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PromotionTermsAndConditionsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PromotionTermsAndConditionsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(PromotionTermsAndConditionsCollectionOrder = exports.PromotionTermsAndConditionsCollectionOrder || (exports.PromotionTermsAndConditionsCollectionOrder = {}));
var PropositionCategoriesCollectionOrder;
(function (PropositionCategoriesCollectionOrder) {
    PropositionCategoriesCollectionOrder["CtaTitleAsc"] = "ctaTitle_ASC";
    PropositionCategoriesCollectionOrder["CtaTitleDesc"] = "ctaTitle_DESC";
    PropositionCategoriesCollectionOrder["CtaUrlAsc"] = "ctaUrl_ASC";
    PropositionCategoriesCollectionOrder["CtaUrlDesc"] = "ctaUrl_DESC";
    PropositionCategoriesCollectionOrder["FeaturedParksTitleAsc"] = "featuredParksTitle_ASC";
    PropositionCategoriesCollectionOrder["FeaturedParksTitleDesc"] = "featuredParksTitle_DESC";
    PropositionCategoriesCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    PropositionCategoriesCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    PropositionCategoriesCollectionOrder["NameAsc"] = "name_ASC";
    PropositionCategoriesCollectionOrder["NameDesc"] = "name_DESC";
    PropositionCategoriesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PropositionCategoriesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PropositionCategoriesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PropositionCategoriesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PropositionCategoriesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PropositionCategoriesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PropositionCategoriesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PropositionCategoriesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(PropositionCategoriesCollectionOrder = exports.PropositionCategoriesCollectionOrder || (exports.PropositionCategoriesCollectionOrder = {}));
var PropositionCategoryAdvertsCollectionOrder;
(function (PropositionCategoryAdvertsCollectionOrder) {
    PropositionCategoryAdvertsCollectionOrder["AnalyticsCategoryAsc"] = "analyticsCategory_ASC";
    PropositionCategoryAdvertsCollectionOrder["AnalyticsCategoryDesc"] = "analyticsCategory_DESC";
    PropositionCategoryAdvertsCollectionOrder["AnalyticsTypeAsc"] = "analyticsType_ASC";
    PropositionCategoryAdvertsCollectionOrder["AnalyticsTypeDesc"] = "analyticsType_DESC";
    PropositionCategoryAdvertsCollectionOrder["AnalyticsVariantAsc"] = "analyticsVariant_ASC";
    PropositionCategoryAdvertsCollectionOrder["AnalyticsVariantDesc"] = "analyticsVariant_DESC";
    PropositionCategoryAdvertsCollectionOrder["CtaAsc"] = "cta_ASC";
    PropositionCategoryAdvertsCollectionOrder["CtaDesc"] = "cta_DESC";
    PropositionCategoryAdvertsCollectionOrder["DescriptionAsc"] = "description_ASC";
    PropositionCategoryAdvertsCollectionOrder["DescriptionDesc"] = "description_DESC";
    PropositionCategoryAdvertsCollectionOrder["SubTitleAsc"] = "subTitle_ASC";
    PropositionCategoryAdvertsCollectionOrder["SubTitleDesc"] = "subTitle_DESC";
    PropositionCategoryAdvertsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PropositionCategoryAdvertsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PropositionCategoryAdvertsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PropositionCategoryAdvertsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PropositionCategoryAdvertsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PropositionCategoryAdvertsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PropositionCategoryAdvertsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PropositionCategoryAdvertsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    PropositionCategoryAdvertsCollectionOrder["TitleAsc"] = "title_ASC";
    PropositionCategoryAdvertsCollectionOrder["TitleDesc"] = "title_DESC";
    PropositionCategoryAdvertsCollectionOrder["UrlAsc"] = "url_ASC";
    PropositionCategoryAdvertsCollectionOrder["UrlDesc"] = "url_DESC";
})(PropositionCategoryAdvertsCollectionOrder = exports.PropositionCategoryAdvertsCollectionOrder || (exports.PropositionCategoryAdvertsCollectionOrder = {}));
var PropositionCategoryExampleImagesCollectionOrder;
(function (PropositionCategoryExampleImagesCollectionOrder) {
    PropositionCategoryExampleImagesCollectionOrder["AltTextAsc"] = "altText_ASC";
    PropositionCategoryExampleImagesCollectionOrder["AltTextDesc"] = "altText_DESC";
    PropositionCategoryExampleImagesCollectionOrder["CaptionOptionalAsc"] = "captionOptional_ASC";
    PropositionCategoryExampleImagesCollectionOrder["CaptionOptionalDesc"] = "captionOptional_DESC";
    PropositionCategoryExampleImagesCollectionOrder["FocusAreaAsc"] = "focusArea_ASC";
    PropositionCategoryExampleImagesCollectionOrder["FocusAreaDesc"] = "focusArea_DESC";
    PropositionCategoryExampleImagesCollectionOrder["NameAsc"] = "name_ASC";
    PropositionCategoryExampleImagesCollectionOrder["NameDesc"] = "name_DESC";
    PropositionCategoryExampleImagesCollectionOrder["SubHeadingAsc"] = "subHeading_ASC";
    PropositionCategoryExampleImagesCollectionOrder["SubHeadingDesc"] = "subHeading_DESC";
    PropositionCategoryExampleImagesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PropositionCategoryExampleImagesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PropositionCategoryExampleImagesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PropositionCategoryExampleImagesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PropositionCategoryExampleImagesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PropositionCategoryExampleImagesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PropositionCategoryExampleImagesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PropositionCategoryExampleImagesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(PropositionCategoryExampleImagesCollectionOrder = exports.PropositionCategoryExampleImagesCollectionOrder || (exports.PropositionCategoryExampleImagesCollectionOrder = {}));
var PropositionCategoryImagesCollectionOrder;
(function (PropositionCategoryImagesCollectionOrder) {
    PropositionCategoryImagesCollectionOrder["AltTextAsc"] = "altText_ASC";
    PropositionCategoryImagesCollectionOrder["AltTextDesc"] = "altText_DESC";
    PropositionCategoryImagesCollectionOrder["CaptionOptionalAsc"] = "captionOptional_ASC";
    PropositionCategoryImagesCollectionOrder["CaptionOptionalDesc"] = "captionOptional_DESC";
    PropositionCategoryImagesCollectionOrder["FocusAreaAsc"] = "focusArea_ASC";
    PropositionCategoryImagesCollectionOrder["FocusAreaDesc"] = "focusArea_DESC";
    PropositionCategoryImagesCollectionOrder["NameAsc"] = "name_ASC";
    PropositionCategoryImagesCollectionOrder["NameDesc"] = "name_DESC";
    PropositionCategoryImagesCollectionOrder["SubHeadingAsc"] = "subHeading_ASC";
    PropositionCategoryImagesCollectionOrder["SubHeadingDesc"] = "subHeading_DESC";
    PropositionCategoryImagesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PropositionCategoryImagesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PropositionCategoryImagesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PropositionCategoryImagesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PropositionCategoryImagesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PropositionCategoryImagesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PropositionCategoryImagesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PropositionCategoryImagesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(PropositionCategoryImagesCollectionOrder = exports.PropositionCategoryImagesCollectionOrder || (exports.PropositionCategoryImagesCollectionOrder = {}));
var PropositionCategoryLinkingCollectionsFullCampaignCollectionOrder;
(function (PropositionCategoryLinkingCollectionsFullCampaignCollectionOrder) {
    PropositionCategoryLinkingCollectionsFullCampaignCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    PropositionCategoryLinkingCollectionsFullCampaignCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    PropositionCategoryLinkingCollectionsFullCampaignCollectionOrder["FeaturedParksTitleAsc"] = "featuredParksTitle_ASC";
    PropositionCategoryLinkingCollectionsFullCampaignCollectionOrder["FeaturedParksTitleDesc"] = "featuredParksTitle_DESC";
    PropositionCategoryLinkingCollectionsFullCampaignCollectionOrder["FeaturedPromotionsTitleAsc"] = "featuredPromotionsTitle_ASC";
    PropositionCategoryLinkingCollectionsFullCampaignCollectionOrder["FeaturedPromotionsTitleDesc"] = "featuredPromotionsTitle_DESC";
    PropositionCategoryLinkingCollectionsFullCampaignCollectionOrder["IntroductionTitleAsc"] = "introductionTitle_ASC";
    PropositionCategoryLinkingCollectionsFullCampaignCollectionOrder["IntroductionTitleDesc"] = "introductionTitle_DESC";
    PropositionCategoryLinkingCollectionsFullCampaignCollectionOrder["NameAsc"] = "name_ASC";
    PropositionCategoryLinkingCollectionsFullCampaignCollectionOrder["NameDesc"] = "name_DESC";
    PropositionCategoryLinkingCollectionsFullCampaignCollectionOrder["PathAsc"] = "path_ASC";
    PropositionCategoryLinkingCollectionsFullCampaignCollectionOrder["PathDesc"] = "path_DESC";
    PropositionCategoryLinkingCollectionsFullCampaignCollectionOrder["PromotionsTitleAsc"] = "promotionsTitle_ASC";
    PropositionCategoryLinkingCollectionsFullCampaignCollectionOrder["PromotionsTitleDesc"] = "promotionsTitle_DESC";
    PropositionCategoryLinkingCollectionsFullCampaignCollectionOrder["ReasonsToBookTitleAsc"] = "reasonsToBookTitle_ASC";
    PropositionCategoryLinkingCollectionsFullCampaignCollectionOrder["ReasonsToBookTitleDesc"] = "reasonsToBookTitle_DESC";
    PropositionCategoryLinkingCollectionsFullCampaignCollectionOrder["SellingPointsTitleAsc"] = "sellingPointsTitle_ASC";
    PropositionCategoryLinkingCollectionsFullCampaignCollectionOrder["SellingPointsTitleDesc"] = "sellingPointsTitle_DESC";
    PropositionCategoryLinkingCollectionsFullCampaignCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PropositionCategoryLinkingCollectionsFullCampaignCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PropositionCategoryLinkingCollectionsFullCampaignCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PropositionCategoryLinkingCollectionsFullCampaignCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PropositionCategoryLinkingCollectionsFullCampaignCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PropositionCategoryLinkingCollectionsFullCampaignCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PropositionCategoryLinkingCollectionsFullCampaignCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PropositionCategoryLinkingCollectionsFullCampaignCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    PropositionCategoryLinkingCollectionsFullCampaignCollectionOrder["TitleAsc"] = "title_ASC";
    PropositionCategoryLinkingCollectionsFullCampaignCollectionOrder["TitleDesc"] = "title_DESC";
})(PropositionCategoryLinkingCollectionsFullCampaignCollectionOrder = exports.PropositionCategoryLinkingCollectionsFullCampaignCollectionOrder || (exports.PropositionCategoryLinkingCollectionsFullCampaignCollectionOrder = {}));
var PropositionCategoryLinkingCollectionsPropositionCollectionOrder;
(function (PropositionCategoryLinkingCollectionsPropositionCollectionOrder) {
    PropositionCategoryLinkingCollectionsPropositionCollectionOrder["FaqFolderIdAsc"] = "faqFolderId_ASC";
    PropositionCategoryLinkingCollectionsPropositionCollectionOrder["FaqFolderIdDesc"] = "faqFolderId_DESC";
    PropositionCategoryLinkingCollectionsPropositionCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    PropositionCategoryLinkingCollectionsPropositionCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    PropositionCategoryLinkingCollectionsPropositionCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    PropositionCategoryLinkingCollectionsPropositionCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    PropositionCategoryLinkingCollectionsPropositionCollectionOrder["NameAsc"] = "name_ASC";
    PropositionCategoryLinkingCollectionsPropositionCollectionOrder["NameDesc"] = "name_DESC";
    PropositionCategoryLinkingCollectionsPropositionCollectionOrder["PathAsc"] = "path_ASC";
    PropositionCategoryLinkingCollectionsPropositionCollectionOrder["PathDesc"] = "path_DESC";
    PropositionCategoryLinkingCollectionsPropositionCollectionOrder["RelatedArticlesTitleAsc"] = "relatedArticlesTitle_ASC";
    PropositionCategoryLinkingCollectionsPropositionCollectionOrder["RelatedArticlesTitleDesc"] = "relatedArticlesTitle_DESC";
    PropositionCategoryLinkingCollectionsPropositionCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PropositionCategoryLinkingCollectionsPropositionCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PropositionCategoryLinkingCollectionsPropositionCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PropositionCategoryLinkingCollectionsPropositionCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PropositionCategoryLinkingCollectionsPropositionCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PropositionCategoryLinkingCollectionsPropositionCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PropositionCategoryLinkingCollectionsPropositionCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PropositionCategoryLinkingCollectionsPropositionCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    PropositionCategoryLinkingCollectionsPropositionCollectionOrder["TagLineAsc"] = "tagLine_ASC";
    PropositionCategoryLinkingCollectionsPropositionCollectionOrder["TagLineDesc"] = "tagLine_DESC";
    PropositionCategoryLinkingCollectionsPropositionCollectionOrder["TitleAsc"] = "title_ASC";
    PropositionCategoryLinkingCollectionsPropositionCollectionOrder["TitleDesc"] = "title_DESC";
})(PropositionCategoryLinkingCollectionsPropositionCollectionOrder = exports.PropositionCategoryLinkingCollectionsPropositionCollectionOrder || (exports.PropositionCategoryLinkingCollectionsPropositionCollectionOrder = {}));
var PropositionCategoryLinkingCollectionsPropositionSubCategoryCollectionOrder;
(function (PropositionCategoryLinkingCollectionsPropositionSubCategoryCollectionOrder) {
    PropositionCategoryLinkingCollectionsPropositionSubCategoryCollectionOrder["NameAsc"] = "name_ASC";
    PropositionCategoryLinkingCollectionsPropositionSubCategoryCollectionOrder["NameDesc"] = "name_DESC";
    PropositionCategoryLinkingCollectionsPropositionSubCategoryCollectionOrder["PathAsc"] = "path_ASC";
    PropositionCategoryLinkingCollectionsPropositionSubCategoryCollectionOrder["PathDesc"] = "path_DESC";
    PropositionCategoryLinkingCollectionsPropositionSubCategoryCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PropositionCategoryLinkingCollectionsPropositionSubCategoryCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PropositionCategoryLinkingCollectionsPropositionSubCategoryCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PropositionCategoryLinkingCollectionsPropositionSubCategoryCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PropositionCategoryLinkingCollectionsPropositionSubCategoryCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PropositionCategoryLinkingCollectionsPropositionSubCategoryCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PropositionCategoryLinkingCollectionsPropositionSubCategoryCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PropositionCategoryLinkingCollectionsPropositionSubCategoryCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    PropositionCategoryLinkingCollectionsPropositionSubCategoryCollectionOrder["TitleAsc"] = "title_ASC";
    PropositionCategoryLinkingCollectionsPropositionSubCategoryCollectionOrder["TitleDesc"] = "title_DESC";
})(PropositionCategoryLinkingCollectionsPropositionSubCategoryCollectionOrder = exports.PropositionCategoryLinkingCollectionsPropositionSubCategoryCollectionOrder || (exports.PropositionCategoryLinkingCollectionsPropositionSubCategoryCollectionOrder = {}));
var PropositionCategoryOrder;
(function (PropositionCategoryOrder) {
    PropositionCategoryOrder["CtaTitleAsc"] = "ctaTitle_ASC";
    PropositionCategoryOrder["CtaTitleDesc"] = "ctaTitle_DESC";
    PropositionCategoryOrder["CtaUrlAsc"] = "ctaUrl_ASC";
    PropositionCategoryOrder["CtaUrlDesc"] = "ctaUrl_DESC";
    PropositionCategoryOrder["FeaturedParksTitleAsc"] = "featuredParksTitle_ASC";
    PropositionCategoryOrder["FeaturedParksTitleDesc"] = "featuredParksTitle_DESC";
    PropositionCategoryOrder["InternalNameAsc"] = "internalName_ASC";
    PropositionCategoryOrder["InternalNameDesc"] = "internalName_DESC";
    PropositionCategoryOrder["NameAsc"] = "name_ASC";
    PropositionCategoryOrder["NameDesc"] = "name_DESC";
    PropositionCategoryOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PropositionCategoryOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PropositionCategoryOrder["SysIdAsc"] = "sys_id_ASC";
    PropositionCategoryOrder["SysIdDesc"] = "sys_id_DESC";
    PropositionCategoryOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PropositionCategoryOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PropositionCategoryOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PropositionCategoryOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(PropositionCategoryOrder = exports.PropositionCategoryOrder || (exports.PropositionCategoryOrder = {}));
var PropositionCategoryTermsAndConditionsCollectionOrder;
(function (PropositionCategoryTermsAndConditionsCollectionOrder) {
    PropositionCategoryTermsAndConditionsCollectionOrder["HolidayTypeAsc"] = "holidayType_ASC";
    PropositionCategoryTermsAndConditionsCollectionOrder["HolidayTypeDesc"] = "holidayType_DESC";
    PropositionCategoryTermsAndConditionsCollectionOrder["NameAsc"] = "name_ASC";
    PropositionCategoryTermsAndConditionsCollectionOrder["NameDesc"] = "name_DESC";
    PropositionCategoryTermsAndConditionsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PropositionCategoryTermsAndConditionsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PropositionCategoryTermsAndConditionsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PropositionCategoryTermsAndConditionsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PropositionCategoryTermsAndConditionsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PropositionCategoryTermsAndConditionsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PropositionCategoryTermsAndConditionsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PropositionCategoryTermsAndConditionsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(PropositionCategoryTermsAndConditionsCollectionOrder = exports.PropositionCategoryTermsAndConditionsCollectionOrder || (exports.PropositionCategoryTermsAndConditionsCollectionOrder = {}));
var PropositionCategoryTestimonialsCollectionOrder;
(function (PropositionCategoryTestimonialsCollectionOrder) {
    PropositionCategoryTestimonialsCollectionOrder["AuthorAsc"] = "author_ASC";
    PropositionCategoryTestimonialsCollectionOrder["AuthorDesc"] = "author_DESC";
    PropositionCategoryTestimonialsCollectionOrder["HolidayTypeAsc"] = "holidayType_ASC";
    PropositionCategoryTestimonialsCollectionOrder["HolidayTypeDesc"] = "holidayType_DESC";
    PropositionCategoryTestimonialsCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    PropositionCategoryTestimonialsCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    PropositionCategoryTestimonialsCollectionOrder["RoleAsc"] = "role_ASC";
    PropositionCategoryTestimonialsCollectionOrder["RoleDesc"] = "role_DESC";
    PropositionCategoryTestimonialsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PropositionCategoryTestimonialsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PropositionCategoryTestimonialsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PropositionCategoryTestimonialsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PropositionCategoryTestimonialsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PropositionCategoryTestimonialsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PropositionCategoryTestimonialsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PropositionCategoryTestimonialsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(PropositionCategoryTestimonialsCollectionOrder = exports.PropositionCategoryTestimonialsCollectionOrder || (exports.PropositionCategoryTestimonialsCollectionOrder = {}));
var PropositionCategoryVideosCollectionOrder;
(function (PropositionCategoryVideosCollectionOrder) {
    PropositionCategoryVideosCollectionOrder["EmbeddedUrlAsc"] = "embeddedUrl_ASC";
    PropositionCategoryVideosCollectionOrder["EmbeddedUrlDesc"] = "embeddedUrl_DESC";
    PropositionCategoryVideosCollectionOrder["NameAsc"] = "name_ASC";
    PropositionCategoryVideosCollectionOrder["NameDesc"] = "name_DESC";
    PropositionCategoryVideosCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PropositionCategoryVideosCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PropositionCategoryVideosCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PropositionCategoryVideosCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PropositionCategoryVideosCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PropositionCategoryVideosCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PropositionCategoryVideosCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PropositionCategoryVideosCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    PropositionCategoryVideosCollectionOrder["TitleAsc"] = "title_ASC";
    PropositionCategoryVideosCollectionOrder["TitleDesc"] = "title_DESC";
})(PropositionCategoryVideosCollectionOrder = exports.PropositionCategoryVideosCollectionOrder || (exports.PropositionCategoryVideosCollectionOrder = {}));
var PropositionFaqsCollectionOrder;
(function (PropositionFaqsCollectionOrder) {
    PropositionFaqsCollectionOrder["QuestionAsc"] = "question_ASC";
    PropositionFaqsCollectionOrder["QuestionDesc"] = "question_DESC";
    PropositionFaqsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PropositionFaqsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PropositionFaqsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PropositionFaqsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PropositionFaqsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PropositionFaqsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PropositionFaqsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PropositionFaqsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(PropositionFaqsCollectionOrder = exports.PropositionFaqsCollectionOrder || (exports.PropositionFaqsCollectionOrder = {}));
var PropositionHeroImagesCollectionOrder;
(function (PropositionHeroImagesCollectionOrder) {
    PropositionHeroImagesCollectionOrder["AltTextAsc"] = "altText_ASC";
    PropositionHeroImagesCollectionOrder["AltTextDesc"] = "altText_DESC";
    PropositionHeroImagesCollectionOrder["CaptionOptionalAsc"] = "captionOptional_ASC";
    PropositionHeroImagesCollectionOrder["CaptionOptionalDesc"] = "captionOptional_DESC";
    PropositionHeroImagesCollectionOrder["FocusAreaAsc"] = "focusArea_ASC";
    PropositionHeroImagesCollectionOrder["FocusAreaDesc"] = "focusArea_DESC";
    PropositionHeroImagesCollectionOrder["NameAsc"] = "name_ASC";
    PropositionHeroImagesCollectionOrder["NameDesc"] = "name_DESC";
    PropositionHeroImagesCollectionOrder["SubHeadingAsc"] = "subHeading_ASC";
    PropositionHeroImagesCollectionOrder["SubHeadingDesc"] = "subHeading_DESC";
    PropositionHeroImagesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PropositionHeroImagesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PropositionHeroImagesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PropositionHeroImagesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PropositionHeroImagesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PropositionHeroImagesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PropositionHeroImagesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PropositionHeroImagesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(PropositionHeroImagesCollectionOrder = exports.PropositionHeroImagesCollectionOrder || (exports.PropositionHeroImagesCollectionOrder = {}));
var PropositionOrder;
(function (PropositionOrder) {
    PropositionOrder["FaqFolderIdAsc"] = "faqFolderId_ASC";
    PropositionOrder["FaqFolderIdDesc"] = "faqFolderId_DESC";
    PropositionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    PropositionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    PropositionOrder["InternalNameAsc"] = "internalName_ASC";
    PropositionOrder["InternalNameDesc"] = "internalName_DESC";
    PropositionOrder["NameAsc"] = "name_ASC";
    PropositionOrder["NameDesc"] = "name_DESC";
    PropositionOrder["PathAsc"] = "path_ASC";
    PropositionOrder["PathDesc"] = "path_DESC";
    PropositionOrder["RelatedArticlesTitleAsc"] = "relatedArticlesTitle_ASC";
    PropositionOrder["RelatedArticlesTitleDesc"] = "relatedArticlesTitle_DESC";
    PropositionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PropositionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PropositionOrder["SysIdAsc"] = "sys_id_ASC";
    PropositionOrder["SysIdDesc"] = "sys_id_DESC";
    PropositionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PropositionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PropositionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PropositionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    PropositionOrder["TagLineAsc"] = "tagLine_ASC";
    PropositionOrder["TagLineDesc"] = "tagLine_DESC";
    PropositionOrder["TitleAsc"] = "title_ASC";
    PropositionOrder["TitleDesc"] = "title_DESC";
})(PropositionOrder = exports.PropositionOrder || (exports.PropositionOrder = {}));
var PropositionPromotionsCollectionOrder;
(function (PropositionPromotionsCollectionOrder) {
    PropositionPromotionsCollectionOrder["AnalyticsCategoryAsc"] = "analyticsCategory_ASC";
    PropositionPromotionsCollectionOrder["AnalyticsCategoryDesc"] = "analyticsCategory_DESC";
    PropositionPromotionsCollectionOrder["AnalyticsTypeAsc"] = "analyticsType_ASC";
    PropositionPromotionsCollectionOrder["AnalyticsTypeDesc"] = "analyticsType_DESC";
    PropositionPromotionsCollectionOrder["AnalyticsVariantAsc"] = "analyticsVariant_ASC";
    PropositionPromotionsCollectionOrder["AnalyticsVariantDesc"] = "analyticsVariant_DESC";
    PropositionPromotionsCollectionOrder["DurationAsc"] = "duration_ASC";
    PropositionPromotionsCollectionOrder["DurationDesc"] = "duration_DESC";
    PropositionPromotionsCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    PropositionPromotionsCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    PropositionPromotionsCollectionOrder["MaxPriceAsc"] = "maxPrice_ASC";
    PropositionPromotionsCollectionOrder["MaxPriceDesc"] = "maxPrice_DESC";
    PropositionPromotionsCollectionOrder["MinPriceAsc"] = "minPrice_ASC";
    PropositionPromotionsCollectionOrder["MinPriceDesc"] = "minPrice_DESC";
    PropositionPromotionsCollectionOrder["PriceAsc"] = "price_ASC";
    PropositionPromotionsCollectionOrder["PriceDesc"] = "price_DESC";
    PropositionPromotionsCollectionOrder["SubTitleAsc"] = "subTitle_ASC";
    PropositionPromotionsCollectionOrder["SubTitleDesc"] = "subTitle_DESC";
    PropositionPromotionsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PropositionPromotionsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PropositionPromotionsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PropositionPromotionsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PropositionPromotionsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PropositionPromotionsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PropositionPromotionsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PropositionPromotionsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    PropositionPromotionsCollectionOrder["TitleAsc"] = "title_ASC";
    PropositionPromotionsCollectionOrder["TitleDesc"] = "title_DESC";
    PropositionPromotionsCollectionOrder["UrlAsc"] = "url_ASC";
    PropositionPromotionsCollectionOrder["UrlDesc"] = "url_DESC";
})(PropositionPromotionsCollectionOrder = exports.PropositionPromotionsCollectionOrder || (exports.PropositionPromotionsCollectionOrder = {}));
var PropositionSafetyMeasuresCollectionOrder;
(function (PropositionSafetyMeasuresCollectionOrder) {
    PropositionSafetyMeasuresCollectionOrder["NameAsc"] = "name_ASC";
    PropositionSafetyMeasuresCollectionOrder["NameDesc"] = "name_DESC";
    PropositionSafetyMeasuresCollectionOrder["PathAsc"] = "path_ASC";
    PropositionSafetyMeasuresCollectionOrder["PathDesc"] = "path_DESC";
    PropositionSafetyMeasuresCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PropositionSafetyMeasuresCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PropositionSafetyMeasuresCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PropositionSafetyMeasuresCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PropositionSafetyMeasuresCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PropositionSafetyMeasuresCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PropositionSafetyMeasuresCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PropositionSafetyMeasuresCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    PropositionSafetyMeasuresCollectionOrder["TitleAsc"] = "title_ASC";
    PropositionSafetyMeasuresCollectionOrder["TitleDesc"] = "title_DESC";
})(PropositionSafetyMeasuresCollectionOrder = exports.PropositionSafetyMeasuresCollectionOrder || (exports.PropositionSafetyMeasuresCollectionOrder = {}));
var PropositionSubCategoryCategoriesCollectionOrder;
(function (PropositionSubCategoryCategoriesCollectionOrder) {
    PropositionSubCategoryCategoriesCollectionOrder["CtaTitleAsc"] = "ctaTitle_ASC";
    PropositionSubCategoryCategoriesCollectionOrder["CtaTitleDesc"] = "ctaTitle_DESC";
    PropositionSubCategoryCategoriesCollectionOrder["CtaUrlAsc"] = "ctaUrl_ASC";
    PropositionSubCategoryCategoriesCollectionOrder["CtaUrlDesc"] = "ctaUrl_DESC";
    PropositionSubCategoryCategoriesCollectionOrder["FeaturedParksTitleAsc"] = "featuredParksTitle_ASC";
    PropositionSubCategoryCategoriesCollectionOrder["FeaturedParksTitleDesc"] = "featuredParksTitle_DESC";
    PropositionSubCategoryCategoriesCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    PropositionSubCategoryCategoriesCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    PropositionSubCategoryCategoriesCollectionOrder["NameAsc"] = "name_ASC";
    PropositionSubCategoryCategoriesCollectionOrder["NameDesc"] = "name_DESC";
    PropositionSubCategoryCategoriesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PropositionSubCategoryCategoriesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PropositionSubCategoryCategoriesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PropositionSubCategoryCategoriesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PropositionSubCategoryCategoriesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PropositionSubCategoryCategoriesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PropositionSubCategoryCategoriesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PropositionSubCategoryCategoriesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(PropositionSubCategoryCategoriesCollectionOrder = exports.PropositionSubCategoryCategoriesCollectionOrder || (exports.PropositionSubCategoryCategoriesCollectionOrder = {}));
var PropositionSubCategoryHeroImagesCollectionOrder;
(function (PropositionSubCategoryHeroImagesCollectionOrder) {
    PropositionSubCategoryHeroImagesCollectionOrder["AltTextAsc"] = "altText_ASC";
    PropositionSubCategoryHeroImagesCollectionOrder["AltTextDesc"] = "altText_DESC";
    PropositionSubCategoryHeroImagesCollectionOrder["CaptionOptionalAsc"] = "captionOptional_ASC";
    PropositionSubCategoryHeroImagesCollectionOrder["CaptionOptionalDesc"] = "captionOptional_DESC";
    PropositionSubCategoryHeroImagesCollectionOrder["FocusAreaAsc"] = "focusArea_ASC";
    PropositionSubCategoryHeroImagesCollectionOrder["FocusAreaDesc"] = "focusArea_DESC";
    PropositionSubCategoryHeroImagesCollectionOrder["NameAsc"] = "name_ASC";
    PropositionSubCategoryHeroImagesCollectionOrder["NameDesc"] = "name_DESC";
    PropositionSubCategoryHeroImagesCollectionOrder["SubHeadingAsc"] = "subHeading_ASC";
    PropositionSubCategoryHeroImagesCollectionOrder["SubHeadingDesc"] = "subHeading_DESC";
    PropositionSubCategoryHeroImagesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PropositionSubCategoryHeroImagesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PropositionSubCategoryHeroImagesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PropositionSubCategoryHeroImagesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PropositionSubCategoryHeroImagesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PropositionSubCategoryHeroImagesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PropositionSubCategoryHeroImagesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PropositionSubCategoryHeroImagesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(PropositionSubCategoryHeroImagesCollectionOrder = exports.PropositionSubCategoryHeroImagesCollectionOrder || (exports.PropositionSubCategoryHeroImagesCollectionOrder = {}));
var PropositionSubCategoryOrder;
(function (PropositionSubCategoryOrder) {
    PropositionSubCategoryOrder["NameAsc"] = "name_ASC";
    PropositionSubCategoryOrder["NameDesc"] = "name_DESC";
    PropositionSubCategoryOrder["PathAsc"] = "path_ASC";
    PropositionSubCategoryOrder["PathDesc"] = "path_DESC";
    PropositionSubCategoryOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PropositionSubCategoryOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PropositionSubCategoryOrder["SysIdAsc"] = "sys_id_ASC";
    PropositionSubCategoryOrder["SysIdDesc"] = "sys_id_DESC";
    PropositionSubCategoryOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PropositionSubCategoryOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PropositionSubCategoryOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PropositionSubCategoryOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    PropositionSubCategoryOrder["TitleAsc"] = "title_ASC";
    PropositionSubCategoryOrder["TitleDesc"] = "title_DESC";
})(PropositionSubCategoryOrder = exports.PropositionSubCategoryOrder || (exports.PropositionSubCategoryOrder = {}));
var PropositionSubCategorySafetyMeasuresCollectionOrder;
(function (PropositionSubCategorySafetyMeasuresCollectionOrder) {
    PropositionSubCategorySafetyMeasuresCollectionOrder["NameAsc"] = "name_ASC";
    PropositionSubCategorySafetyMeasuresCollectionOrder["NameDesc"] = "name_DESC";
    PropositionSubCategorySafetyMeasuresCollectionOrder["PathAsc"] = "path_ASC";
    PropositionSubCategorySafetyMeasuresCollectionOrder["PathDesc"] = "path_DESC";
    PropositionSubCategorySafetyMeasuresCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PropositionSubCategorySafetyMeasuresCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PropositionSubCategorySafetyMeasuresCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PropositionSubCategorySafetyMeasuresCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PropositionSubCategorySafetyMeasuresCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PropositionSubCategorySafetyMeasuresCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PropositionSubCategorySafetyMeasuresCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PropositionSubCategorySafetyMeasuresCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    PropositionSubCategorySafetyMeasuresCollectionOrder["TitleAsc"] = "title_ASC";
    PropositionSubCategorySafetyMeasuresCollectionOrder["TitleDesc"] = "title_DESC";
})(PropositionSubCategorySafetyMeasuresCollectionOrder = exports.PropositionSubCategorySafetyMeasuresCollectionOrder || (exports.PropositionSubCategorySafetyMeasuresCollectionOrder = {}));
var PropositionSupportedHolidayPackagesCollectionOrder;
(function (PropositionSupportedHolidayPackagesCollectionOrder) {
    PropositionSupportedHolidayPackagesCollectionOrder["FeaturesTitleAsc"] = "featuresTitle_ASC";
    PropositionSupportedHolidayPackagesCollectionOrder["FeaturesTitleDesc"] = "featuresTitle_DESC";
    PropositionSupportedHolidayPackagesCollectionOrder["SellingPointsTitleAsc"] = "sellingPointsTitle_ASC";
    PropositionSupportedHolidayPackagesCollectionOrder["SellingPointsTitleDesc"] = "sellingPointsTitle_DESC";
    PropositionSupportedHolidayPackagesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PropositionSupportedHolidayPackagesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PropositionSupportedHolidayPackagesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PropositionSupportedHolidayPackagesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PropositionSupportedHolidayPackagesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PropositionSupportedHolidayPackagesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PropositionSupportedHolidayPackagesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PropositionSupportedHolidayPackagesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    PropositionSupportedHolidayPackagesCollectionOrder["TitleAsc"] = "title_ASC";
    PropositionSupportedHolidayPackagesCollectionOrder["TitleDesc"] = "title_DESC";
})(PropositionSupportedHolidayPackagesCollectionOrder = exports.PropositionSupportedHolidayPackagesCollectionOrder || (exports.PropositionSupportedHolidayPackagesCollectionOrder = {}));
var PropositionTermsAndConditionsCollectionOrder;
(function (PropositionTermsAndConditionsCollectionOrder) {
    PropositionTermsAndConditionsCollectionOrder["HolidayTypeAsc"] = "holidayType_ASC";
    PropositionTermsAndConditionsCollectionOrder["HolidayTypeDesc"] = "holidayType_DESC";
    PropositionTermsAndConditionsCollectionOrder["NameAsc"] = "name_ASC";
    PropositionTermsAndConditionsCollectionOrder["NameDesc"] = "name_DESC";
    PropositionTermsAndConditionsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PropositionTermsAndConditionsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PropositionTermsAndConditionsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PropositionTermsAndConditionsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PropositionTermsAndConditionsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PropositionTermsAndConditionsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PropositionTermsAndConditionsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PropositionTermsAndConditionsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(PropositionTermsAndConditionsCollectionOrder = exports.PropositionTermsAndConditionsCollectionOrder || (exports.PropositionTermsAndConditionsCollectionOrder = {}));
var RegionFaqsCollectionOrder;
(function (RegionFaqsCollectionOrder) {
    RegionFaqsCollectionOrder["QuestionAsc"] = "question_ASC";
    RegionFaqsCollectionOrder["QuestionDesc"] = "question_DESC";
    RegionFaqsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    RegionFaqsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    RegionFaqsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    RegionFaqsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    RegionFaqsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    RegionFaqsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    RegionFaqsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    RegionFaqsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(RegionFaqsCollectionOrder = exports.RegionFaqsCollectionOrder || (exports.RegionFaqsCollectionOrder = {}));
var RegionHighlightedParkFeaturesCollectionOrder;
(function (RegionHighlightedParkFeaturesCollectionOrder) {
    RegionHighlightedParkFeaturesCollectionOrder["ApiIdAsc"] = "apiId_ASC";
    RegionHighlightedParkFeaturesCollectionOrder["ApiIdDesc"] = "apiId_DESC";
    RegionHighlightedParkFeaturesCollectionOrder["DateIntroducedAsc"] = "dateIntroduced_ASC";
    RegionHighlightedParkFeaturesCollectionOrder["DateIntroducedDesc"] = "dateIntroduced_DESC";
    RegionHighlightedParkFeaturesCollectionOrder["NameAsc"] = "name_ASC";
    RegionHighlightedParkFeaturesCollectionOrder["NameDesc"] = "name_DESC";
    RegionHighlightedParkFeaturesCollectionOrder["PropositionTypeAsc"] = "propositionType_ASC";
    RegionHighlightedParkFeaturesCollectionOrder["PropositionTypeDesc"] = "propositionType_DESC";
    RegionHighlightedParkFeaturesCollectionOrder["ShortTitleAsc"] = "shortTitle_ASC";
    RegionHighlightedParkFeaturesCollectionOrder["ShortTitleDesc"] = "shortTitle_DESC";
    RegionHighlightedParkFeaturesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    RegionHighlightedParkFeaturesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    RegionHighlightedParkFeaturesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    RegionHighlightedParkFeaturesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    RegionHighlightedParkFeaturesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    RegionHighlightedParkFeaturesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    RegionHighlightedParkFeaturesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    RegionHighlightedParkFeaturesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    RegionHighlightedParkFeaturesCollectionOrder["TitleAsc"] = "title_ASC";
    RegionHighlightedParkFeaturesCollectionOrder["TitleDesc"] = "title_DESC";
    RegionHighlightedParkFeaturesCollectionOrder["UrlAsc"] = "url_ASC";
    RegionHighlightedParkFeaturesCollectionOrder["UrlDesc"] = "url_DESC";
})(RegionHighlightedParkFeaturesCollectionOrder = exports.RegionHighlightedParkFeaturesCollectionOrder || (exports.RegionHighlightedParkFeaturesCollectionOrder = {}));
var RegionLinkingCollectionsArticleSectionCollectionOrder;
(function (RegionLinkingCollectionsArticleSectionCollectionOrder) {
    RegionLinkingCollectionsArticleSectionCollectionOrder["CoordinatesAsc"] = "coordinates_ASC";
    RegionLinkingCollectionsArticleSectionCollectionOrder["CoordinatesDesc"] = "coordinates_DESC";
    RegionLinkingCollectionsArticleSectionCollectionOrder["NameAsc"] = "name_ASC";
    RegionLinkingCollectionsArticleSectionCollectionOrder["NameDesc"] = "name_DESC";
    RegionLinkingCollectionsArticleSectionCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    RegionLinkingCollectionsArticleSectionCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    RegionLinkingCollectionsArticleSectionCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    RegionLinkingCollectionsArticleSectionCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    RegionLinkingCollectionsArticleSectionCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    RegionLinkingCollectionsArticleSectionCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    RegionLinkingCollectionsArticleSectionCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    RegionLinkingCollectionsArticleSectionCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    RegionLinkingCollectionsArticleSectionCollectionOrder["TitleAsc"] = "title_ASC";
    RegionLinkingCollectionsArticleSectionCollectionOrder["TitleDesc"] = "title_DESC";
})(RegionLinkingCollectionsArticleSectionCollectionOrder = exports.RegionLinkingCollectionsArticleSectionCollectionOrder || (exports.RegionLinkingCollectionsArticleSectionCollectionOrder = {}));
var RegionLinkingCollectionsParkCollectionOrder;
(function (RegionLinkingCollectionsParkCollectionOrder) {
    RegionLinkingCollectionsParkCollectionOrder["ContactNumberAsc"] = "contactNumber_ASC";
    RegionLinkingCollectionsParkCollectionOrder["ContactNumberDesc"] = "contactNumber_DESC";
    RegionLinkingCollectionsParkCollectionOrder["DirectionsUrlAsc"] = "directionsUrl_ASC";
    RegionLinkingCollectionsParkCollectionOrder["DirectionsUrlDesc"] = "directionsUrl_DESC";
    RegionLinkingCollectionsParkCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    RegionLinkingCollectionsParkCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    RegionLinkingCollectionsParkCollectionOrder["NameAsc"] = "name_ASC";
    RegionLinkingCollectionsParkCollectionOrder["NameDesc"] = "name_DESC";
    RegionLinkingCollectionsParkCollectionOrder["ParkTypeAsc"] = "parkType_ASC";
    RegionLinkingCollectionsParkCollectionOrder["ParkTypeDesc"] = "parkType_DESC";
    RegionLinkingCollectionsParkCollectionOrder["PathAsc"] = "path_ASC";
    RegionLinkingCollectionsParkCollectionOrder["PathDesc"] = "path_DESC";
    RegionLinkingCollectionsParkCollectionOrder["RunningCostsAsc"] = "runningCosts_ASC";
    RegionLinkingCollectionsParkCollectionOrder["RunningCostsDesc"] = "runningCosts_DESC";
    RegionLinkingCollectionsParkCollectionOrder["SiteFeesAsc"] = "siteFees_ASC";
    RegionLinkingCollectionsParkCollectionOrder["SiteFeesDesc"] = "siteFees_DESC";
    RegionLinkingCollectionsParkCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    RegionLinkingCollectionsParkCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    RegionLinkingCollectionsParkCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    RegionLinkingCollectionsParkCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    RegionLinkingCollectionsParkCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    RegionLinkingCollectionsParkCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    RegionLinkingCollectionsParkCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    RegionLinkingCollectionsParkCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    RegionLinkingCollectionsParkCollectionOrder["TaglineAsc"] = "tagline_ASC";
    RegionLinkingCollectionsParkCollectionOrder["TaglineDesc"] = "tagline_DESC";
    RegionLinkingCollectionsParkCollectionOrder["ThingsToDoTitleAsc"] = "thingsToDoTitle_ASC";
    RegionLinkingCollectionsParkCollectionOrder["ThingsToDoTitleDesc"] = "thingsToDoTitle_DESC";
    RegionLinkingCollectionsParkCollectionOrder["TitleAsc"] = "title_ASC";
    RegionLinkingCollectionsParkCollectionOrder["TitleDesc"] = "title_DESC";
})(RegionLinkingCollectionsParkCollectionOrder = exports.RegionLinkingCollectionsParkCollectionOrder || (exports.RegionLinkingCollectionsParkCollectionOrder = {}));
var RegionLinkingCollectionsPromotionComponentCollectionOrder;
(function (RegionLinkingCollectionsPromotionComponentCollectionOrder) {
    RegionLinkingCollectionsPromotionComponentCollectionOrder["NameAsc"] = "name_ASC";
    RegionLinkingCollectionsPromotionComponentCollectionOrder["NameDesc"] = "name_DESC";
    RegionLinkingCollectionsPromotionComponentCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    RegionLinkingCollectionsPromotionComponentCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    RegionLinkingCollectionsPromotionComponentCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    RegionLinkingCollectionsPromotionComponentCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    RegionLinkingCollectionsPromotionComponentCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    RegionLinkingCollectionsPromotionComponentCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    RegionLinkingCollectionsPromotionComponentCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    RegionLinkingCollectionsPromotionComponentCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(RegionLinkingCollectionsPromotionComponentCollectionOrder = exports.RegionLinkingCollectionsPromotionComponentCollectionOrder || (exports.RegionLinkingCollectionsPromotionComponentCollectionOrder = {}));
var RegionLinkingCollectionsRegionalHolidayCollectionOrder;
(function (RegionLinkingCollectionsRegionalHolidayCollectionOrder) {
    RegionLinkingCollectionsRegionalHolidayCollectionOrder["HolidayTypeAsc"] = "holidayType_ASC";
    RegionLinkingCollectionsRegionalHolidayCollectionOrder["HolidayTypeDesc"] = "holidayType_DESC";
    RegionLinkingCollectionsRegionalHolidayCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    RegionLinkingCollectionsRegionalHolidayCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    RegionLinkingCollectionsRegionalHolidayCollectionOrder["PathAsc"] = "path_ASC";
    RegionLinkingCollectionsRegionalHolidayCollectionOrder["PathDesc"] = "path_DESC";
    RegionLinkingCollectionsRegionalHolidayCollectionOrder["ReasonsToBookTitleAsc"] = "reasonsToBookTitle_ASC";
    RegionLinkingCollectionsRegionalHolidayCollectionOrder["ReasonsToBookTitleDesc"] = "reasonsToBookTitle_DESC";
    RegionLinkingCollectionsRegionalHolidayCollectionOrder["ShortDescriptionAsc"] = "shortDescription_ASC";
    RegionLinkingCollectionsRegionalHolidayCollectionOrder["ShortDescriptionDesc"] = "shortDescription_DESC";
    RegionLinkingCollectionsRegionalHolidayCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    RegionLinkingCollectionsRegionalHolidayCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    RegionLinkingCollectionsRegionalHolidayCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    RegionLinkingCollectionsRegionalHolidayCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    RegionLinkingCollectionsRegionalHolidayCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    RegionLinkingCollectionsRegionalHolidayCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    RegionLinkingCollectionsRegionalHolidayCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    RegionLinkingCollectionsRegionalHolidayCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    RegionLinkingCollectionsRegionalHolidayCollectionOrder["TitleAsc"] = "title_ASC";
    RegionLinkingCollectionsRegionalHolidayCollectionOrder["TitleDesc"] = "title_DESC";
})(RegionLinkingCollectionsRegionalHolidayCollectionOrder = exports.RegionLinkingCollectionsRegionalHolidayCollectionOrder || (exports.RegionLinkingCollectionsRegionalHolidayCollectionOrder = {}));
var RegionNearbyTownCitiesCollectionOrder;
(function (RegionNearbyTownCitiesCollectionOrder) {
    RegionNearbyTownCitiesCollectionOrder["ApiIdAsc"] = "apiId_ASC";
    RegionNearbyTownCitiesCollectionOrder["ApiIdDesc"] = "apiId_DESC";
    RegionNearbyTownCitiesCollectionOrder["DateIntroducedAsc"] = "dateIntroduced_ASC";
    RegionNearbyTownCitiesCollectionOrder["DateIntroducedDesc"] = "dateIntroduced_DESC";
    RegionNearbyTownCitiesCollectionOrder["NameAsc"] = "name_ASC";
    RegionNearbyTownCitiesCollectionOrder["NameDesc"] = "name_DESC";
    RegionNearbyTownCitiesCollectionOrder["PropositionTypeAsc"] = "propositionType_ASC";
    RegionNearbyTownCitiesCollectionOrder["PropositionTypeDesc"] = "propositionType_DESC";
    RegionNearbyTownCitiesCollectionOrder["ShortTitleAsc"] = "shortTitle_ASC";
    RegionNearbyTownCitiesCollectionOrder["ShortTitleDesc"] = "shortTitle_DESC";
    RegionNearbyTownCitiesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    RegionNearbyTownCitiesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    RegionNearbyTownCitiesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    RegionNearbyTownCitiesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    RegionNearbyTownCitiesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    RegionNearbyTownCitiesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    RegionNearbyTownCitiesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    RegionNearbyTownCitiesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    RegionNearbyTownCitiesCollectionOrder["TitleAsc"] = "title_ASC";
    RegionNearbyTownCitiesCollectionOrder["TitleDesc"] = "title_DESC";
    RegionNearbyTownCitiesCollectionOrder["UrlAsc"] = "url_ASC";
    RegionNearbyTownCitiesCollectionOrder["UrlDesc"] = "url_DESC";
})(RegionNearbyTownCitiesCollectionOrder = exports.RegionNearbyTownCitiesCollectionOrder || (exports.RegionNearbyTownCitiesCollectionOrder = {}));
var RegionOrder;
(function (RegionOrder) {
    RegionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    RegionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    RegionOrder["InternalNameAsc"] = "internalName_ASC";
    RegionOrder["InternalNameDesc"] = "internalName_DESC";
    RegionOrder["NameAsc"] = "name_ASC";
    RegionOrder["NameDesc"] = "name_DESC";
    RegionOrder["NearbyTownCitiesTitleAsc"] = "nearbyTownCitiesTitle_ASC";
    RegionOrder["NearbyTownCitiesTitleDesc"] = "nearbyTownCitiesTitle_DESC";
    RegionOrder["PageTypeAsc"] = "pageType_ASC";
    RegionOrder["PageTypeDesc"] = "pageType_DESC";
    RegionOrder["PathAsc"] = "path_ASC";
    RegionOrder["PathDesc"] = "path_DESC";
    RegionOrder["RegionCodeAsc"] = "regionCode_ASC";
    RegionOrder["RegionCodeDesc"] = "regionCode_DESC";
    RegionOrder["RelatedArticlesTitleAsc"] = "relatedArticlesTitle_ASC";
    RegionOrder["RelatedArticlesTitleDesc"] = "relatedArticlesTitle_DESC";
    RegionOrder["SearchTitleAsc"] = "searchTitle_ASC";
    RegionOrder["SearchTitleDesc"] = "searchTitle_DESC";
    RegionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    RegionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    RegionOrder["SysIdAsc"] = "sys_id_ASC";
    RegionOrder["SysIdDesc"] = "sys_id_DESC";
    RegionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    RegionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    RegionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    RegionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    RegionOrder["ThingsToDoTitleAsc"] = "thingsToDoTitle_ASC";
    RegionOrder["ThingsToDoTitleDesc"] = "thingsToDoTitle_DESC";
    RegionOrder["TitleAsc"] = "title_ASC";
    RegionOrder["TitleDesc"] = "title_DESC";
})(RegionOrder = exports.RegionOrder || (exports.RegionOrder = {}));
var RegionSellingPointsCollectionOrder;
(function (RegionSellingPointsCollectionOrder) {
    RegionSellingPointsCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    RegionSellingPointsCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    RegionSellingPointsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    RegionSellingPointsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    RegionSellingPointsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    RegionSellingPointsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    RegionSellingPointsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    RegionSellingPointsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    RegionSellingPointsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    RegionSellingPointsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    RegionSellingPointsCollectionOrder["TitleAsc"] = "title_ASC";
    RegionSellingPointsCollectionOrder["TitleDesc"] = "title_DESC";
    RegionSellingPointsCollectionOrder["UrlAsc"] = "url_ASC";
    RegionSellingPointsCollectionOrder["UrlDesc"] = "url_DESC";
})(RegionSellingPointsCollectionOrder = exports.RegionSellingPointsCollectionOrder || (exports.RegionSellingPointsCollectionOrder = {}));
var RegionTestimonialsCollectionOrder;
(function (RegionTestimonialsCollectionOrder) {
    RegionTestimonialsCollectionOrder["AuthorAsc"] = "author_ASC";
    RegionTestimonialsCollectionOrder["AuthorDesc"] = "author_DESC";
    RegionTestimonialsCollectionOrder["HolidayTypeAsc"] = "holidayType_ASC";
    RegionTestimonialsCollectionOrder["HolidayTypeDesc"] = "holidayType_DESC";
    RegionTestimonialsCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    RegionTestimonialsCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    RegionTestimonialsCollectionOrder["RoleAsc"] = "role_ASC";
    RegionTestimonialsCollectionOrder["RoleDesc"] = "role_DESC";
    RegionTestimonialsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    RegionTestimonialsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    RegionTestimonialsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    RegionTestimonialsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    RegionTestimonialsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    RegionTestimonialsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    RegionTestimonialsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    RegionTestimonialsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(RegionTestimonialsCollectionOrder = exports.RegionTestimonialsCollectionOrder || (exports.RegionTestimonialsCollectionOrder = {}));
var RegionalHolidayOrder;
(function (RegionalHolidayOrder) {
    RegionalHolidayOrder["HolidayTypeAsc"] = "holidayType_ASC";
    RegionalHolidayOrder["HolidayTypeDesc"] = "holidayType_DESC";
    RegionalHolidayOrder["InternalNameAsc"] = "internalName_ASC";
    RegionalHolidayOrder["InternalNameDesc"] = "internalName_DESC";
    RegionalHolidayOrder["PathAsc"] = "path_ASC";
    RegionalHolidayOrder["PathDesc"] = "path_DESC";
    RegionalHolidayOrder["ReasonsToBookTitleAsc"] = "reasonsToBookTitle_ASC";
    RegionalHolidayOrder["ReasonsToBookTitleDesc"] = "reasonsToBookTitle_DESC";
    RegionalHolidayOrder["ShortDescriptionAsc"] = "shortDescription_ASC";
    RegionalHolidayOrder["ShortDescriptionDesc"] = "shortDescription_DESC";
    RegionalHolidayOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    RegionalHolidayOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    RegionalHolidayOrder["SysIdAsc"] = "sys_id_ASC";
    RegionalHolidayOrder["SysIdDesc"] = "sys_id_DESC";
    RegionalHolidayOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    RegionalHolidayOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    RegionalHolidayOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    RegionalHolidayOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    RegionalHolidayOrder["TitleAsc"] = "title_ASC";
    RegionalHolidayOrder["TitleDesc"] = "title_DESC";
})(RegionalHolidayOrder = exports.RegionalHolidayOrder || (exports.RegionalHolidayOrder = {}));
var RegionalHolidayParkOffersCollectionOrder;
(function (RegionalHolidayParkOffersCollectionOrder) {
    RegionalHolidayParkOffersCollectionOrder["AgeFromAsc"] = "ageFrom_ASC";
    RegionalHolidayParkOffersCollectionOrder["AgeFromDesc"] = "ageFrom_DESC";
    RegionalHolidayParkOffersCollectionOrder["CtaTitleAsc"] = "ctaTitle_ASC";
    RegionalHolidayParkOffersCollectionOrder["CtaTitleDesc"] = "ctaTitle_DESC";
    RegionalHolidayParkOffersCollectionOrder["CtaUrlAsc"] = "ctaUrl_ASC";
    RegionalHolidayParkOffersCollectionOrder["CtaUrlDesc"] = "ctaUrl_DESC";
    RegionalHolidayParkOffersCollectionOrder["EndDateAsc"] = "endDate_ASC";
    RegionalHolidayParkOffersCollectionOrder["EndDateDesc"] = "endDate_DESC";
    RegionalHolidayParkOffersCollectionOrder["HolidayTypeAsc"] = "holidayType_ASC";
    RegionalHolidayParkOffersCollectionOrder["HolidayTypeDesc"] = "holidayType_DESC";
    RegionalHolidayParkOffersCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    RegionalHolidayParkOffersCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    RegionalHolidayParkOffersCollectionOrder["PropositionTypeAsc"] = "propositionType_ASC";
    RegionalHolidayParkOffersCollectionOrder["PropositionTypeDesc"] = "propositionType_DESC";
    RegionalHolidayParkOffersCollectionOrder["StartDateAsc"] = "startDate_ASC";
    RegionalHolidayParkOffersCollectionOrder["StartDateDesc"] = "startDate_DESC";
    RegionalHolidayParkOffersCollectionOrder["SubTitleAsc"] = "subTitle_ASC";
    RegionalHolidayParkOffersCollectionOrder["SubTitleDesc"] = "subTitle_DESC";
    RegionalHolidayParkOffersCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    RegionalHolidayParkOffersCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    RegionalHolidayParkOffersCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    RegionalHolidayParkOffersCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    RegionalHolidayParkOffersCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    RegionalHolidayParkOffersCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    RegionalHolidayParkOffersCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    RegionalHolidayParkOffersCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    RegionalHolidayParkOffersCollectionOrder["TitleAsc"] = "title_ASC";
    RegionalHolidayParkOffersCollectionOrder["TitleDesc"] = "title_DESC";
})(RegionalHolidayParkOffersCollectionOrder = exports.RegionalHolidayParkOffersCollectionOrder || (exports.RegionalHolidayParkOffersCollectionOrder = {}));
var RegionalHolidayParksCollectionOrder;
(function (RegionalHolidayParksCollectionOrder) {
    RegionalHolidayParksCollectionOrder["ContactNumberAsc"] = "contactNumber_ASC";
    RegionalHolidayParksCollectionOrder["ContactNumberDesc"] = "contactNumber_DESC";
    RegionalHolidayParksCollectionOrder["DirectionsUrlAsc"] = "directionsUrl_ASC";
    RegionalHolidayParksCollectionOrder["DirectionsUrlDesc"] = "directionsUrl_DESC";
    RegionalHolidayParksCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    RegionalHolidayParksCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    RegionalHolidayParksCollectionOrder["NameAsc"] = "name_ASC";
    RegionalHolidayParksCollectionOrder["NameDesc"] = "name_DESC";
    RegionalHolidayParksCollectionOrder["ParkTypeAsc"] = "parkType_ASC";
    RegionalHolidayParksCollectionOrder["ParkTypeDesc"] = "parkType_DESC";
    RegionalHolidayParksCollectionOrder["PathAsc"] = "path_ASC";
    RegionalHolidayParksCollectionOrder["PathDesc"] = "path_DESC";
    RegionalHolidayParksCollectionOrder["RunningCostsAsc"] = "runningCosts_ASC";
    RegionalHolidayParksCollectionOrder["RunningCostsDesc"] = "runningCosts_DESC";
    RegionalHolidayParksCollectionOrder["SiteFeesAsc"] = "siteFees_ASC";
    RegionalHolidayParksCollectionOrder["SiteFeesDesc"] = "siteFees_DESC";
    RegionalHolidayParksCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    RegionalHolidayParksCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    RegionalHolidayParksCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    RegionalHolidayParksCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    RegionalHolidayParksCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    RegionalHolidayParksCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    RegionalHolidayParksCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    RegionalHolidayParksCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    RegionalHolidayParksCollectionOrder["TaglineAsc"] = "tagline_ASC";
    RegionalHolidayParksCollectionOrder["TaglineDesc"] = "tagline_DESC";
    RegionalHolidayParksCollectionOrder["ThingsToDoTitleAsc"] = "thingsToDoTitle_ASC";
    RegionalHolidayParksCollectionOrder["ThingsToDoTitleDesc"] = "thingsToDoTitle_DESC";
    RegionalHolidayParksCollectionOrder["TitleAsc"] = "title_ASC";
    RegionalHolidayParksCollectionOrder["TitleDesc"] = "title_DESC";
})(RegionalHolidayParksCollectionOrder = exports.RegionalHolidayParksCollectionOrder || (exports.RegionalHolidayParksCollectionOrder = {}));
var RegionalHolidayPromotionsCollectionOrder;
(function (RegionalHolidayPromotionsCollectionOrder) {
    RegionalHolidayPromotionsCollectionOrder["AnalyticsCategoryAsc"] = "analyticsCategory_ASC";
    RegionalHolidayPromotionsCollectionOrder["AnalyticsCategoryDesc"] = "analyticsCategory_DESC";
    RegionalHolidayPromotionsCollectionOrder["AnalyticsTypeAsc"] = "analyticsType_ASC";
    RegionalHolidayPromotionsCollectionOrder["AnalyticsTypeDesc"] = "analyticsType_DESC";
    RegionalHolidayPromotionsCollectionOrder["AnalyticsVariantAsc"] = "analyticsVariant_ASC";
    RegionalHolidayPromotionsCollectionOrder["AnalyticsVariantDesc"] = "analyticsVariant_DESC";
    RegionalHolidayPromotionsCollectionOrder["DurationAsc"] = "duration_ASC";
    RegionalHolidayPromotionsCollectionOrder["DurationDesc"] = "duration_DESC";
    RegionalHolidayPromotionsCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    RegionalHolidayPromotionsCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    RegionalHolidayPromotionsCollectionOrder["MaxPriceAsc"] = "maxPrice_ASC";
    RegionalHolidayPromotionsCollectionOrder["MaxPriceDesc"] = "maxPrice_DESC";
    RegionalHolidayPromotionsCollectionOrder["MinPriceAsc"] = "minPrice_ASC";
    RegionalHolidayPromotionsCollectionOrder["MinPriceDesc"] = "minPrice_DESC";
    RegionalHolidayPromotionsCollectionOrder["PriceAsc"] = "price_ASC";
    RegionalHolidayPromotionsCollectionOrder["PriceDesc"] = "price_DESC";
    RegionalHolidayPromotionsCollectionOrder["SubTitleAsc"] = "subTitle_ASC";
    RegionalHolidayPromotionsCollectionOrder["SubTitleDesc"] = "subTitle_DESC";
    RegionalHolidayPromotionsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    RegionalHolidayPromotionsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    RegionalHolidayPromotionsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    RegionalHolidayPromotionsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    RegionalHolidayPromotionsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    RegionalHolidayPromotionsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    RegionalHolidayPromotionsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    RegionalHolidayPromotionsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    RegionalHolidayPromotionsCollectionOrder["TitleAsc"] = "title_ASC";
    RegionalHolidayPromotionsCollectionOrder["TitleDesc"] = "title_DESC";
    RegionalHolidayPromotionsCollectionOrder["UrlAsc"] = "url_ASC";
    RegionalHolidayPromotionsCollectionOrder["UrlDesc"] = "url_DESC";
})(RegionalHolidayPromotionsCollectionOrder = exports.RegionalHolidayPromotionsCollectionOrder || (exports.RegionalHolidayPromotionsCollectionOrder = {}));
var RegionalHolidayReasonsToBookCollectionOrder;
(function (RegionalHolidayReasonsToBookCollectionOrder) {
    RegionalHolidayReasonsToBookCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    RegionalHolidayReasonsToBookCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    RegionalHolidayReasonsToBookCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    RegionalHolidayReasonsToBookCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    RegionalHolidayReasonsToBookCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    RegionalHolidayReasonsToBookCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    RegionalHolidayReasonsToBookCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    RegionalHolidayReasonsToBookCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    RegionalHolidayReasonsToBookCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    RegionalHolidayReasonsToBookCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    RegionalHolidayReasonsToBookCollectionOrder["TitleAsc"] = "title_ASC";
    RegionalHolidayReasonsToBookCollectionOrder["TitleDesc"] = "title_DESC";
    RegionalHolidayReasonsToBookCollectionOrder["UrlAsc"] = "url_ASC";
    RegionalHolidayReasonsToBookCollectionOrder["UrlDesc"] = "url_DESC";
})(RegionalHolidayReasonsToBookCollectionOrder = exports.RegionalHolidayReasonsToBookCollectionOrder || (exports.RegionalHolidayReasonsToBookCollectionOrder = {}));
var SafetyMeasureLinkingCollectionsAccommodationTypeCollectionOrder;
(function (SafetyMeasureLinkingCollectionsAccommodationTypeCollectionOrder) {
    SafetyMeasureLinkingCollectionsAccommodationTypeCollectionOrder["ChecklistTitleAsc"] = "checklistTitle_ASC";
    SafetyMeasureLinkingCollectionsAccommodationTypeCollectionOrder["ChecklistTitleDesc"] = "checklistTitle_DESC";
    SafetyMeasureLinkingCollectionsAccommodationTypeCollectionOrder["NameAsc"] = "name_ASC";
    SafetyMeasureLinkingCollectionsAccommodationTypeCollectionOrder["NameDesc"] = "name_DESC";
    SafetyMeasureLinkingCollectionsAccommodationTypeCollectionOrder["PathAsc"] = "path_ASC";
    SafetyMeasureLinkingCollectionsAccommodationTypeCollectionOrder["PathDesc"] = "path_DESC";
    SafetyMeasureLinkingCollectionsAccommodationTypeCollectionOrder["SearchAccommodationNameAsc"] = "searchAccommodationName_ASC";
    SafetyMeasureLinkingCollectionsAccommodationTypeCollectionOrder["SearchAccommodationNameDesc"] = "searchAccommodationName_DESC";
    SafetyMeasureLinkingCollectionsAccommodationTypeCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    SafetyMeasureLinkingCollectionsAccommodationTypeCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    SafetyMeasureLinkingCollectionsAccommodationTypeCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    SafetyMeasureLinkingCollectionsAccommodationTypeCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    SafetyMeasureLinkingCollectionsAccommodationTypeCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    SafetyMeasureLinkingCollectionsAccommodationTypeCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    SafetyMeasureLinkingCollectionsAccommodationTypeCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    SafetyMeasureLinkingCollectionsAccommodationTypeCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    SafetyMeasureLinkingCollectionsAccommodationTypeCollectionOrder["TitleAsc"] = "title_ASC";
    SafetyMeasureLinkingCollectionsAccommodationTypeCollectionOrder["TitleDesc"] = "title_DESC";
})(SafetyMeasureLinkingCollectionsAccommodationTypeCollectionOrder = exports.SafetyMeasureLinkingCollectionsAccommodationTypeCollectionOrder || (exports.SafetyMeasureLinkingCollectionsAccommodationTypeCollectionOrder = {}));
var SafetyMeasureLinkingCollectionsGenericTemplateCollectionOrder;
(function (SafetyMeasureLinkingCollectionsGenericTemplateCollectionOrder) {
    SafetyMeasureLinkingCollectionsGenericTemplateCollectionOrder["NameAsc"] = "name_ASC";
    SafetyMeasureLinkingCollectionsGenericTemplateCollectionOrder["NameDesc"] = "name_DESC";
    SafetyMeasureLinkingCollectionsGenericTemplateCollectionOrder["PathAsc"] = "path_ASC";
    SafetyMeasureLinkingCollectionsGenericTemplateCollectionOrder["PathDesc"] = "path_DESC";
    SafetyMeasureLinkingCollectionsGenericTemplateCollectionOrder["ShowTableOfContentsAsc"] = "showTableOfContents_ASC";
    SafetyMeasureLinkingCollectionsGenericTemplateCollectionOrder["ShowTableOfContentsDesc"] = "showTableOfContents_DESC";
    SafetyMeasureLinkingCollectionsGenericTemplateCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    SafetyMeasureLinkingCollectionsGenericTemplateCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    SafetyMeasureLinkingCollectionsGenericTemplateCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    SafetyMeasureLinkingCollectionsGenericTemplateCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    SafetyMeasureLinkingCollectionsGenericTemplateCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    SafetyMeasureLinkingCollectionsGenericTemplateCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    SafetyMeasureLinkingCollectionsGenericTemplateCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    SafetyMeasureLinkingCollectionsGenericTemplateCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    SafetyMeasureLinkingCollectionsGenericTemplateCollectionOrder["TitleAsc"] = "title_ASC";
    SafetyMeasureLinkingCollectionsGenericTemplateCollectionOrder["TitleDesc"] = "title_DESC";
})(SafetyMeasureLinkingCollectionsGenericTemplateCollectionOrder = exports.SafetyMeasureLinkingCollectionsGenericTemplateCollectionOrder || (exports.SafetyMeasureLinkingCollectionsGenericTemplateCollectionOrder = {}));
var SafetyMeasureLinkingCollectionsListAssemblyCollectionOrder;
(function (SafetyMeasureLinkingCollectionsListAssemblyCollectionOrder) {
    SafetyMeasureLinkingCollectionsListAssemblyCollectionOrder["HeaderAsc"] = "header_ASC";
    SafetyMeasureLinkingCollectionsListAssemblyCollectionOrder["HeaderDesc"] = "header_DESC";
    SafetyMeasureLinkingCollectionsListAssemblyCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    SafetyMeasureLinkingCollectionsListAssemblyCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    SafetyMeasureLinkingCollectionsListAssemblyCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    SafetyMeasureLinkingCollectionsListAssemblyCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    SafetyMeasureLinkingCollectionsListAssemblyCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    SafetyMeasureLinkingCollectionsListAssemblyCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    SafetyMeasureLinkingCollectionsListAssemblyCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    SafetyMeasureLinkingCollectionsListAssemblyCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(SafetyMeasureLinkingCollectionsListAssemblyCollectionOrder = exports.SafetyMeasureLinkingCollectionsListAssemblyCollectionOrder || (exports.SafetyMeasureLinkingCollectionsListAssemblyCollectionOrder = {}));
var SafetyMeasureLinkingCollectionsPropositionCollectionOrder;
(function (SafetyMeasureLinkingCollectionsPropositionCollectionOrder) {
    SafetyMeasureLinkingCollectionsPropositionCollectionOrder["FaqFolderIdAsc"] = "faqFolderId_ASC";
    SafetyMeasureLinkingCollectionsPropositionCollectionOrder["FaqFolderIdDesc"] = "faqFolderId_DESC";
    SafetyMeasureLinkingCollectionsPropositionCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    SafetyMeasureLinkingCollectionsPropositionCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    SafetyMeasureLinkingCollectionsPropositionCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    SafetyMeasureLinkingCollectionsPropositionCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    SafetyMeasureLinkingCollectionsPropositionCollectionOrder["NameAsc"] = "name_ASC";
    SafetyMeasureLinkingCollectionsPropositionCollectionOrder["NameDesc"] = "name_DESC";
    SafetyMeasureLinkingCollectionsPropositionCollectionOrder["PathAsc"] = "path_ASC";
    SafetyMeasureLinkingCollectionsPropositionCollectionOrder["PathDesc"] = "path_DESC";
    SafetyMeasureLinkingCollectionsPropositionCollectionOrder["RelatedArticlesTitleAsc"] = "relatedArticlesTitle_ASC";
    SafetyMeasureLinkingCollectionsPropositionCollectionOrder["RelatedArticlesTitleDesc"] = "relatedArticlesTitle_DESC";
    SafetyMeasureLinkingCollectionsPropositionCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    SafetyMeasureLinkingCollectionsPropositionCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    SafetyMeasureLinkingCollectionsPropositionCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    SafetyMeasureLinkingCollectionsPropositionCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    SafetyMeasureLinkingCollectionsPropositionCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    SafetyMeasureLinkingCollectionsPropositionCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    SafetyMeasureLinkingCollectionsPropositionCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    SafetyMeasureLinkingCollectionsPropositionCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    SafetyMeasureLinkingCollectionsPropositionCollectionOrder["TagLineAsc"] = "tagLine_ASC";
    SafetyMeasureLinkingCollectionsPropositionCollectionOrder["TagLineDesc"] = "tagLine_DESC";
    SafetyMeasureLinkingCollectionsPropositionCollectionOrder["TitleAsc"] = "title_ASC";
    SafetyMeasureLinkingCollectionsPropositionCollectionOrder["TitleDesc"] = "title_DESC";
})(SafetyMeasureLinkingCollectionsPropositionCollectionOrder = exports.SafetyMeasureLinkingCollectionsPropositionCollectionOrder || (exports.SafetyMeasureLinkingCollectionsPropositionCollectionOrder = {}));
var SafetyMeasureLinkingCollectionsPropositionSubCategoryCollectionOrder;
(function (SafetyMeasureLinkingCollectionsPropositionSubCategoryCollectionOrder) {
    SafetyMeasureLinkingCollectionsPropositionSubCategoryCollectionOrder["NameAsc"] = "name_ASC";
    SafetyMeasureLinkingCollectionsPropositionSubCategoryCollectionOrder["NameDesc"] = "name_DESC";
    SafetyMeasureLinkingCollectionsPropositionSubCategoryCollectionOrder["PathAsc"] = "path_ASC";
    SafetyMeasureLinkingCollectionsPropositionSubCategoryCollectionOrder["PathDesc"] = "path_DESC";
    SafetyMeasureLinkingCollectionsPropositionSubCategoryCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    SafetyMeasureLinkingCollectionsPropositionSubCategoryCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    SafetyMeasureLinkingCollectionsPropositionSubCategoryCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    SafetyMeasureLinkingCollectionsPropositionSubCategoryCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    SafetyMeasureLinkingCollectionsPropositionSubCategoryCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    SafetyMeasureLinkingCollectionsPropositionSubCategoryCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    SafetyMeasureLinkingCollectionsPropositionSubCategoryCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    SafetyMeasureLinkingCollectionsPropositionSubCategoryCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    SafetyMeasureLinkingCollectionsPropositionSubCategoryCollectionOrder["TitleAsc"] = "title_ASC";
    SafetyMeasureLinkingCollectionsPropositionSubCategoryCollectionOrder["TitleDesc"] = "title_DESC";
})(SafetyMeasureLinkingCollectionsPropositionSubCategoryCollectionOrder = exports.SafetyMeasureLinkingCollectionsPropositionSubCategoryCollectionOrder || (exports.SafetyMeasureLinkingCollectionsPropositionSubCategoryCollectionOrder = {}));
var SafetyMeasureOrder;
(function (SafetyMeasureOrder) {
    SafetyMeasureOrder["NameAsc"] = "name_ASC";
    SafetyMeasureOrder["NameDesc"] = "name_DESC";
    SafetyMeasureOrder["PathAsc"] = "path_ASC";
    SafetyMeasureOrder["PathDesc"] = "path_DESC";
    SafetyMeasureOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    SafetyMeasureOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    SafetyMeasureOrder["SysIdAsc"] = "sys_id_ASC";
    SafetyMeasureOrder["SysIdDesc"] = "sys_id_DESC";
    SafetyMeasureOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    SafetyMeasureOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    SafetyMeasureOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    SafetyMeasureOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    SafetyMeasureOrder["TitleAsc"] = "title_ASC";
    SafetyMeasureOrder["TitleDesc"] = "title_DESC";
})(SafetyMeasureOrder = exports.SafetyMeasureOrder || (exports.SafetyMeasureOrder = {}));
var SearchPromotionBannerOrder;
(function (SearchPromotionBannerOrder) {
    SearchPromotionBannerOrder["AlwaysVisibleAsc"] = "alwaysVisible_ASC";
    SearchPromotionBannerOrder["AlwaysVisibleDesc"] = "alwaysVisible_DESC";
    SearchPromotionBannerOrder["ButtonLabelAsc"] = "buttonLabel_ASC";
    SearchPromotionBannerOrder["ButtonLabelDesc"] = "buttonLabel_DESC";
    SearchPromotionBannerOrder["DarkAsc"] = "dark_ASC";
    SearchPromotionBannerOrder["DarkDesc"] = "dark_DESC";
    SearchPromotionBannerOrder["EndDateAsc"] = "endDate_ASC";
    SearchPromotionBannerOrder["EndDateDesc"] = "endDate_DESC";
    SearchPromotionBannerOrder["ImageTypeAsc"] = "imageType_ASC";
    SearchPromotionBannerOrder["ImageTypeDesc"] = "imageType_DESC";
    SearchPromotionBannerOrder["RedirectUrlAsc"] = "redirectUrl_ASC";
    SearchPromotionBannerOrder["RedirectUrlDesc"] = "redirectUrl_DESC";
    SearchPromotionBannerOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    SearchPromotionBannerOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    SearchPromotionBannerOrder["SysIdAsc"] = "sys_id_ASC";
    SearchPromotionBannerOrder["SysIdDesc"] = "sys_id_DESC";
    SearchPromotionBannerOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    SearchPromotionBannerOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    SearchPromotionBannerOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    SearchPromotionBannerOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    SearchPromotionBannerOrder["TitleAsc"] = "title_ASC";
    SearchPromotionBannerOrder["TitleDesc"] = "title_DESC";
})(SearchPromotionBannerOrder = exports.SearchPromotionBannerOrder || (exports.SearchPromotionBannerOrder = {}));
var SectionLinkingCollectionsGenericTemplateCollectionOrder;
(function (SectionLinkingCollectionsGenericTemplateCollectionOrder) {
    SectionLinkingCollectionsGenericTemplateCollectionOrder["NameAsc"] = "name_ASC";
    SectionLinkingCollectionsGenericTemplateCollectionOrder["NameDesc"] = "name_DESC";
    SectionLinkingCollectionsGenericTemplateCollectionOrder["PathAsc"] = "path_ASC";
    SectionLinkingCollectionsGenericTemplateCollectionOrder["PathDesc"] = "path_DESC";
    SectionLinkingCollectionsGenericTemplateCollectionOrder["ShowTableOfContentsAsc"] = "showTableOfContents_ASC";
    SectionLinkingCollectionsGenericTemplateCollectionOrder["ShowTableOfContentsDesc"] = "showTableOfContents_DESC";
    SectionLinkingCollectionsGenericTemplateCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    SectionLinkingCollectionsGenericTemplateCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    SectionLinkingCollectionsGenericTemplateCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    SectionLinkingCollectionsGenericTemplateCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    SectionLinkingCollectionsGenericTemplateCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    SectionLinkingCollectionsGenericTemplateCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    SectionLinkingCollectionsGenericTemplateCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    SectionLinkingCollectionsGenericTemplateCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    SectionLinkingCollectionsGenericTemplateCollectionOrder["TitleAsc"] = "title_ASC";
    SectionLinkingCollectionsGenericTemplateCollectionOrder["TitleDesc"] = "title_DESC";
})(SectionLinkingCollectionsGenericTemplateCollectionOrder = exports.SectionLinkingCollectionsGenericTemplateCollectionOrder || (exports.SectionLinkingCollectionsGenericTemplateCollectionOrder = {}));
var SectionOrder;
(function (SectionOrder) {
    SectionOrder["NameAsc"] = "name_ASC";
    SectionOrder["NameDesc"] = "name_DESC";
    SectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    SectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    SectionOrder["SysIdAsc"] = "sys_id_ASC";
    SectionOrder["SysIdDesc"] = "sys_id_DESC";
    SectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    SectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    SectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    SectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    SectionOrder["TitleAsc"] = "title_ASC";
    SectionOrder["TitleDesc"] = "title_DESC";
})(SectionOrder = exports.SectionOrder || (exports.SectionOrder = {}));
var SellingAttributeOrder;
(function (SellingAttributeOrder) {
    SellingAttributeOrder["DescriptionAsc"] = "description_ASC";
    SellingAttributeOrder["DescriptionDesc"] = "description_DESC";
    SellingAttributeOrder["IdAsc"] = "id_ASC";
    SellingAttributeOrder["IdDesc"] = "id_DESC";
    SellingAttributeOrder["RankAsc"] = "rank_ASC";
    SellingAttributeOrder["RankDesc"] = "rank_DESC";
    SellingAttributeOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    SellingAttributeOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    SellingAttributeOrder["SysIdAsc"] = "sys_id_ASC";
    SellingAttributeOrder["SysIdDesc"] = "sys_id_DESC";
    SellingAttributeOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    SellingAttributeOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    SellingAttributeOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    SellingAttributeOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    SellingAttributeOrder["TitleAsc"] = "title_ASC";
    SellingAttributeOrder["TitleDesc"] = "title_DESC";
})(SellingAttributeOrder = exports.SellingAttributeOrder || (exports.SellingAttributeOrder = {}));
var SellingPointLinkingCollectionsAccommodationGradeCollectionOrder;
(function (SellingPointLinkingCollectionsAccommodationGradeCollectionOrder) {
    SellingPointLinkingCollectionsAccommodationGradeCollectionOrder["AccessibleAsc"] = "accessible_ASC";
    SellingPointLinkingCollectionsAccommodationGradeCollectionOrder["AccessibleDesc"] = "accessible_DESC";
    SellingPointLinkingCollectionsAccommodationGradeCollectionOrder["IncludesTitleAsc"] = "includesTitle_ASC";
    SellingPointLinkingCollectionsAccommodationGradeCollectionOrder["IncludesTitleDesc"] = "includesTitle_DESC";
    SellingPointLinkingCollectionsAccommodationGradeCollectionOrder["NameAsc"] = "name_ASC";
    SellingPointLinkingCollectionsAccommodationGradeCollectionOrder["NameDesc"] = "name_DESC";
    SellingPointLinkingCollectionsAccommodationGradeCollectionOrder["SearchAccommodationGradeAsc"] = "searchAccommodationGrade_ASC";
    SellingPointLinkingCollectionsAccommodationGradeCollectionOrder["SearchAccommodationGradeDesc"] = "searchAccommodationGrade_DESC";
    SellingPointLinkingCollectionsAccommodationGradeCollectionOrder["SellingPointsTitleAsc"] = "sellingPointsTitle_ASC";
    SellingPointLinkingCollectionsAccommodationGradeCollectionOrder["SellingPointsTitleDesc"] = "sellingPointsTitle_DESC";
    SellingPointLinkingCollectionsAccommodationGradeCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    SellingPointLinkingCollectionsAccommodationGradeCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    SellingPointLinkingCollectionsAccommodationGradeCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    SellingPointLinkingCollectionsAccommodationGradeCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    SellingPointLinkingCollectionsAccommodationGradeCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    SellingPointLinkingCollectionsAccommodationGradeCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    SellingPointLinkingCollectionsAccommodationGradeCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    SellingPointLinkingCollectionsAccommodationGradeCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    SellingPointLinkingCollectionsAccommodationGradeCollectionOrder["TaglineAsc"] = "tagline_ASC";
    SellingPointLinkingCollectionsAccommodationGradeCollectionOrder["TaglineDesc"] = "tagline_DESC";
})(SellingPointLinkingCollectionsAccommodationGradeCollectionOrder = exports.SellingPointLinkingCollectionsAccommodationGradeCollectionOrder || (exports.SellingPointLinkingCollectionsAccommodationGradeCollectionOrder = {}));
var SellingPointLinkingCollectionsAccommodationTypeCollectionOrder;
(function (SellingPointLinkingCollectionsAccommodationTypeCollectionOrder) {
    SellingPointLinkingCollectionsAccommodationTypeCollectionOrder["ChecklistTitleAsc"] = "checklistTitle_ASC";
    SellingPointLinkingCollectionsAccommodationTypeCollectionOrder["ChecklistTitleDesc"] = "checklistTitle_DESC";
    SellingPointLinkingCollectionsAccommodationTypeCollectionOrder["NameAsc"] = "name_ASC";
    SellingPointLinkingCollectionsAccommodationTypeCollectionOrder["NameDesc"] = "name_DESC";
    SellingPointLinkingCollectionsAccommodationTypeCollectionOrder["PathAsc"] = "path_ASC";
    SellingPointLinkingCollectionsAccommodationTypeCollectionOrder["PathDesc"] = "path_DESC";
    SellingPointLinkingCollectionsAccommodationTypeCollectionOrder["SearchAccommodationNameAsc"] = "searchAccommodationName_ASC";
    SellingPointLinkingCollectionsAccommodationTypeCollectionOrder["SearchAccommodationNameDesc"] = "searchAccommodationName_DESC";
    SellingPointLinkingCollectionsAccommodationTypeCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    SellingPointLinkingCollectionsAccommodationTypeCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    SellingPointLinkingCollectionsAccommodationTypeCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    SellingPointLinkingCollectionsAccommodationTypeCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    SellingPointLinkingCollectionsAccommodationTypeCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    SellingPointLinkingCollectionsAccommodationTypeCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    SellingPointLinkingCollectionsAccommodationTypeCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    SellingPointLinkingCollectionsAccommodationTypeCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    SellingPointLinkingCollectionsAccommodationTypeCollectionOrder["TitleAsc"] = "title_ASC";
    SellingPointLinkingCollectionsAccommodationTypeCollectionOrder["TitleDesc"] = "title_DESC";
})(SellingPointLinkingCollectionsAccommodationTypeCollectionOrder = exports.SellingPointLinkingCollectionsAccommodationTypeCollectionOrder || (exports.SellingPointLinkingCollectionsAccommodationTypeCollectionOrder = {}));
var SellingPointLinkingCollectionsFullCampaignCollectionOrder;
(function (SellingPointLinkingCollectionsFullCampaignCollectionOrder) {
    SellingPointLinkingCollectionsFullCampaignCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    SellingPointLinkingCollectionsFullCampaignCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    SellingPointLinkingCollectionsFullCampaignCollectionOrder["FeaturedParksTitleAsc"] = "featuredParksTitle_ASC";
    SellingPointLinkingCollectionsFullCampaignCollectionOrder["FeaturedParksTitleDesc"] = "featuredParksTitle_DESC";
    SellingPointLinkingCollectionsFullCampaignCollectionOrder["FeaturedPromotionsTitleAsc"] = "featuredPromotionsTitle_ASC";
    SellingPointLinkingCollectionsFullCampaignCollectionOrder["FeaturedPromotionsTitleDesc"] = "featuredPromotionsTitle_DESC";
    SellingPointLinkingCollectionsFullCampaignCollectionOrder["IntroductionTitleAsc"] = "introductionTitle_ASC";
    SellingPointLinkingCollectionsFullCampaignCollectionOrder["IntroductionTitleDesc"] = "introductionTitle_DESC";
    SellingPointLinkingCollectionsFullCampaignCollectionOrder["NameAsc"] = "name_ASC";
    SellingPointLinkingCollectionsFullCampaignCollectionOrder["NameDesc"] = "name_DESC";
    SellingPointLinkingCollectionsFullCampaignCollectionOrder["PathAsc"] = "path_ASC";
    SellingPointLinkingCollectionsFullCampaignCollectionOrder["PathDesc"] = "path_DESC";
    SellingPointLinkingCollectionsFullCampaignCollectionOrder["PromotionsTitleAsc"] = "promotionsTitle_ASC";
    SellingPointLinkingCollectionsFullCampaignCollectionOrder["PromotionsTitleDesc"] = "promotionsTitle_DESC";
    SellingPointLinkingCollectionsFullCampaignCollectionOrder["ReasonsToBookTitleAsc"] = "reasonsToBookTitle_ASC";
    SellingPointLinkingCollectionsFullCampaignCollectionOrder["ReasonsToBookTitleDesc"] = "reasonsToBookTitle_DESC";
    SellingPointLinkingCollectionsFullCampaignCollectionOrder["SellingPointsTitleAsc"] = "sellingPointsTitle_ASC";
    SellingPointLinkingCollectionsFullCampaignCollectionOrder["SellingPointsTitleDesc"] = "sellingPointsTitle_DESC";
    SellingPointLinkingCollectionsFullCampaignCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    SellingPointLinkingCollectionsFullCampaignCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    SellingPointLinkingCollectionsFullCampaignCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    SellingPointLinkingCollectionsFullCampaignCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    SellingPointLinkingCollectionsFullCampaignCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    SellingPointLinkingCollectionsFullCampaignCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    SellingPointLinkingCollectionsFullCampaignCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    SellingPointLinkingCollectionsFullCampaignCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    SellingPointLinkingCollectionsFullCampaignCollectionOrder["TitleAsc"] = "title_ASC";
    SellingPointLinkingCollectionsFullCampaignCollectionOrder["TitleDesc"] = "title_DESC";
})(SellingPointLinkingCollectionsFullCampaignCollectionOrder = exports.SellingPointLinkingCollectionsFullCampaignCollectionOrder || (exports.SellingPointLinkingCollectionsFullCampaignCollectionOrder = {}));
var SellingPointLinkingCollectionsHolidayPackageCollectionOrder;
(function (SellingPointLinkingCollectionsHolidayPackageCollectionOrder) {
    SellingPointLinkingCollectionsHolidayPackageCollectionOrder["FeaturesTitleAsc"] = "featuresTitle_ASC";
    SellingPointLinkingCollectionsHolidayPackageCollectionOrder["FeaturesTitleDesc"] = "featuresTitle_DESC";
    SellingPointLinkingCollectionsHolidayPackageCollectionOrder["SellingPointsTitleAsc"] = "sellingPointsTitle_ASC";
    SellingPointLinkingCollectionsHolidayPackageCollectionOrder["SellingPointsTitleDesc"] = "sellingPointsTitle_DESC";
    SellingPointLinkingCollectionsHolidayPackageCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    SellingPointLinkingCollectionsHolidayPackageCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    SellingPointLinkingCollectionsHolidayPackageCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    SellingPointLinkingCollectionsHolidayPackageCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    SellingPointLinkingCollectionsHolidayPackageCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    SellingPointLinkingCollectionsHolidayPackageCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    SellingPointLinkingCollectionsHolidayPackageCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    SellingPointLinkingCollectionsHolidayPackageCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    SellingPointLinkingCollectionsHolidayPackageCollectionOrder["TitleAsc"] = "title_ASC";
    SellingPointLinkingCollectionsHolidayPackageCollectionOrder["TitleDesc"] = "title_DESC";
})(SellingPointLinkingCollectionsHolidayPackageCollectionOrder = exports.SellingPointLinkingCollectionsHolidayPackageCollectionOrder || (exports.SellingPointLinkingCollectionsHolidayPackageCollectionOrder = {}));
var SellingPointLinkingCollectionsListAssemblyCollectionOrder;
(function (SellingPointLinkingCollectionsListAssemblyCollectionOrder) {
    SellingPointLinkingCollectionsListAssemblyCollectionOrder["HeaderAsc"] = "header_ASC";
    SellingPointLinkingCollectionsListAssemblyCollectionOrder["HeaderDesc"] = "header_DESC";
    SellingPointLinkingCollectionsListAssemblyCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    SellingPointLinkingCollectionsListAssemblyCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    SellingPointLinkingCollectionsListAssemblyCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    SellingPointLinkingCollectionsListAssemblyCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    SellingPointLinkingCollectionsListAssemblyCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    SellingPointLinkingCollectionsListAssemblyCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    SellingPointLinkingCollectionsListAssemblyCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    SellingPointLinkingCollectionsListAssemblyCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(SellingPointLinkingCollectionsListAssemblyCollectionOrder = exports.SellingPointLinkingCollectionsListAssemblyCollectionOrder || (exports.SellingPointLinkingCollectionsListAssemblyCollectionOrder = {}));
var SellingPointLinkingCollectionsParkCollectionOrder;
(function (SellingPointLinkingCollectionsParkCollectionOrder) {
    SellingPointLinkingCollectionsParkCollectionOrder["ContactNumberAsc"] = "contactNumber_ASC";
    SellingPointLinkingCollectionsParkCollectionOrder["ContactNumberDesc"] = "contactNumber_DESC";
    SellingPointLinkingCollectionsParkCollectionOrder["DirectionsUrlAsc"] = "directionsUrl_ASC";
    SellingPointLinkingCollectionsParkCollectionOrder["DirectionsUrlDesc"] = "directionsUrl_DESC";
    SellingPointLinkingCollectionsParkCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    SellingPointLinkingCollectionsParkCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    SellingPointLinkingCollectionsParkCollectionOrder["NameAsc"] = "name_ASC";
    SellingPointLinkingCollectionsParkCollectionOrder["NameDesc"] = "name_DESC";
    SellingPointLinkingCollectionsParkCollectionOrder["ParkTypeAsc"] = "parkType_ASC";
    SellingPointLinkingCollectionsParkCollectionOrder["ParkTypeDesc"] = "parkType_DESC";
    SellingPointLinkingCollectionsParkCollectionOrder["PathAsc"] = "path_ASC";
    SellingPointLinkingCollectionsParkCollectionOrder["PathDesc"] = "path_DESC";
    SellingPointLinkingCollectionsParkCollectionOrder["RunningCostsAsc"] = "runningCosts_ASC";
    SellingPointLinkingCollectionsParkCollectionOrder["RunningCostsDesc"] = "runningCosts_DESC";
    SellingPointLinkingCollectionsParkCollectionOrder["SiteFeesAsc"] = "siteFees_ASC";
    SellingPointLinkingCollectionsParkCollectionOrder["SiteFeesDesc"] = "siteFees_DESC";
    SellingPointLinkingCollectionsParkCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    SellingPointLinkingCollectionsParkCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    SellingPointLinkingCollectionsParkCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    SellingPointLinkingCollectionsParkCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    SellingPointLinkingCollectionsParkCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    SellingPointLinkingCollectionsParkCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    SellingPointLinkingCollectionsParkCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    SellingPointLinkingCollectionsParkCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    SellingPointLinkingCollectionsParkCollectionOrder["TaglineAsc"] = "tagline_ASC";
    SellingPointLinkingCollectionsParkCollectionOrder["TaglineDesc"] = "tagline_DESC";
    SellingPointLinkingCollectionsParkCollectionOrder["ThingsToDoTitleAsc"] = "thingsToDoTitle_ASC";
    SellingPointLinkingCollectionsParkCollectionOrder["ThingsToDoTitleDesc"] = "thingsToDoTitle_DESC";
    SellingPointLinkingCollectionsParkCollectionOrder["TitleAsc"] = "title_ASC";
    SellingPointLinkingCollectionsParkCollectionOrder["TitleDesc"] = "title_DESC";
})(SellingPointLinkingCollectionsParkCollectionOrder = exports.SellingPointLinkingCollectionsParkCollectionOrder || (exports.SellingPointLinkingCollectionsParkCollectionOrder = {}));
var SellingPointLinkingCollectionsRegionCollectionOrder;
(function (SellingPointLinkingCollectionsRegionCollectionOrder) {
    SellingPointLinkingCollectionsRegionCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    SellingPointLinkingCollectionsRegionCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    SellingPointLinkingCollectionsRegionCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    SellingPointLinkingCollectionsRegionCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    SellingPointLinkingCollectionsRegionCollectionOrder["NameAsc"] = "name_ASC";
    SellingPointLinkingCollectionsRegionCollectionOrder["NameDesc"] = "name_DESC";
    SellingPointLinkingCollectionsRegionCollectionOrder["NearbyTownCitiesTitleAsc"] = "nearbyTownCitiesTitle_ASC";
    SellingPointLinkingCollectionsRegionCollectionOrder["NearbyTownCitiesTitleDesc"] = "nearbyTownCitiesTitle_DESC";
    SellingPointLinkingCollectionsRegionCollectionOrder["PageTypeAsc"] = "pageType_ASC";
    SellingPointLinkingCollectionsRegionCollectionOrder["PageTypeDesc"] = "pageType_DESC";
    SellingPointLinkingCollectionsRegionCollectionOrder["PathAsc"] = "path_ASC";
    SellingPointLinkingCollectionsRegionCollectionOrder["PathDesc"] = "path_DESC";
    SellingPointLinkingCollectionsRegionCollectionOrder["RegionCodeAsc"] = "regionCode_ASC";
    SellingPointLinkingCollectionsRegionCollectionOrder["RegionCodeDesc"] = "regionCode_DESC";
    SellingPointLinkingCollectionsRegionCollectionOrder["RelatedArticlesTitleAsc"] = "relatedArticlesTitle_ASC";
    SellingPointLinkingCollectionsRegionCollectionOrder["RelatedArticlesTitleDesc"] = "relatedArticlesTitle_DESC";
    SellingPointLinkingCollectionsRegionCollectionOrder["SearchTitleAsc"] = "searchTitle_ASC";
    SellingPointLinkingCollectionsRegionCollectionOrder["SearchTitleDesc"] = "searchTitle_DESC";
    SellingPointLinkingCollectionsRegionCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    SellingPointLinkingCollectionsRegionCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    SellingPointLinkingCollectionsRegionCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    SellingPointLinkingCollectionsRegionCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    SellingPointLinkingCollectionsRegionCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    SellingPointLinkingCollectionsRegionCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    SellingPointLinkingCollectionsRegionCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    SellingPointLinkingCollectionsRegionCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    SellingPointLinkingCollectionsRegionCollectionOrder["ThingsToDoTitleAsc"] = "thingsToDoTitle_ASC";
    SellingPointLinkingCollectionsRegionCollectionOrder["ThingsToDoTitleDesc"] = "thingsToDoTitle_DESC";
    SellingPointLinkingCollectionsRegionCollectionOrder["TitleAsc"] = "title_ASC";
    SellingPointLinkingCollectionsRegionCollectionOrder["TitleDesc"] = "title_DESC";
})(SellingPointLinkingCollectionsRegionCollectionOrder = exports.SellingPointLinkingCollectionsRegionCollectionOrder || (exports.SellingPointLinkingCollectionsRegionCollectionOrder = {}));
var SellingPointLinkingCollectionsRegionalHolidayCollectionOrder;
(function (SellingPointLinkingCollectionsRegionalHolidayCollectionOrder) {
    SellingPointLinkingCollectionsRegionalHolidayCollectionOrder["HolidayTypeAsc"] = "holidayType_ASC";
    SellingPointLinkingCollectionsRegionalHolidayCollectionOrder["HolidayTypeDesc"] = "holidayType_DESC";
    SellingPointLinkingCollectionsRegionalHolidayCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    SellingPointLinkingCollectionsRegionalHolidayCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    SellingPointLinkingCollectionsRegionalHolidayCollectionOrder["PathAsc"] = "path_ASC";
    SellingPointLinkingCollectionsRegionalHolidayCollectionOrder["PathDesc"] = "path_DESC";
    SellingPointLinkingCollectionsRegionalHolidayCollectionOrder["ReasonsToBookTitleAsc"] = "reasonsToBookTitle_ASC";
    SellingPointLinkingCollectionsRegionalHolidayCollectionOrder["ReasonsToBookTitleDesc"] = "reasonsToBookTitle_DESC";
    SellingPointLinkingCollectionsRegionalHolidayCollectionOrder["ShortDescriptionAsc"] = "shortDescription_ASC";
    SellingPointLinkingCollectionsRegionalHolidayCollectionOrder["ShortDescriptionDesc"] = "shortDescription_DESC";
    SellingPointLinkingCollectionsRegionalHolidayCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    SellingPointLinkingCollectionsRegionalHolidayCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    SellingPointLinkingCollectionsRegionalHolidayCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    SellingPointLinkingCollectionsRegionalHolidayCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    SellingPointLinkingCollectionsRegionalHolidayCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    SellingPointLinkingCollectionsRegionalHolidayCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    SellingPointLinkingCollectionsRegionalHolidayCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    SellingPointLinkingCollectionsRegionalHolidayCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    SellingPointLinkingCollectionsRegionalHolidayCollectionOrder["TitleAsc"] = "title_ASC";
    SellingPointLinkingCollectionsRegionalHolidayCollectionOrder["TitleDesc"] = "title_DESC";
})(SellingPointLinkingCollectionsRegionalHolidayCollectionOrder = exports.SellingPointLinkingCollectionsRegionalHolidayCollectionOrder || (exports.SellingPointLinkingCollectionsRegionalHolidayCollectionOrder = {}));
var SellingPointOrder;
(function (SellingPointOrder) {
    SellingPointOrder["InternalNameAsc"] = "internalName_ASC";
    SellingPointOrder["InternalNameDesc"] = "internalName_DESC";
    SellingPointOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    SellingPointOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    SellingPointOrder["SysIdAsc"] = "sys_id_ASC";
    SellingPointOrder["SysIdDesc"] = "sys_id_DESC";
    SellingPointOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    SellingPointOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    SellingPointOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    SellingPointOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    SellingPointOrder["TitleAsc"] = "title_ASC";
    SellingPointOrder["TitleDesc"] = "title_DESC";
    SellingPointOrder["UrlAsc"] = "url_ASC";
    SellingPointOrder["UrlDesc"] = "url_DESC";
})(SellingPointOrder = exports.SellingPointOrder || (exports.SellingPointOrder = {}));
var TagMetaDataOrder;
(function (TagMetaDataOrder) {
    TagMetaDataOrder["NameAsc"] = "name_ASC";
    TagMetaDataOrder["NameDesc"] = "name_DESC";
    TagMetaDataOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    TagMetaDataOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    TagMetaDataOrder["SysIdAsc"] = "sys_id_ASC";
    TagMetaDataOrder["SysIdDesc"] = "sys_id_DESC";
    TagMetaDataOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    TagMetaDataOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    TagMetaDataOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    TagMetaDataOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(TagMetaDataOrder = exports.TagMetaDataOrder || (exports.TagMetaDataOrder = {}));
var TermsLinkingCollectionsArticlesCollectionOrder;
(function (TermsLinkingCollectionsArticlesCollectionOrder) {
    TermsLinkingCollectionsArticlesCollectionOrder["ArticleSummaryAsc"] = "articleSummary_ASC";
    TermsLinkingCollectionsArticlesCollectionOrder["ArticleSummaryDesc"] = "articleSummary_DESC";
    TermsLinkingCollectionsArticlesCollectionOrder["AuthorAsc"] = "author_ASC";
    TermsLinkingCollectionsArticlesCollectionOrder["AuthorDesc"] = "author_DESC";
    TermsLinkingCollectionsArticlesCollectionOrder["HolidayTypeAsc"] = "holidayType_ASC";
    TermsLinkingCollectionsArticlesCollectionOrder["HolidayTypeDesc"] = "holidayType_DESC";
    TermsLinkingCollectionsArticlesCollectionOrder["NameAsc"] = "name_ASC";
    TermsLinkingCollectionsArticlesCollectionOrder["NameDesc"] = "name_DESC";
    TermsLinkingCollectionsArticlesCollectionOrder["PathAsc"] = "path_ASC";
    TermsLinkingCollectionsArticlesCollectionOrder["PathDesc"] = "path_DESC";
    TermsLinkingCollectionsArticlesCollectionOrder["RelatedArticlesTitleAsc"] = "relatedArticlesTitle_ASC";
    TermsLinkingCollectionsArticlesCollectionOrder["RelatedArticlesTitleDesc"] = "relatedArticlesTitle_DESC";
    TermsLinkingCollectionsArticlesCollectionOrder["ShowTableOfContentsAsc"] = "showTableOfContents_ASC";
    TermsLinkingCollectionsArticlesCollectionOrder["ShowTableOfContentsDesc"] = "showTableOfContents_DESC";
    TermsLinkingCollectionsArticlesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    TermsLinkingCollectionsArticlesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    TermsLinkingCollectionsArticlesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    TermsLinkingCollectionsArticlesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    TermsLinkingCollectionsArticlesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    TermsLinkingCollectionsArticlesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    TermsLinkingCollectionsArticlesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    TermsLinkingCollectionsArticlesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    TermsLinkingCollectionsArticlesCollectionOrder["TitleAsc"] = "title_ASC";
    TermsLinkingCollectionsArticlesCollectionOrder["TitleDesc"] = "title_DESC";
})(TermsLinkingCollectionsArticlesCollectionOrder = exports.TermsLinkingCollectionsArticlesCollectionOrder || (exports.TermsLinkingCollectionsArticlesCollectionOrder = {}));
var TermsLinkingCollectionsFullCampaignCollectionOrder;
(function (TermsLinkingCollectionsFullCampaignCollectionOrder) {
    TermsLinkingCollectionsFullCampaignCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    TermsLinkingCollectionsFullCampaignCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    TermsLinkingCollectionsFullCampaignCollectionOrder["FeaturedParksTitleAsc"] = "featuredParksTitle_ASC";
    TermsLinkingCollectionsFullCampaignCollectionOrder["FeaturedParksTitleDesc"] = "featuredParksTitle_DESC";
    TermsLinkingCollectionsFullCampaignCollectionOrder["FeaturedPromotionsTitleAsc"] = "featuredPromotionsTitle_ASC";
    TermsLinkingCollectionsFullCampaignCollectionOrder["FeaturedPromotionsTitleDesc"] = "featuredPromotionsTitle_DESC";
    TermsLinkingCollectionsFullCampaignCollectionOrder["IntroductionTitleAsc"] = "introductionTitle_ASC";
    TermsLinkingCollectionsFullCampaignCollectionOrder["IntroductionTitleDesc"] = "introductionTitle_DESC";
    TermsLinkingCollectionsFullCampaignCollectionOrder["NameAsc"] = "name_ASC";
    TermsLinkingCollectionsFullCampaignCollectionOrder["NameDesc"] = "name_DESC";
    TermsLinkingCollectionsFullCampaignCollectionOrder["PathAsc"] = "path_ASC";
    TermsLinkingCollectionsFullCampaignCollectionOrder["PathDesc"] = "path_DESC";
    TermsLinkingCollectionsFullCampaignCollectionOrder["PromotionsTitleAsc"] = "promotionsTitle_ASC";
    TermsLinkingCollectionsFullCampaignCollectionOrder["PromotionsTitleDesc"] = "promotionsTitle_DESC";
    TermsLinkingCollectionsFullCampaignCollectionOrder["ReasonsToBookTitleAsc"] = "reasonsToBookTitle_ASC";
    TermsLinkingCollectionsFullCampaignCollectionOrder["ReasonsToBookTitleDesc"] = "reasonsToBookTitle_DESC";
    TermsLinkingCollectionsFullCampaignCollectionOrder["SellingPointsTitleAsc"] = "sellingPointsTitle_ASC";
    TermsLinkingCollectionsFullCampaignCollectionOrder["SellingPointsTitleDesc"] = "sellingPointsTitle_DESC";
    TermsLinkingCollectionsFullCampaignCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    TermsLinkingCollectionsFullCampaignCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    TermsLinkingCollectionsFullCampaignCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    TermsLinkingCollectionsFullCampaignCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    TermsLinkingCollectionsFullCampaignCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    TermsLinkingCollectionsFullCampaignCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    TermsLinkingCollectionsFullCampaignCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    TermsLinkingCollectionsFullCampaignCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    TermsLinkingCollectionsFullCampaignCollectionOrder["TitleAsc"] = "title_ASC";
    TermsLinkingCollectionsFullCampaignCollectionOrder["TitleDesc"] = "title_DESC";
})(TermsLinkingCollectionsFullCampaignCollectionOrder = exports.TermsLinkingCollectionsFullCampaignCollectionOrder || (exports.TermsLinkingCollectionsFullCampaignCollectionOrder = {}));
var TermsLinkingCollectionsHomePageCollectionOrder;
(function (TermsLinkingCollectionsHomePageCollectionOrder) {
    TermsLinkingCollectionsHomePageCollectionOrder["DefaultHolidayNumberOfNightsAsc"] = "defaultHolidayNumberOfNights_ASC";
    TermsLinkingCollectionsHomePageCollectionOrder["DefaultHolidayNumberOfNightsDesc"] = "defaultHolidayNumberOfNights_DESC";
    TermsLinkingCollectionsHomePageCollectionOrder["NameAsc"] = "name_ASC";
    TermsLinkingCollectionsHomePageCollectionOrder["NameDesc"] = "name_DESC";
    TermsLinkingCollectionsHomePageCollectionOrder["PathAsc"] = "path_ASC";
    TermsLinkingCollectionsHomePageCollectionOrder["PathDesc"] = "path_DESC";
    TermsLinkingCollectionsHomePageCollectionOrder["SummaryTitleAsc"] = "summaryTitle_ASC";
    TermsLinkingCollectionsHomePageCollectionOrder["SummaryTitleDesc"] = "summaryTitle_DESC";
    TermsLinkingCollectionsHomePageCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    TermsLinkingCollectionsHomePageCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    TermsLinkingCollectionsHomePageCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    TermsLinkingCollectionsHomePageCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    TermsLinkingCollectionsHomePageCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    TermsLinkingCollectionsHomePageCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    TermsLinkingCollectionsHomePageCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    TermsLinkingCollectionsHomePageCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(TermsLinkingCollectionsHomePageCollectionOrder = exports.TermsLinkingCollectionsHomePageCollectionOrder || (exports.TermsLinkingCollectionsHomePageCollectionOrder = {}));
var TermsLinkingCollectionsParkCollectionOrder;
(function (TermsLinkingCollectionsParkCollectionOrder) {
    TermsLinkingCollectionsParkCollectionOrder["ContactNumberAsc"] = "contactNumber_ASC";
    TermsLinkingCollectionsParkCollectionOrder["ContactNumberDesc"] = "contactNumber_DESC";
    TermsLinkingCollectionsParkCollectionOrder["DirectionsUrlAsc"] = "directionsUrl_ASC";
    TermsLinkingCollectionsParkCollectionOrder["DirectionsUrlDesc"] = "directionsUrl_DESC";
    TermsLinkingCollectionsParkCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    TermsLinkingCollectionsParkCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    TermsLinkingCollectionsParkCollectionOrder["NameAsc"] = "name_ASC";
    TermsLinkingCollectionsParkCollectionOrder["NameDesc"] = "name_DESC";
    TermsLinkingCollectionsParkCollectionOrder["ParkTypeAsc"] = "parkType_ASC";
    TermsLinkingCollectionsParkCollectionOrder["ParkTypeDesc"] = "parkType_DESC";
    TermsLinkingCollectionsParkCollectionOrder["PathAsc"] = "path_ASC";
    TermsLinkingCollectionsParkCollectionOrder["PathDesc"] = "path_DESC";
    TermsLinkingCollectionsParkCollectionOrder["RunningCostsAsc"] = "runningCosts_ASC";
    TermsLinkingCollectionsParkCollectionOrder["RunningCostsDesc"] = "runningCosts_DESC";
    TermsLinkingCollectionsParkCollectionOrder["SiteFeesAsc"] = "siteFees_ASC";
    TermsLinkingCollectionsParkCollectionOrder["SiteFeesDesc"] = "siteFees_DESC";
    TermsLinkingCollectionsParkCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    TermsLinkingCollectionsParkCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    TermsLinkingCollectionsParkCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    TermsLinkingCollectionsParkCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    TermsLinkingCollectionsParkCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    TermsLinkingCollectionsParkCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    TermsLinkingCollectionsParkCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    TermsLinkingCollectionsParkCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    TermsLinkingCollectionsParkCollectionOrder["TaglineAsc"] = "tagline_ASC";
    TermsLinkingCollectionsParkCollectionOrder["TaglineDesc"] = "tagline_DESC";
    TermsLinkingCollectionsParkCollectionOrder["ThingsToDoTitleAsc"] = "thingsToDoTitle_ASC";
    TermsLinkingCollectionsParkCollectionOrder["ThingsToDoTitleDesc"] = "thingsToDoTitle_DESC";
    TermsLinkingCollectionsParkCollectionOrder["TitleAsc"] = "title_ASC";
    TermsLinkingCollectionsParkCollectionOrder["TitleDesc"] = "title_DESC";
})(TermsLinkingCollectionsParkCollectionOrder = exports.TermsLinkingCollectionsParkCollectionOrder || (exports.TermsLinkingCollectionsParkCollectionOrder = {}));
var TermsLinkingCollectionsParkOfferCollectionOrder;
(function (TermsLinkingCollectionsParkOfferCollectionOrder) {
    TermsLinkingCollectionsParkOfferCollectionOrder["AgeFromAsc"] = "ageFrom_ASC";
    TermsLinkingCollectionsParkOfferCollectionOrder["AgeFromDesc"] = "ageFrom_DESC";
    TermsLinkingCollectionsParkOfferCollectionOrder["CtaTitleAsc"] = "ctaTitle_ASC";
    TermsLinkingCollectionsParkOfferCollectionOrder["CtaTitleDesc"] = "ctaTitle_DESC";
    TermsLinkingCollectionsParkOfferCollectionOrder["CtaUrlAsc"] = "ctaUrl_ASC";
    TermsLinkingCollectionsParkOfferCollectionOrder["CtaUrlDesc"] = "ctaUrl_DESC";
    TermsLinkingCollectionsParkOfferCollectionOrder["EndDateAsc"] = "endDate_ASC";
    TermsLinkingCollectionsParkOfferCollectionOrder["EndDateDesc"] = "endDate_DESC";
    TermsLinkingCollectionsParkOfferCollectionOrder["HolidayTypeAsc"] = "holidayType_ASC";
    TermsLinkingCollectionsParkOfferCollectionOrder["HolidayTypeDesc"] = "holidayType_DESC";
    TermsLinkingCollectionsParkOfferCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    TermsLinkingCollectionsParkOfferCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    TermsLinkingCollectionsParkOfferCollectionOrder["PropositionTypeAsc"] = "propositionType_ASC";
    TermsLinkingCollectionsParkOfferCollectionOrder["PropositionTypeDesc"] = "propositionType_DESC";
    TermsLinkingCollectionsParkOfferCollectionOrder["StartDateAsc"] = "startDate_ASC";
    TermsLinkingCollectionsParkOfferCollectionOrder["StartDateDesc"] = "startDate_DESC";
    TermsLinkingCollectionsParkOfferCollectionOrder["SubTitleAsc"] = "subTitle_ASC";
    TermsLinkingCollectionsParkOfferCollectionOrder["SubTitleDesc"] = "subTitle_DESC";
    TermsLinkingCollectionsParkOfferCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    TermsLinkingCollectionsParkOfferCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    TermsLinkingCollectionsParkOfferCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    TermsLinkingCollectionsParkOfferCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    TermsLinkingCollectionsParkOfferCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    TermsLinkingCollectionsParkOfferCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    TermsLinkingCollectionsParkOfferCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    TermsLinkingCollectionsParkOfferCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    TermsLinkingCollectionsParkOfferCollectionOrder["TitleAsc"] = "title_ASC";
    TermsLinkingCollectionsParkOfferCollectionOrder["TitleDesc"] = "title_DESC";
})(TermsLinkingCollectionsParkOfferCollectionOrder = exports.TermsLinkingCollectionsParkOfferCollectionOrder || (exports.TermsLinkingCollectionsParkOfferCollectionOrder = {}));
var TermsLinkingCollectionsPromotionCollectionOrder;
(function (TermsLinkingCollectionsPromotionCollectionOrder) {
    TermsLinkingCollectionsPromotionCollectionOrder["AnalyticsCategoryAsc"] = "analyticsCategory_ASC";
    TermsLinkingCollectionsPromotionCollectionOrder["AnalyticsCategoryDesc"] = "analyticsCategory_DESC";
    TermsLinkingCollectionsPromotionCollectionOrder["AnalyticsTypeAsc"] = "analyticsType_ASC";
    TermsLinkingCollectionsPromotionCollectionOrder["AnalyticsTypeDesc"] = "analyticsType_DESC";
    TermsLinkingCollectionsPromotionCollectionOrder["AnalyticsVariantAsc"] = "analyticsVariant_ASC";
    TermsLinkingCollectionsPromotionCollectionOrder["AnalyticsVariantDesc"] = "analyticsVariant_DESC";
    TermsLinkingCollectionsPromotionCollectionOrder["DurationAsc"] = "duration_ASC";
    TermsLinkingCollectionsPromotionCollectionOrder["DurationDesc"] = "duration_DESC";
    TermsLinkingCollectionsPromotionCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    TermsLinkingCollectionsPromotionCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    TermsLinkingCollectionsPromotionCollectionOrder["MaxPriceAsc"] = "maxPrice_ASC";
    TermsLinkingCollectionsPromotionCollectionOrder["MaxPriceDesc"] = "maxPrice_DESC";
    TermsLinkingCollectionsPromotionCollectionOrder["MinPriceAsc"] = "minPrice_ASC";
    TermsLinkingCollectionsPromotionCollectionOrder["MinPriceDesc"] = "minPrice_DESC";
    TermsLinkingCollectionsPromotionCollectionOrder["PriceAsc"] = "price_ASC";
    TermsLinkingCollectionsPromotionCollectionOrder["PriceDesc"] = "price_DESC";
    TermsLinkingCollectionsPromotionCollectionOrder["SubTitleAsc"] = "subTitle_ASC";
    TermsLinkingCollectionsPromotionCollectionOrder["SubTitleDesc"] = "subTitle_DESC";
    TermsLinkingCollectionsPromotionCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    TermsLinkingCollectionsPromotionCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    TermsLinkingCollectionsPromotionCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    TermsLinkingCollectionsPromotionCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    TermsLinkingCollectionsPromotionCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    TermsLinkingCollectionsPromotionCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    TermsLinkingCollectionsPromotionCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    TermsLinkingCollectionsPromotionCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    TermsLinkingCollectionsPromotionCollectionOrder["TitleAsc"] = "title_ASC";
    TermsLinkingCollectionsPromotionCollectionOrder["TitleDesc"] = "title_DESC";
    TermsLinkingCollectionsPromotionCollectionOrder["UrlAsc"] = "url_ASC";
    TermsLinkingCollectionsPromotionCollectionOrder["UrlDesc"] = "url_DESC";
})(TermsLinkingCollectionsPromotionCollectionOrder = exports.TermsLinkingCollectionsPromotionCollectionOrder || (exports.TermsLinkingCollectionsPromotionCollectionOrder = {}));
var TermsLinkingCollectionsPropositionCategoryCollectionOrder;
(function (TermsLinkingCollectionsPropositionCategoryCollectionOrder) {
    TermsLinkingCollectionsPropositionCategoryCollectionOrder["CtaTitleAsc"] = "ctaTitle_ASC";
    TermsLinkingCollectionsPropositionCategoryCollectionOrder["CtaTitleDesc"] = "ctaTitle_DESC";
    TermsLinkingCollectionsPropositionCategoryCollectionOrder["CtaUrlAsc"] = "ctaUrl_ASC";
    TermsLinkingCollectionsPropositionCategoryCollectionOrder["CtaUrlDesc"] = "ctaUrl_DESC";
    TermsLinkingCollectionsPropositionCategoryCollectionOrder["FeaturedParksTitleAsc"] = "featuredParksTitle_ASC";
    TermsLinkingCollectionsPropositionCategoryCollectionOrder["FeaturedParksTitleDesc"] = "featuredParksTitle_DESC";
    TermsLinkingCollectionsPropositionCategoryCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    TermsLinkingCollectionsPropositionCategoryCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    TermsLinkingCollectionsPropositionCategoryCollectionOrder["NameAsc"] = "name_ASC";
    TermsLinkingCollectionsPropositionCategoryCollectionOrder["NameDesc"] = "name_DESC";
    TermsLinkingCollectionsPropositionCategoryCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    TermsLinkingCollectionsPropositionCategoryCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    TermsLinkingCollectionsPropositionCategoryCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    TermsLinkingCollectionsPropositionCategoryCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    TermsLinkingCollectionsPropositionCategoryCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    TermsLinkingCollectionsPropositionCategoryCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    TermsLinkingCollectionsPropositionCategoryCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    TermsLinkingCollectionsPropositionCategoryCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(TermsLinkingCollectionsPropositionCategoryCollectionOrder = exports.TermsLinkingCollectionsPropositionCategoryCollectionOrder || (exports.TermsLinkingCollectionsPropositionCategoryCollectionOrder = {}));
var TermsLinkingCollectionsPropositionCollectionOrder;
(function (TermsLinkingCollectionsPropositionCollectionOrder) {
    TermsLinkingCollectionsPropositionCollectionOrder["FaqFolderIdAsc"] = "faqFolderId_ASC";
    TermsLinkingCollectionsPropositionCollectionOrder["FaqFolderIdDesc"] = "faqFolderId_DESC";
    TermsLinkingCollectionsPropositionCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    TermsLinkingCollectionsPropositionCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    TermsLinkingCollectionsPropositionCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    TermsLinkingCollectionsPropositionCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    TermsLinkingCollectionsPropositionCollectionOrder["NameAsc"] = "name_ASC";
    TermsLinkingCollectionsPropositionCollectionOrder["NameDesc"] = "name_DESC";
    TermsLinkingCollectionsPropositionCollectionOrder["PathAsc"] = "path_ASC";
    TermsLinkingCollectionsPropositionCollectionOrder["PathDesc"] = "path_DESC";
    TermsLinkingCollectionsPropositionCollectionOrder["RelatedArticlesTitleAsc"] = "relatedArticlesTitle_ASC";
    TermsLinkingCollectionsPropositionCollectionOrder["RelatedArticlesTitleDesc"] = "relatedArticlesTitle_DESC";
    TermsLinkingCollectionsPropositionCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    TermsLinkingCollectionsPropositionCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    TermsLinkingCollectionsPropositionCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    TermsLinkingCollectionsPropositionCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    TermsLinkingCollectionsPropositionCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    TermsLinkingCollectionsPropositionCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    TermsLinkingCollectionsPropositionCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    TermsLinkingCollectionsPropositionCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    TermsLinkingCollectionsPropositionCollectionOrder["TagLineAsc"] = "tagLine_ASC";
    TermsLinkingCollectionsPropositionCollectionOrder["TagLineDesc"] = "tagLine_DESC";
    TermsLinkingCollectionsPropositionCollectionOrder["TitleAsc"] = "title_ASC";
    TermsLinkingCollectionsPropositionCollectionOrder["TitleDesc"] = "title_DESC";
})(TermsLinkingCollectionsPropositionCollectionOrder = exports.TermsLinkingCollectionsPropositionCollectionOrder || (exports.TermsLinkingCollectionsPropositionCollectionOrder = {}));
var TermsOrder;
(function (TermsOrder) {
    TermsOrder["HolidayTypeAsc"] = "holidayType_ASC";
    TermsOrder["HolidayTypeDesc"] = "holidayType_DESC";
    TermsOrder["NameAsc"] = "name_ASC";
    TermsOrder["NameDesc"] = "name_DESC";
    TermsOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    TermsOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    TermsOrder["SysIdAsc"] = "sys_id_ASC";
    TermsOrder["SysIdDesc"] = "sys_id_DESC";
    TermsOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    TermsOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    TermsOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    TermsOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(TermsOrder = exports.TermsOrder || (exports.TermsOrder = {}));
var TestimonialLinkingCollectionsHomePageCollectionOrder;
(function (TestimonialLinkingCollectionsHomePageCollectionOrder) {
    TestimonialLinkingCollectionsHomePageCollectionOrder["DefaultHolidayNumberOfNightsAsc"] = "defaultHolidayNumberOfNights_ASC";
    TestimonialLinkingCollectionsHomePageCollectionOrder["DefaultHolidayNumberOfNightsDesc"] = "defaultHolidayNumberOfNights_DESC";
    TestimonialLinkingCollectionsHomePageCollectionOrder["NameAsc"] = "name_ASC";
    TestimonialLinkingCollectionsHomePageCollectionOrder["NameDesc"] = "name_DESC";
    TestimonialLinkingCollectionsHomePageCollectionOrder["PathAsc"] = "path_ASC";
    TestimonialLinkingCollectionsHomePageCollectionOrder["PathDesc"] = "path_DESC";
    TestimonialLinkingCollectionsHomePageCollectionOrder["SummaryTitleAsc"] = "summaryTitle_ASC";
    TestimonialLinkingCollectionsHomePageCollectionOrder["SummaryTitleDesc"] = "summaryTitle_DESC";
    TestimonialLinkingCollectionsHomePageCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    TestimonialLinkingCollectionsHomePageCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    TestimonialLinkingCollectionsHomePageCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    TestimonialLinkingCollectionsHomePageCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    TestimonialLinkingCollectionsHomePageCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    TestimonialLinkingCollectionsHomePageCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    TestimonialLinkingCollectionsHomePageCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    TestimonialLinkingCollectionsHomePageCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(TestimonialLinkingCollectionsHomePageCollectionOrder = exports.TestimonialLinkingCollectionsHomePageCollectionOrder || (exports.TestimonialLinkingCollectionsHomePageCollectionOrder = {}));
var TestimonialLinkingCollectionsParkCollectionOrder;
(function (TestimonialLinkingCollectionsParkCollectionOrder) {
    TestimonialLinkingCollectionsParkCollectionOrder["ContactNumberAsc"] = "contactNumber_ASC";
    TestimonialLinkingCollectionsParkCollectionOrder["ContactNumberDesc"] = "contactNumber_DESC";
    TestimonialLinkingCollectionsParkCollectionOrder["DirectionsUrlAsc"] = "directionsUrl_ASC";
    TestimonialLinkingCollectionsParkCollectionOrder["DirectionsUrlDesc"] = "directionsUrl_DESC";
    TestimonialLinkingCollectionsParkCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    TestimonialLinkingCollectionsParkCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    TestimonialLinkingCollectionsParkCollectionOrder["NameAsc"] = "name_ASC";
    TestimonialLinkingCollectionsParkCollectionOrder["NameDesc"] = "name_DESC";
    TestimonialLinkingCollectionsParkCollectionOrder["ParkTypeAsc"] = "parkType_ASC";
    TestimonialLinkingCollectionsParkCollectionOrder["ParkTypeDesc"] = "parkType_DESC";
    TestimonialLinkingCollectionsParkCollectionOrder["PathAsc"] = "path_ASC";
    TestimonialLinkingCollectionsParkCollectionOrder["PathDesc"] = "path_DESC";
    TestimonialLinkingCollectionsParkCollectionOrder["RunningCostsAsc"] = "runningCosts_ASC";
    TestimonialLinkingCollectionsParkCollectionOrder["RunningCostsDesc"] = "runningCosts_DESC";
    TestimonialLinkingCollectionsParkCollectionOrder["SiteFeesAsc"] = "siteFees_ASC";
    TestimonialLinkingCollectionsParkCollectionOrder["SiteFeesDesc"] = "siteFees_DESC";
    TestimonialLinkingCollectionsParkCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    TestimonialLinkingCollectionsParkCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    TestimonialLinkingCollectionsParkCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    TestimonialLinkingCollectionsParkCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    TestimonialLinkingCollectionsParkCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    TestimonialLinkingCollectionsParkCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    TestimonialLinkingCollectionsParkCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    TestimonialLinkingCollectionsParkCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    TestimonialLinkingCollectionsParkCollectionOrder["TaglineAsc"] = "tagline_ASC";
    TestimonialLinkingCollectionsParkCollectionOrder["TaglineDesc"] = "tagline_DESC";
    TestimonialLinkingCollectionsParkCollectionOrder["ThingsToDoTitleAsc"] = "thingsToDoTitle_ASC";
    TestimonialLinkingCollectionsParkCollectionOrder["ThingsToDoTitleDesc"] = "thingsToDoTitle_DESC";
    TestimonialLinkingCollectionsParkCollectionOrder["TitleAsc"] = "title_ASC";
    TestimonialLinkingCollectionsParkCollectionOrder["TitleDesc"] = "title_DESC";
})(TestimonialLinkingCollectionsParkCollectionOrder = exports.TestimonialLinkingCollectionsParkCollectionOrder || (exports.TestimonialLinkingCollectionsParkCollectionOrder = {}));
var TestimonialLinkingCollectionsPropositionCategoryCollectionOrder;
(function (TestimonialLinkingCollectionsPropositionCategoryCollectionOrder) {
    TestimonialLinkingCollectionsPropositionCategoryCollectionOrder["CtaTitleAsc"] = "ctaTitle_ASC";
    TestimonialLinkingCollectionsPropositionCategoryCollectionOrder["CtaTitleDesc"] = "ctaTitle_DESC";
    TestimonialLinkingCollectionsPropositionCategoryCollectionOrder["CtaUrlAsc"] = "ctaUrl_ASC";
    TestimonialLinkingCollectionsPropositionCategoryCollectionOrder["CtaUrlDesc"] = "ctaUrl_DESC";
    TestimonialLinkingCollectionsPropositionCategoryCollectionOrder["FeaturedParksTitleAsc"] = "featuredParksTitle_ASC";
    TestimonialLinkingCollectionsPropositionCategoryCollectionOrder["FeaturedParksTitleDesc"] = "featuredParksTitle_DESC";
    TestimonialLinkingCollectionsPropositionCategoryCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    TestimonialLinkingCollectionsPropositionCategoryCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    TestimonialLinkingCollectionsPropositionCategoryCollectionOrder["NameAsc"] = "name_ASC";
    TestimonialLinkingCollectionsPropositionCategoryCollectionOrder["NameDesc"] = "name_DESC";
    TestimonialLinkingCollectionsPropositionCategoryCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    TestimonialLinkingCollectionsPropositionCategoryCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    TestimonialLinkingCollectionsPropositionCategoryCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    TestimonialLinkingCollectionsPropositionCategoryCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    TestimonialLinkingCollectionsPropositionCategoryCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    TestimonialLinkingCollectionsPropositionCategoryCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    TestimonialLinkingCollectionsPropositionCategoryCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    TestimonialLinkingCollectionsPropositionCategoryCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(TestimonialLinkingCollectionsPropositionCategoryCollectionOrder = exports.TestimonialLinkingCollectionsPropositionCategoryCollectionOrder || (exports.TestimonialLinkingCollectionsPropositionCategoryCollectionOrder = {}));
var TestimonialLinkingCollectionsRegionCollectionOrder;
(function (TestimonialLinkingCollectionsRegionCollectionOrder) {
    TestimonialLinkingCollectionsRegionCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    TestimonialLinkingCollectionsRegionCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    TestimonialLinkingCollectionsRegionCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    TestimonialLinkingCollectionsRegionCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    TestimonialLinkingCollectionsRegionCollectionOrder["NameAsc"] = "name_ASC";
    TestimonialLinkingCollectionsRegionCollectionOrder["NameDesc"] = "name_DESC";
    TestimonialLinkingCollectionsRegionCollectionOrder["NearbyTownCitiesTitleAsc"] = "nearbyTownCitiesTitle_ASC";
    TestimonialLinkingCollectionsRegionCollectionOrder["NearbyTownCitiesTitleDesc"] = "nearbyTownCitiesTitle_DESC";
    TestimonialLinkingCollectionsRegionCollectionOrder["PageTypeAsc"] = "pageType_ASC";
    TestimonialLinkingCollectionsRegionCollectionOrder["PageTypeDesc"] = "pageType_DESC";
    TestimonialLinkingCollectionsRegionCollectionOrder["PathAsc"] = "path_ASC";
    TestimonialLinkingCollectionsRegionCollectionOrder["PathDesc"] = "path_DESC";
    TestimonialLinkingCollectionsRegionCollectionOrder["RegionCodeAsc"] = "regionCode_ASC";
    TestimonialLinkingCollectionsRegionCollectionOrder["RegionCodeDesc"] = "regionCode_DESC";
    TestimonialLinkingCollectionsRegionCollectionOrder["RelatedArticlesTitleAsc"] = "relatedArticlesTitle_ASC";
    TestimonialLinkingCollectionsRegionCollectionOrder["RelatedArticlesTitleDesc"] = "relatedArticlesTitle_DESC";
    TestimonialLinkingCollectionsRegionCollectionOrder["SearchTitleAsc"] = "searchTitle_ASC";
    TestimonialLinkingCollectionsRegionCollectionOrder["SearchTitleDesc"] = "searchTitle_DESC";
    TestimonialLinkingCollectionsRegionCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    TestimonialLinkingCollectionsRegionCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    TestimonialLinkingCollectionsRegionCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    TestimonialLinkingCollectionsRegionCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    TestimonialLinkingCollectionsRegionCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    TestimonialLinkingCollectionsRegionCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    TestimonialLinkingCollectionsRegionCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    TestimonialLinkingCollectionsRegionCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    TestimonialLinkingCollectionsRegionCollectionOrder["ThingsToDoTitleAsc"] = "thingsToDoTitle_ASC";
    TestimonialLinkingCollectionsRegionCollectionOrder["ThingsToDoTitleDesc"] = "thingsToDoTitle_DESC";
    TestimonialLinkingCollectionsRegionCollectionOrder["TitleAsc"] = "title_ASC";
    TestimonialLinkingCollectionsRegionCollectionOrder["TitleDesc"] = "title_DESC";
})(TestimonialLinkingCollectionsRegionCollectionOrder = exports.TestimonialLinkingCollectionsRegionCollectionOrder || (exports.TestimonialLinkingCollectionsRegionCollectionOrder = {}));
var TestimonialOrder;
(function (TestimonialOrder) {
    TestimonialOrder["AuthorAsc"] = "author_ASC";
    TestimonialOrder["AuthorDesc"] = "author_DESC";
    TestimonialOrder["HolidayTypeAsc"] = "holidayType_ASC";
    TestimonialOrder["HolidayTypeDesc"] = "holidayType_DESC";
    TestimonialOrder["InternalNameAsc"] = "internalName_ASC";
    TestimonialOrder["InternalNameDesc"] = "internalName_DESC";
    TestimonialOrder["RoleAsc"] = "role_ASC";
    TestimonialOrder["RoleDesc"] = "role_DESC";
    TestimonialOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    TestimonialOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    TestimonialOrder["SysIdAsc"] = "sys_id_ASC";
    TestimonialOrder["SysIdDesc"] = "sys_id_DESC";
    TestimonialOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    TestimonialOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    TestimonialOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    TestimonialOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(TestimonialOrder = exports.TestimonialOrder || (exports.TestimonialOrder = {}));
var TouringSearchOptionsLinkingCollectionsFullCampaignCollectionOrder;
(function (TouringSearchOptionsLinkingCollectionsFullCampaignCollectionOrder) {
    TouringSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    TouringSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    TouringSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["FeaturedParksTitleAsc"] = "featuredParksTitle_ASC";
    TouringSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["FeaturedParksTitleDesc"] = "featuredParksTitle_DESC";
    TouringSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["FeaturedPromotionsTitleAsc"] = "featuredPromotionsTitle_ASC";
    TouringSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["FeaturedPromotionsTitleDesc"] = "featuredPromotionsTitle_DESC";
    TouringSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["IntroductionTitleAsc"] = "introductionTitle_ASC";
    TouringSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["IntroductionTitleDesc"] = "introductionTitle_DESC";
    TouringSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["NameAsc"] = "name_ASC";
    TouringSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["NameDesc"] = "name_DESC";
    TouringSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["PathAsc"] = "path_ASC";
    TouringSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["PathDesc"] = "path_DESC";
    TouringSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["PromotionsTitleAsc"] = "promotionsTitle_ASC";
    TouringSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["PromotionsTitleDesc"] = "promotionsTitle_DESC";
    TouringSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["ReasonsToBookTitleAsc"] = "reasonsToBookTitle_ASC";
    TouringSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["ReasonsToBookTitleDesc"] = "reasonsToBookTitle_DESC";
    TouringSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["SellingPointsTitleAsc"] = "sellingPointsTitle_ASC";
    TouringSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["SellingPointsTitleDesc"] = "sellingPointsTitle_DESC";
    TouringSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    TouringSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    TouringSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    TouringSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    TouringSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    TouringSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    TouringSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    TouringSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    TouringSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["TitleAsc"] = "title_ASC";
    TouringSearchOptionsLinkingCollectionsFullCampaignCollectionOrder["TitleDesc"] = "title_DESC";
})(TouringSearchOptionsLinkingCollectionsFullCampaignCollectionOrder = exports.TouringSearchOptionsLinkingCollectionsFullCampaignCollectionOrder || (exports.TouringSearchOptionsLinkingCollectionsFullCampaignCollectionOrder = {}));
var TouringSearchOptionsOrder;
(function (TouringSearchOptionsOrder) {
    TouringSearchOptionsOrder["DateAsc"] = "date_ASC";
    TouringSearchOptionsOrder["DateDesc"] = "date_DESC";
    TouringSearchOptionsOrder["NumberOfAdultsAsc"] = "numberOfAdults_ASC";
    TouringSearchOptionsOrder["NumberOfAdultsDesc"] = "numberOfAdults_DESC";
    TouringSearchOptionsOrder["NumberOfChildrenAsc"] = "numberOfChildren_ASC";
    TouringSearchOptionsOrder["NumberOfChildrenDesc"] = "numberOfChildren_DESC";
    TouringSearchOptionsOrder["NumberOfDogsAsc"] = "numberOfDogs_ASC";
    TouringSearchOptionsOrder["NumberOfDogsDesc"] = "numberOfDogs_DESC";
    TouringSearchOptionsOrder["NumberOfInfantsAsc"] = "numberOfInfants_ASC";
    TouringSearchOptionsOrder["NumberOfInfantsDesc"] = "numberOfInfants_DESC";
    TouringSearchOptionsOrder["NumberOfNightsAsc"] = "numberOfNights_ASC";
    TouringSearchOptionsOrder["NumberOfNightsDesc"] = "numberOfNights_DESC";
    TouringSearchOptionsOrder["ParksAsc"] = "parks_ASC";
    TouringSearchOptionsOrder["ParksDesc"] = "parks_DESC";
    TouringSearchOptionsOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    TouringSearchOptionsOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    TouringSearchOptionsOrder["SysIdAsc"] = "sys_id_ASC";
    TouringSearchOptionsOrder["SysIdDesc"] = "sys_id_DESC";
    TouringSearchOptionsOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    TouringSearchOptionsOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    TouringSearchOptionsOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    TouringSearchOptionsOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    TouringSearchOptionsOrder["TitleAsc"] = "title_ASC";
    TouringSearchOptionsOrder["TitleDesc"] = "title_DESC";
    TouringSearchOptionsOrder["TourerLengthAsc"] = "tourerLength_ASC";
    TouringSearchOptionsOrder["TourerLengthDesc"] = "tourerLength_DESC";
    TouringSearchOptionsOrder["TourerTypeAsc"] = "tourerType_ASC";
    TouringSearchOptionsOrder["TourerTypeDesc"] = "tourerType_DESC";
})(TouringSearchOptionsOrder = exports.TouringSearchOptionsOrder || (exports.TouringSearchOptionsOrder = {}));
var UmzugMigrationDataOrder;
(function (UmzugMigrationDataOrder) {
    UmzugMigrationDataOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    UmzugMigrationDataOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    UmzugMigrationDataOrder["SysIdAsc"] = "sys_id_ASC";
    UmzugMigrationDataOrder["SysIdDesc"] = "sys_id_DESC";
    UmzugMigrationDataOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    UmzugMigrationDataOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    UmzugMigrationDataOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    UmzugMigrationDataOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    UmzugMigrationDataOrder["TitleAsc"] = "title_ASC";
    UmzugMigrationDataOrder["TitleDesc"] = "title_DESC";
})(UmzugMigrationDataOrder = exports.UmzugMigrationDataOrder || (exports.UmzugMigrationDataOrder = {}));
var VideoLinkingCollectionsAccommodationGradeCollectionOrder;
(function (VideoLinkingCollectionsAccommodationGradeCollectionOrder) {
    VideoLinkingCollectionsAccommodationGradeCollectionOrder["AccessibleAsc"] = "accessible_ASC";
    VideoLinkingCollectionsAccommodationGradeCollectionOrder["AccessibleDesc"] = "accessible_DESC";
    VideoLinkingCollectionsAccommodationGradeCollectionOrder["IncludesTitleAsc"] = "includesTitle_ASC";
    VideoLinkingCollectionsAccommodationGradeCollectionOrder["IncludesTitleDesc"] = "includesTitle_DESC";
    VideoLinkingCollectionsAccommodationGradeCollectionOrder["NameAsc"] = "name_ASC";
    VideoLinkingCollectionsAccommodationGradeCollectionOrder["NameDesc"] = "name_DESC";
    VideoLinkingCollectionsAccommodationGradeCollectionOrder["SearchAccommodationGradeAsc"] = "searchAccommodationGrade_ASC";
    VideoLinkingCollectionsAccommodationGradeCollectionOrder["SearchAccommodationGradeDesc"] = "searchAccommodationGrade_DESC";
    VideoLinkingCollectionsAccommodationGradeCollectionOrder["SellingPointsTitleAsc"] = "sellingPointsTitle_ASC";
    VideoLinkingCollectionsAccommodationGradeCollectionOrder["SellingPointsTitleDesc"] = "sellingPointsTitle_DESC";
    VideoLinkingCollectionsAccommodationGradeCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    VideoLinkingCollectionsAccommodationGradeCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    VideoLinkingCollectionsAccommodationGradeCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    VideoLinkingCollectionsAccommodationGradeCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    VideoLinkingCollectionsAccommodationGradeCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    VideoLinkingCollectionsAccommodationGradeCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    VideoLinkingCollectionsAccommodationGradeCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    VideoLinkingCollectionsAccommodationGradeCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    VideoLinkingCollectionsAccommodationGradeCollectionOrder["TaglineAsc"] = "tagline_ASC";
    VideoLinkingCollectionsAccommodationGradeCollectionOrder["TaglineDesc"] = "tagline_DESC";
})(VideoLinkingCollectionsAccommodationGradeCollectionOrder = exports.VideoLinkingCollectionsAccommodationGradeCollectionOrder || (exports.VideoLinkingCollectionsAccommodationGradeCollectionOrder = {}));
var VideoLinkingCollectionsArticleSectionCollectionOrder;
(function (VideoLinkingCollectionsArticleSectionCollectionOrder) {
    VideoLinkingCollectionsArticleSectionCollectionOrder["CoordinatesAsc"] = "coordinates_ASC";
    VideoLinkingCollectionsArticleSectionCollectionOrder["CoordinatesDesc"] = "coordinates_DESC";
    VideoLinkingCollectionsArticleSectionCollectionOrder["NameAsc"] = "name_ASC";
    VideoLinkingCollectionsArticleSectionCollectionOrder["NameDesc"] = "name_DESC";
    VideoLinkingCollectionsArticleSectionCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    VideoLinkingCollectionsArticleSectionCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    VideoLinkingCollectionsArticleSectionCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    VideoLinkingCollectionsArticleSectionCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    VideoLinkingCollectionsArticleSectionCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    VideoLinkingCollectionsArticleSectionCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    VideoLinkingCollectionsArticleSectionCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    VideoLinkingCollectionsArticleSectionCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    VideoLinkingCollectionsArticleSectionCollectionOrder["TitleAsc"] = "title_ASC";
    VideoLinkingCollectionsArticleSectionCollectionOrder["TitleDesc"] = "title_DESC";
})(VideoLinkingCollectionsArticleSectionCollectionOrder = exports.VideoLinkingCollectionsArticleSectionCollectionOrder || (exports.VideoLinkingCollectionsArticleSectionCollectionOrder = {}));
var VideoLinkingCollectionsFullCampaignCollectionOrder;
(function (VideoLinkingCollectionsFullCampaignCollectionOrder) {
    VideoLinkingCollectionsFullCampaignCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    VideoLinkingCollectionsFullCampaignCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    VideoLinkingCollectionsFullCampaignCollectionOrder["FeaturedParksTitleAsc"] = "featuredParksTitle_ASC";
    VideoLinkingCollectionsFullCampaignCollectionOrder["FeaturedParksTitleDesc"] = "featuredParksTitle_DESC";
    VideoLinkingCollectionsFullCampaignCollectionOrder["FeaturedPromotionsTitleAsc"] = "featuredPromotionsTitle_ASC";
    VideoLinkingCollectionsFullCampaignCollectionOrder["FeaturedPromotionsTitleDesc"] = "featuredPromotionsTitle_DESC";
    VideoLinkingCollectionsFullCampaignCollectionOrder["IntroductionTitleAsc"] = "introductionTitle_ASC";
    VideoLinkingCollectionsFullCampaignCollectionOrder["IntroductionTitleDesc"] = "introductionTitle_DESC";
    VideoLinkingCollectionsFullCampaignCollectionOrder["NameAsc"] = "name_ASC";
    VideoLinkingCollectionsFullCampaignCollectionOrder["NameDesc"] = "name_DESC";
    VideoLinkingCollectionsFullCampaignCollectionOrder["PathAsc"] = "path_ASC";
    VideoLinkingCollectionsFullCampaignCollectionOrder["PathDesc"] = "path_DESC";
    VideoLinkingCollectionsFullCampaignCollectionOrder["PromotionsTitleAsc"] = "promotionsTitle_ASC";
    VideoLinkingCollectionsFullCampaignCollectionOrder["PromotionsTitleDesc"] = "promotionsTitle_DESC";
    VideoLinkingCollectionsFullCampaignCollectionOrder["ReasonsToBookTitleAsc"] = "reasonsToBookTitle_ASC";
    VideoLinkingCollectionsFullCampaignCollectionOrder["ReasonsToBookTitleDesc"] = "reasonsToBookTitle_DESC";
    VideoLinkingCollectionsFullCampaignCollectionOrder["SellingPointsTitleAsc"] = "sellingPointsTitle_ASC";
    VideoLinkingCollectionsFullCampaignCollectionOrder["SellingPointsTitleDesc"] = "sellingPointsTitle_DESC";
    VideoLinkingCollectionsFullCampaignCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    VideoLinkingCollectionsFullCampaignCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    VideoLinkingCollectionsFullCampaignCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    VideoLinkingCollectionsFullCampaignCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    VideoLinkingCollectionsFullCampaignCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    VideoLinkingCollectionsFullCampaignCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    VideoLinkingCollectionsFullCampaignCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    VideoLinkingCollectionsFullCampaignCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    VideoLinkingCollectionsFullCampaignCollectionOrder["TitleAsc"] = "title_ASC";
    VideoLinkingCollectionsFullCampaignCollectionOrder["TitleDesc"] = "title_DESC";
})(VideoLinkingCollectionsFullCampaignCollectionOrder = exports.VideoLinkingCollectionsFullCampaignCollectionOrder || (exports.VideoLinkingCollectionsFullCampaignCollectionOrder = {}));
var VideoLinkingCollectionsParkCollectionOrder;
(function (VideoLinkingCollectionsParkCollectionOrder) {
    VideoLinkingCollectionsParkCollectionOrder["ContactNumberAsc"] = "contactNumber_ASC";
    VideoLinkingCollectionsParkCollectionOrder["ContactNumberDesc"] = "contactNumber_DESC";
    VideoLinkingCollectionsParkCollectionOrder["DirectionsUrlAsc"] = "directionsUrl_ASC";
    VideoLinkingCollectionsParkCollectionOrder["DirectionsUrlDesc"] = "directionsUrl_DESC";
    VideoLinkingCollectionsParkCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    VideoLinkingCollectionsParkCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    VideoLinkingCollectionsParkCollectionOrder["NameAsc"] = "name_ASC";
    VideoLinkingCollectionsParkCollectionOrder["NameDesc"] = "name_DESC";
    VideoLinkingCollectionsParkCollectionOrder["ParkTypeAsc"] = "parkType_ASC";
    VideoLinkingCollectionsParkCollectionOrder["ParkTypeDesc"] = "parkType_DESC";
    VideoLinkingCollectionsParkCollectionOrder["PathAsc"] = "path_ASC";
    VideoLinkingCollectionsParkCollectionOrder["PathDesc"] = "path_DESC";
    VideoLinkingCollectionsParkCollectionOrder["RunningCostsAsc"] = "runningCosts_ASC";
    VideoLinkingCollectionsParkCollectionOrder["RunningCostsDesc"] = "runningCosts_DESC";
    VideoLinkingCollectionsParkCollectionOrder["SiteFeesAsc"] = "siteFees_ASC";
    VideoLinkingCollectionsParkCollectionOrder["SiteFeesDesc"] = "siteFees_DESC";
    VideoLinkingCollectionsParkCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    VideoLinkingCollectionsParkCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    VideoLinkingCollectionsParkCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    VideoLinkingCollectionsParkCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    VideoLinkingCollectionsParkCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    VideoLinkingCollectionsParkCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    VideoLinkingCollectionsParkCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    VideoLinkingCollectionsParkCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    VideoLinkingCollectionsParkCollectionOrder["TaglineAsc"] = "tagline_ASC";
    VideoLinkingCollectionsParkCollectionOrder["TaglineDesc"] = "tagline_DESC";
    VideoLinkingCollectionsParkCollectionOrder["ThingsToDoTitleAsc"] = "thingsToDoTitle_ASC";
    VideoLinkingCollectionsParkCollectionOrder["ThingsToDoTitleDesc"] = "thingsToDoTitle_DESC";
    VideoLinkingCollectionsParkCollectionOrder["TitleAsc"] = "title_ASC";
    VideoLinkingCollectionsParkCollectionOrder["TitleDesc"] = "title_DESC";
})(VideoLinkingCollectionsParkCollectionOrder = exports.VideoLinkingCollectionsParkCollectionOrder || (exports.VideoLinkingCollectionsParkCollectionOrder = {}));
var VideoLinkingCollectionsParkFeaturesCollectionOrder;
(function (VideoLinkingCollectionsParkFeaturesCollectionOrder) {
    VideoLinkingCollectionsParkFeaturesCollectionOrder["ApiIdAsc"] = "apiId_ASC";
    VideoLinkingCollectionsParkFeaturesCollectionOrder["ApiIdDesc"] = "apiId_DESC";
    VideoLinkingCollectionsParkFeaturesCollectionOrder["DateIntroducedAsc"] = "dateIntroduced_ASC";
    VideoLinkingCollectionsParkFeaturesCollectionOrder["DateIntroducedDesc"] = "dateIntroduced_DESC";
    VideoLinkingCollectionsParkFeaturesCollectionOrder["NameAsc"] = "name_ASC";
    VideoLinkingCollectionsParkFeaturesCollectionOrder["NameDesc"] = "name_DESC";
    VideoLinkingCollectionsParkFeaturesCollectionOrder["PropositionTypeAsc"] = "propositionType_ASC";
    VideoLinkingCollectionsParkFeaturesCollectionOrder["PropositionTypeDesc"] = "propositionType_DESC";
    VideoLinkingCollectionsParkFeaturesCollectionOrder["ShortTitleAsc"] = "shortTitle_ASC";
    VideoLinkingCollectionsParkFeaturesCollectionOrder["ShortTitleDesc"] = "shortTitle_DESC";
    VideoLinkingCollectionsParkFeaturesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    VideoLinkingCollectionsParkFeaturesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    VideoLinkingCollectionsParkFeaturesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    VideoLinkingCollectionsParkFeaturesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    VideoLinkingCollectionsParkFeaturesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    VideoLinkingCollectionsParkFeaturesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    VideoLinkingCollectionsParkFeaturesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    VideoLinkingCollectionsParkFeaturesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    VideoLinkingCollectionsParkFeaturesCollectionOrder["TitleAsc"] = "title_ASC";
    VideoLinkingCollectionsParkFeaturesCollectionOrder["TitleDesc"] = "title_DESC";
    VideoLinkingCollectionsParkFeaturesCollectionOrder["UrlAsc"] = "url_ASC";
    VideoLinkingCollectionsParkFeaturesCollectionOrder["UrlDesc"] = "url_DESC";
})(VideoLinkingCollectionsParkFeaturesCollectionOrder = exports.VideoLinkingCollectionsParkFeaturesCollectionOrder || (exports.VideoLinkingCollectionsParkFeaturesCollectionOrder = {}));
var VideoLinkingCollectionsParkOfferCollectionOrder;
(function (VideoLinkingCollectionsParkOfferCollectionOrder) {
    VideoLinkingCollectionsParkOfferCollectionOrder["AgeFromAsc"] = "ageFrom_ASC";
    VideoLinkingCollectionsParkOfferCollectionOrder["AgeFromDesc"] = "ageFrom_DESC";
    VideoLinkingCollectionsParkOfferCollectionOrder["CtaTitleAsc"] = "ctaTitle_ASC";
    VideoLinkingCollectionsParkOfferCollectionOrder["CtaTitleDesc"] = "ctaTitle_DESC";
    VideoLinkingCollectionsParkOfferCollectionOrder["CtaUrlAsc"] = "ctaUrl_ASC";
    VideoLinkingCollectionsParkOfferCollectionOrder["CtaUrlDesc"] = "ctaUrl_DESC";
    VideoLinkingCollectionsParkOfferCollectionOrder["EndDateAsc"] = "endDate_ASC";
    VideoLinkingCollectionsParkOfferCollectionOrder["EndDateDesc"] = "endDate_DESC";
    VideoLinkingCollectionsParkOfferCollectionOrder["HolidayTypeAsc"] = "holidayType_ASC";
    VideoLinkingCollectionsParkOfferCollectionOrder["HolidayTypeDesc"] = "holidayType_DESC";
    VideoLinkingCollectionsParkOfferCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    VideoLinkingCollectionsParkOfferCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    VideoLinkingCollectionsParkOfferCollectionOrder["PropositionTypeAsc"] = "propositionType_ASC";
    VideoLinkingCollectionsParkOfferCollectionOrder["PropositionTypeDesc"] = "propositionType_DESC";
    VideoLinkingCollectionsParkOfferCollectionOrder["StartDateAsc"] = "startDate_ASC";
    VideoLinkingCollectionsParkOfferCollectionOrder["StartDateDesc"] = "startDate_DESC";
    VideoLinkingCollectionsParkOfferCollectionOrder["SubTitleAsc"] = "subTitle_ASC";
    VideoLinkingCollectionsParkOfferCollectionOrder["SubTitleDesc"] = "subTitle_DESC";
    VideoLinkingCollectionsParkOfferCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    VideoLinkingCollectionsParkOfferCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    VideoLinkingCollectionsParkOfferCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    VideoLinkingCollectionsParkOfferCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    VideoLinkingCollectionsParkOfferCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    VideoLinkingCollectionsParkOfferCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    VideoLinkingCollectionsParkOfferCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    VideoLinkingCollectionsParkOfferCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    VideoLinkingCollectionsParkOfferCollectionOrder["TitleAsc"] = "title_ASC";
    VideoLinkingCollectionsParkOfferCollectionOrder["TitleDesc"] = "title_DESC";
})(VideoLinkingCollectionsParkOfferCollectionOrder = exports.VideoLinkingCollectionsParkOfferCollectionOrder || (exports.VideoLinkingCollectionsParkOfferCollectionOrder = {}));
var VideoLinkingCollectionsPromotionCollectionOrder;
(function (VideoLinkingCollectionsPromotionCollectionOrder) {
    VideoLinkingCollectionsPromotionCollectionOrder["AnalyticsCategoryAsc"] = "analyticsCategory_ASC";
    VideoLinkingCollectionsPromotionCollectionOrder["AnalyticsCategoryDesc"] = "analyticsCategory_DESC";
    VideoLinkingCollectionsPromotionCollectionOrder["AnalyticsTypeAsc"] = "analyticsType_ASC";
    VideoLinkingCollectionsPromotionCollectionOrder["AnalyticsTypeDesc"] = "analyticsType_DESC";
    VideoLinkingCollectionsPromotionCollectionOrder["AnalyticsVariantAsc"] = "analyticsVariant_ASC";
    VideoLinkingCollectionsPromotionCollectionOrder["AnalyticsVariantDesc"] = "analyticsVariant_DESC";
    VideoLinkingCollectionsPromotionCollectionOrder["DurationAsc"] = "duration_ASC";
    VideoLinkingCollectionsPromotionCollectionOrder["DurationDesc"] = "duration_DESC";
    VideoLinkingCollectionsPromotionCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    VideoLinkingCollectionsPromotionCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    VideoLinkingCollectionsPromotionCollectionOrder["MaxPriceAsc"] = "maxPrice_ASC";
    VideoLinkingCollectionsPromotionCollectionOrder["MaxPriceDesc"] = "maxPrice_DESC";
    VideoLinkingCollectionsPromotionCollectionOrder["MinPriceAsc"] = "minPrice_ASC";
    VideoLinkingCollectionsPromotionCollectionOrder["MinPriceDesc"] = "minPrice_DESC";
    VideoLinkingCollectionsPromotionCollectionOrder["PriceAsc"] = "price_ASC";
    VideoLinkingCollectionsPromotionCollectionOrder["PriceDesc"] = "price_DESC";
    VideoLinkingCollectionsPromotionCollectionOrder["SubTitleAsc"] = "subTitle_ASC";
    VideoLinkingCollectionsPromotionCollectionOrder["SubTitleDesc"] = "subTitle_DESC";
    VideoLinkingCollectionsPromotionCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    VideoLinkingCollectionsPromotionCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    VideoLinkingCollectionsPromotionCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    VideoLinkingCollectionsPromotionCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    VideoLinkingCollectionsPromotionCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    VideoLinkingCollectionsPromotionCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    VideoLinkingCollectionsPromotionCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    VideoLinkingCollectionsPromotionCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    VideoLinkingCollectionsPromotionCollectionOrder["TitleAsc"] = "title_ASC";
    VideoLinkingCollectionsPromotionCollectionOrder["TitleDesc"] = "title_DESC";
    VideoLinkingCollectionsPromotionCollectionOrder["UrlAsc"] = "url_ASC";
    VideoLinkingCollectionsPromotionCollectionOrder["UrlDesc"] = "url_DESC";
})(VideoLinkingCollectionsPromotionCollectionOrder = exports.VideoLinkingCollectionsPromotionCollectionOrder || (exports.VideoLinkingCollectionsPromotionCollectionOrder = {}));
var VideoLinkingCollectionsPropositionCategoryCollectionOrder;
(function (VideoLinkingCollectionsPropositionCategoryCollectionOrder) {
    VideoLinkingCollectionsPropositionCategoryCollectionOrder["CtaTitleAsc"] = "ctaTitle_ASC";
    VideoLinkingCollectionsPropositionCategoryCollectionOrder["CtaTitleDesc"] = "ctaTitle_DESC";
    VideoLinkingCollectionsPropositionCategoryCollectionOrder["CtaUrlAsc"] = "ctaUrl_ASC";
    VideoLinkingCollectionsPropositionCategoryCollectionOrder["CtaUrlDesc"] = "ctaUrl_DESC";
    VideoLinkingCollectionsPropositionCategoryCollectionOrder["FeaturedParksTitleAsc"] = "featuredParksTitle_ASC";
    VideoLinkingCollectionsPropositionCategoryCollectionOrder["FeaturedParksTitleDesc"] = "featuredParksTitle_DESC";
    VideoLinkingCollectionsPropositionCategoryCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    VideoLinkingCollectionsPropositionCategoryCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    VideoLinkingCollectionsPropositionCategoryCollectionOrder["NameAsc"] = "name_ASC";
    VideoLinkingCollectionsPropositionCategoryCollectionOrder["NameDesc"] = "name_DESC";
    VideoLinkingCollectionsPropositionCategoryCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    VideoLinkingCollectionsPropositionCategoryCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    VideoLinkingCollectionsPropositionCategoryCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    VideoLinkingCollectionsPropositionCategoryCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    VideoLinkingCollectionsPropositionCategoryCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    VideoLinkingCollectionsPropositionCategoryCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    VideoLinkingCollectionsPropositionCategoryCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    VideoLinkingCollectionsPropositionCategoryCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(VideoLinkingCollectionsPropositionCategoryCollectionOrder = exports.VideoLinkingCollectionsPropositionCategoryCollectionOrder || (exports.VideoLinkingCollectionsPropositionCategoryCollectionOrder = {}));
var VideoLinkingCollectionsPropositionCollectionOrder;
(function (VideoLinkingCollectionsPropositionCollectionOrder) {
    VideoLinkingCollectionsPropositionCollectionOrder["FaqFolderIdAsc"] = "faqFolderId_ASC";
    VideoLinkingCollectionsPropositionCollectionOrder["FaqFolderIdDesc"] = "faqFolderId_DESC";
    VideoLinkingCollectionsPropositionCollectionOrder["FaqsTitleAsc"] = "faqsTitle_ASC";
    VideoLinkingCollectionsPropositionCollectionOrder["FaqsTitleDesc"] = "faqsTitle_DESC";
    VideoLinkingCollectionsPropositionCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    VideoLinkingCollectionsPropositionCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    VideoLinkingCollectionsPropositionCollectionOrder["NameAsc"] = "name_ASC";
    VideoLinkingCollectionsPropositionCollectionOrder["NameDesc"] = "name_DESC";
    VideoLinkingCollectionsPropositionCollectionOrder["PathAsc"] = "path_ASC";
    VideoLinkingCollectionsPropositionCollectionOrder["PathDesc"] = "path_DESC";
    VideoLinkingCollectionsPropositionCollectionOrder["RelatedArticlesTitleAsc"] = "relatedArticlesTitle_ASC";
    VideoLinkingCollectionsPropositionCollectionOrder["RelatedArticlesTitleDesc"] = "relatedArticlesTitle_DESC";
    VideoLinkingCollectionsPropositionCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    VideoLinkingCollectionsPropositionCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    VideoLinkingCollectionsPropositionCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    VideoLinkingCollectionsPropositionCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    VideoLinkingCollectionsPropositionCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    VideoLinkingCollectionsPropositionCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    VideoLinkingCollectionsPropositionCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    VideoLinkingCollectionsPropositionCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    VideoLinkingCollectionsPropositionCollectionOrder["TagLineAsc"] = "tagLine_ASC";
    VideoLinkingCollectionsPropositionCollectionOrder["TagLineDesc"] = "tagLine_DESC";
    VideoLinkingCollectionsPropositionCollectionOrder["TitleAsc"] = "title_ASC";
    VideoLinkingCollectionsPropositionCollectionOrder["TitleDesc"] = "title_DESC";
})(VideoLinkingCollectionsPropositionCollectionOrder = exports.VideoLinkingCollectionsPropositionCollectionOrder || (exports.VideoLinkingCollectionsPropositionCollectionOrder = {}));
var VideoLinkingCollectionsSectionCollectionOrder;
(function (VideoLinkingCollectionsSectionCollectionOrder) {
    VideoLinkingCollectionsSectionCollectionOrder["NameAsc"] = "name_ASC";
    VideoLinkingCollectionsSectionCollectionOrder["NameDesc"] = "name_DESC";
    VideoLinkingCollectionsSectionCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    VideoLinkingCollectionsSectionCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    VideoLinkingCollectionsSectionCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    VideoLinkingCollectionsSectionCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    VideoLinkingCollectionsSectionCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    VideoLinkingCollectionsSectionCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    VideoLinkingCollectionsSectionCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    VideoLinkingCollectionsSectionCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    VideoLinkingCollectionsSectionCollectionOrder["TitleAsc"] = "title_ASC";
    VideoLinkingCollectionsSectionCollectionOrder["TitleDesc"] = "title_DESC";
})(VideoLinkingCollectionsSectionCollectionOrder = exports.VideoLinkingCollectionsSectionCollectionOrder || (exports.VideoLinkingCollectionsSectionCollectionOrder = {}));
var VideoOrder;
(function (VideoOrder) {
    VideoOrder["EmbeddedUrlAsc"] = "embeddedUrl_ASC";
    VideoOrder["EmbeddedUrlDesc"] = "embeddedUrl_DESC";
    VideoOrder["NameAsc"] = "name_ASC";
    VideoOrder["NameDesc"] = "name_DESC";
    VideoOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    VideoOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    VideoOrder["SysIdAsc"] = "sys_id_ASC";
    VideoOrder["SysIdDesc"] = "sys_id_DESC";
    VideoOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    VideoOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    VideoOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    VideoOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    VideoOrder["TitleAsc"] = "title_ASC";
    VideoOrder["TitleDesc"] = "title_DESC";
})(VideoOrder = exports.VideoOrder || (exports.VideoOrder = {}));
var VirtualTourLinkingCollectionsParkFeaturesCollectionOrder;
(function (VirtualTourLinkingCollectionsParkFeaturesCollectionOrder) {
    VirtualTourLinkingCollectionsParkFeaturesCollectionOrder["ApiIdAsc"] = "apiId_ASC";
    VirtualTourLinkingCollectionsParkFeaturesCollectionOrder["ApiIdDesc"] = "apiId_DESC";
    VirtualTourLinkingCollectionsParkFeaturesCollectionOrder["DateIntroducedAsc"] = "dateIntroduced_ASC";
    VirtualTourLinkingCollectionsParkFeaturesCollectionOrder["DateIntroducedDesc"] = "dateIntroduced_DESC";
    VirtualTourLinkingCollectionsParkFeaturesCollectionOrder["NameAsc"] = "name_ASC";
    VirtualTourLinkingCollectionsParkFeaturesCollectionOrder["NameDesc"] = "name_DESC";
    VirtualTourLinkingCollectionsParkFeaturesCollectionOrder["PropositionTypeAsc"] = "propositionType_ASC";
    VirtualTourLinkingCollectionsParkFeaturesCollectionOrder["PropositionTypeDesc"] = "propositionType_DESC";
    VirtualTourLinkingCollectionsParkFeaturesCollectionOrder["ShortTitleAsc"] = "shortTitle_ASC";
    VirtualTourLinkingCollectionsParkFeaturesCollectionOrder["ShortTitleDesc"] = "shortTitle_DESC";
    VirtualTourLinkingCollectionsParkFeaturesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    VirtualTourLinkingCollectionsParkFeaturesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    VirtualTourLinkingCollectionsParkFeaturesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    VirtualTourLinkingCollectionsParkFeaturesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    VirtualTourLinkingCollectionsParkFeaturesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    VirtualTourLinkingCollectionsParkFeaturesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    VirtualTourLinkingCollectionsParkFeaturesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    VirtualTourLinkingCollectionsParkFeaturesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    VirtualTourLinkingCollectionsParkFeaturesCollectionOrder["TitleAsc"] = "title_ASC";
    VirtualTourLinkingCollectionsParkFeaturesCollectionOrder["TitleDesc"] = "title_DESC";
    VirtualTourLinkingCollectionsParkFeaturesCollectionOrder["UrlAsc"] = "url_ASC";
    VirtualTourLinkingCollectionsParkFeaturesCollectionOrder["UrlDesc"] = "url_DESC";
})(VirtualTourLinkingCollectionsParkFeaturesCollectionOrder = exports.VirtualTourLinkingCollectionsParkFeaturesCollectionOrder || (exports.VirtualTourLinkingCollectionsParkFeaturesCollectionOrder = {}));
var VirtualTourOrder;
(function (VirtualTourOrder) {
    VirtualTourOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    VirtualTourOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    VirtualTourOrder["SysIdAsc"] = "sys_id_ASC";
    VirtualTourOrder["SysIdDesc"] = "sys_id_DESC";
    VirtualTourOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    VirtualTourOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    VirtualTourOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    VirtualTourOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    VirtualTourOrder["TitleAsc"] = "title_ASC";
    VirtualTourOrder["TitleDesc"] = "title_DESC";
    VirtualTourOrder["UrlAsc"] = "url_ASC";
    VirtualTourOrder["UrlDesc"] = "url_DESC";
})(VirtualTourOrder = exports.VirtualTourOrder || (exports.VirtualTourOrder = {}));
exports.SysFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment SysFields on Sys {
  id
  firstPublishedAt
  publishedAt
}
    `;
exports.ImageFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment ImageFields on Image {
  image {
    url
    height
    width
  }
  captionOptional
  contentfulMetadata {
    tags {
      id
    }
  }
  altText
  focusArea
  subHeading
  sys {
    id
    spaceId
    environmentId
  }
}
    `;
exports.LinkFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment LinkFields on Link {
  entryName
  name
  description
  url
  openNewWindow
}
    `;
exports.NotificationFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment NotificationFields on Notification {
  name
  enabled
  dismissible
  title
  message
  link {
    ...LinkFields
  }
  type
  showInfoIcon
}
    ${exports.LinkFieldsFragmentDoc}`;
exports.SafetyMeasureFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment SafetyMeasureFields on SafetyMeasure {
  name
  title
  path
  icon {
    ...ImageFields
  }
}
    ${exports.ImageFieldsFragmentDoc}`;
exports.SellingPointFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment SellingPointFields on SellingPoint {
  sys {
    ...SysFields
  }
  icon {
    ...ImageFields
  }
  title
  description {
    json
  }
  url
}
    ${exports.SysFieldsFragmentDoc}
${exports.ImageFieldsFragmentDoc}`;
exports.PageMetadataAllFragmentDoc = (0, graphql_tag_1.default) `
    fragment PageMetadataAll on PageMetadata {
  name
  title
  author
  description
  ogTitle
  ogType
  ogUrl
  ogImage
  ogLocale
  ogDescription
  ogSiteName
  canonical
  disableRobots
  disableSitemap
  googleAnalyticsPageName
  googleAnalyticsPageType
  googleAnalyticsPageSubType
}
    `;
exports.VideoFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment VideoFields on Video {
  sys {
    ...SysFields
  }
  name
  title
  description {
    json
  }
  media {
    title
    description
    url
    width
    height
  }
  posterImage {
    ...ImageFields
  }
  embeddedUrl
}
    ${exports.SysFieldsFragmentDoc}
${exports.ImageFieldsFragmentDoc}`;
exports.AccommodationGradeWithParksFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment AccommodationGradeWithParksFields on AccommodationGrade {
  sys {
    ...SysFields
  }
  name
  tagline
  searchAccommodationGrade
  imagesCollection(limit: 15) {
    items {
      ...ImageFields
    }
  }
  videosCollection(limit: 15) {
    items {
      ...VideoFields
    }
  }
  overview {
    json
  }
  numberOfBedrooms
  accessible
  spacesCollection(limit: 15) {
    items {
      ...SellingPointFields
    }
  }
  sellingPointsTitle
  sellingPoints
  includesTitle
  includes
  linkedFrom {
    parkCollection(order: sys_publishedAt_DESC, limit: 50) {
      items {
        name
        path
      }
    }
  }
}
    ${exports.SysFieldsFragmentDoc}
${exports.ImageFieldsFragmentDoc}
${exports.VideoFieldsFragmentDoc}
${exports.SellingPointFieldsFragmentDoc}`;
exports.AccommodationTypeWithParkFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment AccommodationTypeWithParkFields on AccommodationType {
  sys {
    ...SysFields
  }
  name
  searchAccommodationName
  path
  title
  heroImage {
    ...ImageFields
  }
  summary {
    json
  }
  overview {
    json
  }
  notificationBanner {
    ...NotificationFields
  }
  notification {
    ...NotificationFields
  }
  safetyMeasuresCollection(limit: 20) {
    items {
      ...SafetyMeasureFields
    }
  }
  checklistTitle
  checklistCollection(limit: 20) {
    items {
      ...SellingPointFields
    }
  }
  pageMetadata {
    ...PageMetadataAll
  }
  accommodationGradesCollection(limit: 15) {
    items {
      ...AccommodationGradeWithParksFields
    }
  }
}
    ${exports.SysFieldsFragmentDoc}
${exports.ImageFieldsFragmentDoc}
${exports.NotificationFieldsFragmentDoc}
${exports.SafetyMeasureFieldsFragmentDoc}
${exports.SellingPointFieldsFragmentDoc}
${exports.PageMetadataAllFragmentDoc}
${exports.AccommodationGradeWithParksFieldsFragmentDoc}`;
exports.AccommodationGradeFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment AccommodationGradeFields on AccommodationGrade {
  sys {
    ...SysFields
  }
  name
  tagline
  searchAccommodationGrade
  imagesCollection(limit: 10) {
    items {
      ...ImageFields
    }
  }
  videosCollection(limit: 4) {
    items {
      ...VideoFields
    }
  }
  overview {
    json
  }
  numberOfBedrooms
  accessible
  spacesCollection(limit: 13) {
    items {
      ...SellingPointFields
    }
  }
  sellingPointsTitle
  sellingPoints
  includesTitle
  includes
}
    ${exports.SysFieldsFragmentDoc}
${exports.ImageFieldsFragmentDoc}
${exports.VideoFieldsFragmentDoc}
${exports.SellingPointFieldsFragmentDoc}`;
exports.AccommodationTypeFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment AccommodationTypeFields on AccommodationType {
  sys {
    ...SysFields
  }
  name
  searchAccommodationName
  path
  title
  heroImage {
    ...ImageFields
  }
  summary {
    json
  }
  overview {
    json
  }
  notificationBanner {
    ...NotificationFields
  }
  notification {
    ...NotificationFields
  }
  safetyMeasuresCollection(limit: 2) {
    items {
      ...SafetyMeasureFields
    }
  }
  checklistTitle
  checklistCollection(limit: 10) {
    items {
      ...SellingPointFields
    }
  }
  pageMetadata {
    ...PageMetadataAll
  }
  accommodationGradesCollection(limit: 8) {
    items {
      ...AccommodationGradeFields
    }
  }
}
    ${exports.SysFieldsFragmentDoc}
${exports.ImageFieldsFragmentDoc}
${exports.NotificationFieldsFragmentDoc}
${exports.SafetyMeasureFieldsFragmentDoc}
${exports.SellingPointFieldsFragmentDoc}
${exports.PageMetadataAllFragmentDoc}
${exports.AccommodationGradeFieldsFragmentDoc}`;
exports.AllParkPageFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment AllParkPageFields on AllParkPage {
  sys {
    ...SysFields
  }
  path
  name
  notificationBanner {
    ...NotificationFields
  }
  notification {
    ...NotificationFields
  }
  typeOfParkPage
  title
  description {
    json
  }
  pageMetadata {
    ...PageMetadataAll
  }
}
    ${exports.SysFieldsFragmentDoc}
${exports.NotificationFieldsFragmentDoc}
${exports.PageMetadataAllFragmentDoc}`;
exports.ArticleSectionPromoLinkFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment ArticleSectionPromoLinkFields on ArticleSectionPromoLinksItem {
  ... on PromoLink {
    __typename
    name
    image {
      ...ImageFields
    }
    readMore
    link {
      url
    }
  }
  ... on FullCampaign {
    __typename
    title
    path
    hero {
      ...ImageFields
    }
  }
  ... on Park {
    parkInformation {
      latlng
      regionName
    }
    __typename
    title
    path
    hero {
      ...ImageFields
    }
  }
  ... on Region {
    __typename
    title
    path
    hero {
      ...ImageFields
    }
  }
}
    ${exports.ImageFieldsFragmentDoc}`;
exports.ArticlesSectionFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment ArticlesSectionFields on ArticleSection {
  name
  title
  body {
    json
  }
  media {
    __typename
    ... on Image {
      ...ImageFields
    }
    ... on Video {
      ...VideoFields
    }
  }
  coordinates
  promoLinksCollection(limit: 3) {
    items {
      ...ArticleSectionPromoLinkFields
    }
  }
}
    ${exports.ImageFieldsFragmentDoc}
${exports.VideoFieldsFragmentDoc}
${exports.ArticleSectionPromoLinkFieldsFragmentDoc}`;
exports.ArticlesDescriptionFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment ArticlesDescriptionFields on ArticlesDescription {
  json
}
    `;
exports.TermFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment TermFields on Terms {
  sys {
    ...SysFields
  }
  name
  term {
    json
  }
}
    ${exports.SysFieldsFragmentDoc}`;
exports.ArticleFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment ArticleFields on Articles {
  __typename
  sys {
    ...SysFields
  }
  notification {
    ...NotificationFields
  }
  notificationBanner {
    ...NotificationFields
  }
  relatedArticlesTitle
  articleSummary
  title
  author
  relatedArticleIds
  path
  articleSectionsCollection(limit: 30) {
    items {
      ... on ArticleSection {
        ...ArticlesSectionFields
      }
    }
  }
  showTableOfContents
  holidayType
  description {
    ...ArticlesDescriptionFields
  }
  hero {
    ...ImageFields
  }
  relatedParks
  termsAndConditionsCollection(limit: 20) {
    items {
      ...TermFields
    }
  }
  pageMetadata {
    ...PageMetadataAll
  }
}
    ${exports.SysFieldsFragmentDoc}
${exports.NotificationFieldsFragmentDoc}
${exports.ArticlesSectionFieldsFragmentDoc}
${exports.ArticlesDescriptionFieldsFragmentDoc}
${exports.ImageFieldsFragmentDoc}
${exports.TermFieldsFragmentDoc}
${exports.PageMetadataAllFragmentDoc}`;
exports.ArticleSummaryFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment ArticleSummaryFields on Articles {
  sys {
    ...SysFields
  }
  title
  path
  articleSummary
  description {
    json
  }
  hero {
    ...ImageFields
  }
}
    ${exports.SysFieldsFragmentDoc}
${exports.ImageFieldsFragmentDoc}`;
exports.ArticleHubSectionFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment ArticleHubSectionFields on ArticleHubSection {
  path
  title
  articlesCollection(limit: 35) {
    items {
      ...ArticleSummaryFields
    }
  }
  sys {
    ...SysFields
  }
  contentfulMetadata {
    tags {
      id
      name
    }
  }
}
    ${exports.ArticleSummaryFieldsFragmentDoc}
${exports.SysFieldsFragmentDoc}`;
exports.ArticleHubFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment ArticleHubFields on ArticleHub {
  sys {
    ...SysFields
  }
  path
  title
  description
  pageMetadata {
    ...PageMetadataAll
  }
  featuredArticle {
    ...ArticleSummaryFields
  }
  articleHubSectionsCollection(limit: 30) {
    items {
      ...ArticleHubSectionFields
    }
  }
}
    ${exports.SysFieldsFragmentDoc}
${exports.PageMetadataAllFragmentDoc}
${exports.ArticleSummaryFieldsFragmentDoc}
${exports.ArticleHubSectionFieldsFragmentDoc}`;
exports.CaravanTypesFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment CaravanTypesFields on CaravanTypes {
  name
  title
  subTitle
  caravanCode
  caravanCodes
  caravanImagesCollection(limit: 33) {
    items {
      ...ImageFields
    }
  }
  caravanFeaturesCollection(limit: 30) {
    items {
      title
      image {
        image {
          url
        }
      }
    }
  }
  caravansByParkCollection(limit: 25) {
    items {
      parkInformation {
        parkCode
      }
      sys {
        id
      }
    }
  }
  floorPlan {
    ...ImageFields
  }
  matterportId
  accommodationGrade {
    ...AccommodationGradeFields
  }
}
    ${exports.ImageFieldsFragmentDoc}
${exports.AccommodationGradeFieldsFragmentDoc}`;
exports.ParkInformationFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment ParkInformationFields on ParkInformation {
  latlng
  parkName
  parkCode
  regionName
  regionCode
  subRegion
  activitiesUrl
  addressParkName
  streetAddress
  suburb
  town
  county
  postcode
  country
  ukMapImage {
    ...ImageFields
  }
  sys {
    id
  }
}
    ${exports.ImageFieldsFragmentDoc}`;
exports.CaravanTypeByParkFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment CaravanTypeByParkFields on CaravanTypeByPark {
  contentfulName
  displayName
  title
  subTitle
  parkInformation {
    ...ParkInformationFields
  }
  caravanImagesCollection(limit: 25) {
    items {
      ...ImageFields
    }
  }
  caravanFeaturesCollection(limit: 35) {
    items {
      title
      image {
        image {
          url
        }
      }
    }
  }
  floorPlan {
    ...ImageFields
  }
  matterportId
  sys {
    id
  }
}
    ${exports.ParkInformationFieldsFragmentDoc}
${exports.ImageFieldsFragmentDoc}`;
exports.ExtraBundleFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment ExtraBundleFields on ExtraBundle {
  extraId
  invoiceId
  title
  shortDescription
  longDescription {
    json
  }
  priceDescription
  rank
  selectType
  maxQuantity
  conditionalQuantity
  invoiceOnly
  allowUserModify
}
    `;
exports.ExtraFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment ExtraFields on Extra {
  extraId
  invoiceId
  priceDescription
  shortDescription
  rank
  selectType
  maxQuantity
  conditionalQuantity
  invoiceOnly
  allowUserModify
}
    `;
exports.ParkOfferFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment ParkOfferFields on ParkOffer {
  title
  subTitle
  sys {
    id
  }
  description {
    json
  }
  startDate
  endDate
  dayRange
  imagesCollection(limit: 20) {
    items {
      ...ImageFields
    }
  }
  video {
    ...VideoFields
  }
  propositionType
  parkCodes
  holidayType
  ageFrom
  ctaTitle
  ctaUrl
  terms {
    ...TermFields
  }
  contentfulMetadata {
    tags {
      id
      name
    }
  }
}
    ${exports.ImageFieldsFragmentDoc}
${exports.VideoFieldsFragmentDoc}
${exports.TermFieldsFragmentDoc}`;
exports.ParkSummaryFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment ParkSummaryFields on Park {
  sys {
    id
  }
  title
  tagline
  name
  path
  parkType
  offersCollection(limit: 1) {
    items {
      ...ParkOfferFields
    }
  }
  hero {
    ...ImageFields
  }
  parkSummary {
    json
  }
  region {
    path
  }
  parkInformation {
    ...ParkInformationFields
  }
  parkFeaturesCollection(limit: 4) {
    items {
      sys {
        id
      }
      title
      shortTitle
      imagesCollection(limit: 1) {
        items {
          ...ImageFields
        }
      }
      propositionType
    }
  }
  videoHero {
    ...VideoFields
  }
  contentfulMetadata {
    tags {
      id
      name
    }
  }
}
    ${exports.ParkOfferFieldsFragmentDoc}
${exports.ImageFieldsFragmentDoc}
${exports.ParkInformationFieldsFragmentDoc}
${exports.VideoFieldsFragmentDoc}`;
exports.FocusParkListFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment FocusParkListFields on FocusParkList {
  title
  parksCollection {
    items {
      ...ParkSummaryFields
    }
  }
  parkType
}
    ${exports.ParkSummaryFieldsFragmentDoc}`;
exports.HolidaySearchParamsFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment HolidaySearchParamsFields on HolidaySearchParameters {
  title
  startDate
  endDate
  periods
  holidayType
  dogFriendly
  accessibleVans
  parkCodes
  accommodation
  durations
}
    `;
exports.TouringSearchOptionsFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment TouringSearchOptionsFields on TouringSearchOptions {
  title
  parks
  tourerType
  tourerLength
  date
  numberOfNights
  numberOfAdults
  numberOfChildren
  numberOfInfants
  numberOfDogs
}
    `;
exports.OwnershipSearchOptionsFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment OwnershipSearchOptionsFields on OwnershipSearchOptions {
  title
  parks
  priceRange
  numberOfBedrooms
}
    `;
exports.PromotionFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment PromotionFields on Promotion {
  sys {
    ...SysFields
  }
  url
  title
  subTitle
  minPrice
  maxPrice
  duration
  description {
    json
  }
  imagesCollection(limit: 1) {
    items {
      ...ImageFields
    }
  }
  video {
    ...VideoFields
  }
  termsAndConditionsCollection {
    items {
      ...TermFields
    }
  }
  contentfulMetadata {
    tags {
      id
      name
    }
  }
  analyticsCategory
  analyticsType
  analyticsVariant
  searchParameters {
    ...HolidaySearchParamsFields
  }
}
    ${exports.SysFieldsFragmentDoc}
${exports.ImageFieldsFragmentDoc}
${exports.VideoFieldsFragmentDoc}
${exports.TermFieldsFragmentDoc}
${exports.HolidaySearchParamsFieldsFragmentDoc}`;
exports.AdvertFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment AdvertFields on Advert {
  title
  subTitle
  description
  image {
    ...ImageFields
  }
  url
  cta
  contentfulMetadata {
    tags {
      id
      name
    }
  }
  analyticsCategory
  analyticsVariant
  analyticsType
}
    ${exports.ImageFieldsFragmentDoc}`;
exports.TestimonialsFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment TestimonialsFields on Testimonial {
  quote {
    json
  }
  author
  holidayType
  role
  image {
    ...ImageFields
  }
  parkInformation {
    parkName
    regionName
    linkedFrom {
      parkCollection(limit: 3) {
        items {
          path
          parkType
        }
      }
    }
  }
}
    ${exports.ImageFieldsFragmentDoc}`;
exports.PropositionCategoryFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment PropositionCategoryFields on PropositionCategory {
  internalName
  name
  imagesCollection(limit: 20) {
    items {
      ...ImageFields
    }
  }
  videosCollection(limit: 6) {
    items {
      ...VideoFields
    }
  }
  description {
    json
  }
  ctaTitle
  ctaUrl
  highlights
  exampleImagesCollection(limit: 15) {
    items {
      ...ImageFields
    }
  }
  featuredParksTitle
  featuredParkPaths
  advertsCollection(limit: 5) {
    items {
      ...AdvertFields
    }
  }
  testimonialsCollection(limit: 5) {
    items {
      ...TestimonialsFields
    }
  }
  termsAndConditionsCollection(limit: 5) {
    items {
      ...TermFields
    }
  }
  contentfulMetadata {
    tags {
      id
      name
    }
  }
}
    ${exports.ImageFieldsFragmentDoc}
${exports.VideoFieldsFragmentDoc}
${exports.AdvertFieldsFragmentDoc}
${exports.TestimonialsFieldsFragmentDoc}
${exports.TermFieldsFragmentDoc}`;
exports.FaqFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment FaqFields on Faq {
  question
  answer {
    json
  }
}
    `;
exports.FullCampaignFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment FullCampaignFields on FullCampaign {
  name
  path
  notificationBanner {
    ...NotificationFields
  }
  notification {
    ...NotificationFields
  }
  holidayTypes
  title
  hero {
    ...ImageFields
  }
  videoHero {
    ...VideoFields
  }
  heroIcon {
    ...ImageFields
  }
  holidaySearchParams {
    ...HolidaySearchParamsFields
  }
  touringSearchOptions {
    ...TouringSearchOptionsFields
  }
  ownershipSearchOptions {
    ...OwnershipSearchOptionsFields
  }
  featuredPromotionsTitle
  featuredPromotionsCollection(limit: 20) {
    items {
      ...PromotionFields
    }
  }
  promotionsTitle
  promotionsCollection(limit: 30) {
    items {
      ...PromotionFields
    }
  }
  parkOffersCollection(limit: 20) {
    items {
      ...ParkOfferFields
    }
  }
  featuredParksTitle
  featuredParks {
    ...HolidaySearchParamsFields
  }
  introductionTitle
  introduction {
    json
  }
  sellingPointsTitle
  sellingPointsCollection(limit: 25) {
    items {
      ...SellingPointFields
    }
  }
  reasonsToBookTitle
  reasonsToBookCollection(limit: 25) {
    items {
      ...SellingPointFields
    }
  }
  propositionsCollection(limit: 18) {
    items {
      ...PropositionCategoryFields
    }
  }
  relatedArticleIds
  faqsTitle
  faqsCollection(limit: 25) {
    items {
      ...FaqFields
    }
  }
  faqsTags
  advertsCollection(limit: 5) {
    items {
      ...AdvertFields
    }
  }
  termsAndConditionsCollection(limit: 15) {
    items {
      ...TermFields
    }
  }
  pageMetadata {
    ...PageMetadataAll
  }
  sys {
    ...SysFields
  }
  contentfulMetadata {
    tags {
      id
      name
    }
  }
}
    ${exports.NotificationFieldsFragmentDoc}
${exports.ImageFieldsFragmentDoc}
${exports.VideoFieldsFragmentDoc}
${exports.HolidaySearchParamsFieldsFragmentDoc}
${exports.TouringSearchOptionsFieldsFragmentDoc}
${exports.OwnershipSearchOptionsFieldsFragmentDoc}
${exports.PromotionFieldsFragmentDoc}
${exports.ParkOfferFieldsFragmentDoc}
${exports.SellingPointFieldsFragmentDoc}
${exports.PropositionCategoryFieldsFragmentDoc}
${exports.FaqFieldsFragmentDoc}
${exports.AdvertFieldsFragmentDoc}
${exports.TermFieldsFragmentDoc}
${exports.PageMetadataAllFragmentDoc}
${exports.SysFieldsFragmentDoc}`;
exports.SectionFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment SectionFields on Section {
  name
  title
  body {
    json
  }
  media {
    __typename
    ... on Image {
      ...ImageFields
    }
    ... on Video {
      ...VideoFields
    }
  }
}
    ${exports.ImageFieldsFragmentDoc}
${exports.VideoFieldsFragmentDoc}`;
exports.GenericTemplateFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment GenericTemplateFields on GenericTemplate {
  sys {
    ...SysFields
  }
  path
  name
  title
  hero {
    ...ImageFields
  }
  description {
    json
  }
  sectionsCollection {
    items {
      ...SectionFields
    }
  }
  showTableOfContents
  safetyMeasuresCollection {
    items {
      ...SafetyMeasureFields
    }
  }
  pageMetadata {
    ...PageMetadataAll
  }
}
    ${exports.SysFieldsFragmentDoc}
${exports.ImageFieldsFragmentDoc}
${exports.SectionFieldsFragmentDoc}
${exports.SafetyMeasureFieldsFragmentDoc}
${exports.PageMetadataAllFragmentDoc}`;
exports.HavenPromiseFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment HavenPromiseFields on HavenPromise {
  title
  image {
    ...ImageFields
  }
  description
}
    ${exports.ImageFieldsFragmentDoc}`;
exports.HolidaySelectionPageSummaryFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment HolidaySelectionPageSummaryFields on HolidaySelectionPage {
  name
  path
  title
  thumbnail {
    ...ImageFields
  }
}
    ${exports.ImageFieldsFragmentDoc}`;
exports.HolidayPackageFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment HolidayPackageFields on HolidayPackage {
  title
  description
  image {
    ...ImageFields
  }
  sellingPointsTitle
  sellingPointsCollection {
    items {
      ...SellingPointFields
    }
  }
  featuresTitle
  featuresCollection(limit: 50) {
    items {
      ...SellingPointFields
    }
  }
}
    ${exports.ImageFieldsFragmentDoc}
${exports.SellingPointFieldsFragmentDoc}`;
exports.HolidaySelectionPageFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment HolidaySelectionPageFields on HolidaySelectionPage {
  name
  path
  title
  description
  holidayPackagesCollection(limit: 8) {
    items {
      ...HolidayPackageFields
    }
  }
  hero {
    ...ImageFields
  }
  thumbnail {
    ...ImageFields
  }
  pageMetadata {
    ...PageMetadataAll
  }
  sys {
    ...SysFields
  }
}
    ${exports.HolidayPackageFieldsFragmentDoc}
${exports.ImageFieldsFragmentDoc}
${exports.PageMetadataAllFragmentDoc}
${exports.SysFieldsFragmentDoc}`;
exports.PromotionFieldsWithMultipleImagesFragmentDoc = (0, graphql_tag_1.default) `
    fragment PromotionFieldsWithMultipleImages on Promotion {
  sys {
    ...SysFields
  }
  url
  title
  subTitle
  minPrice
  maxPrice
  duration
  description {
    json
  }
  imagesCollection(limit: 20) {
    items {
      ...ImageFields
    }
  }
  video {
    ...VideoFields
  }
  termsAndConditionsCollection {
    items {
      ...TermFields
    }
  }
  contentfulMetadata {
    tags {
      id
      name
    }
  }
  analyticsCategory
  analyticsType
  analyticsVariant
  searchParameters {
    ...HolidaySearchParamsFields
  }
}
    ${exports.SysFieldsFragmentDoc}
${exports.ImageFieldsFragmentDoc}
${exports.VideoFieldsFragmentDoc}
${exports.TermFieldsFragmentDoc}
${exports.HolidaySearchParamsFieldsFragmentDoc}`;
exports.HomepageFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment HomepageFields on HomePage {
  sys {
    ...SysFields
  }
  name
  notificationBanner {
    ...NotificationFields
  }
  notification {
    ...NotificationFields
  }
  path
  defaultHolidayNumberOfNights
  promotionsCollection(limit: 20) {
    items {
      ...PromotionFieldsWithMultipleImages
    }
  }
  parkOffersCollection(limit: 4) {
    items {
      ...ParkOfferFields
    }
  }
  commercialSellingPointsCollection(limit: 20) {
    items {
      ...PromotionFieldsWithMultipleImages
    }
  }
  specialOffer {
    ...PromotionFieldsWithMultipleImages
  }
  advertsCollection(limit: 5) {
    items {
      ...AdvertFields
    }
  }
  testimonialsCollection(limit: 10) {
    items {
      ...TestimonialsFields
    }
  }
  termsCollection {
    items {
      ...TermFields
    }
  }
  pageMetadata {
    ...PageMetadataAll
  }
  faqIds
  summary {
    json
  }
  summaryTitle
}
    ${exports.SysFieldsFragmentDoc}
${exports.NotificationFieldsFragmentDoc}
${exports.PromotionFieldsWithMultipleImagesFragmentDoc}
${exports.ParkOfferFieldsFragmentDoc}
${exports.AdvertFieldsFragmentDoc}
${exports.TestimonialsFieldsFragmentDoc}
${exports.TermFieldsFragmentDoc}
${exports.PageMetadataAllFragmentDoc}`;
exports.ParkSeasonsFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment ParkSeasonsFields on Park {
  parkInformation {
    ...ParkInformationFields
  }
  seasons
}
    ${exports.ParkInformationFieldsFragmentDoc}`;
exports.ParkFeatureSummaryFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment ParkFeatureSummaryFields on ParkFeatures {
  name
  title
  shortTitle
  description
  icon {
    ...ImageFields
  }
  dateIntroduced
  imagesCollection(limit: 10) {
    items {
      ...ImageFields
    }
  }
  propositionType
  url
  contentfulMetadata {
    tags {
      id
    }
  }
  sys {
    id
    environmentId
    spaceId
  }
}
    ${exports.ImageFieldsFragmentDoc}`;
exports.ParkFeatureSummaryWithParkFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment ParkFeatureSummaryWithParkFields on ParkFeatures {
  ...ParkFeatureSummaryFields
  linkedFrom {
    parkCollection(limit: 15) {
      items {
        path
        parkInformation {
          parkName
        }
      }
    }
  }
}
    ${exports.ParkFeatureSummaryFieldsFragmentDoc}`;
exports.RegionFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment RegionFields on Region {
  sys {
    ...SysFields
  }
  name
  path
  title
  description {
    json
  }
  sellingPointsCollection {
    items {
      ...SellingPointFields
    }
  }
  introduction {
    json
  }
  notificationBanner {
    ...NotificationFields
  }
  notification {
    ...NotificationFields
  }
  pageType
  hero {
    ...ImageFields
  }
  searchTitle
  regionCode
  thingsToDoTitle
  thingsToDoDescription {
    json
  }
  highlightedParkFeaturesCollection(limit: 20) {
    items {
      ...ParkFeatureSummaryFields
    }
  }
  nearbyTownCitiesTitle
  nearbyTownCitiesCollection(limit: 10) {
    items {
      ...ParkFeatureSummaryWithParkFields
    }
  }
  testimonialsCollection(limit: 20) {
    items {
      ...TestimonialsFields
    }
  }
  relatedArticlesTitle
  relatedArticleIds
  faqsTitle
  faqsCollection(limit: 30) {
    items {
      ...FaqFields
    }
  }
  faqsTags
  pageMetadata {
    ...PageMetadataAll
  }
}
    ${exports.SysFieldsFragmentDoc}
${exports.SellingPointFieldsFragmentDoc}
${exports.NotificationFieldsFragmentDoc}
${exports.ImageFieldsFragmentDoc}
${exports.ParkFeatureSummaryFieldsFragmentDoc}
${exports.ParkFeatureSummaryWithParkFieldsFragmentDoc}
${exports.TestimonialsFieldsFragmentDoc}
${exports.FaqFieldsFragmentDoc}
${exports.PageMetadataAllFragmentDoc}`;
exports.AwardFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment AwardFields on Award {
  title
  image {
    ...ImageFields
  }
  description
  url
}
    ${exports.ImageFieldsFragmentDoc}`;
exports.VirtualTourFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment VirtualTourFields on VirtualTour {
  title
  image {
    ...ImageFields
  }
  url
}
    ${exports.ImageFieldsFragmentDoc}`;
exports.MaintenancePeriodFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment MaintenancePeriodFields on MaintenancePeriod {
  startDate
  endDate
  title
  description {
    json
  }
}
    `;
exports.ParkFeaturesFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment ParkFeaturesFields on ParkFeatures {
  name
  title
  shortTitle
  description
  icon {
    ...ImageFields
  }
  imagesCollection(limit: 10) {
    items {
      ...ImageFields
    }
  }
  videosCollection(limit: 5) {
    items {
      ...VideoFields
    }
  }
  propositionType
  dateIntroduced
  url
  virtualToursCollection(limit: 5) {
    items {
      ...VirtualTourFields
    }
  }
  maintenancePeriodsCollection(limit: 10) {
    items {
      ...MaintenancePeriodFields
    }
  }
  apiId
  sys {
    id
  }
  contentfulMetadata {
    tags {
      id
    }
  }
}
    ${exports.ImageFieldsFragmentDoc}
${exports.VideoFieldsFragmentDoc}
${exports.VirtualTourFieldsFragmentDoc}
${exports.MaintenancePeriodFieldsFragmentDoc}`;
exports.ParkRestrictionFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment ParkRestrictionFields on ParkRestriction {
  name
  title
  description {
    json
  }
  alternativeSuggestion {
    json
  }
}
    `;
exports.ParkFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment ParkFields on Park {
  name
  tagline
  parkInformation {
    ...ParkInformationFields
  }
  parkSummary {
    json
  }
  region {
    ...RegionFields
  }
  parkType
  path
  directionsUrl
  notificationBanner {
    ...NotificationFields
  }
  notification {
    ...NotificationFields
  }
  hero {
    ...ImageFields
  }
  videoHero {
    ...VideoFields
  }
  title
  description {
    json
  }
  exploreParkImage {
    ...ImageFields
  }
  exploreParkPdf {
    url
  }
  contactNumber
  sellingPointsCollection(limit: 5) {
    items {
      ...SellingPointFields
    }
  }
  awardsCollection(limit: 3) {
    items {
      ...AwardFields
    }
  }
  promotionVideo {
    ...VideoFields
  }
  parkFeaturesCollection(limit: 50) {
    items {
      ...ParkFeaturesFields
    }
  }
  exclusiveCollection(limit: 15) {
    items {
      ...ParkFeaturesFields
    }
  }
  parkRestrictionsCollection(limit: 10) {
    items {
      ...ParkRestrictionFields
    }
  }
  thingsToDoTitle
  thingsToDoDescription {
    json
  }
  accommodationDescription {
    json
  }
  supportedAccommodationGradesCollection(limit: 20) {
    items {
      ...AccommodationGradeFields
    }
  }
  testimonialsCollection(limit: 10) {
    items {
      ...TestimonialsFields
    }
  }
  termsAndConditionsCollection(limit: 12) {
    items {
      ...TermFields
    }
  }
  faqsTitle
  faqsCollection(limit: 20) {
    items {
      ...FaqFields
    }
  }
  faqsTags
  advertsCollection(limit: 5) {
    items {
      ...AdvertFields
    }
  }
  pageMetadata {
    ...PageMetadataAll
  }
  offersCollection(limit: 10) {
    items {
      ...ParkOfferFields
    }
  }
  siteFees
  runningCosts
  relatedArticlesIds
  nearbyParkCodes
  seasons
  sys {
    ...SysFields
  }
  contentfulMetadata {
    tags {
      id
      name
    }
  }
}
    ${exports.ParkInformationFieldsFragmentDoc}
${exports.RegionFieldsFragmentDoc}
${exports.NotificationFieldsFragmentDoc}
${exports.ImageFieldsFragmentDoc}
${exports.VideoFieldsFragmentDoc}
${exports.SellingPointFieldsFragmentDoc}
${exports.AwardFieldsFragmentDoc}
${exports.ParkFeaturesFieldsFragmentDoc}
${exports.ParkRestrictionFieldsFragmentDoc}
${exports.AccommodationGradeFieldsFragmentDoc}
${exports.TestimonialsFieldsFragmentDoc}
${exports.TermFieldsFragmentDoc}
${exports.FaqFieldsFragmentDoc}
${exports.AdvertFieldsFragmentDoc}
${exports.PageMetadataAllFragmentDoc}
${exports.ParkOfferFieldsFragmentDoc}
${exports.SysFieldsFragmentDoc}`;
exports.BoxFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment BoxFields on Box {
  name
  title
  titleLevel
  showOnPages
  description {
    json
  }
  image {
    ...ImageFields
  }
  href
  descriptionUrl
  parkLink {
    ...LinkFields
  }
  badge {
    ...ImageFields
  }
  sys {
    id
  }
}
    ${exports.ImageFieldsFragmentDoc}
${exports.LinkFieldsFragmentDoc}`;
exports.PitchParkFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment PitchParkFields on Park {
  parkInformation {
    parkCode
  }
}
    `;
exports.PitchFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment PitchFields on PitchType {
  name
  title
  pitchCode
  pitchFeaturesCollection(limit: 30) {
    items {
      ...BoxFields
    }
  }
  parksCollection(limit: 8) {
    items {
      ...PitchParkFields
    }
  }
}
    ${exports.BoxFieldsFragmentDoc}
${exports.PitchParkFieldsFragmentDoc}`;
exports.PropositionSubCategoryFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment PropositionSubCategoryFields on PropositionSubCategory {
  sys {
    ...SysFields
  }
  name
  path
  title
  heroImagesCollection(limit: 20) {
    items {
      ...ImageFields
    }
  }
  overview {
    json
  }
  notificationBanner {
    ...NotificationFields
  }
  notification {
    ...NotificationFields
  }
  categoriesCollection(limit: 30) {
    items {
      ...PropositionCategoryFields
    }
  }
  safetyMeasuresCollection(limit: 30) {
    items {
      ...SafetyMeasureFields
    }
  }
  pageMetadata {
    ...PageMetadataAll
  }
}
    ${exports.SysFieldsFragmentDoc}
${exports.ImageFieldsFragmentDoc}
${exports.NotificationFieldsFragmentDoc}
${exports.PropositionCategoryFieldsFragmentDoc}
${exports.SafetyMeasureFieldsFragmentDoc}
${exports.PageMetadataAllFragmentDoc}`;
exports.ListAssemblyFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment ListAssemblyFields on ListAssembly {
  header
  itemsCollection(limit: 20) {
    items {
      ... on SellingPoint {
        ...SellingPointFields
      }
      ... on SafetyMeasure {
        ...SafetyMeasureFields
      }
    }
  }
}
    ${exports.SellingPointFieldsFragmentDoc}
${exports.SafetyMeasureFieldsFragmentDoc}`;
exports.PropositionFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment PropositionFields on Proposition {
  sys {
    ...SysFields
  }
  name
  path
  title
  tagLine
  heroImagesCollection(limit: 25) {
    items {
      ...ImageFields
    }
  }
  videoHero {
    ...VideoFields
  }
  thumbnail {
    ...ImageFields
  }
  overview {
    json
  }
  promotionsCollection(limit: 15) {
    items {
      ...PromotionFields
    }
  }
  notificationBanner {
    ...NotificationFields
  }
  notification {
    ...NotificationFields
  }
  categoriesCollection(limit: 15) {
    items {
      ...PropositionCategoryFields
    }
  }
  sellingPoints {
    ...ListAssemblyFields
  }
  relatedArticlesTitle
  relatedArticleIds
  safetyMeasuresCollection(limit: 5) {
    items {
      ...SafetyMeasureFields
    }
  }
  supportedHolidayPackagesCollection(limit: 8) {
    items {
      ...HolidayPackageFields
    }
  }
  pageMetadata {
    ...PageMetadataAll
  }
  activitiesTimetableLink {
    ...LinkFields
  }
  faqsTitle
  faqsCollection(limit: 10) {
    items {
      ...FaqFields
    }
  }
  faqsTags
  faqFolderId
  termsAndConditionsCollection(limit: 15) {
    items {
      ...TermFields
    }
  }
  contentfulMetadata {
    tags {
      id
      name
    }
  }
}
    ${exports.SysFieldsFragmentDoc}
${exports.ImageFieldsFragmentDoc}
${exports.VideoFieldsFragmentDoc}
${exports.PromotionFieldsFragmentDoc}
${exports.NotificationFieldsFragmentDoc}
${exports.PropositionCategoryFieldsFragmentDoc}
${exports.ListAssemblyFieldsFragmentDoc}
${exports.SafetyMeasureFieldsFragmentDoc}
${exports.HolidayPackageFieldsFragmentDoc}
${exports.PageMetadataAllFragmentDoc}
${exports.LinkFieldsFragmentDoc}
${exports.FaqFieldsFragmentDoc}
${exports.TermFieldsFragmentDoc}`;
exports.PropositionSummaryFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment PropositionSummaryFields on Proposition {
  title
  overview {
    json
  }
  name
  path
  thumbnail {
    ...ImageFields
  }
}
    ${exports.ImageFieldsFragmentDoc}`;
exports.SearchPromotionBannerFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment SearchPromotionBannerFields on SearchPromotionBanner {
  sys {
    ...SysFields
  }
  title
  description
  buttonLabel
  imageType
  alwaysVisible
  dark
  endDate
  redirectUrl
  image {
    ...ImageFields
  }
}
    ${exports.SysFieldsFragmentDoc}
${exports.ImageFieldsFragmentDoc}`;
exports.RegionalHolidayFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment RegionalHolidayFields on RegionalHoliday {
  title
  path
  description
  shortDescription
  hero {
    ...ImageFields
  }
  region {
    ...RegionFields
  }
  reasonsToBookTitle
  reasonsToBookCollection(limit: 20) {
    items {
      ...SellingPointFields
    }
  }
  promotionsCollection(limit: 20) {
    items {
      ...PromotionFields
    }
  }
  holidayType
  parkOffersCollection(limit: 6) {
    items {
      ...ParkOfferFields
    }
  }
  parksCollection(limit: 10) {
    items {
      ...ParkSummaryFields
    }
  }
  contentfulMetadata {
    tags {
      id
      name
    }
  }
}
    ${exports.ImageFieldsFragmentDoc}
${exports.RegionFieldsFragmentDoc}
${exports.SellingPointFieldsFragmentDoc}
${exports.PromotionFieldsFragmentDoc}
${exports.ParkOfferFieldsFragmentDoc}
${exports.ParkSummaryFieldsFragmentDoc}`;
exports.RegionalHolidayFieldsWithoutRegionFragmentDoc = (0, graphql_tag_1.default) `
    fragment RegionalHolidayFieldsWithoutRegion on RegionalHoliday {
  title
  path
  description
  shortDescription
  hero {
    ...ImageFields
  }
  reasonsToBookTitle
  reasonsToBookCollection(limit: 20) {
    items {
      ...SellingPointFields
    }
  }
  region {
    sys {
      ...SysFields
    }
    name
  }
  holidayType
  parkOffersCollection(limit: 6) {
    items {
      ...ParkOfferFields
    }
  }
  contentfulMetadata {
    tags {
      id
      name
    }
  }
}
    ${exports.ImageFieldsFragmentDoc}
${exports.SellingPointFieldsFragmentDoc}
${exports.SysFieldsFragmentDoc}
${exports.ParkOfferFieldsFragmentDoc}`;
exports.RegionArticlesFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment RegionArticlesFields on Articles {
  sys {
    id
  }
  path
  title
  description {
    json
  }
  articleSummary
  hero {
    ...ImageFields
  }
}
    ${exports.ImageFieldsFragmentDoc}`;
exports.SellingAttributeFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment SellingAttributeFields on SellingAttribute {
  id
  title
  description
  rank
}
    `;
exports.TagMetaDataFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment TagMetaDataFields on TagMetaData {
  sys {
    ...SysFields
  }
  name
  longDescription
  pageMetadata {
    ...PageMetadataAll
  }
}
    ${exports.SysFieldsFragmentDoc}
${exports.PageMetadataAllFragmentDoc}`;
exports.TagIdFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment TagIdFields on TagMetaData {
  contentfulMetadata {
    tags {
      id
    }
  }
}
    `;
exports.TermByHolidayTypeFieldsFragmentDoc = (0, graphql_tag_1.default) `
    fragment TermByHolidayTypeFields on Terms {
  ...TermFields
  linkedFrom {
    entryCollection(limit: 1) {
      total
    }
  }
}
    ${exports.TermFieldsFragmentDoc}`;
exports.GetAccommodationTypeByPathDocument = (0, graphql_tag_1.default) `
    query getAccommodationTypeByPath($path: String, $preview: Boolean) {
  accommodationTypeCollection(where: {path: $path}, preview: $preview, limit: 1) {
    items {
      ...AccommodationTypeWithParkFields
    }
  }
}
    ${exports.AccommodationTypeWithParkFieldsFragmentDoc}`;
exports.GetAccommodationTypesDocument = (0, graphql_tag_1.default) `
    query getAccommodationTypes($preview: Boolean) {
  accommodationTypeCollection(preview: $preview, limit: 10) {
    items {
      ...AccommodationTypeFields
    }
  }
}
    ${exports.AccommodationTypeFieldsFragmentDoc}`;
exports.GetAccommodationTypePathsDocument = (0, graphql_tag_1.default) `
    query getAccommodationTypePaths($preview: Boolean) {
  accommodationTypeCollection(preview: $preview) {
    items {
      path
    }
  }
}
    `;
exports.GetAccommodationTypeByTypesDocument = (0, graphql_tag_1.default) `
    query getAccommodationTypeByTypes($preview: Boolean, $types: [String]) {
  accommodationTypeCollection(
    preview: $preview
    limit: 10
    where: {name_in: $types}
  ) {
    items {
      ...AccommodationTypeFields
    }
  }
}
    ${exports.AccommodationTypeFieldsFragmentDoc}`;
exports.GetAccommodationGradeByNameDocument = (0, graphql_tag_1.default) `
    query getAccommodationGradeByName($grade: String, $preview: Boolean) {
  accommodationGradeCollection(where: {name: $grade}, preview: $preview, limit: 1) {
    items {
      ...AccommodationGradeFields
    }
  }
}
    ${exports.AccommodationGradeFieldsFragmentDoc}`;
exports.FetchAllParkPageByTypeDocument = (0, graphql_tag_1.default) `
    query fetchAllParkPageByType($typeOfParkPage: String, $preview: Boolean) {
  allParkPageCollection(
    where: {typeOfParkPage: $typeOfParkPage}
    limit: 1
    preview: $preview
  ) {
    items {
      ...AllParkPageFields
    }
  }
}
    ${exports.AllParkPageFieldsFragmentDoc}`;
exports.GetArticlesByTagDocument = (0, graphql_tag_1.default) `
    query getArticlesByTag($tagIds: [String], $preview: Boolean, $limit: Int) {
  articlesCollection(
    limit: $limit
    where: {contentfulMetadata: {tags: {id_contains_some: $tagIds}}}
    preview: $preview
    order: sys_firstPublishedAt_DESC
  ) {
    items {
      ...ArticleSummaryFields
    }
  }
}
    ${exports.ArticleSummaryFieldsFragmentDoc}`;
exports.GetArticlesByIdsDocument = (0, graphql_tag_1.default) `
    query getArticlesByIds($ids: [String], $preview: Boolean) {
  articlesCollection(where: {sys: {id_in: $ids}}, preview: $preview) {
    items {
      ...ArticleSummaryFields
    }
  }
}
    ${exports.ArticleSummaryFieldsFragmentDoc}`;
exports.GetArticleByPathDocument = (0, graphql_tag_1.default) `
    query getArticleByPath($path: String, $preview: Boolean) {
  articlesCollection(where: {path: $path}, limit: 1, preview: $preview) {
    items {
      ...ArticleFields
    }
  }
}
    ${exports.ArticleFieldsFragmentDoc}`;
exports.FetchArticleHubByPathDocument = (0, graphql_tag_1.default) `
    query fetchArticleHubByPath($path: String, $preview: Boolean) {
  articleHubCollection(where: {path: $path}, limit: 1, preview: $preview) {
    items {
      ...ArticleHubFields
    }
  }
}
    ${exports.ArticleHubFieldsFragmentDoc}`;
exports.GetArticleHubPathsDocument = (0, graphql_tag_1.default) `
    query getArticleHubPaths($preview: Boolean) {
  articleHubCollection(preview: $preview) {
    items {
      path
    }
  }
}
    `;
exports.GetArticlesByArticleHubSectionIdDocument = (0, graphql_tag_1.default) `
    query getArticlesByArticleHubSectionId($id: String, $preview: Boolean) {
  articleHubSectionCollection(where: {sys: {id: $id}}, preview: $preview) {
    items {
      articlesCollection {
        items {
          sys {
            id
          }
        }
      }
    }
  }
}
    `;
exports.GetCaravanTypesDocument = (0, graphql_tag_1.default) `
    query getCaravanTypes($preview: Boolean, $skip: Int) {
  caravanTypesCollection(
    preview: $preview
    limit: 30
    skip: $skip
    order: sys_publishedAt_DESC
  ) {
    items {
      ...CaravanTypesFields
    }
  }
}
    ${exports.CaravanTypesFieldsFragmentDoc}`;
exports.GetCaravanTypesByParkDocument = (0, graphql_tag_1.default) `
    query getCaravanTypesByPark($preview: Boolean, $skip: Int) {
  caravanTypeByParkCollection(preview: $preview, limit: 30, skip: $skip) {
    items {
      ...CaravanTypeByParkFields
    }
  }
}
    ${exports.CaravanTypeByParkFieldsFragmentDoc}`;
exports.GetCaravanLimitsDocument = (0, graphql_tag_1.default) `
    query getCaravanLimits($preview: Boolean) {
  caravanTypesCollection(preview: $preview) {
    total
  }
  caravanTypeByParkCollection(preview: $preview) {
    total
  }
}
    `;
exports.FetchExtraBundlesDocument = (0, graphql_tag_1.default) `
    query fetchExtraBundles($preview: Boolean) {
  extraBundleCollection(preview: $preview) {
    items {
      ...ExtraBundleFields
    }
  }
}
    ${exports.ExtraBundleFieldsFragmentDoc}`;
exports.FetchExtrasDocument = (0, graphql_tag_1.default) `
    query fetchExtras($preview: Boolean) {
  extraCollection(preview: $preview) {
    items {
      ...ExtraFields
    }
  }
}
    ${exports.ExtraFieldsFragmentDoc}`;
exports.GetFocusParkListByIdDocument = (0, graphql_tag_1.default) `
    query getFocusParkListByID($id: String, $preview: Boolean) {
  focusParkListCollection(where: {sys: {id: $id}}, preview: $preview, limit: 1) {
    items {
      ...FocusParkListFields
    }
  }
}
    ${exports.FocusParkListFieldsFragmentDoc}`;
exports.GetFullCampaignByPathDocument = (0, graphql_tag_1.default) `
    query getFullCampaignByPath($path: String, $preview: Boolean) {
  fullCampaignCollection(where: {path: $path}, preview: $preview, limit: 1) {
    items {
      ...FullCampaignFields
    }
  }
}
    ${exports.FullCampaignFieldsFragmentDoc}`;
exports.GetCampaignPromotionsDocument = (0, graphql_tag_1.default) `
    query getCampaignPromotions($tags: [String], $preview: Boolean) {
  fullCampaignCollection(
    preview: $preview
    where: {contentfulMetadata: {tags: {id_contains_some: $tags}}}
    limit: 8
  ) {
    items {
      featuredPromotionsCollection(limit: 10) {
        items {
          ...PromotionFields
        }
      }
    }
  }
}
    ${exports.PromotionFieldsFragmentDoc}`;
exports.FetchGenericTemplateDocument = (0, graphql_tag_1.default) `
    query fetchGenericTemplate($path: String, $preview: Boolean) {
  genericTemplateCollection(where: {path: $path}, limit: 1, preview: $preview) {
    items {
      ...GenericTemplateFields
    }
  }
}
    ${exports.GenericTemplateFieldsFragmentDoc}`;
exports.GetHavenPromisesDocument = (0, graphql_tag_1.default) `
    query getHavenPromises($preview: Boolean) {
  havenPromiseCollection(preview: $preview) {
    items {
      ...HavenPromiseFields
    }
  }
}
    ${exports.HavenPromiseFieldsFragmentDoc}`;
exports.GetHolidaySelectionPagesByPathDocument = (0, graphql_tag_1.default) `
    query getHolidaySelectionPagesByPath($path: String, $preview: Boolean) {
  holidaySelectionPageCollection(
    where: {path: $path}
    preview: $preview
    limit: 1
  ) {
    items {
      ...HolidaySelectionPageFields
    }
  }
}
    ${exports.HolidaySelectionPageFieldsFragmentDoc}`;
exports.GetHolidaySelectionPagesSummariesDocument = (0, graphql_tag_1.default) `
    query getHolidaySelectionPagesSummaries($preview: Boolean) {
  holidaySelectionPageCollection(preview: $preview) {
    items {
      ...HolidaySelectionPageSummaryFields
    }
  }
}
    ${exports.HolidaySelectionPageSummaryFieldsFragmentDoc}`;
exports.FetchHomepageDocument = (0, graphql_tag_1.default) `
    query fetchHomepage($path: String, $preview: Boolean) {
  homePageCollection(where: {path: $path}, limit: 1, preview: $preview) {
    items {
      ...HomepageFields
    }
  }
}
    ${exports.HomepageFieldsFragmentDoc}`;
exports.GetParkInformationIdsByParkTypesDocument = (0, graphql_tag_1.default) `
    query getParkInformationIdsByParkTypes($typeOfPark: String, $preview: Boolean) {
  parkCollection(where: {parkType: $typeOfPark}, preview: $preview) {
    items {
      parkInformation {
        sys {
          id
        }
      }
    }
  }
}
    `;
exports.GetParkByParkInformationIdDocument = (0, graphql_tag_1.default) `
    query getParkByParkInformationId($preview: Boolean, $parkInfoId: String, $parkType: String) {
  parkCollection(
    preview: $preview
    limit: 1
    where: {parkInformation: {sys: {id: $parkInfoId}}, parkType: $parkType}
  ) {
    items {
      ...ParkFields
    }
  }
}
    ${exports.ParkFieldsFragmentDoc}`;
exports.GetParksByParkCodesDocument = (0, graphql_tag_1.default) `
    query getParksByParkCodes($preview: Boolean, $parkType: String, $parkCodes: [String]) {
  parkCollection(
    preview: $preview
    where: {parkInformation: {parkCode_in: $parkCodes}, parkType: $parkType}
    limit: 50
  ) {
    items {
      parkInformation {
        ...ParkInformationFields
      }
      hero {
        ...ImageFields
      }
      sys {
        id
      }
      contentfulMetadata {
        tags {
          id
        }
      }
    }
  }
}
    ${exports.ParkInformationFieldsFragmentDoc}
${exports.ImageFieldsFragmentDoc}`;
exports.GetAllParkSeasonsDocument = (0, graphql_tag_1.default) `
    query getAllParkSeasons($preview: Boolean, $parkType: String) {
  parkCollection(preview: $preview, where: {parkType: $parkType}, limit: 50) {
    items {
      ...ParkSeasonsFields
    }
  }
}
    ${exports.ParkSeasonsFieldsFragmentDoc}`;
exports.GetParkByPathDocument = (0, graphql_tag_1.default) `
    query getParkByPath($preview: Boolean, $path: String) {
  parkCollection(preview: $preview, where: {path: $path}, limit: 1) {
    items {
      ...ParkFields
    }
  }
}
    ${exports.ParkFieldsFragmentDoc}`;
exports.GetAllParksWithAccommodationGradesDocument = (0, graphql_tag_1.default) `
    query getAllParksWithAccommodationGrades($preview: Boolean) {
  parkCollection(
    preview: $preview
    limit: 100
    where: {supportedAccommodationGradesCollection_exists: true}
  ) {
    items {
      path
      parkType
      parkInformation {
        parkName
        parkCode
        regionName
      }
      supportedAccommodationGradesCollection(limit: 20) {
        items {
          sys {
            id
          }
        }
      }
    }
  }
}
    `;
exports.GetOffersDocument = (0, graphql_tag_1.default) `
    query getOffers($parkCode: [String!]!, $holidayType: String!, $preview: Boolean) {
  parkOfferCollection(
    where: {parkCodes_contains_all: $parkCode, holidayType: $holidayType}
    preview: $preview
  ) {
    items {
      ...ParkOfferFields
    }
  }
}
    ${exports.ParkOfferFieldsFragmentDoc}`;
exports.GetParkOffersByHolidayTypeDocument = (0, graphql_tag_1.default) `
    query getParkOffersByHolidayType($holidayType: String!, $preview: Boolean) {
  parkOfferCollection(where: {holidayType: $holidayType}, preview: $preview) {
    items {
      ...ParkOfferFields
    }
  }
}
    ${exports.ParkOfferFieldsFragmentDoc}`;
exports.FetchParkSummariesByParkTypeDocument = (0, graphql_tag_1.default) `
    query fetchParkSummariesByParkType($parkType: String, $preview: Boolean, $tagIds: [String]) {
  parkCollection(
    where: {parkType: $parkType, contentfulMetadata: {tags: {id_contains_some: $tagIds}}}
    preview: $preview
  ) {
    items {
      ...ParkSummaryFields
    }
  }
}
    ${exports.ParkSummaryFieldsFragmentDoc}`;
exports.GetAllPathsDocument = (0, graphql_tag_1.default) `
    query getAllPaths($preview: Boolean) {
  accommodationTypeCollection(preview: $preview, limit: 400) {
    items {
      path
      pageMetadata {
        disableSitemap
      }
    }
  }
  allParkPageCollection(preview: $preview, limit: 400) {
    items {
      path
      pageMetadata {
        disableSitemap
      }
    }
  }
  articlesCollection(preview: $preview, limit: 1000) {
    items {
      path
      pageMetadata {
        disableSitemap
      }
    }
  }
  fullCampaignCollection(preview: $preview, limit: 400) {
    items {
      path
      pageMetadata {
        disableSitemap
      }
    }
  }
  genericTemplateCollection(preview: $preview, limit: 400) {
    items {
      path
      pageMetadata {
        disableSitemap
      }
    }
  }
  holidaySelectionPageCollection(preview: $preview, limit: 400) {
    items {
      path
      pageMetadata {
        disableSitemap
      }
    }
  }
  parkCollection(preview: $preview, limit: 400) {
    items {
      path
      pageMetadata {
        disableSitemap
      }
    }
  }
  propositionCollection(preview: $preview, limit: 400) {
    items {
      path
      pageMetadata {
        disableSitemap
      }
    }
  }
  propositionSubCategoryCollection(preview: $preview, limit: 400) {
    items {
      path
      pageMetadata {
        disableSitemap
      }
    }
  }
  regionCollection(preview: $preview, limit: 400) {
    items {
      path
      pageMetadata {
        disableSitemap
      }
    }
  }
  homePageCollection(preview: $preview, limit: 100) {
    items {
      path
      pageMetadata {
        disableSitemap
      }
    }
  }
}
    `;
exports.GetPitchesDocument = (0, graphql_tag_1.default) `
    query getPitches($preview: Boolean) {
  pitchTypeCollection(preview: $preview, limit: 40) {
    items {
      ...PitchFields
    }
  }
}
    ${exports.PitchFieldsFragmentDoc}`;
exports.GetFeaturedParkPromotionsByCodeDocument = (0, graphql_tag_1.default) `
    query getFeaturedParkPromotionsByCode($parkCodes: [String], $preview: Boolean) {
  promotionCollection(
    limit: 40
    preview: $preview
    where: {searchParameters: {parkCodes_contains_some: $parkCodes}}
  ) {
    items {
      ...PromotionFields
      linkedFrom {
        fullCampaignCollection {
          items {
            path
          }
        }
      }
    }
  }
}
    ${exports.PromotionFieldsFragmentDoc}`;
exports.GetParkPromotionsByCodeDocument = (0, graphql_tag_1.default) `
    query getParkPromotionsByCode($parkCodes: [String], $tagIds: [String], $preview: Boolean, $skip: Int) {
  promotionCollection(
    limit: 80
    preview: $preview
    where: {searchParameters: {parkCodes_contains_some: $parkCodes}, contentfulMetadata: {tags: {id_contains_some: $tagIds}}}
    skip: $skip
  ) {
    items {
      ...PromotionFields
    }
  }
}
    ${exports.PromotionFieldsFragmentDoc}`;
exports.GetParkPromotionByCodeLimitsDocument = (0, graphql_tag_1.default) `
    query getParkPromotionByCodeLimits($parkCodes: [String], $tagIds: [String], $preview: Boolean) {
  promotionCollection(
    preview: $preview
    where: {searchParameters: {parkCodes_contains_some: $parkCodes}, contentfulMetadata: {tags: {id_contains_some: $tagIds}}}
  ) {
    total
  }
}
    `;
exports.GetPropositionByPathDocument = (0, graphql_tag_1.default) `
    query getPropositionByPath($path: String, $preview: Boolean) {
  propositionCollection(where: {path: $path}, preview: $preview, limit: 1) {
    items {
      ...PropositionFields
    }
  }
}
    ${exports.PropositionFieldsFragmentDoc}`;
exports.GetPropositionSubCategoriesPathsDocument = (0, graphql_tag_1.default) `
    query getPropositionSubCategoriesPaths($preview: Boolean) {
  propositionSubCategoryCollection(preview: $preview) {
    items {
      path
    }
  }
}
    `;
exports.GetPropositionsSummariesDocument = (0, graphql_tag_1.default) `
    query getPropositionsSummaries($preview: Boolean) {
  propositionCollection(preview: $preview) {
    items {
      ...PropositionSummaryFields
    }
  }
}
    ${exports.PropositionSummaryFieldsFragmentDoc}`;
exports.GetPropositionsSummariesByTagDocument = (0, graphql_tag_1.default) `
    query getPropositionsSummariesByTag($tagIds: String, $preview: Boolean) {
  propositionCollection(
    preview: $preview
    where: {contentfulMetadata: {tags: {id_contains_some: [$tagIds]}}}
  ) {
    items {
      ...PropositionSummaryFields
    }
  }
}
    ${exports.PropositionSummaryFieldsFragmentDoc}`;
exports.GetPropositionSubCategoryByPathDocument = (0, graphql_tag_1.default) `
    query getPropositionSubCategoryByPath($path: String, $preview: Boolean) {
  propositionSubCategoryCollection(
    where: {path: $path}
    preview: $preview
    limit: 1
  ) {
    items {
      ...PropositionSubCategoryFields
    }
  }
}
    ${exports.PropositionSubCategoryFieldsFragmentDoc}`;
exports.GetLastSearchPromotionBannerDocument = (0, graphql_tag_1.default) `
    query getLastSearchPromotionBanner($preview: Boolean) {
  searchPromotionBannerCollection(
    order: endDate_DESC
    preview: $preview
    limit: 1
  ) {
    items {
      ...SearchPromotionBannerFields
    }
  }
}
    ${exports.SearchPromotionBannerFieldsFragmentDoc}`;
exports.FetchRegionDocument = (0, graphql_tag_1.default) `
    query fetchRegion($path: String, $preview: Boolean) {
  regionCollection(where: {path: $path}, limit: 1, preview: $preview) {
    items {
      ...RegionFields
    }
  }
}
    ${exports.RegionFieldsFragmentDoc}`;
exports.RegionParksDocument = (0, graphql_tag_1.default) `
    query regionParks($parkType: String!, $regionCode: String!, $preview: Boolean) {
  parkCollection(
    order: name_ASC
    limit: 10
    where: {parkType: $parkType, region: {regionCode_contains: $regionCode}}
    preview: $preview
  ) {
    items {
      ...ParkSummaryFields
    }
  }
}
    ${exports.ParkSummaryFieldsFragmentDoc}`;
exports.GetRegionalHolidayPathsDocument = (0, graphql_tag_1.default) `
    query getRegionalHolidayPaths($preview: Boolean) {
  regionalHolidayCollection(preview: $preview, limit: 500) {
    items {
      path
    }
  }
}
    `;
exports.GetRegionalHolidayByPathDocument = (0, graphql_tag_1.default) `
    query getRegionalHolidayByPath($path: String!, $preview: Boolean) {
  regionalHolidayCollection(where: {path: $path}, preview: $preview, limit: 1) {
    items {
      ...RegionalHolidayFields
    }
  }
}
    ${exports.RegionalHolidayFieldsFragmentDoc}`;
exports.GetRegionHolidaysByTagDocument = (0, graphql_tag_1.default) `
    query getRegionHolidaysByTag($tagIds: [String], $preview: Boolean) {
  regionalHolidayCollection(
    limit: 100
    where: {contentfulMetadata: {tags: {id_contains_some: $tagIds}}}
    preview: $preview
  ) {
    items {
      path
      title
      region {
        name
        sys {
          ...SysFields
        }
      }
      contentfulMetadata {
        tags {
          id
          name
        }
      }
    }
  }
}
    ${exports.SysFieldsFragmentDoc}`;
exports.GetRegionalHolidaysDocument = (0, graphql_tag_1.default) `
    query getRegionalHolidays($name: String!, $type: String!, $preview: Boolean) {
  regionalHolidayCollection(
    where: {region: {AND: [{name: $name}, {pageType: $type}]}}
    preview: $preview
    limit: 20
  ) {
    items {
      ...RegionalHolidayFieldsWithoutRegion
    }
  }
}
    ${exports.RegionalHolidayFieldsWithoutRegionFragmentDoc}`;
exports.RelatedRegionArticlesDocument = (0, graphql_tag_1.default) `
    query relatedRegionArticles($relatedArticleIds: [String!]!, $preview: Boolean) {
  articlesCollection(where: {sys: {id_in: $relatedArticleIds}}, preview: $preview) {
    items {
      ...RegionArticlesFields
    }
  }
}
    ${exports.RegionArticlesFieldsFragmentDoc}`;
exports.FetchSellingAttributesDocument = (0, graphql_tag_1.default) `
    query fetchSellingAttributes($preview: Boolean) {
  sellingAttributeCollection(preview: $preview) {
    items {
      ...SellingAttributeFields
    }
  }
}
    ${exports.SellingAttributeFieldsFragmentDoc}`;
exports.GetSellingPointsByTagDocument = (0, graphql_tag_1.default) `
    query getSellingPointsByTag($tagIds: [String], $preview: Boolean, $limit: Int) {
  sellingPointCollection(
    limit: $limit
    where: {contentfulMetadata: {tags: {id_contains_some: $tagIds}}}
    preview: $preview
    order: sys_firstPublishedAt_ASC
  ) {
    items {
      ...SellingPointFields
    }
  }
}
    ${exports.SellingPointFieldsFragmentDoc}`;
exports.GetTagMetaDataDocument = (0, graphql_tag_1.default) `
    query getTagMetaData($tagIds: [String], $preview: Boolean, $limit: Int) {
  tagMetaDataCollection(
    limit: $limit
    where: {contentfulMetadata: {tags: {id_contains_some: $tagIds}}}
    preview: $preview
  ) {
    items {
      ...TagMetaDataFields
    }
  }
}
    ${exports.TagMetaDataFieldsFragmentDoc}`;
exports.GetTagIdsDocument = (0, graphql_tag_1.default) `
    query getTagIds($preview: Boolean, $limit: Int) {
  tagMetaDataCollection(limit: $limit, preview: $preview) {
    items {
      ...TagIdFields
    }
  }
}
    ${exports.TagIdFieldsFragmentDoc}`;
exports.GetTermsByHolidayTypeDocument = (0, graphql_tag_1.default) `
    query getTermsByHolidayType($holidayType: String, $preview: Boolean, $limit: Int) {
  termsCollection(
    limit: $limit
    where: {holidayType: $holidayType}
    preview: $preview
  ) {
    items {
      ...TermByHolidayTypeFields
    }
  }
}
    ${exports.TermByHolidayTypeFieldsFragmentDoc}`;
const defaultWrapper = (action, _operationName, _operationType) => action();
function getSdk(client, withWrapper = defaultWrapper) {
    return {
        getAccommodationTypeByPath(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetAccommodationTypeByPathDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getAccommodationTypeByPath', 'query');
        },
        getAccommodationTypes(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetAccommodationTypesDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getAccommodationTypes', 'query');
        },
        getAccommodationTypePaths(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetAccommodationTypePathsDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getAccommodationTypePaths', 'query');
        },
        getAccommodationTypeByTypes(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetAccommodationTypeByTypesDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getAccommodationTypeByTypes', 'query');
        },
        getAccommodationGradeByName(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetAccommodationGradeByNameDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getAccommodationGradeByName', 'query');
        },
        fetchAllParkPageByType(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.FetchAllParkPageByTypeDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'fetchAllParkPageByType', 'query');
        },
        getArticlesByTag(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetArticlesByTagDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getArticlesByTag', 'query');
        },
        getArticlesByIds(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetArticlesByIdsDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getArticlesByIds', 'query');
        },
        getArticleByPath(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetArticleByPathDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getArticleByPath', 'query');
        },
        fetchArticleHubByPath(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.FetchArticleHubByPathDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'fetchArticleHubByPath', 'query');
        },
        getArticleHubPaths(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetArticleHubPathsDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getArticleHubPaths', 'query');
        },
        getArticlesByArticleHubSectionId(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetArticlesByArticleHubSectionIdDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getArticlesByArticleHubSectionId', 'query');
        },
        getCaravanTypes(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetCaravanTypesDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getCaravanTypes', 'query');
        },
        getCaravanTypesByPark(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetCaravanTypesByParkDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getCaravanTypesByPark', 'query');
        },
        getCaravanLimits(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetCaravanLimitsDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getCaravanLimits', 'query');
        },
        fetchExtraBundles(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.FetchExtraBundlesDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'fetchExtraBundles', 'query');
        },
        fetchExtras(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.FetchExtrasDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'fetchExtras', 'query');
        },
        getFocusParkListByID(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetFocusParkListByIdDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getFocusParkListByID', 'query');
        },
        getFullCampaignByPath(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetFullCampaignByPathDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getFullCampaignByPath', 'query');
        },
        getCampaignPromotions(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetCampaignPromotionsDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getCampaignPromotions', 'query');
        },
        fetchGenericTemplate(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.FetchGenericTemplateDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'fetchGenericTemplate', 'query');
        },
        getHavenPromises(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetHavenPromisesDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getHavenPromises', 'query');
        },
        getHolidaySelectionPagesByPath(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetHolidaySelectionPagesByPathDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getHolidaySelectionPagesByPath', 'query');
        },
        getHolidaySelectionPagesSummaries(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetHolidaySelectionPagesSummariesDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getHolidaySelectionPagesSummaries', 'query');
        },
        fetchHomepage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.FetchHomepageDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'fetchHomepage', 'query');
        },
        getParkInformationIdsByParkTypes(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetParkInformationIdsByParkTypesDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getParkInformationIdsByParkTypes', 'query');
        },
        getParkByParkInformationId(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetParkByParkInformationIdDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getParkByParkInformationId', 'query');
        },
        getParksByParkCodes(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetParksByParkCodesDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getParksByParkCodes', 'query');
        },
        getAllParkSeasons(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetAllParkSeasonsDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getAllParkSeasons', 'query');
        },
        getParkByPath(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetParkByPathDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getParkByPath', 'query');
        },
        getAllParksWithAccommodationGrades(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetAllParksWithAccommodationGradesDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getAllParksWithAccommodationGrades', 'query');
        },
        getOffers(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetOffersDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getOffers', 'query');
        },
        getParkOffersByHolidayType(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetParkOffersByHolidayTypeDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getParkOffersByHolidayType', 'query');
        },
        fetchParkSummariesByParkType(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.FetchParkSummariesByParkTypeDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'fetchParkSummariesByParkType', 'query');
        },
        getAllPaths(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetAllPathsDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getAllPaths', 'query');
        },
        getPitches(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetPitchesDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getPitches', 'query');
        },
        getFeaturedParkPromotionsByCode(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetFeaturedParkPromotionsByCodeDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getFeaturedParkPromotionsByCode', 'query');
        },
        getParkPromotionsByCode(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetParkPromotionsByCodeDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getParkPromotionsByCode', 'query');
        },
        getParkPromotionByCodeLimits(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetParkPromotionByCodeLimitsDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getParkPromotionByCodeLimits', 'query');
        },
        getPropositionByPath(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetPropositionByPathDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getPropositionByPath', 'query');
        },
        getPropositionSubCategoriesPaths(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetPropositionSubCategoriesPathsDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getPropositionSubCategoriesPaths', 'query');
        },
        getPropositionsSummaries(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetPropositionsSummariesDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getPropositionsSummaries', 'query');
        },
        getPropositionsSummariesByTag(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetPropositionsSummariesByTagDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getPropositionsSummariesByTag', 'query');
        },
        getPropositionSubCategoryByPath(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetPropositionSubCategoryByPathDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getPropositionSubCategoryByPath', 'query');
        },
        getLastSearchPromotionBanner(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetLastSearchPromotionBannerDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getLastSearchPromotionBanner', 'query');
        },
        fetchRegion(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.FetchRegionDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'fetchRegion', 'query');
        },
        regionParks(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.RegionParksDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'regionParks', 'query');
        },
        getRegionalHolidayPaths(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetRegionalHolidayPathsDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getRegionalHolidayPaths', 'query');
        },
        getRegionalHolidayByPath(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetRegionalHolidayByPathDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getRegionalHolidayByPath', 'query');
        },
        getRegionHolidaysByTag(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetRegionHolidaysByTagDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getRegionHolidaysByTag', 'query');
        },
        getRegionalHolidays(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetRegionalHolidaysDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getRegionalHolidays', 'query');
        },
        relatedRegionArticles(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.RelatedRegionArticlesDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'relatedRegionArticles', 'query');
        },
        fetchSellingAttributes(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.FetchSellingAttributesDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'fetchSellingAttributes', 'query');
        },
        getSellingPointsByTag(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetSellingPointsByTagDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getSellingPointsByTag', 'query');
        },
        getTagMetaData(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetTagMetaDataDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getTagMetaData', 'query');
        },
        getTagIds(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetTagIdsDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getTagIds', 'query');
        },
        getTermsByHolidayType(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetTermsByHolidayTypeDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'getTermsByHolidayType', 'query');
        }
    };
}
exports.getSdk = getSdk;
